import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      // Master agreement signing: what is still missing and where to do it
      manual_signing_awaiting_client: "Waiting for the client's signature. When the client returns the copy signed by hand, upload it here. After that our company signs it in Dokobit.",
      manual_signing_awaiting_company: "The client has signed. Now our company has to sign the uploaded copy in Dokobit. Until then the contract is not in force and order documents cannot be created.",
      manual_signing_awaiting_company_sent: "The client has signed. Waiting for our company's signature in Dokobit.",
      sign_request_company_side: "Send for our company's signature",
      order_contract_no_finance: "The client has no master agreement for {{year}}. Create the finance approval on the client card.",
      order_contract_not_approved: "The {{year}} master agreement is not approved yet.",
      order_contract_no_document: "The {{year}} master agreement document has not been generated yet.",
      order_contract_withdrawn: "The {{year}} master agreement document was withdrawn. Generate a new one on the agreement page.",
      // mobile: shared
      open_pdf: "Open PDF",
      order_contract_awaiting_client: "The master agreement is waiting for the client's signature. When the signed copy arrives, upload it on the agreement page.",
      order_contract_awaiting_company: "The client has signed the master agreement. Our company still has to sign it in Dokobit on the agreement page.",
      order_contract_awaiting_signatures: "The master agreement is not signed by all parties yet.",
      order_open_master_agreement: "Open the agreement",
      order_open_customer_card: "Open the client card",
      // mobile: customers
      contacts: "Contacts",
      finance_document_should_be_sign: "The master agreement must be signed.",
      // Customer card → documents tab: the category tree beside the file list
      "customer_documents_all": "All documents",
      "customer_documents_uncategorized": "No category",
      "customer_documents_show_all": "Show all",
      "customer_documents_select_all": "Select all",
      "customer_documents_unselect_all": "Unselect all",
      // Files list rows (features/files): status pill, meta line, signers
      "files_status_annulled": "Annulled",
      "files_status_withdrawn": "Withdrawn",
      "files_status_signed": "Signed",
      "files_status_rejected": "Declined",
      "files_status_approval_required": "Needs manager approval",
      "files_status_progress": "{{signed}} of {{total}} signed",
      "files_status_no_signing": "No signing",
      "files_number": "No. {{number}}",
      "files_related": "Related ({{count}})",
      "files_signer_signed": "signed",
      "files_signer_pending": "waiting",
      "files_signer_rejected": "declined",
      "files_signer_withdrawn": "withdrawn",
      "files_signer_since": "since {{date}}",
      "files_signer_decline_reason": "Reason: {{reason}}",
      "files_remind": "Remind",
      "files_remind_by_email": "Remind by e-mail",
      "files_reminder_sent": "Reminder sent",
      "files_reminder_failed": "Could not send the reminder",
      "files_open_document_page": "Open the document page",
      "files_empty_category": "No documents in this category",
      "files_empty": "No documents",
      "registry_details_withheld_short": "VAT number is valid",
      "registry_details_withheld": "This country does not publish the company name and address (Germany, for example). The VAT number is confirmed valid — fill in the rest by hand.",
      "registry_search_help_foreign": "For a company outside Lithuania, enter its VAT number with the country prefix, e.g. EE100594102.",
      "registry_already_exists": "You already have this counterparty",
      "customer_exists_error": "This counterparty is already on file — a VAT code can belong to only one customer.",
      "registry_search_placeholder": "e.g. UAB Pavyzdys, 304237850 or LT100010465613",
      "registry_search_label": "Find the company in the public registers",
      "registry_search_help": "Enter the company name, company code, or VAT code — the legal details will be filled in for you.",
      "registry_no_results": "Nothing found in the registers. Fill the form in by hand.",
      "registry_unavailable": "The public registers are not responding. Fill the form in by hand.",
      "registry_failed": "The lookup failed. Fill the form in by hand.",
      "registry_inactive": "(deregistered)",
      "registry_not_vat_payer": "not registered for VAT",
      "registry_filled_from_public_data": "Legal details filled from the public registers. Check them, and add the bank and commercial terms yourself.",
      "storage_quota_full": "You have used all of your storage. New uploads will be refused until files are removed — contact us to raise the limit.",
      "storage_quota_nearly_full": "You are close to your storage limit.",
      "storage_loading": "Checking…",
      "storage_unknown": "Could not be determined",
      "storage_where_ours": "Documents are stored in our storage",
      "storage_where_google": "Documents are stored in your own Google Drive",
      "storage_where_microsoft": "Documents are stored in your own OneDrive",
      "storage_own_cloud_note": "The files are in your own cloud account. We do not keep a second copy, and the space they use is yours, not ours.",
      "storage_used": "Used",
      "storage_of": "of",
      "storage_choose": "Where to keep new documents",
      "storage_option_ours": "Our storage",
      "storage_option_google": "My Google Drive",
      "storage_option_microsoft": "My OneDrive",
      "storage_switch_note": "Switching affects new documents only. Everything already stored stays where it is and keeps opening normally.",
      "storage_google_section": "Connect Google Drive",
      "storage_google_scope_note": "We ask only for access to the files this system creates in your Drive — not to the rest of it.",
      "storage_google_connect": "Connect",
      "storage_google_reconnect": "Reconnect",
      "storage_google_connected": "Google Drive connected.",
      "storage_google_connect_failed": "Google Drive was not connected.",
      "storage_google_app_saved": "Saved. Now press Connect to grant access.",
      "storage_google_app_save_failed": "Could not save the Google application.",
      "storage_google_app_required": "Enter and save the Google application first.",
      "storage_google_not_connected": "Connect Google Drive before choosing it.",
      "storage_microsoft_not_connected": "Connect OneDrive first — use the button below.",
      "storage_s3_not_configured": "Our storage is not configured on this server.",
      "storage_provider_changed": "New documents will go to the selected storage.",
      "storage_provider_change_failed": "Could not change the storage.",
      "storage_load_failed": "Could not load storage information.",
      "storage_files_count_one": "{{count, number}} file",
      "storage_files_count_other": "{{count, number}} files",
      "storage_files_unknown_size_one": "size unknown for {{count}} file",
      "storage_files_unknown_size_other": "size unknown for {{count}} files",
      "finvalda_pass_keep_placeholder": "Leave empty to keep the current password",
      "finvalda_password_required": "If you change the address, user or company ID, enter the password again.",
      "finvalda_save_failed": "Could not save the Finvalda settings.",
      "finvaldaUser": "Finvalda user",
      "finvaldaPass": "Finvalda password",
      "finvaldaAddress": "Finvalda server address",
      "finvaldaCompanyId": "Company ID in Finvalda",
      "finvalda_sync_active": "Fetch data from Finvalda automatically",
      "finvalda_sync_active_hint": "Customers, products, invoices, payments and debts are fetched every 15 minutes.",
      settings_finvalda_sync_on: "Data updates automatically",
      settings_finvalda_sync_off: "Automatic fetching is off",
      settings_finvalda_last_sync: "Last successful update: {{when}}",
      settings_finvalda_never_synced: "none yet",
      settings_finvalda_check: "Check connection",
      settings_finvalda_checking: "Checking...",
      settings_finvalda_check_ok: "The connection to Finvalda works.",
      settings_finvalda_check_not_configured: "The Finvalda login is not saved yet. Fill it in below and save it.",
      settings_finvalda_check_access_denied: "Finvalda refused the login. Check the user, password and company ID.",
      settings_finvalda_check_timeout: "Finvalda did not answer within 10 seconds. Try again later.",
      settings_finvalda_check_unreachable: "Could not reach the Finvalda server. Check the address.",
      settings_finvalda_check_failed: "Could not check the connection. Try again.",
      settings_finvalda_save_connection_first: "Save the Finvalda login below first.",
      settings_finvalda_journal_group_label: "Sales journal group",
      settings_finvalda_journal_group_description: "The Finvalda journal group sales invoices are fetched from.",
      settings_finvalda_journal_group_hint: "Letters without accents, digits, spaces and . _ $ - , up to 40 characters, for example ERP.PARD.",
      settings_finvalda_journal_group_invalid: "The group code has characters that are not allowed.",
      settings_finvalda_connection_title: "Finvalda login",
      settings_finvalda_connection_lead: "The Finvalda administrator gives these details.",
      settings_finvalda_password_saved: "Entered",
      settings_finvalda_fields_required: "Fill in all the fields.",
      settings_finvalda_address_not_allowed: "This server address is not allowed: it must point to a public server.",
      "last_master_error": "The company must keep at least one administrator (Master).",
      "outlook_connect_by_employee_hint": "The employee connects their mailbox in their own profile.",
      "no_companies_yet": "No company yet",
      "no_companies_yet_hint": "Your account is active but is not linked to a company yet. Contact whoever set up your access.",
      "company_access_turned_off": "Your access to this company has been turned off.",
      "company_no_access": "You don't have access to this company.",
      "no_access_to_any_company": "You no longer have access to any company. If you think this is a mistake, contact your company administrator.",
      "companies_load_failed": "Could not load your companies",
      "companies_load_failed_hint": "The request did not go through. Try again, and if it keeps failing your session may have expired.",
      "try_again": "Try again",
      "customer_invoices_load_failed": "Could not load this customer's invoices. Existing invoices may be hidden — do not create a new one until the list loads.",
      // Invoice Inbox / purchase-document register.
      // NB no bare "invoice" key here: it is a shared label owned by the sales
      // screens (Invoices.tsx, customer-details.jsx). Defining it as "Document"
      // for this module silently relabelled those. Everything this module owns
      // is prefixed invoice_inbox_*.
      "approve": "Approve",
      "reject": "Reject",
      "invoice_inbox_confirming_account": "Confirming",
      "supplier": "Supplier",
      "iban": "IBAN",
      "amounts": "Amounts",
      "net": "Net",
      "approvals": "Approvals",
      "sender": "Sender",
      "invoice_inbox_upload": "Upload a document",
      "invoice_inbox_upload_failed": "The file was not accepted.",
      "settings": "Settings",
      "invoice_mailboxes": "Invoice mailboxes",
      "invoice_mailboxes_intro": "Mail arriving at these addresses becomes documents in the register. The address belongs to the company, not to you — everyone who manages the settings sees it.",
      "invoice_mailbox_load_failed": "Could not load the mailboxes.",
      "invoice_mailbox_forbidden": "You do not have the right to manage the invoice mailboxes.",
      "invoice_mailbox_start_delay": "Collection starts within a minute of saving. Only mail that arrives after that is collected — nothing already in the mailbox is pulled in.",
      "invoice_mailbox_add": "Add a mailbox",
      "invoice_mailbox_edit": "Mailbox settings",
      "invoice_mailbox_provider": "Provider",
      "invoice_mailbox_provider_other": "Other (IMAP)",
      "invoice_mailbox_imap_host": "IMAP server",
      "invoice_mailbox_imap_port": "IMAP port",
      "invoice_mailbox_folder": "Folder",
      "invoice_mailbox_folder_hint": "Leave empty to collect the whole inbox (INBOX). A mail-server rule can file invoices into a separate folder — only mail that arrives after the change is collected.",
      "invoice_mailbox_app_password": "App password",
      "invoice_mailbox_password_stored": "Saved — leave empty to keep it",
      "invoice_mailbox_app_password_help": "Not the account password: create an app-specific password in the mail provider's security settings.",
      "invoice_mailbox_ingest_mode": "Collect",
      "invoice_mailbox_ingest_all": "Every incoming message",
      "invoice_mailbox_ingest_label": "Only one label",
      "invoice_mailbox_label_name": "Label",
      "invoice_mailbox_active": "Collect mail from this address",
      "invoice_mailbox_test": "Test connection",
      "invoice_mailbox_test_ok": "The mailbox answered.",
      "invoice_mailbox_test_failed": "Could not sign in to the mailbox.",
      "invoice_mailbox_label_missing": "Signed in, but there is no such label — nothing would be collected.",
      "invoice_mailbox_folders_found": "The connection test found {{count}} folders — pick one from the list.",
      "invoice_mailbox_folder_missing": "Signed in, but there is no such folder — nothing would be collected.",
      "invoice_inbox_no_mailbox_connected": "No mailbox is connected — connect one in the settings.",
      "invoice_mailbox_check_now": "Check mail now",
      "invoice_mailbox_swept_new": "Checked — {{count}} new message(s).",
      "invoice_mailbox_swept_none": "Checked — no new mail.",
      "invoice_mailbox_busy": "A check is already running.",
      "invoice_mailbox_not_checked": "The mailbox was not checked ({{status}}).",
      "invoice_mailbox_stop": "Stop collecting",
      "invoice_mailbox_stop_confirm": "The saved password is erased and no new mail is collected. Everything already received stays in the register.",
      "invoice_mailbox_delete_confirm": "The mailbox is removed for good. Only possible while it has received nothing.",
      "invoice_mailbox_disabled": "Collection stopped.",
      "invoice_mailbox_deleted": "The mailbox was deleted.",
      "invoice_mailbox_has_messages": "This mailbox has already received mail — stop collection instead.",
      "invoice_mailbox_disconnect_first": "Stop collection before deleting the mailbox.",
      "invoice_mailbox_address_taken": "This address is already collected into the register.",
      "invoice_mailbox_password_required": "An app password is required.",
      "invoice_mailbox_password_required_address_change": "The address changed — enter the app password of the new account.",
      "invoice_mailbox_label_gmail_only": "Label mode works with Gmail only.",
      "invoice_mailbox_host_not_allowed": "This mail host is not allowed.",
      "invoice_mailbox_invalid_address": "Enter a valid email address.",
      "invoice_mailbox_invalid_folder": "Invalid folder name.",
      "invoice_mailbox_invalid_port": "Enter a port between 1 and 65535.",
      "invoice_mailbox_collecting": "Collecting",
      "invoice_mailbox_off": "Not collecting",
      "invoice_mailbox_error": "Error",
      "invoice_mailbox_lost": "{{count}} message(s) lost",
      "invoice_mailbox_silent": "Quiet for {{count}} day(s)",
      "invoice_mailbox_health": "State",
      "invoice_mailbox_also_desk": "This address is also collected into Desk — every invoice will become a task card as well.",
      "invoice_mailbox_lost_explained": "{{count}} message(s) arrived in the last {{days}} days and became no document. They are not in the register.",
      "invoice_mailbox_silent_explained": "Nothing has arrived for {{count}} day(s), which is unusual for this mailbox. A forwarding rule or an MX record may be broken upstream.",
      "invoice_mailbox_last_sync": "Last checked",
      "invoice_mailbox_last_received": "Last message",
      "invoice_mailbox_traffic": "Messages in {{days}} days",
      "invoice_inbox_empty_settings_link": "Set up the mailbox invoices are sent to",
      "invoice_inbox_enter_by_hand": "Enter by hand",
      "invoice_inbox_delete_reason": "Why is it being removed?",
      "invoice_inbox_delete_reason_help": "The document is kept and can be restored — this is what explains it to whoever looks later.",
      "invoice_inbox_confirm_delete": "Confirm removal",
      "invoice_inbox_block_sender": "Block sender",
      "invoice_inbox_blocked_notice": "Future mail from {{sender}} will not become documents. {{count}} invoice(s) have come from this sender before.",
      "invoice_inbox_doc_kind": "Document type",
      "invoice_inbox_credit_note_hint": "Stored as a negative amount — it reduces what we owe.",
      "invoice_inbox_field_unverified": "Could not be verified automatically",
      "invoice_inbox_changed_fields": "{{count}} field(s) changed",
      "invoice_inbox_edit_invalidates": "This document has already been approved by someone. Changing an amount, the account or the number withdraws those approvals — they described the document as it was.",
      "invoice_inbox_series": "Series",
      "invoice_inbox_kind_invoice": "Invoice",
      "invoice_inbox_kind_credit_note": "Credit note",
      "invoice_inbox_kind_debit_note": "Debit note",
      "invoice_inbox_kind_proforma": "Proforma",
      "invoice_inbox_kind_advance": "Advance invoice",
      "invoice_inbox_kind_statement": "Statement",
      "invoice_inbox_kind_receipt": "Receipt",
      "invoice_inbox_kind_not_a_document": "Not a document",
      "invoice_inbox": "Incoming invoices",
      "invoice_inbox_tab_needs_review": "To check",
      "invoice_inbox_tab_awaiting": "Awaiting approval",
      "invoice_inbox_tab_approved": "Approved",
      "invoice_inbox_tab_bookkept": "Entered",
      "invoice_inbox_waiting_for_me": "Waiting for you",
      "invoice_inbox_tab_rejected": "Rejected",
      "invoice_inbox_tab_all": "All",
      "invoice_inbox_tab_deleted": "Deleted",
      "invoice_inbox_actors_needs_review_approveAccountant": "Checks and sends for approval (accountant)",
      "invoice_inbox_actors_needs_review_verifyBankChange": "Confirms a changed bank account",
      "invoice_inbox_actors_awaiting_approval_approveManager": "Approves payment (manager)",
      "invoice_inbox_actors_awaiting_approval_approveAccountant": "Confirms the data (accountant)",
      "invoice_inbox_actors_approved_access": "Can mark as entered",
      "invoice_inbox_actors_bookkept_access": "Can mark as paid",
      "invoice_inbox_actors_rejected_approveAccountant": "Fixes and sends again (accountant)",
      "invoice_inbox_actors_all_access": "Can see the register",
      "invoice_inbox_actors_deleted_access": "Can restore",
      "invoice_inbox_actors_nobody": "Nobody holds the permission “{{permission}}”",
      "invoice_inbox_actors_assign": "Give it to someone in Permissions",
      "invoice_inbox_actors_not_activated": "not activated",
      "invoice_approvals_intro": "Purchase invoices waiting for your decision. Approving as manager means: we agree to pay.",
      "invoice_approvals_empty": "No invoices are waiting for your approval.",
      "invoice_approvals_load_failed": "Could not load the invoices waiting for you.",
      "invoice_approvals_role_manager": "Manager: agree to pay",
      "invoice_approvals_role_accountant": "Accountant: the data is correct",
      "invoice_approvals_col_supplier": "Supplier",
      "invoice_approvals_col_invoice": "Invoice",
      "invoice_approvals_col_due": "Due",
      "invoice_approvals_col_amount": "Amount",
      "invoice_approvals_col_role": "Your decision",
      "invoice_approvals_overdue": "Overdue",
      "invoice_approvals_bank_change": "Bank account changed",
      "invoice_approvals_duplicate": "Possible duplicate",
      "invoice_approvals_open": "Open",
      "invoice_approvals_approve": "Approve",
      "invoice_approvals_approve_confirm": "Approve invoice {{number}} from {{supplier}} for {{amount}}?",
      "invoice_approvals_reject": "Reject",
      "invoice_approvals_reject_reason": "Reason for rejection",
      "invoice_approvals_reject_confirm": "Confirm rejection",
      "invoice_approvals_cancel": "Cancel",
      "invoice_approvals_go_register": "Go to the register",
      "header_my_work_title": "Tasks: {{count}} waiting",
      "invoice_inbox_col_preview": "File",
      "invoice_inbox_preview": "Preview the file",
      "invoice_inbox_preview_open_doc": "Open the document",
      "invoice_inbox_preview_open_file": "Open the file separately",
      "invoice_inbox_preview_unsupported": "This file type cannot be shown in the browser.",
      "invoice_inbox_col_supplier": "Supplier",
      "invoice_inbox_col_invoice_number": "Invoice no.",
      "invoice_inbox_col_date": "Date",
      "invoice_inbox_col_due": "Due",
      "invoice_inbox_col_status": "Status",
      "invoice_inbox_status_new": "New",
      "invoice_inbox_status_needs_review": "To check",
      "invoice_inbox_status_awaiting_approval": "Awaiting approval",
      "invoice_inbox_status_approved": "Approved",
      "invoice_inbox_status_rejected": "Rejected",
      "invoice_inbox_status_exported": "Handed over",
      "invoice_inbox_flag_bank_change": "Bank account changed",
      "invoice_inbox_flag_suspicious": "Suspicious content",
      "invoice_inbox_flag_duplicate": "Possible duplicate",
      "invoice_inbox_unknown_supplier": "Not recognised",
      "invoice_inbox_supplier_unresolved": "not linked",
      "invoice_inbox_search_placeholder": "Supplier, invoice number, file name…",
      "invoice_inbox_filter_flags": "Only show",
      "invoice_inbox_empty": "No documents here yet",
      "invoice_inbox_empty_hint": "Invoices sent to the company mailbox appear here within a few minutes. You can also upload one by hand.",
      "invoice_inbox_empty_filtered": "Nothing matches these filters",
      "invoice_inbox_empty_filtered_hint": "Clear the filters to see the rest of the register.",
      "invoice_inbox_load_doc_failed": "Could not open this document.",
      "invoice_inbox_refresh_failed": "Could not refresh the document. Reload the page.",
      "invoice_inbox_action_failed": "The action did not go through.",
      "invoice_inbox_banner_suspicious": "This document contains text addressed to the reader. Treat its contents with suspicion.",
      "invoice_inbox_banner_bank": "The bank account on this invoice is not one we have confirmed for this supplier. Call them on a number from your own records — not one printed here — before it goes any further.",
      "invoice_inbox_banner_entity": "This invoice is addressed to a different company in the group.",
      "invoice_inbox_banner_duplicate": "Possibly the same as",
      "invoice_inbox_reextract": "Read it again",
      "invoice_inbox_reextract_queued": "Reading it again — the fields will appear here shortly.",
      "invoice_inbox_banner_unread": "This document could not be read automatically. The file is here — the fields can be filled in by hand.",
      "invoice_inbox_previous_account": "Previously used",
      "invoice_inbox_verify_note": "Who did you speak to, and on which number?",
      "invoice_inbox_confirm_account": "Confirm this account",
      "invoice_inbox_cannot_dispatch": "Before this can go for approval:",
      "invoice_inbox_blocker_supplier_unresolved": "the supplier is not linked yet",
      "invoice_inbox_blocker_bank_change_unverified": "the bank account has not been confirmed",
      "invoice_inbox_blocker_no_amount": "there is no total",
      "invoice_inbox_blocker_not_read_yet": "the document has not been read yet",
      "invoice_inbox_blocker_wrong_status": "the document is not in a state to be sent",
      "invoice_inbox_blocker_deleted": "the document is deleted",
      "invoice_inbox_refusal_verifier_edited_the_iban": "Someone else has to confirm this account: you are the one who entered this IBAN.",
      "invoice_inbox_refusal_verifier_is_an_approver": "Someone else has to confirm this account: you are an approver of the invoice it holds up.",
      "invoice_inbox_refusal_manager_lacks_permission": "The person who would approve the payment has no right to approve invoices (permission “Approve invoices as manager”).",
      "invoice_inbox_refusal_accountant_lacks_permission": "The accountant has no right to approve invoices (permission “Approve invoices as accountant”).",
      "invoice_inbox_refusal_missing_approver": "No approver could be found for this document.",
      "invoice_inbox_refusal_same_person_both_slots": "The accountant and the payment approver are the same person — two different people must approve.",
      "invoice_inbox_refusal_dispatcher_would_approve_alone": "You would be the only approver of a document you sent — someone else has to approve it too.",
      "invoice_inbox_refusal_DUPLICATE_FILE": "This file is already attached",
      "invoice_inbox_refusal_FILE_IS_SIGNED": "A signed file cannot be removed.",
      "invoice_inbox_refusal_ATTACHMENT_REFUSED": "This file cannot be attached — use a PDF or an image (JPG, PNG, TIFF).",
      // The attachment filter's own reason codes (attachment-filter.js) —
      // add-file.js sends the reason itself as `code`, not ATTACHMENT_REFUSED.
      "invoice_inbox_refusal_refused_type": "This file type is not accepted for security reasons",
      "invoice_inbox_refusal_inline_image": "A small picture pasted into the email body (logo or signature), not a document",
      "invoice_inbox_refusal_decorative_name": "The file looks like a logo or signature image, not a document",
      "invoice_inbox_refusal_unsupported_type": "Only PDF and image files are accepted",
      "invoice_inbox_refusal_no_extension": "The file has no file extension, so its type cannot be recognized",
      "invoice_inbox_refusal_unsupported_mime": "The file's content does not match a supported type",
      "invoice_inbox_refusal_too_large": "The file is larger than 25 MB",
      "invoice_inbox_refusal_too_small": "The image is too small to be a real document",
      "invoice_inbox_refusal_over_limit": "More than 20 attachments in one email; the rest were not processed",
      "invoice_inbox_refusal_DOC_DELETED": "The document is deleted.",
      "invoice_inbox_refusal_SOURCE_NOT_MERGEABLE": "Only a document that has not been sent for approval can be attached to another",
      "invoice_inbox_refusal_TARGET_DELETED": "The chosen document is deleted",
      "invoice_inbox_refusal_TARGET_NOT_FOUND": "The chosen document was not found",
      "invoice_inbox_refusal_SAME_DOC": "A document cannot be attached to itself",
      "invoice_inbox_refusal_TARGET_REQUIRED": "Choose the document to attach to",
      "invoice_inbox_role_accountant": "Accountant — data is correct",
      "invoice_inbox_role_manager": "Approved — agreed to pay",
      "invoice_inbox_decision_pending": "Waiting",
      "invoice_inbox_decision_approved": "Approved",
      "invoice_inbox_decision_rejected": "Rejected",
      "invoice_inbox_decision_invalidated": "No longer counts",
      "invoice_inbox_delegated": "delegated (on leave)",
      "invoice_inbox_trail_title": "Who did what",
      "invoice_inbox_trail_dispatched": "Checked and sent for approval",
      "invoice_inbox_trail_sent_voided": "Sending was recalled or the data changed",
      "invoice_inbox_trail_bookkept": "Entered into accounting",
      "invoice_inbox_trail_marked_paid": "Marked as paid",
      "invoice_inbox_trail_paid_by_import": "Payment import",
      "invoice_inbox_trail_paid_auto": "Marked automatically: this supplier's invoices arrive paid",
      "invoice_inbox_trail_waiting_for": "Waiting for {{name}}",
      "invoice_inbox_trail_rejected_by": "Rejected: {{name}}",
      "invoice_inbox_trail_delegated_from": "standing in for {{name}} (on leave)",
      "invoice_inbox_send_for_approval": "Send for approval",
      "invoice_inbox_bulk_mark_bookkept": "Mark entered",
      "invoice_inbox_bulk_mark_not_bookkept": "Mark not entered",
      "invoice_inbox_bulk_mark_paid": "Mark as paid",
      "invoice_inbox_bulk_nothing_applies": "No common action applies to the selected documents.",
      "invoice_inbox_bulk_confirm": "{{action}}: {{count}} document(s)?",
      "invoice_inbox_bulk_flagged_not_approved": "{{count}} with a red warning — approve those from the document itself.",
      "invoice_inbox_bulk_done": "Done: {{count}} document(s).",
      "invoice_inbox_bulk_partial": "Done: {{done}}. Did not go through: {{failed}} —",
      "invoice_inbox_bulk_error_missing_approver": "no approver could be found (company settings)",
      "invoice_inbox_bulk_error_same_person_both_slots": "the accountant and the manager are the same person",
      "invoice_inbox_bulk_error_dispatcher_would_approve_alone": "you would be the only approver of a document you sent",
      "invoice_inbox_bulk_error_accountant_lacks_permission": "the accountant has no right to approve",
      "invoice_inbox_bulk_error_manager_lacks_permission": "the manager has no right to approve",
      "invoice_inbox_bulk_error_NOT_YOUR_DECISION": "it is not waiting for your approval",
      "invoice_inbox_bulk_error_NOT_AWAITING_APPROVAL": "it is no longer awaiting approval",
      "invoice_inbox_bulk_error_MISSING_APPROVAL_PERMISSION": "you no longer have the right to approve",
      "invoice_inbox_bulk_error_DOCUMENT_CHANGED": "the document changed after it was sent — send it again",
      "invoice_inbox_bulk_error_ALREADY_EXPORTED": "already handed over to accounting",
      "invoice_inbox_bulk_error_DOC_DELETED": "the document is deleted",
      "invoice_inbox_bulk_error_DOC_NOT_FOUND": "the document was not found",
      "invoice_inbox_bulk_error_EMPLOYEE_NOT_IN_COMPANY": "that person is not an employee of this company",
      "invoice_inbox_bulk_error_EMPLOYEE_REQUIRED": "no employee was chosen",
      "invoice_inbox_recall": "Recall",
      "invoice_inbox_reject_reason": "Why is it being rejected?",
      "invoice_inbox_reject_reason_help": "The accountant sees this — without it they cannot tell what to fix.",
      "invoice_inbox_confirm_reject": "Confirm rejection",
      "invoice_inbox_no_notes": "No notes yet.",
      "invoice_inbox_note_placeholder": "Paid in advance, waiting for the delivery note…",
      "invoice_inbox_add_note": "Add note",
      "invoice_inbox_needs_check": "Fields marked in amber could not be verified automatically — please check them.",
      "invoice_inbox_file_pending": "The file is still being filed away — reload in a moment.",
      "invoice_inbox_files": "Files",
      "invoice_inbox_file_primary": "Document",
      "invoice_inbox_file_add": "Add file",
      "invoice_inbox_file_added": "File added",
      "invoice_inbox_file_remove": "Remove file",
      "invoice_inbox_file_remove_confirm": "Remove the file {{name}} from this document?",
      "invoice_inbox_file_removed": "File removed",
      "invoice_inbox_file_download": "Download",
      "invoice_inbox_file_signed": "Signed",
      "invoice_inbox_file_uploaded_by": "Added by {{name}}, {{date}}",
      "invoice_inbox_file_cannot_preview": "This file cannot be shown here — download it.",
      "invoice_inbox_merge": "Attach to another document",
      "invoice_inbox_merge_hint": "An invoice and its work act sent in one email arrive as two rows. Find the document this one belongs to.",
      "invoice_inbox_merge_search": "Search documents",
      "invoice_inbox_merge_no_results": "Nothing found",
      "invoice_inbox_merge_confirm_text": "This document will be attached to №{{number}} as additional files and disappear from the register.",
      "invoice_inbox_merge_done": "Attached to №{{number}}",
      "invoice_inbox_signatures_title": "Signatures",
      "invoice_inbox_signature_awaiting_me": "Awaiting your signature",
      "invoice_inbox_sign_none": "No signatures have been requested.",
      "invoice_inbox_sign_request": "Request signature",
      "invoice_inbox_sign_request_deleted": "The document is deleted — restore it to ask for signatures.",
      "invoice_inbox_sign_state_pending": "Signing in progress",
      "invoice_inbox_sign_state_rejected": "Declined",
      "invoice_inbox_sign_type_Dokobit": "Dokobit (qualified e-signature)",
      "invoice_inbox_sign_type_Click": "Click (signed in the ERP)",
      "invoice_inbox_sign_ref_employee": "Employee",
      "invoice_inbox_sign_ref_contact": "Supplier contact",
      "invoice_inbox_sign_now": "Sign",
      "invoice_inbox_sign_cancel": "Cancel signing",
      "invoice_inbox_sign_cancel_confirm": "Cancel the signing of {{name}}? Those who have not signed yet will no longer be asked.",
      "invoice_inbox_sign_cancelled": "Signing cancelled",
      "invoice_inbox_cancel_signing_cancel_signing_forbidden": "Only the person who requested it or a Master can cancel",
      "invoice_inbox_cancel_signing_nothing_to_cancel": "Nothing is waiting for a signature any more.",
      "invoice_inbox_sign_which_file": "Which file",
      "invoice_inbox_sign_how": "Signature type",
      "invoice_inbox_sign_file_already_signed": "already signed",
      "invoice_inbox_sign_file_in_progress": "signing in progress",
      "invoice_inbox_sign_file_not_pdf": "not a PDF — only a PDF can be signed",
      "invoice_inbox_sign_file_not_ready": "the file is still being filed away",
      "invoice_inbox_sign_type_dokobit_hint": "qualified e-signature — employees and supplier contacts",
      "invoice_inbox_sign_type_click_hint": "simple signature inside the ERP — employees only",
      "invoice_inbox_sign_dokobit_unavailable": "Dokobit is not set up for this company",
      "invoice_inbox_sign_click_unavailable": "Click signing is not available for this company",
      "invoice_inbox_sign_employees": "Employees",
      "invoice_inbox_sign_supplier_contacts": "Supplier contacts",
      "invoice_inbox_sign_no_supplier": "Link the supplier first to ask its contacts",
      "invoice_inbox_sign_send": "Send request",
      "invoice_inbox_sign_request_sent": "Signature request sent",
      "invoice_inbox_sign_selected_count": "Selected: {{count}}",
      "invoice_inbox_sign_search_employees": "Search employees",
      "invoice_inbox_refusal_FILE_NOT_FOUND": "This file is no longer attached to the document.",
      "invoice_inbox_refusal_FILE_NOT_AVAILABLE": "The file is not stored yet — try again in a moment.",
      "invoice_inbox_refusal_NOT_A_PDF": "Only a PDF file can be signed.",
      "invoice_inbox_refusal_INVALID_SIGN_TYPE": "Choose Dokobit or Click.",
      "invoice_inbox_refusal_NO_SIGNERS": "Choose at least one person to sign.",
      "invoice_inbox_refusal_CLICK_USERS_ONLY": "Click signing is for employees only — ask the supplier's contacts through Dokobit.",
      "invoice_inbox_refusal_USER_NOT_MEMBER": "One of the chosen people is not an employee of this company.",
      "invoice_inbox_refusal_SUPPLIER_REQUIRED": "Link the supplier first to ask its contacts.",
      "invoice_inbox_refusal_CONTACT_NOT_SUPPLIER": "One of the chosen contacts does not belong to this document's supplier.",
      "invoice_inbox_refusal_ALREADY_SIGNED": "This file is already signed.",
      "invoice_inbox_refusal_DOCUMENT_ANNULLED": "The file has been annulled and cannot be signed.",
      "invoice_inbox_refusal_SIGNING_IN_PROGRESS": "Signatures for this file have already been requested — cancel that request first.",
      "invoice_inbox_refusal_PREVIOUS_REQUEST_OPEN": "An earlier signature request on this file is still open (declined or unfinished) — cancel it first.",
      "invoice_inbox_refusal_FILE_SIGNING_IN_PROGRESS": "This file is out for signing and cannot be removed — cancel the signing first.",
      "invoice_inbox_refusal_SOURCE_SIGNING_IN_PROGRESS": "A file of this document is out for signing — cancel the signing before attaching it elsewhere.",
      "invoice_inbox_refusal_CONTACT_NO_EMAIL": "A chosen contact has no e-mail address or name — add it on the supplier's card first.",
      "invoice_inbox_refusal_MERGED_INTO": "This document was attached to another one and cannot be restored on its own.",
      "invoice_inbox_blocker_state_changed": "the document changed meanwhile — reload and try again",
      "invoice_inbox_refusal_DOKOBIT_NOT_CONFIGURED": "Dokobit is not set up for this company.",
      "invoice_inbox_refusal_DOKOBIT_FAILED": "Dokobit did not accept the request — try again later.",
      "invoice_inbox_suggestion_label": "Read from the document",
      "invoice_inbox_suggestion_accept": "Accept",
      "invoice_inbox_suggestion_reason_not_grounded": "not found in the document's text (may be part of an image)",
      "invoice_inbox_suggestion_reason_arithmetic": "does not add up with the other amounts",
      "invoice_inbox_suggestion_reason_amount_unparsed": "number format unclear",
      "invoice_inbox_suggestion_reason_default": "not confirmed",
      // Month handover (Invoice Inbox tree view): group the register by
      // accounting period so a month can be checked off and handed to
      // accounting as a batch, instead of paging through the flat register.
      "invoice_inbox_flag_not_entered": "Not entered into accounting yet",
      "invoice_inbox_col_bookkept": "Entered",
      "invoice_inbox_bookkept_toggle_on": "Entered — click to undo",
      "invoice_inbox_bookkept_toggle_off": "Mark as entered",
      "invoice_inbox_col_payment": "Payment",
      "invoice_inbox_paid_toggle_on": "Paid — click to undo",
      "invoice_inbox_paid_toggle_on_by": "Paid — marked by {{name}}, {{date}}. Click to undo",
      "invoice_inbox_paid_toggle_import": "Paid — from the payment import",
      "invoice_inbox_paid_toggle_off": "Mark as paid",
      "invoice_inbox_period_unassigned": "Period not determined",
      "invoice_inbox_period_docs_count": "{{count}} document(s)",
      "invoice_inbox_period_tab_count": "{{tab}}: {{count}}",
      "invoice_inbox_period_entered_of": "Entered {{entered}} of {{total}}",
      "invoice_inbox_period_missing_amounts": "No net / VAT amounts: {{count}} doc.",
      "invoice_inbox_period_month_total": "This month in total {{count}}:",
      "invoice_inbox_period_month_total_currency": "Month total, {{currency}}",
      "invoice_inbox_period_year_docs": "{{count}} doc.",
      "invoice_inbox_period_total_eur": "All in EUR",
      "invoice_inbox_period_unconverted": "without a rate yet, not included: {{count}}",
      "invoice_inbox_fx_pending_short": "EUR: no rate yet",
      "invoice_inbox_fx_rate_line": "Rate 1 EUR = {{rate}} {{currency}} on {{date}}",
      "invoice_inbox_fx_source_lb": "Bank of Lithuania",
      "invoice_inbox_fx_source_manual": "entered manually",
      "invoice_inbox_fx_pending": "The Bank of Lithuania has not published the rate for the invoice date yet — the EUR amounts will be filled in automatically.",
      "invoice_inbox_fx_no_date": "Enter the invoice date to convert the amounts to EUR.",
      "invoice_inbox_fx_rate_field": "Exchange rate (1 EUR = …)",
      "invoice_inbox_pvm_code": "VAT code",
      "invoice_inbox_pvm_auto": "Automatic",
      "invoice_inbox_pvm_saved": "VAT code saved",
      "invoice_inbox_pvm_save_failed": "Could not save the VAT code",
      "invoice_inbox_supply_kind": "Goods or services",
      "invoice_inbox_supply_kind_unset": "Not set",
      "invoice_inbox_supply_kind_goods": "Goods",
      "invoice_inbox_supply_kind_services": "Services",
      "invoice_inbox_supply_kind_mixed": "Goods and services",
      "invoice_inbox_pvm_reason_lt_standard": "Lithuanian VAT payer, rate as invoiced",
      "invoice_inbox_pvm_reason_lt_rate_no_vat_code": "Supplier VAT code not read – check",
      "invoice_inbox_pvm_reason_lt_reverse_charge": "Domestic reverse charge (art. 96)",
      "invoice_inbox_pvm_reason_lt_exempt": "VAT-exempt supply",
      "invoice_inbox_pvm_reason_lt_zero_rated": "0% from a Lithuanian supplier – check the basis",
      "invoice_inbox_pvm_reason_lt_farmer_compensation": "Farmers' 6% flat-rate compensation",
      "invoice_inbox_pvm_reason_lt_outside_scope": "Outside the scope of VAT – check",
      "invoice_inbox_pvm_reason_lt_not_vat_payer": "Supplier has no VAT code – not a VAT invoice?",
      "invoice_inbox_pvm_reason_eu_goods_acquisition": "Acquisition of goods from an EU VAT payer",
      "invoice_inbox_pvm_reason_eu_services_reverse_charge": "Services from an EU VAT payer, buyer accounts for VAT",
      "invoice_inbox_pvm_reason_eu_supply_kind_unknown": "EU supplier – unclear whether goods or services",
      "invoice_inbox_pvm_reason_eu_goods_services_conflict": "Marked as goods by the seller but as services here – check",
      "invoice_inbox_pvm_reason_eu_exempt_services": "VAT-exempt services from the EU – check",
      "invoice_inbox_pvm_reason_eu_foreign_vat_charged": "Foreign VAT charged on the invoice",
      "invoice_inbox_pvm_reason_eu_lt_rate_vat_charged": "EU supplier charged a Lithuanian-looking VAT rate – check",
      "invoice_inbox_pvm_reason_eu_outside_scope": "Outside the scope of VAT (EU supplier) – check",
      "invoice_inbox_pvm_reason_foreign_goods_import": "Goods from a third country (import)",
      "invoice_inbox_pvm_reason_foreign_services_reverse_charge": "Services from outside the EU, buyer accounts for VAT",
      "invoice_inbox_pvm_reason_foreign_supply_kind_unknown": "Non-EU supplier – unclear whether goods or services",
      "invoice_inbox_pvm_reason_foreign_exempt_services": "VAT-exempt services from outside the EU – check",
      "invoice_inbox_pvm_reason_foreign_vat_charged": "Foreign VAT charged on the invoice",
      "invoice_inbox_pvm_reason_foreign_outside_scope": "Outside the scope of VAT (non-EU supplier) – check",
      "invoice_inbox_pvm_reason_supplier_origin_unknown": "Supplier country unknown – set the code",
      "invoice_inbox_pvm_reason_not_an_invoice": "Not a VAT invoice",
      "invoice_inbox_pvm_reason_unmapped": "Combination not recognised – set the code",
      "invoice_inbox_pvm_reason_rate_unknown": "Unusual rate – set the code",
      "invoice_inbox_pvm_reason_supplier_learned": "From an earlier choice for this supplier",
      "invoice_inbox_pvm_reason_foreign_lt_rate_vat_charged": "Non-EU supplier charged a Lithuanian-looking VAT rate – check",
      "invoice_inbox_pvm_reason_eu_zero_rated_services": "0% services from the EU – check the basis",
      "invoice_inbox_pvm_reason_foreign_zero_rated_services": "0% services from outside the EU – check the basis",
      "invoice_inbox_pvm_reason_supplier_learned_mismatch": "The earlier code for this supplier does not fit this line – check",
      "invoice_inbox_pvm_reason_model_suggested": "Suggested by the document reader – check",
      "invoice_inbox_pvm_reason_model_disagrees": "The document reader suggests {{code}} – check",
      "invoice_inbox_pvm_reason_manual": "Set manually",
      "pvm_code_PVM1": "21% – goods/services in Lithuania",
      "pvm_code_PVM2": "9% – goods/services in Lithuania",
      "pvm_code_PVM3": "5% – goods/services in Lithuania",
      "pvm_code_PVM58": "12% – services in Lithuania (from 2026)",
      "pvm_code_PVM5": "VAT-exempt (VAT Act art. 20–33)",
      "pvm_code_PVM14": "0% – other transactions (VAT Act art. 42–53)",
      "pvm_code_PVM25": "21% – domestic reverse charge (VAT Act art. 96)",
      "pvm_code_PVM26": "9% – domestic reverse charge (VAT Act art. 96)",
      "pvm_code_PVM27": "5% – domestic reverse charge (VAT Act art. 96)",
      "pvm_code_PVM16": "21% – acquisition of goods from the EU",
      "pvm_code_PVM17": "9% – acquisition of goods from the EU",
      "pvm_code_PVM18": "5% – acquisition of goods from the EU",
      "pvm_code_PVM35": "0% – acquisition of goods from the EU",
      "pvm_code_PVM36": "VAT-exempt acquisition of goods from the EU",
      "pvm_code_PVM19": "Triangular trade (intermediary)",
      "pvm_code_PVM21": "21% – services from the EU (reverse charge)",
      "pvm_code_PVM40": "5% – services from the EU (reverse charge)",
      "pvm_code_PVM57": "9% – services from the EU (reverse charge)",
      "pvm_code_PVM41": "0% – services from the EU",
      "pvm_code_PVM42": "VAT-exempt services from the EU",
      "pvm_code_PVM20": "21% – services from outside the EU (reverse charge)",
      "pvm_code_PVM37": "5% – services from outside the EU (reverse charge)",
      "pvm_code_PVM54": "9% – services from outside the EU (reverse charge)",
      "pvm_code_PVM38": "0% – services from outside the EU",
      "pvm_code_PVM39": "VAT-exempt services from outside the EU",
      "pvm_code_PVM43": "21% – foreign supplier in Lithuania (VAT Act art. 95(3–5))",
      "pvm_code_PVM44": "9% – foreign supplier in Lithuania (VAT Act art. 95(3–5))",
      "pvm_code_PVM45": "5% – foreign supplier in Lithuania (VAT Act art. 95(3–5))",
      "pvm_code_PVM60": "12% – foreign supplier in Lithuania (VAT Act art. 95(5))",
      "pvm_code_PVM46": "0% – foreign supplier in Lithuania",
      "pvm_code_PVM47": "VAT-exempt – foreign supplier in Lithuania",
      "pvm_code_PVM48": "Acquired outside Lithuania (foreign VAT, imports, hotels abroad)",
      "pvm_code_PVM32": "21% – margin scheme",
      "pvm_code_PVM52": "9% – margin scheme",
      "pvm_code_PVM53": "5% – margin scheme",
      "pvm_code_PVM33": "0% – margin scheme",
      "pvm_code_PVM49": "6% – farmers' flat-rate compensation",
      "pvm_code_PVM51": "0% – VAT Act art. 19(5)",
      "pvm_code_PVM55": "0% – aid to disaster victims (VAT Act art. 50¹)",
      "pvm_code_PVM56": "Aid to disaster victims – acquisition from the EU",
      "pvm_code_PVM23": "Import VAT paid (not in i.SAF)",
      "pvm_code_PVM24": "Import VAT deducted through the tax authority (not in i.SAF)",
      "pvm_code_PVM100": "Other cases (fines, penalties, fees, SME scheme)",
      "invoice_inbox_fx_rate_help": "Leave empty to use the Bank of Lithuania rate for the invoice date. Fill in only to override it.",
      "invoice_inbox_period_download": "Download the month",
      "invoice_inbox_period_register_pdf": "PDF list",
      "invoice_inbox_period_load_failed": "Could not load the periods. Nothing has been lost — try again.",
      "invoice_inbox_period_docs_load_failed": "Could not load this month's documents.",
      "invoice_inbox_export_too_many": "This month has {{count}} documents — more than one download can package at once (limit {{limit}}). Narrow the date range, or download it in smaller parts.",
      "invoice_inbox_export_too_large": "This month's files total more than one download can package at once (limit {{limit}} MB). Narrow the date range, or download it in smaller parts.",
      "invoice_inbox_export_invalid_period": "This period could not be exported.",
      "invoice_inbox_export_failed": "Could not prepare the download. Try again.",
      "invoice_inbox_supplier_unlinked": "This supplier is not linked to a customer card yet.",
      "invoice_inbox_create_supplier": "Create supplier",
      "invoice_inbox_supplier_form_title": "Create or link the supplier",
      "invoice_inbox_supplier_legal_form": "Legal form",
      "invoice_inbox_supplier_vat_payer": "VAT payer",
      "invoice_inbox_supplier_bank_name": "Bank",
      "invoice_inbox_supplier_iban_note": "Saved with the supplier — a new bank account still has to be confirmed separately before this document can be paid.",
      "invoice_inbox_supplier_submit": "Create and link",
      "invoice_inbox_supplier_conflict": "This counterparty is already on file",
      "invoice_inbox_supplier_link_it": "Link it",
      "invoice_inbox_supplier_unlink": "Wrong supplier? Unlink",
      "invoice_inbox_supplier_unlink_confirm": "Unlink this supplier? Invoices with this supplier name will no longer be linked to it automatically.",
      "invoice_inbox_supplier_unlink_yes": "Unlink",
      "invoice_inbox_supplier_iban_warning": "The account on this document is not on that customer's card yet.",
      "invoice_inbox_supplier_iban_ignore": "Leave the card as it is",
      "invoice_inbox_supplier_iban_add": "Add this account",
      "invoice_inbox_supplier_iban_replace": "Make it the primary account",
      "invoice_inbox_supplier_doc_deleted": "This document has been removed.",
      "invoice_inbox_supplier_already_linked": "This document already has a linked supplier.",
      "invoice_inbox_supplier_matched_vat_code": "Matched by this counterparty's VAT code.",
      "invoice_inbox_supplier_matched_document_vat_code": "Matched by the VAT code on this document.",
      "invoice_inbox_supplier_matched_company_code": "Matched by its company code.",
      "invoice_inbox_supplier_primary_bank_hint": "This customer's contracts and orders print the primary account's bank — the new account is usually at a different bank, so confirm or retype it below.",
      "invoice_inbox_supplier_bank_details_required": "Making this account primary would erase the bank name and SWIFT code printed on this customer's contracts and orders — enter them to confirm, or pick a different option above.",
      "invoice_inbox_supplier_too_many_accounts": "This customer already has the maximum of 20 bank accounts on file — nothing was changed.",
      "invoice_inbox_payment_source_title": "How this was paid",
      "invoice_inbox_payment_card": "Payment",
      "invoice_inbox_document_card": "Document",
      "invoice_inbox_more_actions": "More actions",
      "invoice_inbox_sender_auth_title": "Sender (DKIM/SPF)",
      "invoice_inbox_sender_passed": "Verified",
      "invoice_inbox_sender_partly_checked": "Partly checked",
      "invoice_inbox_sender_check": "Check",
      "invoice_inbox_payment_source_unset": "Not stated",
      "invoice_inbox_payment_source_company": "Paid from the company account",
      "invoice_inbox_payment_source_employee": "Paid by an employee",
      "invoice_inbox_payment_source_employee_picker": "Which employee?",
      "invoice_inbox_payment_source_current_employee": "Currently marked as paid by {{name}} — the company owes them back.",
      "invoice_inbox_payment_source_company_short": "Company",
      "invoice_inbox_marked_paid_label": "Paid",
      "invoice_inbox_marked_paid_by": "Marked paid by {{name}}, {{date}}",
      "invoice_inbox_marked_paid_auto": "Marked automatically: this supplier's invoices arrive paid, {{date}}",
      "invoice_inbox_filter_payment_source": "Paid by",
      "invoice_inbox_supplier_invoices_arrive_paid": "Invoices from this supplier arrive already paid",
      "invoice_inbox_supplier_invoices_arrive_paid_help": "Changes how invoices from this supplier are approved from now on — the manager's approval step is skipped, the accountant's check still applies. Documents already in the register are not affected.",
      "invoice_inbox_supplier_create_arrive_paid_help": "From now on the manager's approval step is skipped for this supplier's invoices — the accountant's check still applies.",
      "invoice_inbox_supplier_settings_permission_required": "Setting that invoices arrive paid needs the invoice inbox settings right.",
      "invoice_inbox_supplier_expects_monthly": "This supplier invoices every month",
      "invoice_inbox_supplier_expects_monthly_help": "The register will warn when a month's invoice from this supplier has not arrived by the day it usually comes.",
      "invoice_inbox_expectations_title": "Monthly invoices that have not arrived ({{count}})",
      "invoice_inbox_expectations_intro": "These suppliers invoice every month, but the invoice for the month shown is past the day it usually arrives and is not in the register.",
      "invoice_inbox_expectations_unnamed_supplier": "Unnamed supplier",
      "invoice_inbox_expectations_expected_by": "expected by {{date}}",
      "invoice_inbox_expectations_last_seen": "last invoice was for {{period}}",
      "invoice_inbox_expectations_waive": "No invoice for this month",
      "invoice_inbox_expectations_waive_explain": "Only this month ({{period}}) is dismissed for this supplier. The supplier stays marked as invoicing every month, and the following months are checked as usual.",
      "invoice_inbox_expectations_note": "Note (optional)",
      "invoice_inbox_expectations_note_placeholder": "e.g. the service was paused that month",
      "invoice_inbox_expectations_waive_confirm": "Dismiss this month",
      "invoice_inbox_expectations_waived": "{{supplier}}, {{period}}: no invoice expected.",
      "invoice_inbox_expectations_undo": "Undo",
      "invoice_inbox_expectations_restored": "{{supplier}}, {{period}}: the invoice is expected again.",
      "invoice_inbox_expectations_month_summary": "Monthly invoices expected: {{expected}} · received {{received}}",
      "invoice_inbox_expectations_chip_pending": "{{supplier}} (expected by {{date}})",
      "invoice_inbox_expectations_chip_missing": "{{supplier}} — overdue (due by {{date}})",
      "invoice_inbox_expectations_waived_count": "not expected: {{count}}",
      "invoice_inbox_mail_without_documents_summary": "Mail without a document in the last {{days}} days: {{count}}",
      "invoice_inbox_mail_without_documents_show": "Show",
      "invoice_inbox_mail_without_documents_hide": "Hide",
      "invoice_inbox_mail_without_documents_no_subject": "(no subject)",
      "invoice_inbox_mail_without_documents_unknown_sender": "(unknown sender)",
      "invoice_inbox_mail_without_documents_why_blocked": "Blocked by a sender rule",
      "invoice_inbox_mail_without_documents_why_quarantined": "Held by a sender rule",
      "invoice_inbox_mail_without_documents_why_no_attachments": "The email has no attachments",
      "invoice_inbox_mail_without_documents_why_auto_mail": "Automatic reply or delivery report, no attachments",
      "invoice_inbox_mail_without_documents_why_attachments_rejected": "Attachments were not accepted:",
      "invoice_inbox_mail_without_documents_why_processing_failed": "The attachments were accepted, but the document could not be created (processing error)",
      "invoice_inbox_mail_without_documents_reason_unknown": "The reason was not recorded (older mail)",
      "invoice_inbox_mail_without_documents_shown_of_total": "Showing the latest {{shown}} of {{total}}",
      "invoice_inbox_mail_without_documents_hint": "A file that was not accepted can be uploaded to the register by hand.",
      "not_checked": "not checked",
      // mobile: cabinet-tasks
      training_open_pdf: "Open PDF",
      training_submit_unanswered: "{{count}} question(s) unanswered. Submit the test anyway?",
      training_submit_all_answered: "All questions are answered. Submit the test?",
      assistant_settings_hint: "Each company uses its own Anthropic API key — usage is billed to this company.",
      assistant_settings_used_by:
        "Used by: Invoice inbox (recognising invoices), Procedures (training questions).",
      assistant_api_key: "Anthropic API key",
      assistant_api_key_stored: "A key is saved. Leave this field as-is to keep it, or paste a new one to replace it.",
      assistant_api_key_empty: "No key saved yet — the assistant stays off until one is added.",
      assistant_model_default: "Default (Sonnet 5)",
      assistant_model_sonnet: "Sonnet 5 — balanced speed and cost (recommended)",
      assistant_model_opus: "Opus 5 — strongest reasoning, slower and pricier",
      assistant_model_haiku: "Haiku 4.5 — fastest and cheapest, simpler answers",
      assistant_model: "Model",
      assistant_settings_load_failed: "Could not load assistant settings",
      assistant_settings_save_failed: "Could not save assistant settings",
      assistant_title: "Tomas",
      assistant_placeholder: "Ask Tomas…",
      assistant_intro: "Ask me to find a record, or why the system won't let you do something.",
      assistant_thinking: "Thinking…",
      assistant_searching: "Searching…",
      assistant_error: "The assistant could not answer. Please try again.",
      assistant_new_conversation: "New chat",
      assistant_disclaimer: "Read-only. Answers come from your company's data — verify before acting.",
      cancel_signer_request: "Cancel request",
      cancel_signer_request_confirm:
        "Cancel the signature request for {{name}}?",
      cancel_signer_request_signatures_kept:
        "Signed: {{signed}} of {{total}}. Already collected signatures will be kept.",
      cancel_signer_request_success: "Signature request cancelled",
      cancel_signing_confirm:
        "Cancel all pending signature requests for “{{name}}”?",
      cancel_signing_hint:
        "The document leaves the unsigned list. Signatures already collected are kept.",
      cancel_signing_success: "Signing cancelled",
      cancel_signing_completed:
        "Pending requests removed — everyone left had signed, so the document is now complete",
      cancel_signing_withdrawn:
        "Signing cancelled. Someone had already signed, so the document is marked as withdrawn.",
      cancel_signing_failed:
        "Signing could not be cancelled. Please try again or contact an administrator.",
      cancel_signing_session_gone:
        "Signing cancelled. The Dokobit session had already expired, so the document has to be sent for signing again.",
      cancel_signing_partial:
        "Cancelled {{removed}} of {{total}} signature requests.",
      signing_history: "Reminder history",
      reminder_recipient_unknown: "Recipient no longer known",
      // The reminder modal's own strings existed only in Lithuanian; an
      // English user saw raw keys. It is now reachable from the document view
      // as well, so give it a full English set.
      reminder_settings: "Reminder settings",
      enable_automatic_reminders: "Enable automatic reminders",
      days_between_reminders: "Days between reminders",
      select_days: "Select days",
      reminder_day: "day",
      reminder_days: "days",
      sent_reminders: "Sent reminders",
      reminder_number: "No.",
      reminder_date: "Date",
      reminder_recipients: "Recipients",
      no_reminders_sent_yet: "No reminders sent yet",
      failed_to_load_reminder_data:
        "Could not load the reminder data. Please try again.",
      reminder_settings_updated_successfully: "Reminder settings saved",
      failed_to_save_settings: "Could not save the settings",
      // Returned by files/cancel-signing when the document is gone.
      file_not_found: "Document not found",
      // Document parent/attach (Desk #237) — codes returned by
      // PATCH /files/:id/parent, keyed by the same name as the code.
      parent_file_not_found: "The selected document was not found",
      file_parent_self: "A document cannot be attached to itself",
      file_parent_is_child:
        "The selected document is itself attached to another one — pick a main document instead",
      file_has_children:
        "This document has documents attached to it, so it cannot be attached to another one",
      file_parent_managed_document:
        "This document is managed by a module (order, business trip, fuel report, onboarding or finance) — it cannot be moved",
      file_not_child: "This document has no main document to detach from",
      file_category_required: "Pick at least one category",
      invalid_category: "This category cannot be used",
      attach_to_document: "Attach to document",
      attach_to_document_search_placeholder:
        "Search for a document by name or number",
      attach_to_document_confirm: "Attach",
      attach_to_document_suggestions: "Suggested documents",
      attach_to_document_none_found: "No documents found",
      attach_to_document_type_more: "Type at least 2 characters to search",
      attach_to_document_load_failed: "Could not load the documents",
      attach_to_document_success: "Attached: {{count}}",
      attach_to_document_failed: "Failed to attach: {{count}}",
      attach_to_document_failures_title: "Could not attach:",
      make_main_document: "Make a main document",
      make_main_document_confirm: "Make main",
      // Per-child-row document tree actions (Desk #237 follow-up) — same
      // move, phrased from the parent document's child list instead of the
      // document's own page.
      move_to_another_document: "Move to another document",
      make_separate_document: "Make a separate document",
      make_separate_document_confirm: "Make separate",
      make_separate_document_hint:
        "Fill in the fields this document is missing before making it a separate document — anything left empty here stays empty on the document.",
      make_separate_document_signed_note:
        "The document is signed — its fields cannot be changed.",
      make_separate_document_patch_failed:
        "The document was made separate, but the fields could not be saved:",
      cancel_signing_forbidden:
        "Only the document owner, the assigned user or a Master can cancel signing",
      cancel_signing_unsupported:
        "Signing cannot be cancelled for this document type",
      nothing_to_cancel: "There are no pending signature requests",
      signers_progress: "Signed",
      waiting_days: "Waiting",
      days_short: "d",
      dokobit_session_expiring: "Dokobit session ends in {{count}} d.",
      dokobit_session_expired: "Dokobit session has expired",
      dokobit_session_expires_at: "Dokobit keeps the document until {{date}}",
      edit_sign_request_disabled_partial:
        "Some signers have already signed, so the request can no longer be edited as a whole. Remove or add signers one by one instead.",
      click_sign_contacts_switch_hint:
        "Click signing is for employees only. Ticking a customer contact switches the signing method to {{type}}.",
      customer_inherited_from_parent: "(from the main document)",
      signature_not_found: "Signature request not found",
      signer_already_signed: "This signer has already signed the document",
      document_already_signed: "The document is already fully signed",
      batch_signature_not_supported:
        "This signature is part of a batch signing and cannot be removed here",
      edit_sign_request: "Edit signature request",
      Login: "Login",
      Email: "El. paštas",
      Password: "Password",
      your_company_operating_system: "Your Company Operating System",
      complete_solution_description:
        "Complete solution for CRM, HR, documents, assets, and team collaboration in one unified system.",
      crm_contracts_invoices_client_management:
        "CRM, contracts, invoices and client management",
      hr_automation_employee_requests_document_flow:
        "HR automation, employee requests and document flow",
      asset_tracking_fuel_management_expense_control:
        "Asset tracking, fuel management and expense control",
      task_management_team_collaboration_gamification:
        "Task management, team collaboration and gamification",
      sign_in_to_your_account: "Sign in to your account",
      enter_email_receive_secure_login_link:
        "Enter your email to receive a secure login link",
      email_address: "Email address",
      how_it_works: "How it works",
      we_will_send_secure_link:
        "We'll send a secure link to your email. Click the link to instantly sign in — no password needed.",
      check_your_email: "Check your email",
      we_have_sent_login_link_to: "We've sent a login link to",
      link_expire_warning:
        "The link will expire in 15 minutes for security reasons. Make sure to check your spam folder if you don't see it.",
      mail: "Mail",
      use_different_email: "Use a different email",
      email_confirmation_sent:
        "We sent a confirmation link to {{email}}. Your email changes once you open it.",
      having_trouble_signing_in: "Having trouble signing in?",
      privacy_policy: "Privacy Policy",
      terms_of_service: "Terms of Service",
      company_created_successfully: "Company {{name}} created successfully",
      create_company: "Create company",
      tasks: "Tasks and requests",
      create_task: "Create task",
      update_task: "Update task",
      title: "Title",
      reporter: "Author",
      assigned: "Assigned",
      resolution: "Status",
      due_date: "Due date",
      select_task_from_list: "Select a task from the list",
      resolved: "Resolved",
      is_resolved: "Resolved",
      not_resolved: "Not resolved",
      description: "Description",
      select_user: "Select user",
      log_out: "Log out",
      left: "left",
      search: "Search",
      search_tags: "Search",
      no_data: "No data",
      owner: "Owner",
      assignedTo: "Assigned To",
      assigned_user: "Assigned User",
      users: "Employees",
      company_settings: "Company settings",
      name: "Name",
      restore: "Restore",
      create_user: "Create user",
      update_user: "Update user",
      external_code: "External code",
      external_code_hint: "Code that links the person to other systems, e.g. accounting software.",
      shared_across_companies:
        "Shared with every company this user belongs to",
      user_status: "Status",
      is_disabled: "Disabled",
      not_disabled: "Active",
      company_name: "Company name",
      company_code: "Company code",
      company_vat: "VAT code",
      company_address: "Address",
      company_description: "Description",
      isDisabled: "Disabled",
      news: "News",
      Accounts: "Accounts",
      user_position: "Position",
      customers: "Customer",
      street: "Street",
      house_number: "House number",
      city: "City",
      postal_code_letters: "Postal code (Letters)",
      history: "History",
      postal_code_figures: "Postal code (Figures)",
      country_of_registration: "Country (of registration)",
      create_customer: "Create customer",
      update_customer: "Update customer",
      customer_code: "Customer code",
      sales_turnover_excl_vat: "Sales turnover excl. VAT",
      purchase_turnover_excl_vat: "Purchase turnover excl. VAT",
      debt_incl_vat: "Debt incl. VAT",
      overdue_debt_incl_vat: "Overdue debt incl. VAT",
      settlements: "Settlements",
      receivable: "They owe us",
      payable: "We owe them",
      // Existing usages (customer-details.jsx, debt-invoices-container.jsx,
      // the customers list) call t("debt")/t("overdue_debt") but had no
      // English translation yet (lt-only app default hid the gap) — added
      // here, matching the established lt wording ("Skola" / "Pradelsta skola").
      debt: "Debt",
      overdue_debt: "Overdue debt",
      kind: "Type",
      ledger_kind_all: "All",
      ledger_kind_sale: "Sale",
      ledger_kind_sale_return: "Sales return",
      ledger_kind_purchase: "Purchase",
      ledger_kind_purchase_return: "Purchase return",
      reconciled_with_finvalda: "Matches Finvalda",
      not_reconciled_with_finvalda: "Does not match Finvalda: Finvalda {{balance}}",
      unexplained_amount: "Unexplained amount",
      finvalda_mismatch_hint:
        "The difference is usually unallocated payments, advances or loans that Finvalda does not share with the ERP yet.",
      finvalda_balance_unknown: "Finvalda balance unknown",
      only_unpaid: "Unpaid only",
      only_finvalda_mismatch: "Only mismatching Finvalda",
      finvalda_mismatch_tooltip: "Finvalda: {{balance}} · difference {{difference}}",
      excluded_from_turnover: "not in turnover",
      settlements_not_synced_yet:
        "Accounting documents appear once the accounting mirror is synchronised.",
      ledger_journals_title: "Journals excluded from turnover",
      ledger_journals_hint:
        "Excluded journals do not count in turnover; debt always uses every document so it can match Finvalda.",
      overdue_receivable_payable_line: "receivable {{receivable}} / payable {{payable}}",
      pagination_range: "{{start}}–{{end}} of {{total}}",
      ledger_col_date: "Date",
      ledger_col_kind: "Type",
      ledger_col_journal: "Journal",
      ledger_col_series_number: "Series / No.",
      ledger_col_due_date: "Due",
      ledger_col_amount_doc: "Amount",
      ledger_col_amount_eur: "Amount EUR",
      ledger_col_paid: "Paid",
      ledger_col_debt: "Debt",
      // Document lines expander (pr7-contract.md §Frontend/1).
      ledger_line_col_no: "No.",
      ledger_line_col_item: "Item",
      ledger_line_col_qty: "Qty",
      ledger_line_col_unit_price: "Unit price",
      ledger_line_col_net: "Net",
      ledger_line_col_vat: "VAT",
      ledger_line_col_gross: "Gross",
      ledger_no_lines: "no lines",
      ledger_lines_truncated_note: "…more lines not shown",
      settlements_load_failed: "Could not load settlements.",
      // Payments view of the Atsiskaitymai tab: money movements and the
      // advances hiding inside them.
      settlements_view: "View",
      settlements_view_documents: "Documents",
      settlements_view_payments: "Payments",
      settlement_kind_all: "All",
      settlement_kind_payment_in: "Received",
      settlement_kind_payment_out: "Paid",
      settlements_paid_in: "Received",
      settlements_paid_out: "Paid",
      settlements_advance_received: "Advances received",
      settlements_advance_received_hint:
        "Not yet covered by a document — increases what we owe",
      settlements_advance_paid: "Advances paid",
      settlements_advance_paid_hint:
        "Not yet covered by a document — increases what they owe",
      settlements_only_open_advances: "Only open advances",
      settlements_col_description: "Description",
      settlements_col_allocated: "Allocated",
      settlements_col_open: "Advance",
      settlements_col_document: "Document",
      settlements_col_allocation_source: "Applied as",
      settlements_source_advance: "Advance offset",
      settlements_source_payment: "Direct payment",
      settlements_no_allocations:
        "Not spread over any document — the whole amount is an advance.",
      settlements_allocations_truncated: "Only the first 200 allocations are shown.",
      settlements_payments_load_failed: "Could not load payments.",
      settlements_payments_not_synced_yet:
        "Payments appear once this company's first full payment import has finished.",
      debt_advances_line: "incl. advances: paid {{paid}} / received {{received}}",
      // Customer card "Rezervacijos" tab (pr7-contract.md §Frontend/2).
      reservations_load_failed: "Could not load reservations.",
      reservations_only_active: "Active only",
      reservation_col_date: "Date",
      reservation_col_due_date: "Due",
      reservation_col_title: "Title",
      reservation_col_series_number: "Series / No.",
      reservation_col_items: "Items",
      reservation_col_status: "Status",
      reservation_status_active: "Active",
      reservation_status_inactive: "Inactive",
      reservation_no_items: "no items",
      reservation_items_truncated_note: "…more items not shown",
      reservation_items_col_item: "Item",
      reservation_items_col_qty: "Qty",
      ledger_journals_load_failed: "Could not load the journal list.",
      ledger_journals_save_failed: "Could not save.",
      finvalda_mismatch_label: "Debt does not match Finvalda",
      selected_count: "Selected: {{count}}",
      selected_hidden_count: "({{count}} hidden by filter)",
      show_only_selected: "Show only selected",
      show_all_rows: "Show all",
      clear_selection: "Clear",
      select_all_rows: "Select all shown",
      select_row: "Select",
      selection_totals_failed: "Could not calculate totals",
      selection_removed_missing:
        "{{count}} selected customers are no longer available and were removed",
      save: "Save",
      saved_successfully: "Saved successfully",
      json_view: "JSON view",
      builder_view: "Builder view",
      json_must_be_array: "JSON must be an array",
      invalid_json: "Invalid JSON",
      not_saved: "Not saved",
      cancel: "Cancel",
      last_edit: "Last Edit",
      make_a_comment: "Make a comment",
      project_details: "Project Details",
      error: "Error",
      field_must_be_at_least_characters:
        "Field must be at least {{minLength}} characters",
      field_must_be_at_least_characters_label:
        "{{label}} must be at least {{minLength}} characters",
      error_getting_data: "Error getting data",
      vat_code: "VAT code",
      address: "Address",
      valid_to: "Valid until",
      date_picker: "Date picker",
      contact_person: "Contact person",
      orders: "Orders",
      create_order: "Create order",
      orders_search_placeholder: "Search orders",
      expires: "Expires",
      date: "Date",
      assigned_date: "Assigned Date",
      number: "Code",
      customer: "Customer",
      // Pre-existing gap noticed while adding the order-form.tsx closed-order
      // fix: this key was lt-only, so a plain company member with no customer
      // selected saw a raw untranslated key instead of a sentence.
      customer_is_required: "a customer is required",
      company: "Company",
      select: "Select",
      unexpected_error: "Unexpected error",
      vats: "Vats",
      create_vat: "Create Vat",
      percent: "Percent",
      products: "Products",
      create_product: "Create product",
      sku: "Sku",
      supplier_sku: "Supplier SKU",
      unitPrice: "Unit price",
      type: "Type",
      vat: "VAT",
      is_active: "Is active",
      product: "Product",
      service: "Service",
      inactive: "Inactive",
      bills: "Bills",
      invoices: "Invoices",
      requisites: "Requisites",
      create_invoice: "Create invoice",
      // Create invoice modal (customer → Invoices tab)
      create_invoice_modal_hint:
        "Fully signed orders of this customer without an invoice yet. Long-term orders are invoiced by their monthly schedule and are not listed here. One invoice is created per selected order.",
      create_invoice_actions_hint:
        "Open an order to edit its products, quantities and prices before invoicing. Draft saves editable drafts without numbers. Build invoices confirms immediately: assigns the invoice number and generates the PDF; tick the box to email the customer as well.",
      create_invoice_actions_hint_no_build:
        "Open an order to edit its products, quantities and prices before invoicing. Draft saves editable drafts without numbers — assigning a number, PDF and email needs the Master, Admin, Signature or “Access all customers” permission.",
      invoice_lines_edited: "Edited",
      create_invoice_no_orders:
        "No orders are ready to invoice. An order must be fully signed and not already invoiced.",
      create_invoice_partial_failure: "Some orders could not be invoiced",
      invoice_order_line_count_one: "{{count}} product",
      invoice_order_line_count_other: "{{count}} products",
      selected_of_orders: "{{selected}} of {{total}} orders selected",
      select_order_for_invoice: "Select this order for invoicing",
      save_as_draft_count: "Draft ({{count}})",
      build_invoices_count: "Build invoices ({{count}})",
      invoices_drafted: "{{count}} draft invoice(s) created",
      invoices_built: "{{count}} invoice(s) created and confirmed",
      // Draft deletion — releases the order back into the list above
      delete_draft_invoice: "Delete draft invoice",
      delete_draft_invoice_confirm:
        "This draft has no invoice number and nothing has been sent to {{customer}}. Its order becomes available again for creating an invoice.",
      draft_invoice_deleted: "Draft invoice deleted",
      draft_invoice_deleted_period_skipped:
        "Deleted. {{month}} will not be invoiced for this order.",
      delete_draft_invoice_confirm_no_customer:
        "This draft has no invoice number and nothing has been sent to the customer. Its order becomes available again for creating an invoice.",
      deleting: "Deleting…",
      invoice_existing_draft_loaded:
        "This order already has a draft invoice, so your changes were not applied to it. It is now shown here — review it, then edit and save.",
      invoice_line_quantity_required: "Above 0",
      invoice_line_price_required: "0 or more",
      invoice_lines_need_fixing: "Needs fixing",
      // Bare (non-pluralized) fallback alongside the `_one`/`_other` keys
      // below — kept in sync with `_other`'s text.
      create_invoice_lines_invalid:
        "{{count}} selected order(s) have a product with no quantity. Enter a quantity above 0, remove the line, or deselect the order.",
      create_invoice_lines_invalid_one:
        "{{count}} selected order has a product with no quantity. Enter a quantity above 0, remove the line, or deselect the order.",
      create_invoice_lines_invalid_other:
        "{{count}} selected orders have a product with no quantity. Enter a quantity above 0, remove the line, or deselect the order.",
      create_invoice_already_invoiced: "an invoice already exists for this order",
      payment_due_date: "Payment due date",
      download: "Download",
      price: "Price",
      totalPrice: "Total price",
      product_name: "Name",
      // Closing an order
      order_ended_badge: "Ended",
      order_external_contract: "External contract",
      order_external_contract_help:
        "The contract was drawn up and signed outside the system (a legacy contract, or one the customer prepared). It keeps its own number, and you attach its signed PDF on the order page instead of generating one.",
      order_external_number: "Contract number",
      order_external_number_help: "The number printed on the signed contract. Invoices quote it.",
      order_external_number_required: "Enter the external contract's number.",
      order_external_number_too_long: "A contract number is at most 36 characters.",
      order_external_number_duplicate:
        "Another order already has contract number {{number}}. Check that the contract is not being imported twice:",
      order_external_origin_locked:
        "This can't be changed any more: the order's document has been sent for signing, or a signed contract is attached.",
      order_external_invalid_origin:
        "An order is either an ERP order or an external contract.",
      order_external_badge: "External contract",
      // mobile: company
      leave_calendar_add_leave: "Add leave",
      leave_calendar_legend: "Legend",
      leave_calendar_tap_last_day: "Tap the last day of the leave",
      leave_calendar_previous: "Previous",
      leave_calendar_next: "Next",
      billing_start_before_import:
        "An imported contract can't bill months before it was brought into the system. Bill from {{month}} or later.",
      external_billing_finvalda_hint:
        "Months already invoiced in Finvalda are not detected. Set \"Bill from\" to the first month that has not been invoiced yet.",
      signed_order_edit_forbidden:
        "This order's document is signed. Only a user with the Signature permission can edit it.",
      external_contract_document: "Signed contract",
      external_contract_date: "Contract date",
      external_contract_date_help: "The date on the signed contract. It becomes the order's date.",
      external_document_missing: "No signed contract attached yet.",
      attach_external_document: "Attach signed contract",
      attach_external_document_intro:
        "Upload the contract PDF signed outside the system. It becomes this order's document, marked as signed.",
      replace_external_document: "Replace",
      replace_external_document_confirm:
        "The attached document will be replaced by the new PDF. The previous file stays recorded in the order's history.",
      external_document_file: "Signed PDF",
      external_document_choose_file: "Choose a PDF file",
      external_document_attached: "Signed contract attached",
      external_document_replaced: "Signed contract replaced",
      external_document_not_pdf: "The signed contract must be a PDF file.",
      external_document_already_sent:
        "This order's document has been sent for signing or is signed, so it can't be replaced.",
      external_document_forbidden:
        "Only a user with the Signature permission can attach a signed contract.",
      external_document_file_attached:
        "That file already belongs to another document. Upload the signed contract again.",
      external_document_order_not_external:
        "Mark the order as an external contract before attaching its signed document.",
      external_document_annulled:
        "This document has been annulled and can't be replaced.",
      external_document_order_not_found:
        "This order was not found. It may have been deleted.",
      external_document_invalid_file_type: "That file type was not found.",
      external_document_invalid_category: "That category was not found.",
      external_document_invalid_date: "The contract date is not a valid date.",
      external_document_no_signatures_to_reset:
        "This document was attached as a signed external contract, not signed in the system — there is nothing to reset. Attach a new file instead.",
      amendment_slot_required:
        "Amendments of an external contract use the company's amendment series. Configure it in Orders settings → Order amendment.",
      order_invalid_contract_end: "The contract end date is not a valid date.",
      external_contract_not_found:
        "Not found. It may have been deleted or moved.",
      invoice_settings_locked:
        "Reopen the order to change its invoice settings",
      close_order_confirm_intro: "Closing this order means:",
      close_order_confirm_recurring:
        "The contract ends today: no months after this one are billed.",
      close_order_arrears_warning:
        "This order bills in arrears, so the invoice for {{month}} is still to come — it will be drafted on the next schedule day. Closing does not cancel it.",
      close_order_confirm_settings:
        "Its invoice settings become read-only.",
      close_order_confirm_list:
        "It no longer appears when creating invoices for this customer.",
      close_order_confirm_reopen:
        "Invoices already issued are not affected. Only an administrator can reopen a closed order.",
      close_order_confirm_reopen_same_people:
        "Invoices already issued are not affected. Whoever can close an order can also reopen it.",
      close_order_confirm_terminal:
        "It no longer appears on the terminal when a loading order is created.",
      invoice_lines_out_of_sync: "This invoice changed elsewhere. Close and reopen it before editing the lines.",
      invoice_form_line_invalid:
        "A product line has no quantity, or a negative price. Fix it before saving or confirming this invoice.",
      invoice_order_changed_reloaded:
        "The order changed while this form was open. The lines were reloaded — check them and try again.",
      // Sales-invoice error codes (orders/create-invoice, invoices/confirm,
      // invoices/patch, invoices/delete-draft, customers/create-invoices-bulk
      // — see utils/invoice-errors.ts).
      invoice_err_no_items: "The invoice must have at least one line.",
      invoice_err_nothing_to_bill:
        "Nothing to invoice: every month up to now is invoiced or was skipped.",
      invoice_err_invalid_amount: "One of the line amounts is invalid.",
      invoice_err_invalid_line:
        "One of the invoice lines is invalid — check for a duplicate line, or a title/description that is too long.",
      invoice_err_invalid_date:
        "One of the dates is not valid. Check the invoice date and payment due date.",
      invoice_err_no_vat: "No VAT rate is available for this product.",
      invoice_err_vat_foreign: "That VAT rate belongs to another company.",
      invoice_err_no_product: "Product not found for this company.",
      invoice_err_order_not_signed:
        "The order must be fully signed before it can be invoiced.",
      invoice_err_order_closed:
        "This order is closed, so it can no longer be invoiced.",
      invoice_err_order_contract_ended:
        "The order's contract period has ended, so it can no longer be invoiced.",
      invoice_err_order_contract_annulled:
        "This order's contract has been annulled, so it can no longer be invoiced.",
      invoice_err_order_billing_changed:
        "This order's billing settings changed — reopen it to see the current period.",
      invoice_err_order_not_found: "Order not found.",
      invoice_err_customer_not_found: "Customer not found.",
      invoice_err_invoice_not_found: "Invoice not found.",
      invoice_err_access_denied:
        "You do not have access to this order's customer.",
      invoice_err_not_draft: "Only draft invoices can be edited or deleted.",
      invoice_err_not_erp: "Only ERP invoices can be confirmed.",
      invoice_err_lock_timeout:
        "Another confirmation is already in progress for this invoice — try again shortly.",
      invoice_err_series_changed:
        "The company's active invoice series changed — try again.",
      invoice_err_series_not_configured:
        "No invoice numbering series is configured for this company. Set one up in Orders settings.",
      invoice_err_series_shared_finvalda:
        "This numbering series is also used by imported Finvalda invoices — choose a series dedicated to ERP invoices.",
      invoice_err_invalid_number_template:
        "The invoice numbering series has an invalid number format.",
      invoice_err_date_in_future:
        "The invoice date is later than today. Change the date, or wait until then.",
      invoice_err_number_taken:
        "This number already exists on another invoice of the company. Check the series.",
      invoice_file_locked:
        "This invoice has already been issued, so its PDF can no longer be changed.",
      invoice_err_invalid_period:
        "That billing period is not valid for this invoice.",
      invoice_err_period_not_allowed:
        "This invoice's order does not bill by period.",
      invoice_err_period_not_yet_billable: "That month cannot be billed yet.",
      invoice_err_period_before_billing_start:
        "That period is before the order's billing start.",
      invoice_err_date_before_last_issued:
        "This series has already issued invoices in {{period}}, so this date would break its sequence. Change the invoice date, or use a series whose number carries no date.",
      invoice_err_date_before_last_issued_unknown_period:
        "This date would break the series' number sequence. Change the invoice date, or use a series whose number carries no date.",
      invoice_already_exists: "Invoice already exists for this order",
      invoice_needs_products:
        "Add products to the order before generating an invoice",
      invoice_needs_signed_order:
        "Order must be fully signed before creating an invoice",
      invoice_needs_attached_external_contract:
        "Attach the signed contract PDF before creating an invoice",
      contract_deferred: "Contract will be signed later",
      contract_deferred_help:
        "Invoices can be issued before the contract is signed. Once it is signed, this no longer matters.",
      contract_deferred_save_failed: "Could not save. Please try again.",
      sales_invoice_order_schedule_hint:
        "Monthly invoice generation is controlled per order (long-term order settings), not here.",
      invoice_settings: "Invoice settings",
      invoice_settings_hint:
        "Configure how sales invoices are generated for this order. Order products and document details are edited separately.",
      invoice_settings_permission_error:
        "Only users who manage sales invoices can change billing settings.",
      order_closed_billing_locked_hint:
        "This order is closed, so its billing settings are read-only. Reopen it to change them — the rest of the form can still be saved.",
      order_is_recurring: "Long-term contract (monthly invoices)",
      order_is_recurring_help:
        "Generate one sales invoice each month until the order is closed or the contract end date is reached.",
      order_invoice_schedule_mode: "Invoice generation day",
      order_invoice_schedule_last_day: "Last day of the month",
      order_invoice_schedule_specific_day: "Specific day of the month",
      order_invoice_schedule_day: "Day of month (1–28)",
      order_invoice_schedule_day_invalid: "Enter a day from 1 to 28 — later days do not exist in every month.",
      contract_term: "Contract term",
      contract_term_indefinite: "Indefinite contract",
      contract_term_indefinite_help:
        "Invoices are issued every month until you close the contract.",
      contract_term_fixed: "Fixed term until",
      contract_term_end_date: "End date",
      contract_term_date_required:
        "Choose the end date, or switch to an indefinite contract.",
      contract_valid_indefinite: "Valid: indefinite",
      contract_valid_until: "Valid until {{date}}",
      order_form_title_edit: "Edit contract",
      order_form_section_customer: "Customer and date",
      order_form_section_items: "Products and services",
      order_form_section_invoices: "Invoices",
      order_draft_found: "You have an unsaved draft (saved {{time}}).",
      order_draft_restore: "Restore",
      order_draft_discard: "Discard",
      order_line_incomplete:
        'Fill in the quantity and price of "{{title}}", or remove the line',
      create_product_option: 'Create "{{text}}"',
      invoice_billing_period_mode: "Each invoice covers",
      invoice_billing_period_current_month: "The month it is issued in",
      invoice_billing_period_previous_month: "The previous month (in arrears)",
      invoice_billing_period_current_month_help:
        "An invoice issued on the schedule day bills that same month — issued on 31 October, it covers October.",
      invoice_billing_period_previous_month_help:
        "An invoice issued on the schedule day bills the month before — issued on 5 November, it covers October. For work billed once it is done.",
      invoice_billing_start: "Bill from",
      invoice_billing_start_help:
        "The first month to invoice. Months are billed whole — the first and last in full. Leave empty to start from the month billed today; earlier months are invoiced only if you pick them.",
      invoice_billing_start_backfill:
        "Billing from {{from}} drafts every month up to {{to}} that has no invoice yet — up to {{n}} invoices on the next run.",
      invoice_billing_start_backfill_open:
        "Billing from {{from}} is earlier than the default. Every month from then that has no invoice yet will be drafted — the past ones on the next run.",
      month_short_1: "Jan",
      month_short_2: "Feb",
      month_short_3: "Mar",
      month_short_4: "Apr",
      month_short_5: "May",
      month_short_6: "Jun",
      month_short_7: "Jul",
      month_short_8: "Aug",
      month_short_9: "Sep",
      month_short_10: "Oct",
      month_short_11: "Nov",
      month_short_12: "Dec",
      this_month: "This month",
      previous_year: "Previous year",
      next_year: "Next year",
      invoice_period: "Billing period",
      invoice_period_column: "Period",
      invoice_due_column: "Due",
      invoice_last: "Last",
      invoices_all: "All invoices",
      invoices_none_yet: "No invoices yet",
      invoice_period_help: "The month this invoice bills. Its date can be anything; this decides what is covered.",
      invoice_service_act_add: "Attach a service completion act",
      invoice_service_act_title: "Service completion act",
      invoice_service_act_text: "Work done",
      invoice_service_act_help:
        "Printed as the second page of the invoice PDF — same file, same e-mail.",
      invoice_service_act_required:
        "Enter the work done, or untick the service completion act.",
      invoice_err_invalid_service_act:
        "The service completion act text is not valid — it can be at most 20,000 characters.",
      invoice_period_already_billed:
        "That month is already billed by another invoice of this order.",
      invoice_period_already_billed_by:
        "{{month}} is already billed by another invoice of this order: {{invoice}}.",
      invoice_next_period_hint: "The next invoice bills {{month}}.",
      invoice_all_periods_billed: "Every month up to now is already invoiced.",
      invoice_billing_not_started: "Billing starts from {{month}}.",
      close_order: "Close order",
      reopen_order: "Reopen order",
      order_closed: "Order closed",
      order_reopened: "Order reopened",
      order_recurring_badge: "Monthly",
      order_closed_badge: "Closed",
      invoice_order_closed_hint:
        "This order is closed — no new invoices will be created.",
      invoice_contract_ended_hint:
        "The contract period has ended — no new invoices will be created. Extend it in Invoice settings to resume, or close the order.",
      download_invoice: "Download invoice PDF",
      invoice_type: "Type",
      invoice_type_erp: "ERP",
      invoice_type_finvalda: "Finvalda",
      confirm_invoice: "Confirm invoice",
      invoice_number: "Invoice number",
      invoice_contract: "Contract",
      customer_invoices_drafts_heading: "Drafts ({{count}})",
      invoice_confirmed: "Invoice confirmed",
      invoice_confirmed_emailed: "Invoice confirmed and emailed",
      invoice_email_skipped_no_address:
        "Invoice confirmed, but email was not sent — customer has no invoice email.",
      invoice_email_skipped_pdf:
        "Invoice confirmed, but email was not sent — PDF generation failed.",
      invoice_email_skipped_invalid:
        "Confirmed, but the invoice email address is invalid. Fix it on the customer and use Send again.",
      invoice_email_skipped_invalid_with_reason:
        "Confirmed, but the invoice email address is invalid — {{reason}}. Fix it on the customer and use Send again.",
      invoice_email_skipped_send:
        "Invoice confirmed, but sending the email failed. Check mail settings / logs.",
      invoice_email_skipped_send_with_reason:
        "Confirmed, but sending the email failed — {{reason}}. Use Send again once fixed.",
      invoice_already_confirmed:
        "Invoice was already confirmed (email is not sent again).",
      outgoing_invoices: "Outgoing invoices",
      outgoing_invoices_subtitle:
        "Sales invoices: confirm drafts, or browse and send confirmed invoices.",
      outgoing_invoices_tab_draft: "Ready",
      outgoing_invoices_tab_complete: "Confirmed",
      outgoing_invoices_tab_register: "Register",
      sales_register_empty: "No issued invoices yet.",
      sales_register_load_failed: "Could not load the invoice register.",
      sales_register_month_load_failed: "Could not load this month's invoices.",
      sales_register_pdf: "PDF register",
      sales_register_pdf_failed: "Could not download the register PDF.",
      sales_register_vat_classifier: "VAT classifier",
      sales_register_company_code: "Co. code {{code}}",
      sales_register_vat_code: "VAT code {{code}}",
      outgoing_invoices_complete_hint:
        "Confirmed sales invoices with assigned numbers. Send them to customers from here.",
      outgoing_invoices_complete_empty: "No confirmed sales invoices",
      outgoing_invoices_complete_empty_body:
        "Confirmed invoices will appear here after you confirm drafts.",
      sales_invoices_confirmation_hint:
        "Draft invoices created on the schedule day. Confirm to assign a number; emailing the customer is optional.",
      sales_invoices_drafts_empty: "No draft sales invoices",
      sales_invoices_drafts_empty_body:
        "When auto-schedule creates drafts for signed orders, they will appear here for confirmation.",
      sales_invoices_confirm_all: "Confirm all",
      sales_invoices_confirm_all_title: "Confirm all sales invoices",
      sales_invoices_confirm_selected: "Confirm selected ({{count}})",
      sales_invoices_confirm_all_body:
        "Confirm {{count}} selected draft invoice(s): each gets a number and a PDF. Tick the box below to email the customers as well. Uncheck any you want to leave as draft.",
      sales_invoices_bulk_selected_count: "{{selected}} of {{total}} selected",
      sales_invoices_bulk_progress: "Confirming {{current}} of {{total}}…",
      exclude: "Exclude",
      include: "Include",
      deselect_all: "Deselect all",
      failed: "Failed",
      sales_invoices_bulk_success: "{{count}} invoices confirmed",
      sales_invoices_bulk_partial: "{{ok}} confirmed, {{fail}} failed",
      sales_invoices_bulk_missing_email_warn:
        "{{count}} invoice(s) have no invoice email — they will still be confirmed but not emailed.",
      sales_invoices_bulk_results: "Results",
      sales_invoices_bulk_not_attempted:
        "Not attempted — stopped after an earlier failure.",
      sales_invoices_bulk_skipped: "Not attempted",
      sales_invoices_bulk_partial_stopped:
        "{{ok}} confirmed, {{fail}} failed, {{skipped}} not attempted",
      invoice_email_missing: "No invoice email",
      invoice_send_status_sent: "Sent",
      invoice_send_status_not_sent: "Not sent",
      invoice_send_status_failed: "Sending failed",
      invoice_send_filter_all: "All",
      invoice_send_filter_not_sent: "Not sent",
      invoice_send_filter_sent: "Sent",
      invoice_send_filter_failed: "Failed",
      invoice_send_column: "Emailing",
      invoice_send_again: "Send again",
      invoice_send_title: "Send invoice {{number}}",
      invoice_send_recipient: "Send to",
      invoice_send_recipient_help:
        "Leave empty to use the customer's invoice email. Separate several addresses with a comma.",
      invoice_send_already_sent: "Already sent on {{date}}{{who}}. Send again?",
      invoice_send_done: "Sent to {{to}}",
      invoice_send_not_accepted: "The email could not be sent: {{reason}}",
      invoice_send_to_customer: "Email the customer",
      invoice_send_to_customers: "Email the customers",
      invoice_preview_pdf: "Preview PDF",
      invoice_preview_save_first: "Save to preview your changes",
      invoice_buyer: "Buyer",
      invoice_refresh_buyer: "Update buyer details",
      invoice_buyer_refreshed: "Buyer details updated",
      invoice_period_one_off_help:
        "Optional. Pick the month this invoice bills; it is printed on the invoice.",
      invoice_number_short: "No.",
      invoice_status_confirmed: "Confirmed",
      invoice_confirmed_not_emailed:
        "Confirmed. It was not emailed — send it from Outgoing invoices.",
      invoice_err_not_confirmed:
        "Only confirmed invoices can be emailed to the customer.",
      invoice_err_already_sent: "This invoice was already emailed to the customer.",
      invoice_err_missing_email:
        "The customer has no invoice email. Enter a recipient address.",
      invoice_err_invalid_email: "The email address is not valid.",
      invoice_err_popup_blocked: "Allow pop-ups to preview the PDF.",
      settlements_erp_invoices_title:
        "Issued ERP invoices (not in accounting yet)",
      invoice_confirm_needs_permission:
        "Confirming needs the Master, Admin, Signature or “Access all customers” permission. Save keeps it as a draft.",
      invoice_confirmed_readonly:
        "This invoice is confirmed and can no longer be edited.",
      edit_invoice: "Edit invoice",
      view_invoice: "View invoice",
      select_order: "Select active order",
      orders_settings: "Orders",
      orders_settings_err_master_required: "Only a company Master can change these settings.",
      orders_settings_err_amendment_invalid_source: "Pick a valid template source for the order amendment.",
      orders_settings_err_amendment_template_missing: "Choose a custom template for the order amendment, or switch it back to the system template.",
      orders_settings_err_amendment_template_not_found: "The selected order amendment template no longer exists.",
      orders_settings_err_amendment_series_not_found: "The selected order amendment series no longer exists.",
      orders_settings_err_amendment_file_type_not_found: "The selected order amendment file type no longer exists.",
      orders_settings_err_amendment_category_not_found: "The selected order amendment category no longer exists.",
      orders_settings_err_amendment_metadata_required: "The order amendment needs a series, a file type and a category before it can be saved.",
      orders_settings_err_invoice_invalid_source: "Pick a valid template source for the sales invoice.",
      orders_settings_err_invoice_template_missing: "Choose a custom template for the sales invoice, or switch it back to the system template.",
      orders_settings_err_invoice_template_not_found: "The selected sales invoice template no longer exists.",
      orders_settings_err_invoice_series_not_found: "The selected sales invoice series no longer exists.",
      orders_settings_err_invoice_number_series_not_found: "The selected invoice numbering series no longer exists.",
      orders_settings_err_invoice_file_type_not_found: "The selected sales invoice file type no longer exists.",
      orders_settings_err_invoice_category_not_found: "The selected sales invoice category no longer exists.",
      orders_settings_err_invoice_metadata_required: "The sales invoice needs a series, a file type and a category before it can be saved.",
      invoice_number_format: "Invoice number format",
      invoice_series: "Invoice series",
      invoice_series_choose: "— choose a series —",
      invoice_series_subtitle: "How sales invoices are numbered. Create one here, then choose it in Orders settings.",
      invoice_series_numbering: "Invoice numbering",
      invoice_series_create: "New invoice series",
      invoice_series_edit: "Edit invoice series",
      invoice_series_name: "Name",
      invoice_series_name_hint: "For people. Never appears on an invoice, so it can always be changed.",
      invoice_series_name_required: "A name is required",
      invoice_series_label: "Label",
      invoice_series_label_hint: "The code printed on the invoice. Letters and digits only — this will print as {{example}}.",
      invoice_series_next_number: "Next number",
      invoice_series_issued: "Issued",
      invoice_series_active_label: "Series in use",
      invoice_series_active_hint: "Invoices confirmed from now on number from this series. Everything already issued keeps its number.",
      invoice_series_in_use: "In use",
      invoice_series_saved: "Invoice series saved",
      invoice_series_save_failed: "Could not save the invoice series.",
      invoice_series_label_taken:
        "Another series of this company already prints as this label. Choose a different one.",
      invoice_series_label_prefix:
        "This label and another series' label begin the same way, so their invoice numbers could coincide. Choose a label that neither begins with another series' label nor is the beginning of one.",
      invoice_series_label_finvalda:
        "This label collides with a series used by invoices imported from Finvalda — choose another label.",
      invoice_series_load_failed: "Could not load the invoice series.",
      invoice_series_not_found: "That invoice series no longer exists.",
      invoice_series_action_failed: "Could not complete that action.",
      invoice_series_none: "No invoice series yet. Sales invoices cannot be issued until one exists and is selected in Orders settings.",
      invoice_series_locked: "This series has issued {{count}} invoice(s), so its label, format and starting number can no longer change. Create a new series to start a different format — the invoices already issued keep their numbers.",
      invoice_number_format_locked_badge: "In use",
      invoice_number_format_locked: "This series has already issued {{count}} invoice(s), so its format can no longer change. To start a new format — from 1 January, say — create a new series and select it above. The invoices already issued keep their numbers.",
      invoice_number_reset: "Restart the counter every",
      invoice_number_reset_hint: "No date is the simplest to defend: the numbers run in issue order, so a draft dated last month can still be confirmed today. A dated format refuses that.",
      invoice_number_preset_none: "No date — one continuous sequence",
      invoice_number_preset_year: "Year",
      invoice_number_preset_month: "Month",
      invoice_number_preset_day: "Day",
      invoice_number_preset_custom: "Custom",
      invoice_number_template: "Format",
      invoice_number_template_hint: "Tokens: {SERIES}, {YYYY} or {YY}, {MM}, {DD}, and {N} or {N:4} to pad the counter.",
      invoice_number_error_counter: "The format needs exactly one {N}.",
      invoice_number_error_series: "The format must contain {SERIES}.",
      invoice_number_error_token: "{{token}} is not one of the tokens listed below.",
      invoice_number_start: "Start at",
      invoice_number_start_hint: "Where the counter starts — set 1051 to continue a series from another system. A format without a date uses it once, for the first invoice; a dated format starts every new year, month or day from it.",
      invoice_number_preview: "Next invoices will read: {{example}}",
      invoice_number_preview_one: "Next invoice will read: {{example}}",
      invoice_number_format_saved: "Number format saved",
      invoice_number_format_save_failed: "Could not save the number format.",
      invoice_number_format_load_failed: "Could not load the number format for this series.",
      sales_invoice_custom_template_warning:
        "Custom invoice templates must include the expected fields for series, number, customer and line items.",
      serial: "Serial",
      series: "Series",
      series_card_description: "A short code in front of a document number, e.g. SUT-0045. A prefix does not number anything — the system assigns the number.",
      series_add: "New prefix",
      series_prefix: "Prefix",
      series_empty: "No prefixes yet.",
      series_already_exists: "This prefix already exists.",
      series_rename_warning: "Renaming a prefix also changes the numbers shown on documents already issued. Continue?",
      series_rename_confirm_button: "Yes, rename",
      series_invoice_numbering_note: "Invoice numbering is set on the <salesLink>Orders and invoices</salesLink> page.",
      user: "User",
      order: "Order",
      quantity: "Quantity",
      unit_price: "Unit price",
      add_invoice_item: "Add invoice item",
      email_incorrect: "Email not found",
      category_not_found: "Category not found",
      user_exists: "E-mail address already registered",
      add_order_item: "Add order item",
      is_period: "Is period",
      next_invoice_date: "Next order date",
      month: "Month",
      day: "Day",
      total: "Total",
      period: "Period",
      unknown_period: "Unknown period",
      expand_all: "Expand all",
      collapse_all: "Collapse all",
      totalWithVat: "Total with VAT",
      totalWithoutVat: "Total without VAT",
      important: "Important",
      comment: "Comment",
      documents: "Documents",
      category: "Category",
      subject: "Subject",
      action: "Action",
      audit_action_create: "Create",
      audit_action_update: "Update",
      audit_action_delete: "Delete",
      audit_action_view: "View",
      audit_action_review: "Review",
      audit_action_signature: "Signature",
      audit_action_signature_complete: "Signature Completed",
      audit_action_download: "Download",
      audit_action_unknown: "Other Action",
      audit_subject_Customer: "Customer",
      audit_subject_File: "Document",
      audit_subject_Asset: "Asset",
      audit_subject_FuelReport: "Fuel Report",
      audit_subject_FuelBarcode: "Fuel Barcode",
      audit_subject_BusinessTrip: "Business Trip",
      audit_subject_Order: "Order",
      audit_subject_Project: "Project",
      audit_subject_ProjectBoard: "Project Board",
      audit_subject_ProjectBoardColumn: "Project Stage",
      audit_subject_User: "User",
      audit_subject_UserMembership: "Membership",
      audit_subject_Company: "Company",
      audit_subject_FileCategory: "File Category",
      audit_subject_Onboarding: "Onboarding",
      audit_subject_Department: "Department",
      audit_subject_Expense: "Expense",
      audit_subject_TripExpense: "Trip Expense",
      audit_subject_PointTransaction: "Recognition",
      audit_subject_CompanyHoliday: "Holiday",
      audit_subject_CompaniesSignOnTab: "SignOnTab Settings",
      audit_subject_PermissionsGroup: "Permission Group",
      audit_subject_CustomField: "Custom Field",
      audit_subject_Series: "Series",
      audit_subject_FileType: "File Type",
      audit_subject_AssetType: "Asset Type",
      audit_subject_Template: "Template",
      audit_subject_SignontabUser: "SignOnTab device",
      audit_subject_CustomerFinance: "Customer Finance",
      audit_open_entity: "Open",
      performed_by: "Performed by",
      audit_actor_system: "System",
      activity_log: "Activity Log",
      custom_field_code: "Code",
      custom_field_label: "Label",
      custom_field_type: "Type",
      custom_field_card_description: "Fields shown on the document card, e.g. a contract end date.",
      custom_field_add: "New field",
      custom_field_type_text: "Text",
      custom_field_type_number: "Number",
      custom_field_type_date: "Date",
      custom_field_type_select: "Choice from a list",
      custom_field_type_checkbox: "Checkbox",
      custom_field_options: "Choices",
      custom_field_option: "Choice",
      custom_field_add_option: "Add a choice",
      custom_field_remove_option: "Remove this choice",
      custom_field_required: "Required",
      custom_field_required_hint: "The document can't be saved while this field is empty.",
      custom_field_visible_in_list: "Shown in the document form",
      custom_field_visible_in_list_hint: "When off, the field is hidden when someone fills in a document.",
      custom_field_empty: "No custom fields yet.",
      email_connect: "Email connect",
      status: "Status",
      not_connected: "Not connected",
      connected: "Connected",
      connect: "Connect",
      external: "External",
      internal: "Internal",
      close: "Close",
      view_products: "View products",
      invoice_products: "Invoice products",
      about_company: "About Company",
      // Reused by MakeSeparateDocumentModal/file-form.jsx — existed only in
      // the lt block below (Desk #237 follow-up).
      select_series: "Select series",
      externalNumber: "External number",
      document_date: "Document date",
      the_file_was_uploaded_by: "The file was uploaded by",
      label: "Label",
      template: "Template",
      files_types_card_description: "Each document type has a rule the system names its files by.",
      files_types_add: "New rule",
      files_types_document: "Document",
      files_types_document_hint: "What kind of document it is, e.g. Employment contract. Shown when choosing a document type.",
      files_types_rule: "Naming rule",
      files_types_rule_help: "Write text and put fields in curly brackets — the system replaces them with the document's details:",
      files_types_rule_template_fields: "Documents made from a template can also use the template's own form fields, e.g. {customFields.firstName}.",
      files_types_rule_example: "Example",
      files_types_empty: "No file naming rules yet.",
      files_types_placeholder_date: "document date (year-month-day)",
      files_types_placeholder_number: "document number",
      files_types_placeholder_series: "document prefix",
      files_types_placeholder_customer: "customer name (several customers are joined with “_”)",
      files_types_placeholder_user: "employee name (several are joined with “_”)",
      files_types_placeholder_company: "your company name",
      files_types_placeholder_project: "project name",
      files_types_placeholder_asset: "asset name",
      files_types_placeholder_template: "template name",
      files_types_placeholder_context: "text from the “File context” field of the document",
      files_types_placeholder_fuel_period: "fuel report month",
      files_types_select: "Select document type",
      document_is_signed_edit_is_not_allowed:
        "Document is signed edit is not allowed",
      not_signed: "Not signed",
      all: "All",
      filters: "Filter",
      apply_filters: "Apply filters",
      // mobile: public
      onboarding_file_delete_confirm: "Delete this document?",
      clear: "Clear",
      preparing_filters: "Preparing filters…",
      clear_all_filters: "Clear all filters",
      user_search: "Search user…",
      customer_search: "Search customer…",
      select_products: "Select products",
      generate_order_document: "Generate order document",
      sign_the_order: "Sign the order",
      invoice_customer: "Invoice customer",
      soon: "Soon",
      files_template_custom_min_length: "Minimum character count",
      files_template_custom_number_min: "Minimum value",
      files_template_custom_number_max: "Maximum value",
      field_must_be_between_min_and_max:
        "{{label}} must be between {{min}} and {{max}}",
      field_must_be_at_least_min: "{{label}} must be at least {{min}}",
      field_must_be_at_most_max: "{{label}} must be at most {{max}}",
      must_be_between_min_and_max: "Must be from {{min}} to {{max}}",
      must_be_at_least_min: "Must be at least {{min}}",
      must_be_at_most_max: "Must be at most {{max}}",
      number_min_must_be_less_than_or_equal_to_max:
        "Minimum value must be less than or equal to maximum value.",
      files_template_custom_type_products: "Products",
      files_template_custom_type_product_groups: "Product Groups",
      files_template_custom_type_products_or_groups: "Products or Product Groups",
      files_template_custom_enable_group_option: "Enable Product Groups",
      signontab_select_user: "Select a SignOnTab device",
      signontab_select_tablet_user: "Select a SignOnTab device",
      manager_should_be_assigned_first: "Manager should be assigned first",
      upload_document_1: "Upload Document 1",
      upload_document_2: "Upload Document 2",
      upload_document_3: "Upload Document 3",
      click_to_upload: "Click here to upload file",
      file_uploaded: "File uploaded successfully",
      manager: "Manager",
      manager_approval: "Manager Approval",
      waiting_for_manager_approval: "Waiting for manager approval",
      generate_document: "Generate Document",
      generate_document_description: "Generate and send the finance document",
      collect_signatures: "Collect Signatures",
      order_creation_unlocked:
        "All steps completed. You can now create orders for this customer.",
      complete_previous_step: "Complete previous step first",
      complete_all_steps_to_unlock:
        "Complete all previous steps to unlock order creation",
      eu_sanctions_check: "EU Sanctions Check",
      usa_sanctions_check: "USA Sanctions Check",
      lt_sanctions_check: "LT Sanctions Check",
      sanctions_file_category: "File category",
      sanctions_file_type: "File type",
      eu_sanctions_check_description:
        "Click the link below to check EU sanctions, then upload a screenshot of the result.",
      usa_sanctions_check_description:
        "Click the link below to check USA sanctions, then upload a screenshot of the result.",
      lt_sanctions_check_description:
        "Click the link below to check LT sanctions, then upload a screenshot of the result.",
      upload_screenshot_description:
        "Please upload a screenshot or PDF of the sanctions check result.",
      product_groups: "Product Groups",
      product_group: "Product Group",
      create_product_group: "Create Product Group",
      edit_product_group: "Edit Product Group",
      select_product_group: "Select Product Group",
      selected_product_groups: "Selected Product Groups",
      at_least_one_product_or_product_group_required:
        "At least one product or product group is required with quantity and price",
      // Feed/Posts translations
      feed_comment: "Comment",
      feed_comments: "Comments",
      feed_reply: "Reply",
      feed_replies: "replies",
      feed_reply_singular: "reply",
      feed_edit: "Edit",
      feed_delete: "Delete",
      feed_confirm_delete: "Confirm Delete",
      feed_deleting: "Deleting...",
      feed_cancel: "Cancel",
      feed_show_more: "Show more",
      feed_show_less: "Show less",
      feed_show_more_capital: "Show More",
      feed_show_less_capital: "Show Less",
      feed_view_reply_singular: "View {{count}} reply",
      feed_view_replies_plural: "View {{count}} replies",
      feed_hide_replies: "Hide replies",
      feed_posting: "Posting...",
      feed_updating: "Updating...",
      feed_reply_to: "Reply to {{name}}...",
      feed_edit_comment: "Edit your comment...",
      feed_edit_comment_max: "Edit your comment... (max {{limit}} characters)",
      feed_write_comment: "Write a comment...",
      feed_write_comment_max: "Write a comment... (max {{limit}} characters)",
      feed_edited: "(edited)",
      feed_no_comments_yet: "No comments yet. Be the first to comment!",
      feed_load_more_comments: "Load More Comments",
      feed_loading: "Loading...",
      feed_more_options: "More options",
      feed_close: "Close",
      feed_previous: "Previous",
      feed_next: "Next",
      feed_post_image: "Post image {{index}}",
      feed_thumbnail: "Thumbnail {{index}}",
      feed_comment_length_error: "Comment must be no more than {{limit}} characters. Current: {{current}}",
      feed_reply_length_error: "Reply must be no more than {{limit}} characters. Current: {{current}}",
      feed_user: "User",
      feed_whats_on_mind: "What's on your mind?",
      feed_photo: "Photo",
      feed_post: "Post",
      feed_group_post: "Group Post",
      feed_save: "Save",
      feed_saving: "Saving...",
      feed_only_images_allowed: "Only image files are allowed (JPG, PNG, WEBP)",
      feed_file: "File {{index}}",
      feed_failed_to_load_posts: "Failed to load posts",
      feed_failed_to_load_news_context: "Failed to load feed settings",
      feed_reply_placeholder: "Reply to {{name}}... (max {{limit}} characters)",
      feed_recently: "recently",
      feed_refresh: "Refresh",
      feed_failed_to_create_post: "Failed to create post",
      feed_failed_to_upload_files: "Failed to upload files. Please try again.",
      feed_failed_to_update_comment: "Failed to update comment",
      feed_no_posts_yet: "No posts yet",
      feed_be_first_to_share: "Be the first to share something with your team!",
      feed_all_caught_up: "You're all caught up! 🎉",
      feed_editing: "editing...",
      feed_permission_required: "Permission required",
      feed_feed_write_permission_required: "Feed Write permission is required to perform this action",
      feed_filter_label: "Show posts of",
      feed_filter_whole_group: "Whole group",
      company_selector_group_companies: "Group companies",
      about_visitor_legal_name: "Legal name",
      about_visitor_employees: "Employees",
      about_visitor_no_employees: "No employees to show",
      about_visitor_work_phone: "Work phone",
      // News page: header and sidebar
      news_greeting_morning: "Good morning",
      news_greeting_day: "Good afternoon",
      news_greeting_evening: "Good evening",
      news_absent_summary_one: "{{count}} colleague is away today",
      news_absent_summary_other: "{{count}} colleagues are away today",
      news_sidebar_absent_title: "Away today",
      news_sidebar_new_colleagues_title: "New colleagues",
      news_sidebar_anniversaries_title: "Work anniversaries",
      news_absent_trip: "Business trip",
      news_absent_leave: "Leave",
      news_until: "until {{date}}",
      news_since: "since {{date}}",
      news_today: "today",
      news_years_one: "{{count}} year",
      news_years_other: "{{count}} years",
      news_more_people: "+{{count}} more",
      news_sidebar_events_title: "Events",
      news_events_empty: "No upcoming events",
      news_events_create: "Create event",
      news_event_composer_toggle: "Event",
      news_event_title_label: "Title",
      news_event_date_label: "Date",
      news_event_time_label: "Time",
      news_event_location_label: "Location (optional)",
      news_event_going: "Going",
      news_event_not_going: "Can't make it",
      news_event_going_count: "{{count}} going",
      news_event_past: "Took place",
      news_event_response_failed: "Failed to save your answer",
      news_pinned_badge: "Pinned",
      news_important_checkbox: "Important information",
      news_important_badge: "Important",
      news_details_add: "+ Add a detailed description",
      news_details_placeholder: "Detailed description – shown when someone presses “Show more”",
      news_details_remove: "Remove the detailed description",
      news_pin_action: "Pin",
      news_unpin_action: "Unpin",
      news_pin_dialog_title: "Pin this post to the top",
      news_pin_requires_ack: "Acknowledgement required",
      news_pin_failed: "Failed to save the pin",
      news_ack_button: "I have read this",
      news_ack_done: "You have read this",
      news_ack_count: "{{done}} of {{total}} have read this",
      news_ack_failed: "Failed to save your acknowledgement",
      news_ack_pending_link: "Who has not read it yet",
      news_ack_dialog_title: "Who has read this post",
      news_ack_acknowledged_heading: "Read ({{number}})",
      news_ack_pending_heading: "Not read yet ({{number}})",
      news_ack_nobody_acknowledged: "Nobody yet",
      news_ack_nobody_pending: "Everyone has read it",
      news_ack_load_failed: "Failed to load the list",
      news_reaction_like: "Like",
      news_reaction_celebrate: "Celebrate",
      news_reaction_love: "Love",
      news_reactions_who: "Who reacted",
      news_reactions_none_yet: "No reactions yet",
      news_reactions_load_failed: "Failed to load the list",
      news_reaction_failed: "Failed to save your reaction",
      news_sidebar_birthdays_title: "Birthdays",
      news_birthday_summary_one: "{{count}} birthday today",
      news_birthday_summary_other: "{{count}} birthdays today",
      birthday_card_title: "Birthday",
      birthday_card_hint: "Only the day and month are stored, never the year or age.",
      birthday_month_label: "Month",
      birthday_day_label: "Day",
      birthday_not_set: "Not set",
      birthday_show_to_colleagues: "Show to colleagues in the news",
      birthday_saved: "Birthday saved",
      birthday_save_failed: "Failed to save the birthday",
      birthday_load_failed: "Failed to load the birthday",

      // Deliveries
      deliveries: "Deliveries",
      deliveries_create: "Create Delivery",
      deliveries_edit: "Edit Delivery",
      deliveries_view: "View Delivery",
      deliveries_number: "Delivery #{{number}}",
      deliveries_date: "Delivery Date",
      deliveries_items: "Items",
      deliveries_items_count: "{{count}} items",
      deliveries_no_deliveries: "No deliveries yet",
      deliveries_no_deliveries_description: "Create your first delivery for this order.",
      deliveries_create_first: "Create First Delivery",
      deliveries_summary: "Delivery Summary",
      delivered: "Delivered",
      remaining: "Remaining",
      remaining_to_deliver: "To Deliver",
      deliveries_no_items: "No items in this delivery",
      deliveries_error_loading: "Failed to load deliveries",
      deliveries_error_saving: "Failed to save delivery",
      deliveries_delete_confirm: "Are you sure you want to delete this delivery?",
      deliveries_status_draft: "Draft",
      deliveries_status_planned: "Planned",
      deliveries_status_shipped: "Shipped",
      deliveries_status_delivered: "Delivered",
      deliveries_status_cancelled: "Cancelled",
      deliveries_add_from_order: "Add items from order",
      deliveries_add_selected: "Add selected",
      deliveries_add_any_product: "Add any product",
      deliveries_add_any_product_description: "Search and add products that are not in the order (e.g., from product groups)",
      deliveries_add_from_reservations: "Add from reservations",
      deliveries_add_from_reservations_description: "Select products from confirmed reservations to deliver",
      deliveries_no_available_reservations: "No available reservations. Create and confirm a reservation first.",
      deliveries_reserved: "Reserved",
      deliveries_delivered: "Delivered",
      deliveries_available: "Available",
      deliveries_max_quantity: "max: {{max}}",
      carrier: "Carrier",
      select_carrier: "Select carrier",
      carrier_pristatymas_a: "Pristatymas A",
      carrier_pristatymas_b: "Pristatymas B",
      notes_placeholder: "Add note",
      deliveries_error_no_items: "Please add at least one item to the delivery",
      deliveries_error_missing_reservations: "All items must be linked to reservations",
      deliveries_error_legacy_mix: "Legacy delivery items cannot be mixed with reservation items. Create a new delivery for reservation items.",

      // Deliveries — table of an order's deliveries
      deliveries_col_number: "No.",
      deliveries_col_date: "Date",
      deliveries_col_vehicle: "Truck",
      deliveries_col_products: "Products",
      deliveries_col_quantity_t: "Quantity, t",
      deliveries_col_status: "Status",
      deliveries_col_source: "Source",
      deliveries_source_manual: "Manual",
      deliveries_items_more: "+{{count}}",
      deliveries_total: "Total: {{count}} · {{tonnes}} t",
      deliveries_show_details: "Show details",
      deliveries_hide_details: "Hide details",

      // Deliveries — terminalas sync (source: 'terminalas')
      deliveries_terminalas_badge: "Terminal",
      deliveries_terminalas_managed_notice: "Managed by the terminal — cannot be edited here",
      deliveries_terminalas_plate: "Truck / plate no.",
      deliveries_terminalas_driver: "Driver",
      deliveries_terminalas_carrier: "Carrier",
      deliveries_terminalas_loaded_at: "Loaded",
      deliveries_terminalas_gate_exit_at: "Gate exit",
      deliveries_terminalas_net_weight: "Net weight",
      deliveries_terminalas_order_code: "Terminal order",
      deliveries_terminalas_warning_over_reserved: "Reserved quantity exceeded",
      deliveries_terminalas_warning_over_ordered: "Contract quantity exceeded",
      deliveries_terminalas_warning_product_not_in_contract: "Product not in contract",
      deliveries_terminalas_warning_product_not_in_reservation: "Product not in reservation",
      deliveries_terminalas_warning_product_unknown: "Unknown product",
      deliveries_terminalas_warning_order_not_sellable: "Contract not signed or annulled",

      ordered: "Ordered",
      remove: "Remove",
      add: "Add",
      search_products: "Search products",
      retry: "Retry",
      expand: "Expand",
      collapse: "Collapse",
      // Customer card → products tab: sales by period
      customer_products_search_placeholder: "Search product or code",
      customer_products_quantity: "Quantity",
      customer_products_no_unit: "no unit",
      customer_products_net_amount: "Amount excl. VAT",
      customer_products_returned: "Returned",
      customer_products_invoice_count: "Times purchased",
      customer_products_count: "Products",
      customer_products_period: "Period",
      customer_products_preset_this_month: "This month",
      customer_products_preset_last_month: "Last month",
      customer_products_preset_this_year: "This year",
      customer_products_preset_last_year: "Last year",
      customer_products_preset_last_12_months: "Last 12 months",
      customer_products_preset_all: "All time",
      customer_products_preset_custom: "Custom…",
      customer_products_custom_from: "From",
      customer_products_custom_to: "To",
      customer_products_custom_apply: "Show",
      customer_products_period_with_dates: "{{label}} ({{from}} – {{to}})",
      customer_products_period_custom_label: "Chosen period",
      customer_products_unconverted: "Documents in another currency that could not be converted to EUR are not included in the amounts: {{value}}",
      customer_products_empty_customer: "No sales for this customer.",
      customer_products_empty_period: "No sales in this period.",
      customer_products_load_failed: "Could not load the products.",
      // Products page (catalogue with the product's sales)
      products_page_search_placeholder: "Search by title or code",
      products_page_services: "Services",
      products_page_goods: "Goods",
      products_page_new: "New product or service",
      products_page_type_product: "Product",
      products_page_type_service: "Service",
      products_page_stock: "In stock {{quantity}}",
      products_page_reserved_short: "res. {{quantity}}",
      products_page_list_failed: "Could not load the products.",
      products_page_nothing_found: "Nothing found",
      products_page_load_failed: "Could not load the product.",
      products_page_pick_one: "Pick a product or service from the list.",
      products_page_back_to_list: "Back to the list",
      products_page_price: "Price",
      products_page_in_stock: "In stock",
      products_page_reserved: "Reserved",
      products_page_free: "Available",
      products_page_tab_sales: "Sales",
      products_page_tab_stock: "Stock",
      products_page_tab_reservations: "Reservations",
      products_page_tab_meta: "Finvalda data",
      products_page_no_stock: "No stock.",
      products_page_no_reservations: "No reservations.",
      products_page_meta_field: "Field",
      products_page_meta_value: "Value",
      products_page_period: "Period",
      products_page_period_this_year: "This year",
      products_page_period_last_year: "Last year",
      products_page_period_last_12_months: "12 months",
      products_page_period_total: "Over the chosen period",
      products_page_unconverted: "Documents in another currency that could not be converted to EUR are not included in the amounts: {{value}}",
      products_page_sales_failed: "Could not load the sales.",
      products_page_no_sales: "No sales in this period.",
      products_page_invoice: "Invoice",
      products_page_net_amount: "Amount excl. VAT",
      products_page_return: "Return",
      // Reservations
      reservations: "Reservations",
      reservation: "Reservation",
      reservations_create: "Create Reservation",
      reservations_edit: "Edit Reservation",
      reservations_view: "View Reservation",
      reservations_number: "Reservation #{{number}}",
      reservations_items: "Items",
      reservations_items_count: "{{count}} items",
      reservations_no_reservations: "No reservations yet",
      reservations_no_reservations_description: "Create your first reservation for this order.",
      reservations_create_first: "Create First Reservation",
      reservations_summary: "Reservation Summary",
      reserved: "Reserved",
      reservations_no_items: "No items in this reservation",
      reservations_stock_warning: "Stock Warning",
      reservations_stock_warning_message: "Insufficient stock: requested {{requested}}, available {{available}}",
      reservations_stock_warnings_title: "Some items have insufficient stock:",
      reservations_no_available_quantity: "No available quantity left to reserve",
      reservations_no_items_yet: "No items added yet",
      reservations_error_loading: "Failed to load reservations",
      reservations_error_saving: "Failed to save reservation",
      reservations_delete_confirm: "Are you sure you want to delete this reservation?",
      reservations_status_draft: "Draft",
      reservations_status_confirmed: "Confirmed",
      reservations_status_cancelled: "Cancelled",
      reservations_add_from_order: "Add items from order",
      reservations_add_selected: "Add selected",
      reservations_add_any_product: "Add any product",
      reservations_add_any_product_description: "Search and add products that are not in the order",
      reservations_error_no_items: "Please add at least one item to the reservation",
      reservations_customer_fills_delivery: "Customer fills delivery info",
      reservations_customer_fills_delivery_help: "Customer will be able to fill transport and delivery details in the customer portal",
      customer_portal: "Customer portal",
      customer_portal_generate_link: "Generate login link",
      customer_portal_send_link: "Send login link",
      customer_portal_copy_link: "Copy link",
      customer_portal_link_copied: "Copied!",
      customer_portal_link_error: "Failed to generate link.",
      customer_portal_send_link_success: "Login link sent.",
      customer_portal_send_link_error: "Failed to send login link.",
      customer_portal_email_missing: "Customer email is missing.",
      reservations_select_warehouse_first: "Please select a warehouse first",
      select_warehouse: "Select warehouse",
      warehouse: "Warehouse",
      available_stock: "Available stock",

      // Fulfillment
      fulfillment: "Fulfillment",
      amendments: "Amendments",
      fulfillment_summary: "Fulfillment Summary",
      fulfillment_group_line: "{{name}} (group {{code}})",
      shipped: "Shipped",
      ship: "Ship",
      reserve: "Reserve",
      complete: "Complete",
      confirmed: "Confirmed",
      draft: "Draft",
      new: "New",
      // NEW: Annual Finance System translations
      finance_approvals: "Finance Approvals",
      create_new_year_approval: "Create New Year Approval",
      year: "Year",
      valid_until: "Valid Until",
      view_details: "View Details",
      view_details_for: "View details for {{name}}",
      active: "Active",
      expired: "Expired",
      approved: "Approved",
      no_finance_approvals: "No Finance Approvals",
      no_finance_approvals_description: "Create the first finance approval for this customer",
      create_first_approval: "Create First Approval",
      finance_approval_expired: "Finance approval has expired",
      cannot_create_order: "Cannot create order",
      no_valid_finance_approval: "No valid finance approval found",
      finance_approval: "Finance Approval",
      questionnaire_satisfied_from_previous_year:
        "Questionnaire satisfied (completed in a previous year). You can proceed to the next steps.",
      regenerate_questionnaire_pdf: "Regenerate questionnaire PDF",
      questionnaire_sent: "Sent",
      questionnaire_cross_company_confirm_title: "Copy questionnaire from another company?",
      questionnaire_cross_company_confirm_message:
        "A completed questionnaire exists for this VAT in “{{company}}”. Form fields{{attachments}} will be copied into this request (including re-uploading attachments to this company). Continue?",
      questionnaire_cross_company_attachments_suffix:
        " and {{count}} attached file(s)",
      questionnaire_cross_company_attachments_none: "",
      confirm_copy_and_send: "Yes, copy and send",
      questionnaire_send_fresh_form:
        "Send empty form (no copy from other company)",
      questionnaire_signed_at: "Signed",
      new_version_available: "New version available",
      request_sent_to_manager_for_approval:
        "Request has been sent to manager for approval.",
      are_you_sure_you_want_to_save_and_approve_finance:
        "Are you sure you want to save and approve these terms?",
      finance_terms_approved: "Terms approved",
      finance_document_regenerate_failed:
        "Terms approved, but the document could not be updated. Please try again.",
      no_pending_approvals: "No pending approvals",
      no_expiring_documents: "No expiring documents",
      expiring_documents_description:
        "Documents assigned to you that expire within the next 30 days",
      expiring_soon: "Expiring Soon",
      expiring: "Expiring",
      no_date: "No Date",
      expiration_date: "Expiration Date",
      business_trips: "Business Trips",
      leave_calendar: "Leave calendar",
      // The company-wide calendar's menu item and page title; «leave_calendar» stays for the employee's own wall calendar.
      team_calendar: "Team calendar",
      leave_calendar_all_teams: "All teams",
      leave_calendar_view: "View",
      leave_calendar_monthly: "Monthly",
      leave_calendar_yearly: "Yearly",
      leave_calendar_year: "Year",
      leave_calendar_month: "Month",
      leave_calendar_team: "Team",
      leave_calendar_search_employees: "Search employees",
      leave_calendar_today: "Today",
      leave_calendar_employee: "Employee",
      leave_calendar_vacation: "Vacation days",
      leave_calendar_holidays: "Holidays",
      leave_calendar_weekend_holidays: "Weekend off",
      leave_calendar_rules_today_bg: "Teal ring = today",
      leave_calendar_sick: "Sick leave",
      leave_calendar_business_trip: "Business trip",
      leave_calendar_type_vacation: "Vacation",
      leave_calendar_type_sick: "Sick leave",
      leave_calendar_type_business_trip: "Business trip",
      leave_calendar_type_remote_work: "Remote work",
      leave_calendar_modal_create_title: "New leave",
      leave_calendar_modal_edit_title: "Edit leave",
      leave_calendar_modal_create_hint:
        "Select employee, dates and type. Each type requires a File Type where 'template' or 'label' matches the code, and a User Template using that file type. PDF is generated on submit; request waits for approval.",
      leave_calendar_leave_VACATION: "Vacation",
      leave_calendar_leave_UNPAID_LEAVE: "Unpaid leave",
      leave_calendar_leave_ADDITIONAL_DAY_OFF: "Additional day off (parents)",
      leave_calendar_leave_ADDITIONAL_REST_TIME: "Additional rest time (September 1)",
      leave_calendar_leave_PATERNITY_LEAVE: "Paternity leave",
      leave_calendar_leave_BUSINESS_TRIP_LEAVE: "Business trip leave",
      leave_calendar_leave_REMOTE_WORK: "Remote work",
      past: "Past",
      leave_calendar_template_resolve_error:
        "No template found for this type. Please create a File Type with 'template' or 'label' matching the type, and a User Template with that type.",
      leave_calendar_error_invalid_type: "Invalid leave type.",
      leave_calendar_modal_edit_hint: "Leave request details.",
      leave_calendar_modal_view_title: "Leave request",
      leave_calendar_modal_view_hint: "View this request. Approvers can accept or reject while it is pending.",
      leave_calendar_modal_employee: "Employee",
      leave_calendar_modal_start: "Start date",
      leave_calendar_modal_end: "End date",
      leave_calendar_modal_type: "Leave type",
      leave_calendar_modal_comment: "Comment (optional)",
      leave_calendar_submit: "Submit",
      leave_calendar_generate_document: "Generate Document",
      leave_calendar_footer_hint:
        "Drag across days to request leave. Click a block to open the request. Pending items show an amber outline; half-days use a half-height bar.",
      leave_calendar_rules_title: "Calendar rules",
      leave_calendar_rules_vacation: "Vacation / Unpaid / Additional days / Paternity / Business Trip Leave",
      leave_calendar_rules_business_trip: "Business Trip",
      leave_calendar_rules_today_holiday: "Today + Holiday",
      leave_calendar_rules_sick: "Sick leave (legacy)",
      leave_calendar_rules_trip: "Business trip (legacy)",
      leave_calendar_rules_pending: "Pending approval",
      leave_calendar_rules_rejected_cancelled: "Rejected or cancelled",
      leave_calendar_rules_holiday_dot: "Yellow dot = holiday",
      leave_calendar_rules_holiday_bg: "Grey background = holiday day",
      leave_calendar_rules_weekend_bg: "Light violet = weekend off-day",
      leave_calendar_rules_half_day: "Half-day strip = 0.5 per working day",
      leave_calendar_rules_hourly:
        "Thin bottom strip = hourly leave; totals use (hours ÷ 8) per day",
      leave_calendar_hourly_single_date:
        "Hourly leave must use the same start and end date.",
      leave_calendar_duration_label: "Duration",
      leave_calendar_duration_full: "Full day(s)",
      leave_calendar_duration_half: "Half day",
      leave_calendar_duration_hourly: "Hourly",
      leave_calendar_start_time: "Start time",
      leave_calendar_end_time: "End time",
      leave_calendar_status_label: "Status",
      leave_calendar_status_draft: "Draft",
      leave_calendar_status_pending_approval: "Pending approval",
      leave_calendar_status_approved: "Approved",
      leave_calendar_status_rejected: "Rejected",
      leave_calendar_status_cancelled: "Cancelled",
      leave_calendar_approve: "Approve",
      leave_calendar_reject: "Reject",
      leave_calendar_reject_reason: "Rejection reason (optional)",
      leave_calendar_open_document: "Open document",
      leave_calendar_validation_required:
        "Please fill dates and leave type (and sign in if your session is missing).",
      leave_calendar_half_day_single_date: "Half-day leave must use the same start and end date.",
      leave_calendar_half_day_times: "Start and end times are required.",
      leave_calendar_template_required: "Please select a template before submitting.",
      leave_calendar_time_range_invalid: "Start time must be earlier than end time.",
      leave_calendar_no_template_for_type: "No document template is configured for this leave type.",
      leave_calendar_error_not_configured: "This leave type is not configured for your company.",
      leave_calendar_error_template_missing: "The leave type has no template assigned.",
      leave_calendar_error_pdf_failed: "The PDF could not be generated. Check the template and try again.",
      leave_calendar_error_generic: "Could not submit the leave request.",
      leave_calendar_action_failed: "Action failed. Check your permissions and try again.",
      leave_calendar_open_file_failed: "Could not open the file. Try from the employee profile files list.",
      leave_calendar_off_day_error_toast: "You cannot add a leave request on a weekend or holiday",
      leave_calendar_start_off_day: "Start date cannot be a weekend or holiday",
      leave_calendar_end_off_day: "End date cannot be a weekend or holiday",
      leave_calendar_overlap_error: "You already have a leave request during this period",
      leave_calendar_past_date_error: "Start date cannot be in the past",
      leave_calendar_start_after_end: "Start date must be before or equal to end date",
      leave_calendar_max_days_error: "A leave request cannot be longer than {{days}} days",
      leave_calendar_trip_required:
        "Business trip selection is required for this leave type",
      leave_calendar_trip_select_dates_hint:
        "Select start and end dates to load available trips.",
      leave_calendar_trip_not_found_for_dates:
        "No business trips found for this user in the selected date range.",
      business_trip: "Business Trip",
      business_trip_settings: "Business Trip Settings",
      // mobile: documents-modules
      category_access_subcategories: "Subcategories",
      add_to_favorites: "Add to favorites",
      remove_from_favorites: "Remove from favorites",
      asset_assign_user: "Assign user",
      onboarding_contract_settings: "Onboarding Contract Settings",
      onboarding_contract_standard: "Standard Employment Contract",
      onboarding_contract_director: "Director Employment Contract",
      onboarding_document_settings_hint:
        "A document without a category is created and can be found by search, but it does not appear in the document tree.",
      onboarding_generated_documents: "Generated documents",
      onboarding_generated_documents_hint: "The system creates these while hiring.",
      onboarding_uploaded_documents: "Documents uploaded by the employee",
      onboarding_uploaded_documents_hint:
        "The employee or an HR specialist uploads these while hiring.",
      onboarding_hiring_questionnaire: "Hiring Questionnaire",
      onboarding_esignature_agreement: "E-Signature Agreement",
      onboarding_employee_questionnaire: "Employee Questionnaire",
      onboarding_application: "Application for Employment",
      onboarding_gdpr_statement: "GDPR Statement",
      onboarding_upload_other: "Other document",
      onboarding_signed_container: "Signed e-document package (ASiC-E)",
      onboarding_filed_in: "Filed in: {{path}}",
      onboarding_category_missing: "No category chosen — the document will not appear in the tree",
      onboarding_asset_requests_link: "Permissions settings",
      approve_medical: "Approve medical check",
      medical_approve_not_authorized: "Only a Master, HR, medical-check staff or the employee's department head can approve the medical check.",
      can_approve: "Can approve",
      resend: "Resend",
      reminder_sent: "Reminder sent",
      activation_pending_message: "All documents have been signed. Your account will be activated shortly by the administrator.",
      employee_activation_setup: "Employee Activation",
      activate_employee: "Activate Employee",
      activation_permissions_title: "What they can do",
      activation_permissions_hint: "Rights from the position are added automatically. You can add extra rights here (optional).",
      activation_master_assign_forbidden: "Only an administrator can give the administrator right.",
      activation_personal_area_only: "The employee gets access to their personal area. Further rights are given by a Master.",
      select_folder_access: "Folder access",
      no_categories: "No categories available",
      revoke_medical_approval: "Revoke medical approval",
      generate_documents: "Generate documents",
      send_for_signature: "Send for signature",
      regenerate_documents: "Regenerate documents",
      manual_signature: "Manual (paper)",
      amendment_signontab_tablet: "SignOnTab tablet",
      amendment_signontab_no_tablets: "No SignOnTab tablets for this company",
      amendment_signontab_tablets_failed: "Could not load SignOnTab tablets.",
      amendment_signontab_waiting: "Waiting for signatures on the SignOnTab tablet",
      amendment_signontab_send_failed: "Could not send the amendment to SignOnTab",
      onboarding_signontab_send_failed: "Could not send the documents to SignOnTab",
      onboarding_signontab_still_on_tablet: "Some documents may still be on the tablet. Check the tablet and cancel them there, or press Regenerate later.",
      onboarding_signontab_document_cancelled: "A document was cancelled on the tablet. Regenerate the documents and send them again.",
      medical_check: "Medical check",
      medical_check_pending: "Pending approval",
      medical_check_approved: "Approved",
      medical_certificate: "Medical certificate",
      upload_medical_files: "Upload medical files",
      manager_required: "Manager is required",
      confirm_revoke_medical: "Are you sure you want to revoke the medical check approval?",
      medical_approval_revoked: "Medical approval revoked",
      sent_for_signature: "Sent for signature",
      configured: "Configured",
      reviewed: "Reviewed",
      confirm_delete: "Delete?",
      order_amendment_custom_template_warning:
        "Custom templates may diverge from the latest system or legal updates. Consider resetting to the system template to stay up to date.",
      fuel_report_settings: "Fuel Report Settings",
      fuel_report_document_template: "Fuel Report Document",
      fuel_report_custom_template_warning:
        "Custom templates may diverge from the latest system or legal updates. Consider resetting to the system template to stay up to date.",
      fuel_report_document_already_created:
        "A document for this report has already been created.",
      fuel_report_signatures_locked:
        "This report's document is waiting for a signature that would be lost by this change (for example, the approver no longer works here). Ask a fuel reports manager for help.",
      fuel_report_not_found: "Fuel report not found.",
      fuel_report_signed_edit_forbidden:
        "The report is signed — only a fuel reports manager can edit it.",
      fuel_report_document_in_progress:
        "This report is being saved right now. Wait a moment and try again.",
      fuel_barcode_panel_description:
        "Fuel card statement lines that match this list count as fuel. All other lines count as additional expenses.",
      fuel_barcode_provider_hint:
        "Rotada statements are recognised by barcode, E100 by product class and Korta by service type (Paslaugos rūšis).",
      fuel_barcode_defaults_notice:
        "No active fuel barcodes — no records will be classified as fuel. Click \"Import defaults\" or add entries.",
      fuel_barcode_import_defaults: "Import defaults",
      fuel_barcode_defaults_imported:
        "Default barcodes, product class, and service types imported.",
      fuel_barcode_defaults_already_present:
        "All default barcodes are already added.",
      fuel_barcode_no_data: "No fuel barcodes configured yet.",
      fuel_barcode_value: "Barcode",
      fuel_barcode_value_help:
        "The barcode as it appears in the station export. Leading zeros are ignored.",
      fuel_barcode_product_class_value: "Product class",
      fuel_barcode_service_type_value: "Service type",
      fuel_barcode_service_type_help:
        "Paslaugos rūšis value from the Korta (V3) CSV export, e.g. Benzinas 95.",
      fuel_barcode_type: "Type",
      fuel_barcode_type_barcode: "Barcode",
      fuel_barcode_type_product_class: "Product class",
      fuel_barcode_type_service_type: "Service type",
      fuel_barcode_description: "Description",
      fuel_barcode_active: "Active",
      fuel_barcode_resource_singular: "fuel barcode",
      fuel_barcode_resource_plural: "fuel barcodes",
      fuel_barcode_duplicate: "This value already exists for the selected type.",
      fuel_barcode_value_required: "Please enter a value.",
      fuel_barcode_error_loading: "Failed to load fuel barcodes.",
      fuel_barcode_error_saving: "Failed to save. Please try again.",
      fuel_barcodes_card_title: "What counts as fuel on a statement",
      fuel_barcode_provider: "Supplier",
      fuel_barcode_recognised_by: "Recognised by",
      fuel_barcode_column_value: "Value",
      business_trip_main_template: "Business trip order",
      business_trip_report_template: "Business trip report",
      business_trip_leave_template: "Request for a day off during the trip",
      business_trip_main_template_not_configured: "Main trip document template is not configured. Please set it in Company Settings → Business Trip Settings.",
      business_trip_report_template_not_configured: "Report document template is not configured. Please set it in Company Settings → Business Trip Settings.",
      business_trip_leave_template_not_configured: "Leave document template is not configured. Please set it in Company Settings → Business Trip Settings.",
      business_trip_custom_template_warning: "Custom templates may diverge from the latest system or legal updates. Consider resetting to the system template to stay up to date.",
      use_custom_template: "Use custom template",
      reset_to_system_template: "Reset to system template",
      select_template: "Select a template",
      series_file_type_category_required:
        "Series, file type, and category are required for system template mode.",
      required: "Required",
      system: "System",
      custom: "Custom",
      template_slot_system: "System template",
      template_slot_custom: "Own template",
      template_slot_placed_in: "placed in: {{category}}",
      template_slot_not_placed: "not placed anywhere yet",
      template_slot_system_metadata_required:
        "Choose a series, file type and category for every document that uses the system template.",
      template_slot_template_required:
        "Choose a template for every document that uses your own template.",
      template_slot_choice_missing: "Something you chose no longer exists. Choose it again.",
      trip_updated_document_invalidated: "Trip updated. The main document has been removed — please regenerate it.",
      create_business_trip: "Create Business Trip",
      edit_business_trip: "Edit Business Trip",
      generate_business_trip_document: "Generate Business Trip Document",
      sign_the_business_trip: "Sign the Business Trip Document",
      business_trip_document_empty_hint:
        "Generate a PDF document from this business trip to download or send for signing.",
      business_trip_signers_empty_hint:
        "After generating the document, signers will appear here.",
      date_range: "Date range",
      date_range_placeholder: "YYYY-MM-DD – YYYY-MM-DD",
      date_range_open_calendar: "Open calendar to choose range",
      date_range_input_help:
        "Type each date as year–month–day (digits only, same as elsewhere), or pick a range in the calendar. The highlighted days show your selection.",
      date_from: "Date From",
      date_to: "Date To",
      // Reused by MakeSeparateDocumentModal/file-form.jsx — existed only in
      // the lt block below (Desk #237 follow-up). Distinct from `date_to`
      // above (business trip date range).
      dateTo: "To date",
      place_of_business_trip: "Place of Business Trip",
      transport_used: "Transport Used",
      purpose: "Purpose",
      advance_for_expenses: "Advance for Expenses",
      substitute_person: "Substitute Person",
      details: "Details",
      date_to_must_be_after_date_from: "Date to must be after date from",
      status_draft: "Draft",
      status_pending_approval: "Pending Approval",
      status_approved: "Approved",
      status_in_progress: "In Progress",
      status_pending_report: "Pending Report",
      status_report_rejected: "Report Rejected",
      status_completed: "Completed",
      decline: "Decline",
      declined: "Declined",
      are_you_sure_you_want_to_decline_document_signature_request:
        "Are you sure you want to decline the document signature request?",
      reason_for_decline_signature: "Reason for declining",
      annul_report: "Annul report",
      are_you_sure_you_want_to_annul_report:
        "Are you sure you want to annul this report?",
      annul_report_warning:
        "If the report document was fully signed, it stays on file marked ANNULLED and every signer is notified by email; otherwise it is deleted outright. Either way the report data stays and can be regenerated and re-signed.",
      annul_report_reason: "Reason for annulment",
      annul_report_reason_placeholder:
        "Describe why the report is being annulled",
      report_annulled_success_title: "Report annulled",
      report_annulled_success_instruction:
        "If the report document was fully signed, it stays on file marked ANNULLED and signers were notified; otherwise it was deleted. Regenerate the report document in step 3 and have all parties sign it again.",
      please_provide_a_reason_for_declining_the_signature_request:
        "Please provide a reason for declining the signature request",
      // Business trip expenses
      add_expense: "Add Expense",
      no_expenses_yet: "No expenses added yet. Add your trip expenses to include them in the report.",
      expense_category: "Category",
      expense_category_transport: "Transport",
      expense_category_fuel: "Fuel",
      expense_category_accommodation: "Accommodation",
      expense_category_food: "Food & Meals",
      expense_category_taxes: "Taxes & Fees",
      expense_category_other: "Other",
      amount_eur: "Amount EUR",
      amount_in_eur: "Amount in EUR",
      receipt: "Receipt",
      receipt_attached: "Receipt attached",
      receipt_missing: "Receipt missing",
      receipt_upload_hint: "Upload receipt image or PDF (max 10 MB)",
      missing_receipts_warning: "{{missing}} of {{total}} expenses are missing receipts",
      exchange_rate: "Exchange Rate",
      exchange_rate_reference_link: "Bank of Lithuania exchange rates",
      invalid_amount: "Invalid amount",
      invalid_exchange_rate: "Invalid exchange rate",
      difference: "Difference",
      to_reimburse: "to reimburse employee",
      employee_returns: "employee returns",
      advance_fully_used: "advance fully used",
      currency: "Currency",
      actions: "Actions",
      // Onboarding
      onboarding: "Onboarding",
      hr_module: "HR",
      create_onboarding: "Create Onboarding",
      hiring_questionnaire: "Hiring Questionnaire",
      employee: "Employee",
      position: "Position",
      hiring_date: "Hiring Date",
      created_at: "Created At",
      step: "Step",
      completed: "Completed",
      cancelled: "Cancelled",
      progress: "Progress",
      administration: "Administration",
      work_email: "Work Email",
      company_car: "Company Car",
      kiosk_code: "Kiosk Code",
      kiosk_instructions: "Open /onboarding/kiosk on a tablet. The employee enters their personal code and this kiosk code to fill forms.",
      signing_method: "Signing Method",
      complete_step: "Complete Step",
      step_completed: "Step completed successfully",
      send_login_link: "Send login link",
      login_link_sent: "Login link sent",
      complete_step_1: "Complete step 1",
      confirm_complete_step_1:
        "Mark step 1 as complete and advance to step 2? The assets-responsible user will be notified.",
      confirm: "Confirm",
      Yes: "Yes",
      No: "No",
      confirm_cancel_onboarding: "Are you sure you want to cancel this onboarding?",
      first_name: "First Name",
      last_name: "Last Name",
      personal_email: "Personal Email",
      personal_phone: "Personal Phone",
      birth_year: "Birth Year",
      birth_date: "Date of Birth",
      work_location: "Work Location",
      position_lt: "Position (LT)",
      position_en: "Position (EN)",
      target_company: "Target Company",
      salary: "Salary",
      hours_per_week: "Hours per Week",
      probation_months: "Probation (months)",
      contract_type: "Contract Type",
      contract_variant: "Contract Variant",
      contract_end_date: "Contract End Date",
      contract_type_other: "Contract Type (other)",
      contract_type_indefinite: "Indefinite",
      contract_type_fixed_term: "Fixed term",
      contract_type_other_value: "Other",
      contract_variant_standard: "Standard",
      contract_variant_summed: "Summed working time",
      contract_variant_director: "Director",
      my_onboarding: "My Onboarding",
      no_active_onboarding: "You don't have an active onboarding process.",
      multiple_onboardings_select_company: "You have onboarding processes in multiple companies. Select one to continue.",
      continue: "Continue",
      data_saved: "Data saved successfully",
      waiting_for_signature_description: "This step is waiting for signatures. You will be notified when it's your turn to sign.",
      onboarding_completed_message: "Your onboarding is complete! All documents have been signed.",
      user_form_permissions_title: "What they can do",
      user_form_permissions_hint: "Rights from the position are added automatically. Tick only the extra rights here.",
      membership_kind: "Membership type",
      membership_kind_employee: "Employee",
      membership_kind_employee_hint: "Works under an employment contract. Shown in About company and HR.",
      membership_kind_authorized: "Authorized person",
      membership_kind_authorized_hint: "Not under an employment contract. Hidden from employee lists but can sign documents and procedures.",
      membership_kind_guest: "Guest",
      membership_kind_guest_hint: "Hidden from employee lists and cannot be chosen as a signer.",
      activation_waiting: "Your documents have been signed. The administrator is finalizing your account setup.",
      employee_activated: "Employee activated successfully",
      onboarding_documents: "Onboarding Documents",
      upload_photo: "Upload photo",
      change_photo: "Change photo",
      remove_photo: "Remove photo",
      avatar_updated: "Photo updated",
      avatar_removed: "Photo removed",
      avatar_imported: "Photo imported",
      avatar_import_failed: "Could not import the photo",
      avatar_upload_failed: "Could not upload the photo",
      use_photo_from_other_company: "Use my photo from another company",
      use_this_photo: "Use this",
      avatar_must_be_image: "File must be an image",
      avatar_file_too_large: "Image must be 10 MB or smaller",
      select_image_to_upload: "Select an image to upload",
      choose_file: "Choose file",
      choose_another: "Choose another",
      zoom: "Zoom",
      online: "Online",
      online_count: "{{count}} online",
      no_one_online: "No one else online",
      offline_section_title: "Offline",
      last_seen: "Last seen",
      open_full_profile: "Open full profile",
      avatar_upload_prompt: "Add a photo so colleagues recognise you →",
      chats: "Chats",
      company_chat: "Company chat",
      // chat calls (1:1 voice)
      call_start: "Call",
      call_incoming_title: "Incoming call",
      call_accept: "Answer",
      call_decline: "Decline",
      call_hang_up: "Hang up",
      call_mute: "Mute",
      call_unmute: "Unmute",
      call_ringing: "Ringing…",
      call_connecting: "Connecting…",
      call_declined: "Call declined",
      call_busy: "They are on another call",
      call_missed: "Missed call",
      call_no_answer: "No answer",
      call_offline: "They are not online",
      call_failed: "Call failed",
      call_mic_denied: "Microphone unavailable",
      call_already_in_call: "You are already on a call",
      call_camera_denied: "Camera unavailable",
      call_camera_on: "Turn camera on",
      call_camera_off: "Turn camera off",
      call_screen_share: "Share screen",
      call_screen_stop: "Stop sharing",
      call_screen_unavailable: "Screen sharing is not available here",
      call_add_person: "Add someone",
      call_invite_title: "Invited you to a call",
      call_invited: "{{name}} has been invited",
      call_group_title: "Group call",
      call_group_unavailable: "Group calls are not available",
      call_you: "You",
      call_your_screen: "Your screen",
      call_reconnecting: "Reconnecting…",
      call_everyone_left: "Everyone else left the call",
      call_on_a_call: "On a call",
      call_guest_link: "Link for a guest",
      call_guest_link_copied: "Guest link copied",
      call_guest_title: "You have been invited to a call",
      call_guest_name: "Your name",
      call_guest_join: "Join",
      call_guest_link_invalid: "This link no longer works",
      call_guest_over: "The call has ended",
      call_guest_left: "You have left the call",
      call_guest_mic_hint: "Your microphone will be asked for when you join",
      call_enlarge: "Enlarge",
      call_fullscreen: "Full screen",
      call_mic_permission: "Waiting for microphone permission…",
      call_peer_mic_permission: "{{name}} is allowing the microphone…",
      call_the_other_side: "The other side",
      call_mic_permission_prompt: "Your browser is asking to use the microphone — click Allow.",
      call_mic_permission_hidden: "Don't see the request? Click the microphone/site icon in the address bar, or bring this tab to the front.",
      call_help_chrome_open: "Click the icon at the left of the address bar (the lock or site settings)",
      call_help_set_allow: "Set Microphone to Allow",
      call_help_safari_open: "In the Safari menu, choose Settings for This Website",
      call_help_safari_ios_open: "Tap “aA” in the address bar, then Website Settings",
      call_help_firefox_open: "Click the microphone (permissions) icon in the address bar",
      call_help_firefox_unblock: "Remove the microphone block (the × next to “Blocked”)",
      call_help_generic: "Allow the microphone for this site in the browser's site settings",
      call_help_reload: "Reload the page",
      call_help_os_mac: "If the browser is allowed but still has no microphone: System Settings → Privacy & Security → Microphone → turn the browser on",
      call_help_os_windows: "If the browser is allowed but still has no microphone: Windows Settings → Privacy & security → Microphone → turn on “Let desktop apps access your microphone”",
      call_help_os_ios: "If the browser is allowed but still has no microphone: iPhone Settings → {{browser}} → Microphone: on",
      call_help_os_android: "If the browser is allowed but still has no microphone: Settings → Apps → {{browser}} → Permissions → Microphone",
      call_help_this_browser: "your browser",
      call_fail_mic_title: "Microphone unavailable",
      call_fail_mic_body: "The browser did not allow this page to use the microphone. To fix it:",
      call_fail_mic_pending_title: "No microphone permission",
      call_fail_mic_pending_body: "The microphone request was never answered — it was probably hidden (a background tab, a dismissed popup, a window on top). Click the microphone/site icon in the address bar, or bring this tab to the front, and allow the microphone:",
      call_fail_peer_title: "{{name}} did not connect",
      call_fail_peer_body: "Their browser did not grant the microphone. Ask them to allow it next to the address bar, then call again.",
      call_fail_network_title: "Could not connect",
      call_fail_network_body: "The network or a firewall is probably blocking calls.",
      call_fail_dropped_title: "Connection lost",
      call_fail_dropped_body: "The call dropped — the network connection was interrupted.",
      call_check_mic: "Check microphone",
      call_check_network: "Check network",
      call_checking: "Checking…",
      call_again: "Call again",
      call_copy_report: "Copy report",
      call_report: "Call problem report",
      call_report_copied: "Report copied",
      call_check_mic_ok: "Microphone works",
      call_check_mic_ok_device: "Microphone works: {{device}}",
      call_check_mic_silent: "…but it seems silent — check the input device or the mute switch.",
      call_check_mic_denied: "Microphone is blocked for this site",
      call_check_mic_missing: "No microphone found",
      call_check_mic_busy: "Another app is using the microphone",
      call_check_mic_failed: "Microphone check failed",
      call_check_net_needs_call: "The network check needs a call attempt first — call again, then check.",
      call_check_net_blocked: "Your network blocks calls — please send this report to your IT administrator.",
      call_check_net_tls_only: "Only the encrypted TCP path works; calls should still connect — try again.",
      call_check_net_no_relay: "Direct connections may work, but the relay servers are unreachable — if calls keep failing, send this report to your IT administrator.",
      call_check_net_ok: "Network is fine — try calling again.",
      call_check_net_no_turn: "The call service offered no relay server for this call — that is not your network. Call again; if it keeps happening, send this report to support.",
      call_check_ok: "works",
      call_check_fail: "blocked",
      user_profile: "Profile",
      no_conversations: "No conversations yet",
      no_messages_yet: "No messages yet",
      message_deleted: "Message deleted",
      edited: "edited",
      composer_coming_soon: "Composer — coming next",
      new_messages_count: "{{count}} new",
      link_kind_asset: "Asset",
      link_kind_profile: "Profile",
      link_kind_customer: "Customer",
      link_kind_document: "Document",
      link_kind_onboarding: "Onboarding",
      link_kind_business_trip: "Business trip",
      link_kind_leave: "Leave",
      link_kind_link: "Link",
      new_message: "New message",
      new_dm_in_other_company: "New message in {{company}}",
      open: "Open",
      type_a_message: "Type a message...",
      send: "Send",
      send_message: "Send message",
      attach_file: "Attach file",
      message_too_long: "Message is too long",
      file_upload_failed: "File upload failed",
      cannot_edit_after_window: "Edit window has expired",
      recognition: "Recognition",
      give_kudos: "Give kudos",
      send_kudos: "Send kudos",
      kudos_sent: "Kudos sent",
      giving_kudos_to: "Giving kudos to",
      kudos_reason_label: "Why?",
      kudos_reason_placeholder: "Helped me debug an issue, stayed late to push the fix.",
      kudos_reason_min: "At least 3 characters",
      kudos_no_balance: "No kudos left for today",
      kudos_no_balance_hint: "You have no kudos left today. Balance refreshes every day.",
      kudos_self_forbidden: "You cannot give kudos to yourself",
      kudos_reason_too_short: "Reason is too short",
      kudos_reason_too_long: "Reason is too long",
      kudos_invalid_amount: "Invalid amount",
      kudos_amount: "Amount",
      kudos_balance_tooltip: "Kudos to give today (resets every day)",
      kudos_received_from: "{{name}} gave you kudos",
      kudos_received_from_amount: "{{name}} gave you {{bolts}}",
      unread_kudos: "You have unread kudos",
      gave_kudos_to: "gave kudos to",
      no_kudos_yet: "No kudos in this company yet — be the first!",
      recent_kudos: "Recent kudos",
      karma_unit: "karma",
      balance: "Balance",
      level_newbie: "Newbie",
      level_helper: "Helper",
      level_contributor: "Contributor",
      level_star: "Star",
      level_champion: "Champion",
      level_legend: "Legend",
      last_seen_never: "Never",
      last_seen_just_now: "Just now",
      last_seen_minutes: "{{count}}m ago",
      last_seen_hours: "{{count}}h ago",
      last_seen_days: "{{count}}d ago",
      click_to_collapse: "Click to collapse",
      profile_leaves_tab: "Employee calendar",
      profile_leaves_list_toggle: "List",
      profile_leaves_heading: "Leave requests",
      profile_no_leave_requests: "No leave requests in this period.",
      profile_leaves_load_error: "Could not load leave requests.",
      profile_leave_view_in_calendar: "View in leave calendar",
      profile_leave_calendar_short: "Calendar",
      leave_calendar_deep_link_not_found:
        "Could not open this leave on the calendar.",
      leave_calendar_copy_link: "Copy link",
      leave_calendar_copy_link_success: "Leave calendar link copied.",
      leave_calendar_copy_link_error: "Could not copy link.",
      no_onboarding_documents: "No onboarding documents found",
      contract_amendments: "Contract Amendments",
      create_amendment: "Create Amendment",
      amendment_number: "Amendment number",
      effective_date: "Effective date",
      change_point: "Contract point",
      change_text: "New text",
      new_point: "New point",
      change_existing: "Change existing",
      remove_point: "Remove point",
      add_change: "Add change",
      is_position_change: "Position change",
      is_position_change_hint:
        "When checked, saving will update the user profile and reopen the procedures step.",
      is_employment_terms_change: "Position / compensation change",
      is_employment_terms_change_hint:
        "Add only the fields you want to change. Removed sections will not be updated when the amendment is signed.",
      add_position_update: "Position update",
      add_salary_update: "Salary update",
      add_hours_update: "Working hours update",
      salary_update_required: "Salary is required for a salary update",
      hours_update_required: "Hours per week is required for a working hours update",
      new_position_lt: "New position (LT)",
      new_position_en: "New position (EN)",
      new_position_lt_required: "Position (LT) is required for a position change",
      amendment_position_reviews: "Position change reviews",
      amendment_position_reviews_hint:
        "Complete the procedures review for this position change (same actions as hiring). The personnel record status stays unchanged; position applies once the procedures review is complete.",
      amendment_ws_review: "Procedures review",
      amendment_ws_review_pending: "Procedures review pending",
      amendment_ws_review_approved: "Procedures review confirmed",
      amendment_terms_applied: "Terms applied",
      amendment_change_positions: "Position change",
      amendment_change_salary: "Salary change",
      amendment_change_hours: "Working hours change",
      generate: "Generate",
      sign: "Sign",
      upload: "Upload",
      signing: "Signing",
      changes: "Changes",
      amendment_created: "Amendment created",
      amendment_updated: "Amendment updated",
      amendment_deleted: "Amendment deleted",
      amendment_generated: "Document generated",
      amendment_revoked: "Signing revoked",
      regenerate: "Regenerate",
      revoke: "Revoke",
      confirm_delete_amendment: "Are you sure you want to delete this amendment?",
      confirm_revoke_amendment: "Active signatures will be cancelled and the amendment will return to the generated state. Continue?",
      // Registering an old signed amendment, stating terms on a signed one
      amendment_register_signed: "Register signed amendment",
      amendment_registered: "Amendment registered",
      amendment_registered_scan: "Registered (scan)",
      amendment_signed_scan: "Signed document (scan)",
      amendment_set_terms: "Set new terms",
      amendment_terms_not_set: "Terms not set",
      amendment_terms_required: "Add at least one term: position, salary or working hours",
      amendment_terms_saved: "Terms saved",
      amendment_terms_hint:
        "If this changes the salary, positions or working hours, add them with the buttons below — only then «Sutarties informacija» is updated.",
      amendment_number_required: "Enter the amendment number",
      amendment_effective_date_required: "Enter the effective date",
      amendment_scan_required: "Attach or pick the signed document",
      amendment_number_taken: "An amendment with this number already exists",
      amendment_scan_not_found: "The document was not found — upload it again or pick another one",
      amendment_onboarding_not_found: "The employment record was not found",
      amendment_not_signed: "Terms can only be set on a signed amendment",
      amendment_not_found: "Amendment not found",
      amendment_terms_already_set: "This amendment already has its terms",
      contract_terms_updated_by_amendment: "Updated by amendment {{number}} ({{date}})",
      amendment_number_too_long: "The amendment number is too long (at most 100 characters)",
      amendment_scan_not_fresh: "This file is already in use — upload a new scanned document",
      amendment_document_annulled: "The amendment document was annulled or withdrawn",
      amendment_file_choice_conflict: "Send either an uploaded file or an existing document, not both",
      amendment_file_in_signing: "The document is still being signed — pick a signed document",
      amendment_file_already_used: "This document is already linked to another record",
      amendment_not_registered: "Only amendments registered from a signed document can be edited",
      amendment_edit_registered: "Edit registered amendment",
      amendment_document_upload: "Upload from computer",
      amendment_document_from_tree: "Pick from the documents tree",
      amendment_document_change: "Change",
      amendment_document_locked: "The document of a registered amendment cannot be replaced",
      document_tree_all_folders: "All folders",
      // mobile: personnel
      scan_to_pdf_hint:
        "Only a PDF can be uploaded, not a photo. On a phone, in the file picker choose Scan Documents (iPhone) or scan with Google Drive (Android), then pick the PDF.",
      is_hide: "Hidden",
      document_tree_open_folder_to_search: "Open a folder to search inside it",
      document_tree_pick: "Select",
      amendment_positions_warning:
        "If this is the newest amendment by date, the employee's positions will be changed (with area approval). Do not enter positions on old amendments if they changed later.",
      no_documents: "No documents",
      // mobile: products-projects
      project_summary: "Summary",
      regenerate_document: "Regenerate Document",
      confirm_regenerate_document: "The existing document will be deleted and a new one generated. Any active signature requests will be cancelled. Continue?",
      confirm_regenerate_document_no_sign: "The existing document will be deleted and a new one generated. Continue?",
      generated: "Generated",
      id_document: "ID Document",
      birth_certificate: "Birth Certificate",
      drivers_license: "Driver's License",
      health_certificate: "Health Certificate",
      education_document: "Education Document",
      other_documents: "Other Documents",
      upload_error: "File upload failed",
      upload_partial_error: "Some files failed to upload",
      drop_file_or_click: "Click to upload a file",
      personal_code: "Personal Code",
      fill_all_fields: "Please fill all fields",
      rate_limit_exceeded: "Too many attempts. Please try again later.",
      invalid_code: "Invalid code combination",
      thank_you: "Thank you!",
      kiosk_complete_message: "Your forms have been submitted. The company representative will handle signing.",
      kiosk_no_pending_actions: "There are no pending actions for you at this time. The company representative is handling the current step.",
      kiosk_work_security_message:
        "You have procedure documents to sign — check your email for your login link or ask HR.",
      start_over: "Start Over",
      no_steps_available: "No steps available at this time.",
      saving: "Saving...",
      saved: "Saved ✓",
      save_error: "Save failed",
      next: "Next",
      back: "Back",
      skip: "Skip",
      submit: "Submit",
      field_is_required: "This field is required",
      custom_field_required_message: "{{message}}",
      no_contacts_authorized_to_sign: "No contacts authorized to sign",
      template_is_required: "Please select a document template.",
      select_template_from_list:
        "Please choose a template from the list.",
      // Reused by MakeSeparateDocumentModal/file-form.jsx — existed only in
      // the lt block below (Desk #237 follow-up).
      file_type_is_required: "File type is required",
      invalid_format: "Invalid format",
      value_too_small: "Value is too small",
      value_too_large: "Value is too large",
      value_too_short: "Value is too short",
      value_too_long: "Value is too long",
      login: "Login",
      view_pdf: "View PDF",
      employee_documents: "Employee Documents",
      no_documents_uploaded: "No documents uploaded",
      attach_scanned_document: "Attach scanned document",
      employee_data: "Employee Data",
      education: "Education",
      education_institution: "Institution",
      education_specialty: "Specialty",
      declared_address: "Declared address",
      actual_address: "Actual address",
      emergency_contact: "Person to contact in case of emergency",
      id_document_issue_date: "Issue date",
      id_document_expiry_date: "Expiry date",
      id_document_issue_place: "Issue place",
      residence_permit: "Residence permit",
      has_disability: "Disability",
      disability_cert_number: "Disability cert. No.",
      disability_cert_expiry: "Cert. valid until",
      work_capacity_percent: "Work capacity (%)",
      has_conflict_of_interest: "Conflict of interest",
      conflict_of_interest_details: "Conflict details",
      additional_info_field: "Additional info",
      data_processing_consent: "Data processing consent",
      bank_account: "Bank Account",
      payment_frequency: "Payment frequency",
      npd_option: "NPD",
      disability_level: "Disability level",
      children_info: "Children",
      once_per_month: "Once per month",
      twice_per_month: "Twice per month",
      no_npd: "No NPD",
      standard_npd: "Standard NPD",
      id_card: "ID card",
      passport_doc: "Passport",
      agree: "Agree",
      disagree: "Disagree",
      primary_edu: "Primary",
      basic_edu: "Basic",
      secondary_edu: "Secondary",
      vocational: "Vocational",
      vocational_secondary: "Vocational secondary",
      higher_non_university: "Higher non-university",
      higher_university: "Higher university",
      studying: "Studying",
      children_under_12: "Children under 12",
      children_under_14: "Children under 14",
      disabled_children_under_18: "Disabled children under 18",
      employee_data_required: "Employee has not yet submitted the required data for this step. The document cannot be generated until the employee fills in the form via kiosk or personal account.",
      reopen_for_employee: "Reopen for employee",
      reopen_to: "Reopen to",
      reopen_step_prompt: "Enter step to reopen ({{steps}}):",
      confirm_reopen_step: "This will delete generated documents from this step onwards and allow the employee to re-edit data. Continue?",
      step_reopened: "Step reopened for employee editing",
      confirm_unlock_step: "This will reopen the form for the employee so they can edit their data again. Continue?",
      step_unlocked: "Step unlocked for employee",
      unlock_form: "Unlock form",
      form_active: "Form is active",
      edit_data: "Edit data",
      activate_user: "Activate user",
      confirm_activate_user: "This will grant the user full access to the company. Continue?",
      user_activated: "User activated successfully",
      signatures: "Signatures",
      waiting_for_document_generation: "Waiting for the document to be prepared by the administrator",
      data_submitted_waiting: "Your data has been submitted. Waiting for the administrator to prepare the document.",
      gdpr_consents: "GDPR Consents",
      birthday_greeting: "Birthday greeting",
      photo_sessions: "Photo sessions",
      website_team: "Website team page",
      social_media: "Social media",
      client_presentations: "Client presentations",
      internal_photo_video: "Internal photo/video",
      internal_network: "Internal network",
      no: "No",
      yes: "Yes",
      company_signer: "Company Signer",
      computer_details: "Computer Details",
      needs_server_access: "Needs Server Access",
      server_name: "Server Name",
      folder_access: "Folder Access",
      fuel_card: "Fuel Card",
      fuel_limit: "Fuel Limit",
      fuel_limit_amount: "Fuel Limit Amount",
      not_needed: "Not needed",
      personal: "Personal",
      any_paid: "Any (paid)",
      existing: "Existing",
      new_owned: "New (owned)",
      existing_owned: "Existing (owned)",
      rented: "Rented",
      personal_rent: "Personal (rent)",
      phone_device: "Phone device",
      signed_documents: "Signed Documents",
      signing_status: "Signing Status",
      sign_document: "Sign",
      all_signed: "All signatures collected",
      download_signed_container: "Download signed documents (.asice)",
      waiting_for_signatures: "Waiting for signatures",
      document_generated: "Document generated",
      document_ready: "Document ready",
      document: "Document",
      refresh: "Refresh",
      upload_signed_document: "Upload manually signed document",
      document_uploaded: "Document uploaded",
      edit_will_delete_document: "Saving changes will delete the existing document. You will need to generate a new one.",
      reactivate: "Reactivate",
      onboarding_reactivated: "Onboarding reactivated",
      onboarding_reactivate_membership_disabled_activated:
        "This person already worked here and their access is turned off — this hiring cannot be restored. Start a new hiring instead.",
      contract_registration: "Contract Registration",
      contract_registration_description: "Register an existing contract for a current employee",
      new_hire: "New Hire",
      new_hire_description: "Full onboarding flow for a new employee",
      original_contract_number: "Original Contract Number",
      original_contract_number_required: "Original contract number is required",
      personal_code_required: "Personal code is required",
      contract_file: "Contract File",
      contract_file_required: "Contract file is required",
      contract_details: "Contract Details",
      employee_required: "Employee is required",
      error_creating_registration: "Error creating contract registration",
      select_file: "Select file",
      no_file: "No file attached",
      no_documents_found: "No documents found",
      contract_category_not_configured: "Contract file category is not configured in settings",
      company_director: "Company director",
      select_director: "Select director",
      board_member: "Board member",
      select_board_member: "Select board member",
      board_member_hint:
        "Signs on the employer side when the employee is the company director — both at hiring and on contract amendments",
      company_logo_title: "Logo",
      company_logo_hint: "Shown at the top left of sales invoices. Best as PNG, 352 × 128 px, up to 300 KB.",
      company_logo_none: "No logo uploaded",
      company_logo_upload: "Upload",
      company_logo_remove: "Remove",
      company_logo_wrong_type: "Use a PNG, JPEG or SVG image.",
      company_logo_too_large: "The logo must be 300 KB or smaller.",
      company_logo_load_failed: "Could not load the logo.",
      company_logo_save_failed: "Could not update the logo.",
      settings_company_details_title: "Company details",
      settings_company_details_lead: "The seller's or employer's details in documents.",
      settings_company_name_label: "Name in the system",
      settings_company_name_hint: "Shown in the menu and in lists.",
      settings_company_legal_name_label: "Legal name",
      settings_company_legal_name_hint: "Printed on documents.",
      settings_company_code_label: "Company code",
      settings_company_vat_label: "VAT code",
      settings_company_address_label: "Address",
      settings_company_contact_email_label: "Email",
      settings_company_contact_email_hint: "Shown in invoice emails; customer replies come here.",
      settings_company_contact_email_invalid: "Enter a valid email address",
      settings_company_contact_phone_label: "Phone",
      settings_company_contact_phone_hint: "Shown in invoice emails.",
      settings_company_bank_label: "Bank",
      settings_company_iban_label: "Bank account (IBAN)",
      settings_company_description_label: "Description",
      settings_company_field_required: "Required",
      activity: "Activity",
      audit_log_total: "Total activities",
      audit_log_active_action: "Action filter",
      audit_log_all_actions: "All actions",
      audit_log_active_user: "Performer filter",
      audit_log_all_users: "All users",
      audit_log_loading: "Retrieving activity records...",
      audit_log_load_failed: "Failed to load activity logs",
      audit_log_empty: "No activity logs found",
      audit_log_empty_filtered_hint:
        "Try adjusting or clearing your filters to see more activity history.",
      audit_log_empty_hint:
        "Any events performed within the system will appear here in chronological order.",
      audit_log_clear_filters: "Reset filters",
      audit_log_refresh: "Refresh",
      validation_attempt_customers_settings: "Customer form validation issues",
      validation_attempt_customers_help:
        "Customers who tried to submit a questionnaire but failed frontend validation.",
      validation_attempt_customers_empty: "No validation errors yet",
      validation_attempt_forms_title: "Failed form attempts — {{name}}",
      validation_attempt_count: "Attempts",
      validation_attempt_last: "Last attempt",
      validation_attempt_at: "Attempted at",
      validation_attempt_errors: "Validation errors",
      validation_attempt_detail_title: "Failed questionnaire attempt",
      source_user_to_close: "Account to close",
      target_user_survivor: "Account that stays",
      all_records_below_will_be_transferred: "All records below will be transferred",
      this_user_will_inherit_all_records: "This user will inherit all records",
      analyzing_data_structures: "Analyzing data structures",
      merge_impact_analysis: "What will be moved",
      data_category: "Data Category",
      source_transfer: "Source Transfer",
      target_existing: "Target Existing",
      final_count: "Final Count",
      confirm_and_start_transfer: "Merge accounts",
      processing_merge: "Processing Merge",
      merge_successful: "Merge Successful",
      all_records_have_been_successfully_migrated: "All records have been successfully migrated.",
      batch_id: "Batch ID",
      return_to_settings: "Return to Settings",
      error_analyzing_merge: "Error analyzing merge",
      error_performing_merge: "Error performing merge",
      merge_completed_successfully: "Merge completed successfully",
      merge_intro:
        "When the same person has two accounts: this company's records move to the account that stays, and the closed account no longer belongs to this company. This cannot be undone.",
      merge_confirm_label: "Type “{{word}}” to confirm",
      merge_confirm_word: "MERGE",
      merge_source_membership_closed:
        "The closed account no longer belongs to this company. Its memberships in other companies are unchanged.",
      merge_tab_merge: "Merge",
      merge_tab_history: "History",
      user_merge_history_subtitle: "View past account merges for this company.",
      user_merge_history_detail: "Merge audit detail",
      merge_history_empty: "No merges recorded yet.",
      merge_history_merged_at: "Merged at",
      merge_history_source_user: "Source user",
      merge_history_target_user: "Target user",
      merge_history_actor: "Performed by",
      merge_history_steps: "Steps",
      merge_history_back_to_list: "Back to list",
      merge_history_sequence: "Seq",
      merge_history_table_column: "Table",
      merge_history_column_column: "Column",
      merge_history_operation: "Operation",
      merge_history_row_id: "Row ID",
      merge_history_old_value: "Old value",
      merge_history_new_value: "New value",
      merge_history_load_error: "Could not load merge history.",
      merge_history_batch_not_found: "This merge batch was not found.",
      select_users_to_begin_analysis: "Select users to begin analysis",
      merge_select_both_users:
        "Select both a source user and a target user to run the impact analysis.",
      merge_invalid_same_user:
        "Source and target cannot be the same person. Choose two different users.",
      Are_you_sure_you_want_to_resend_email: "Are you sure you want to resend the email?",
      access: "Access",
      assetTypes: "Asset types",
      assets_types: "Asset types",
      assets_types_add: "New type",
      assets_types_type: "Type",
      assets_types_empty: "No asset types yet.",
      assets_types_requests_note: "E-mails about new asset requests go to the company's assets responsible person (Settings → HR); if nobody is set, to people with the “Assets” permission.",
      cannot_select_same_category: "Cannot select the same category",
      click: "Click",
      companies: "Companies",
      contact: "Contact",
      created_by: "Created by",
      default_today: "Default: today",
      dokobit_acess_key: "Dokobit access key",
      download_file: "Download file",
      feed_max_files_exceeded: "Maximum file count exceeded",
      fetch_error: "Failed to load data",
      file_context: "File context",
      groups: "Groups",
      hide: "Hide",
      info: "Info",
      requiredFields: "Please fill in all required fields.",
      must_be_number: "Must be a number",
      needs_computer: "Needs a computer",
      no_assigned_to_provided: "No assignee provided",
      no_brand_provided: "No brand provided",
      no_model_provided: "No model provided",
      no_notes_provided: "No notes provided",
      no_purchase_date_provided: "No purchase date provided",
      no_serial_provided: "No serial number provided",
      no_status_provided: "No status provided",
      no_type_provided: "No type provided",
      user_permissions: "Permissions",
      no_user_permissions_provided: "No permissions",
      order_required: "Order is required",
      pending: "Pending",
      phone: "Phone",
      please_fill_required_fields: "Please fill in the required fields",
      regenerate_code: "Regenerate code",
      search_templates: "Search templates",
      select_sign_type: "Select signing method",
      select_stock: "Select stock",
      selected: "selected",
      sent: "Sent",
      stock: "Stock",
      stock_select: "Select stock",
      subject_required: "Subject is required",
      title_required: "Title is required",
      type_required: "Type is required",
      view: "View",
      open_in_documents: "Open in the documents module",
      pending_onboarding_banner: "You have an employment questionnaire waiting to be filled in.",
      pending_onboarding_banner_with_company:
        "You have an employment questionnaire waiting to be filled in ({{companies}}).",
      pending_onboarding_action: "Fill in the questionnaire",
      visible_in_all_profile: "Visible in all profiles",
      year_month_required: "Year and month are required",
      // Reused by FileRowMenu's "more actions" trigger — existed only in the
      // lt block below (Desk #237 follow-up).
      more: "More",
      upload_document_failed: "Unable to upload document. Please try again.",
      generate_document_failed: "Unable to generate document. Please try again.",
      amend_role_rules: "Amend Role Rules",
      view_document_preview: "Document Preview",
      assign_users_failed: "Unable to assign users. Please try again.",
      confirm_remove_user_title: "Remove User from Role",
      role_load_failed: "Unable to Load Role",
      role_load_failed_desc: "We couldn't load this role. Please try again.",
      role_not_found: "Role Not Found",
      role_not_found_desc: "The requested role does not exist or has been deleted.",
      back_to_roles: "Back to Roles",
      current_security_rules: "Active Rules",
      previous_versions: "Previous Versions",
      amend_rules: "Amend Rules",
      no_rules_defined: "No rules defined for this role yet.",
      no_previous_versions: "No previous versions available.",
      earlier_version: "Version",
      go_to_document: "Go to Document",
      step_1_title: "Document Generation",
      step_1_description: "System template automatically renders rules into an official PDF document version.",
      latest_version_doc: "Latest Document Version",
      generated_on: "Generated on",
      no_document_yet: "No procedure document generated for this role yet.",
      generating: "Generating...",
      generate_pdf_document: "Generate PDF Document",
      uploading: "Uploading...",
      upload_file: "Upload File",
      file_upload_empty:
        "The file is empty (0 KB). Open it on your computer to check it, then upload it again.",
      document_file_empty:
        "The document file is empty (0 KB), so it cannot be sent for signing. Upload the file again and retry.",
      owner_must_sign_first: "The employee must sign the document first.",
      add_rule_to_generate: "Please add at least one rule to enable generation.",
      document_signature: "Document Signature",
      add_more_signers: "Add more signers",
      assigning: "Assigning...",
      assign: "Assign",
      no_users_assigned: "No users currently assigned to this role.",
      workers_signature_hint: "Assigned workers will receive signature requests once a document is generated.",
      failed_load_user_assignments: "Failed to load the user's current role assignments.",
      user_required: "Please select a user first.",
      failed_save_assignments: "Failed to save user role assignments.",
      choose_user: "Choose a user...",
      select_user_to_assign: "Select User",
      select_users_to_assign: "Select users to assign",
      select_roles_to_assign: "Select Roles",
      no_roles_available: "No roles defined yet.",
      failed_to_remove_user: "Failed to remove user.",
      confirm_unassign_user_description: "Are you sure you want to remove {{userName}} from this role? Doing so will invalidate pending signature invites if they haven't signed yet.",
      pointwise_security_rules: "Pointwise Rules",
      add_rule: "Add Point",
      rule_text_placeholder: "Rule text (e.g. Always wear personal protective equipment...)",
      rules_required: "At least one rule is required",
      failed_amend_role: "Failed to update rules.",
      amend_rules_warning_title: "Amend Rules & Invalidate Signatures?",
      amend_rules_warning_desc: "Modifying the rules will require generating a new PDF document. All existing signatures for this role will be invalidated, and users will need to sign the new document. Do you want to proceed?",
      role_name_required: "Role name is required",
      failed_create_role: "Failed to create role.",
      role_name: "Role Name",
      role_name_placeholder: "e.g. Welder",
      role_description: "Description",
      role_desc_placeholder: "Brief description of the role requirements...",
      create_work_security_role: "Create Role",
      edit: "Edit",
      archive: "Archive",
      archived: "Archive",
      archived_at: "Archived At",
      edit_work_security_role: "Edit Role",
      archive_role: "Archive Role",
      role_archived_banner: "This role is archived. Restore it to make changes or add workers.",
      confirm_archive_role_desc: "Archive \"{{roleName}}\"? It will be hidden from the roles list, the assignments dashboard and workers' documents, and can no longer receive new assignments. Existing signatures are kept and you can restore it anytime.",
      failed_update_role: "Failed to update role.",
      failed_restore_role: "Unable to restore role. Please try again.",
      failed_archive_role: "Failed to archive role.",
      no_archived_roles: "No archived roles",
      no_archived_roles_description: "Roles you archive will appear here and can be restored.",
      work_security_roles: "Procedures",
      // The module's menu item and page title; «work_security_roles» stays for the employee card tile.
      work_security_module_title: "Company internal documents",
      work_security: "Procedures",
      work_security_roles_tab: "Roles",
      area_switcher_label: "Sphere",
      all_areas: "All spheres",
      manage_areas_link: "Manage spheres",
      ws_areas_load_failed: "Unable to load instruction spheres. Showing all accessible items.",
      ws_area_invalid_reset: "The requested sphere is not available to you. Showing the default sphere.",
      area_unknown: "Other sphere",
      work_security_required_at_hiring: "Required for hiring",
      work_security_required_at_hiring_hint:
        "Hiring cannot be completed until the employee signs this instruction.",
      area_field_required: "Please choose an instruction sphere.",
      area_error_forbidden: "You do not have access to this instruction sphere.",
      area_error_archived: "This instruction sphere is archived.",
      area_error_group_mismatch: "This group belongs to a different instruction sphere.",
      area_error_mismatch: "This item belongs to a different instruction sphere.",
      area_error_incidents_disabled: "This instruction sphere does not track incidents.",
      area_error_system_archive_forbidden: "The system sphere cannot be archived.",
      area_error_move_has_test_links:
        "This role is linked to training tests from another sphere ({{tests}}). Unlink them before moving the role.",
      area_error_master_required: "Only Master can move this to another sphere.",
      work_security_areas_title: "Areas",
      work_security_areas_hint:
        "An area is a separate group of procedures with its own responsible people, e.g. work safety or fire safety. Responsible people see and manage only their own area.",
      work_security_area_create: "New area",
      work_security_areas_load_error: "Failed to load instruction areas.",
      work_security_area_system_badge: "System",
      work_security_area_archived_badge: "Archived",
      work_security_area_no_responsibles: "No responsibles assigned",
      work_security_area_responsibles_list: "Responsible: {{names}}",
      work_security_area_can_register_incidents: "Incidents can be registered",
      work_security_area_can_register_incidents_hint:
        "This area gets an incident log and incident acts.",
      work_security_area_name: "Area name",
      work_security_area_name_placeholder: "e.g., Cybersecurity",
      work_security_area_name_required: "Area name is required.",
      work_security_area_responsibles_select: "Add responsible",
      work_security_area_save_failed: "Failed to save the area.",
      work_security_area_responsibles_save_failed:
        "The area was saved, but updating its responsible people failed. Please try again.",
      work_security_area_archive: "Archive area",
      work_security_area_archive_confirm_desc:
        "The area's instructions will remain, but you will no longer be able to create new ones.",
      work_security_area_archive_confirm: "Confirm archiving",
      work_security_area_archive_failed: "Failed to archive the area.",
      work_security_area_restore: "Restore area",
      work_security_area_restore_failed: "Failed to restore the area.",
      work_security_area_system_archive_disabled: "The system area cannot be archived.",
      work_security_settings_scope_label: "Settings apply to",
      work_security_settings_scope_company: "Whole company",
      work_security_settings_inherited_banner_title: "This area uses the company-wide settings",
      work_security_settings_inherited_banner_desc:
        "You can give this area its own settings, and return to the company-wide ones whenever you like.",
      work_security_settings_use_own: "Use separate settings for this area",
      work_security_area_reset_label: "Own settings of this area",
      work_security_area_reset_description: "This area uses its own document settings instead of the company-wide ones.",
      work_security_area_reset: "Return to company-wide settings",
      work_security_area_reset_confirm_description: "The area's document settings will be deleted, and it will use the company-wide settings.",
      work_security_area_reset_confirm: "Return",
      work_security_area_reset_done: "The area uses the company-wide settings.",
      work_security_area_reset_failed: "Couldn't return to the company-wide settings. Try again.",
      work_security_settings_scope_load_error:
        "Failed to load this area's settings. Please try again.",
      work_security_documents_title: "Documents",
      work_security_documents_hint: "Apply to all areas unless an area has its own settings.",
      work_security_documents_hint_area: "Documents used by the selected area.",
      work_security_role_document: "Role procedures document",
      work_security_role_document_hint:
        "The document the system generates for a role with its procedures.",
      work_security_incident_act: "Incident act",
      work_security_incident_act_hint:
        "The document the system generates when an incident is registered.",
      work_security_template_system: "System template",
      work_security_template_custom: "Own template",
      work_security_filed_in: "filed in: {{path}}",
      work_security_filed_nowhere: "no folder chosen",
      work_security_upload_folders: "Folders existing documents can be attached from",
      work_security_upload_folders_hint:
        "Only documents from these folders (including subfolders) can be added to a role or a training.",
      work_security_upload_folders_none: "None chosen",
      desk: "Desk",
      desk_settings: "Desk settings",
      desk_mailboxes: "Mailboxes",
      desk_mailboxes_hint:
        "Connected mailboxes and their ingest health. Every incoming email becomes a card.",
      desk_mailboxes_manage_hint: "Select a mailbox to view and edit its settings, or add another.",
      desk_mailboxes_new_hint: "Fill in the form below to connect this mailbox.",
      desk_no_mailboxes: "No mailboxes connected yet.",
      desk_shared_without_mailbox_hint: "You can still open cards shared with you. Connect a mailbox in Desk settings to receive your own email.",
      desk_mailbox_switch: "Mailbox",
      desk_mailbox_switch_empty_hint: "Connect a mailbox in Desk settings to see emails here.",
      desk_mailboxes_load_failed: "Could not load mailboxes. Please try again.",
      desk_address: "Address",
      desk_provider: "Provider",
      desk_ingest_mode: "Collection mode",
      desk_ingest_mode_all: "All mail",
      desk_ingest_mode_label: "By label",
      desk_last_sync: "Last sync",
      desk_ingest_errors: "Ingest errors",
      desk_never_synced: "Never synced",
      desk_mailbox_disabled: "Disabled",
      desk_sync_stale: "Sync stale",
      desk_sync_ok: "OK",
      desk_inbox: "Inbox",
      desk_inbox_empty: "Inbox is empty — new emails become cards automatically.",
      desk_archive: "Archive",
      desk_archive_empty: "No archived cards yet.",
      desk_drafts: "Drafts",
      desk_shared: "Shared",
      desk_shared_empty: "No shared cards yet — nothing shared with you, and you have not shared any cards.",
      desk_shared_with_me_empty: "No cards have been shared with you yet.",
      desk_shared_by_me_empty: "You have not shared any cards yet.",
      desk_shared_scope_all: "All",
      desk_shared_scope_with_me: "Shared with me",
      desk_shared_scope_by_me: "Shared by me",
      desk_draft: "Draft",
      desk_drafts_empty: "No draft tasks found.",
      desk_trash: "Trash",
      desk_trash_empty: "Trash is empty.",
      desk_save_draft: "Save as Draft",
      desk_restore: "Restore",
      desk_publish: "Publish",
      desk_panel_widen: "Widen panel",
      desk_panel_narrow: "Narrow panel",
      desk_delete_permanently: "Delete permanently",
      desk_archive_action: "Archive",
      desk_unarchive: "Unarchive",
      desk_archived_at: "Archived",
      desk_actions: "Actions",
      desk_search: "Search",
      desk_search_clear: "Clear",
      desk_search_text: "Text",
      desk_search_text_placeholder: "Title, subject, preview…",
      desk_search_email: "Email",
      desk_search_email_placeholder: "name@company.com",
      desk_search_date_from: "From date",
      desk_search_date_to: "To date",
      desk_search_empty: "No cards match this search.",
      desk_show_noise: "Show noise",
      desk_check_mail: "Check mail",
      desk_check_mail_checking: "Checking…",
      desk_check_mail_new: "New messages: {{count}}",
      desk_check_mail_none: "No new mail",
      desk_check_mail_problem: "{{address}}: {{reason}}",
      desk_check_mail_status_busy: "a check is already running",
      desk_check_mail_status_disconnected: "not connected right now",
      desk_check_mail_status_offline: "mail collection is not running",
      desk_check_mail_status_timeout: "no answer yet — the list will update itself",
      desk_check_mail_status_unavailable: "mail service unavailable",
      desk_check_mail_status_error: "check failed",
      // mobile: work-security
      incident_action_delete_confirm: "Delete this corrective action?",
      ws_section_picker: "Section",
      ws_filters_toggle: "Filters",
      desk_card: "Card",
      desk_from: "From",
      desk_waiting: "Waiting",
      desk_last_message: "Last message",
      desk_status_open: "Open",
      desk_status_waiting_client: "Waiting on client",
      desk_status_done: "Done",
      desk_noise: "Noise",
      desk_badge_manual: "User Task",
      desk_participants: "Participants",
      desk_you: "You",
      desk_note: "Note",
      desk_auto_mail: "auto",
      desk_meeting_join: "Join",
      desk_meeting_organizer: "Organizer",
      desk_meeting_cancelled: "Cancelled",
      desk_meeting_all_day: "all day",
      desk_meeting_recurring: "repeats",
      desk_meeting_sender_time: "sender's local time",
      desk_send_failed: "Send failed",
      desk_download: "Download",
      desk_reply: "Reply",
      desk_forward: "Forward",
      desk_share: "Share",
      desk_share_send: "Share card",
      desk_share_placeholder: "Add a note for your colleagues (required)…",
      desk_share_users_required: "Select at least one colleague.",
      desk_share_note_required: "A share note is required.",
      desk_shared_with: "Shared with",
      desk_unshare: "Remove",
      desk_shared_with_me: "Shared with me",
      desk_share_pick_users: "Colleagues",
      desk_share_search_placeholder: "Search by name or email…",
      desk_share_users_empty: "No colleagues found. Try clearing the search.",
      desk_share_users_load_failed: "Could not load colleagues.",
      desk_to: "To",
      desk_cc: "Cc",
      desk_reply_placeholder: "Write a reply — it will be emailed to the client…",
      desk_forward_placeholder: "Add a short note for your colleague…",
      desk_forward_to_placeholder: "colleague@company.com",
      desk_forward_send: "Forward email",
      desk_forward_recipients_required: "Add at least one recipient email.",
      desk_note_placeholder: "Internal note — never emailed…",
      desk_sending: "Sending…",
      desk_send_waiting: "Send → Waiting on client",
      desk_send_keep_status: "Send (keep status)",
      desk_save_note: "Save note",
      desk_new_task: "New task",
      desk_new_task_title: "Create task",
      desk_task_title: "Title",
      desk_task_title_placeholder: "What needs to be done?",
      desk_customer_email: "Customer email",
      desk_customer_name: "Customer name",
      desk_customer_name_optional: "Optional",
      desk_task_note_optional: "First note (optional)",
      desk_create_task: "Create",
      desk_creating_task: "Creating…",
      desk_customer_email_required: "Customer email is required.",
      desk_task_title_required: "Title is required.",
      desk_no_project: "— Inbox (no project)",
      desk_snooze_tomorrow: "Snooze → tomorrow",
      desk_snooze_until: "Snooze until",
      desk_snooze: "Snooze",
      desk_plan_on: "Plan on",
      desk_add_to_plan: "Add to plan",
      desk_planned: "Planned",
      desk_mark_noise: "Mark noise",
      desk_unmark_noise: "Not noise",
      desk_merge: "Merge",
      desk_merge_into_number: "into #…",
      desk_mail_collection: "Mail collection",
      desk_clients: "Clients",
      desk_connect_mailbox: "Connect mailbox",
      desk_add_mailbox: "Add mailbox",
      desk_add_mailbox_title: "Connect a mailbox",
      desk_edit_mailbox: "Edit",
      desk_edit_mailbox_title: "Mailbox settings",
      desk_provider_other: "Other",
      desk_app_password: "App password",
      desk_app_password_saved: "•••••• (saved)",
      desk_own_addresses: "Own addresses (skipped by ingest)",
      desk_label_name: "Label name",
      desk_mailbox_active: "Mailbox active",
      desk_test_connection: "Test connection",
      desk_connection_ok: "Connection OK",
      desk_connection_failed: "Connection failed",
      desk_address_taken: "This email address is already connected. You cannot add it again.",
      desk_save: "Save",
      desk_saved: "Saved",
      desk_client_name: "Client name",
      desk_domains: "Domains",
      desk_add_client: "Add client",
      desk_projects: "Projects",
      desk_new_project: "New project…",
      desk_add_project: "Add project",
      desk_today: "Today",
      desk_add_to_today: "→ Today",
      desk_carry_over: "Unfinished from previous days",
      desk_carry_over_all: "Move all to today",
      desk_no_plan: "Nothing planned — open the Inbox and add cards with “→ Today”.",
      desk_entry_note: "note…",
      desk_done_lc: "done",
      desk_waiting_on_clients: "waiting on clients",
      desk_points: "Points",
      desk_edit_capacity: "Edit day capacity",
      desk_over_capacity: "over capacity!",
      desk_pick_customer: "Client (from Customers)",
      desk_pick_customer_placeholder: "— pick a customer or type a name —",
      desk_view_all: "All cards",
      desk_discard_draft: "Discard the unsent draft?",
      desk_points_short: "pts",
      desk_domains_taken: "Domains already used by another client",
      desk_confirm_delete_card: "Are you sure you want to delete this card?",
      desk_confirm_delete_cards: "Are you sure you want to delete {{count}} cards?",
      desk_confirm_delete_card_soft: "Are you sure you want to delete this card? It will be moved to the Trash.",
      desk_confirm_delete_cards_soft: "Are you sure you want to delete {{count}} cards? They will be moved to the Trash.",
      desk_confirm_delete_card_permanent: "Are you sure you want to permanently delete this card and all its messages? This action cannot be undone.",
      desk_confirm_delete_cards_permanent: "Are you sure you want to permanently delete {{count}} cards and all their messages? This action cannot be undone.",
      desk_confirm_restore_card: "Are you sure you want to restore this card to the Inbox?",
      desk_confirm_restore_draft: "Are you sure you want to restore this draft to Drafts?",
      desk_confirm_restore_card_yes: "Restore",
      desk_confirm_restore_card_no: "Cancel",
      desk_confirm_delete_card_title: "Delete Card",
      desk_confirm_delete_card_yes: "Confirm Delete",
      desk_confirm_delete_card_no: "Cancel",
      desk_selected_count: "{{count}} selected",
      desk_delete_selected: "Delete",
      desk_archive_selected: "Archive",
      desk_unarchive_selected: "Unarchive",
      desk_clear_selection: "Clear",
      desk_star: "Star",
      desk_unstar: "Unstar",
      desk_action_failed: "Action failed",
      desk_load_failed: "Could not load the day plan.",
      desk_move_up: "Move up",
      desk_move_down: "Move down",
      desk_remove_from_plan: "Remove from plan",
      desk_mark_done: "Mark done",
      desk_prev_day: "Previous day",
      desk_next_day: "Next day",
      desk_plan_date: "Plan date",
      desk_card_number: "Card number",
      desk_added_to_plan: "#{{number}} added to the plan",
      desk_carry_over_one: "Move to this day",
      desk_carry_over_done: "Moved {{count}} entries to this day",
      desk_carry_over_failed: "Could not move: {{numbers}}",
      desk_capacity_override: "override",
      desk_capacity_reset: "Reset to the default capacity",
      desk_invalid_capacity: "Enter a number between 0 and 100.",
      desk_invalid_points: "Enter a number between 0 and 100, or leave it empty to use the card estimate.",
      desk_entry_points: "Points for this day",
      desk_entry_points_hint: "Points for this day — leave empty to use the card estimate",
      desk_err_card_not_plannable: "This card cannot be planned — it is a draft, archived, merged or deleted.",
      desk_all_mailboxes: "All mailboxes",
      desk_select_all_on_page: "Select all on this page",
      desk_mark_done_toggle: "Mark done / reopen",
      desk_toggle_noise: "Mark as noise / not noise",
      desk_move_to_project: "Move to project",
      desk_no_projects: "No projects yet",
      desk_unknown_sender: "Unknown",
      desk_open_card_aria: "Open card: {{contact}} — {{title}}",
      desk_page_prev: "Previous page",
      desk_page_next: "Next page",
      desk_bulk_success: "{{count}} cards updated",
      desk_bulk_partial: "{{success}} updated, {{failed}} failed",
      desk_bulk_failed: "Failed to update {{count}} cards",
      desk_publish_success: "Card #{{number}} published",
      desk_shortcuts_hint: "d done · n noise · t today · s snooze · p project",
      desk_project: "Project",
      desk_refresh_card: "Refresh card",
      desk_summarize: "Summarize",
      desk_summarize_refresh: "Refresh summary",
      desk_summarized: "Summarized",
      desk_ai_fix: "Fix mistakes",
      desk_ai_rewrite: "Rewrite nicer",
      desk_ai_fixing: "Fixing…",
      desk_ai_rewriting: "Rewriting…",
      desk_ai_fixed: "Mistakes fixed",
      desk_ai_rewritten: "Draft rewritten",
      desk_ai_no_change: "The assistant found nothing to change",
      desk_ai_undo: "Undo the AI edit",
      desk_ai_draft_changed: "The draft changed while the assistant was working — nothing was replaced",
      desk_ai_too_long: "The draft is too long for the assistant — shorten it to about 6000 characters",
      desk_ai_disabled: "The AI assistant is not set up for this company",
      desk_copy_context: "Copy context",
      desk_copy_context_hint: "Copies the card and its whole thread as plain text — paste it into a chat that has no access to the ERP",
      desk_copy_context_done: "Card context copied",
      desk_copy_context_failed: "Could not copy to the clipboard",
      api_token_tab: "AI access",
      api_token_heading: "Connect an AI client to your Desk",
      api_token_intro: "Create a personal token and your AI assistant can read your Desk cards and their email threads — and, if you allow it, answer them. The token acts as you and sees exactly what you see. Anyone you give it to gets the same access, so treat it like a password and revoke it when you stop using it.",
      api_token_new: "New token",
      api_token_name: "Token name",
      api_token_name_placeholder: "e.g. Claude on my laptop",
      api_token_create: "Create token",
      api_token_creating: "Creating…",
      api_token_scope_write: "Also allow changing cards and sending replies",
      api_token_scope_write_warning: "With this on, the assistant can send real email to clients from your mailbox without asking you first. Leave it off to keep the token read-only.",
      api_token_created_once: "Copy the token now — it is shown once and cannot be recovered.",
      api_token_copy: "Copy",
      api_token_copied: "Token copied",
      api_token_command_copied: "Command copied",
      api_token_connect_hint: "In a terminal with Claude Code, run:",
      api_token_hide: "Done, hide it",
      api_token_active: "Your tokens",
      api_token_none: "No tokens yet.",
      api_token_created_at: "created {{date}}",
      api_token_last_used: "last used {{date}}",
      api_token_never_used: "never used",
      api_token_revoke: "Revoke",
      api_token_revoke_confirm: "Revoke the token \"{{name}}\"? Any client using it stops working immediately.",
      api_token_revoked: "Token revoked",
      api_token_copy_failed: "Could not copy to the clipboard",
      desk_ai_summary_disclaimer: "AI can make mistakes – review for accuracy.",
      desk_ai_summary_generated_at: "generated {{date}}",
      desk_ai_summary_stale: "New messages have arrived since this summary.",
      desk_delete_card: "Delete card",
      desk_deleted: "Deleted",
      desk_deleted_done: "Moved to Trash: {{count}}",
      desk_deleted_permanently_done: "Deleted permanently: {{count}}",
      desk_delete_failed: "Could not delete the card.",
      desk_restore_failed: "Could not restore the card.",
      desk_restored_done: "Restored: {{count}}",
      desk_confirm_restore_cards: "Are you sure you want to restore {{count}} cards to the Inbox?",
      desk_draft_saving: "Saving draft…",
      desk_draft_saved_at: "Draft saved {{time}}",
      desk_draft_not_saved: "Draft not saved — check your connection.",
      desk_recipients_required: "Add at least one recipient.",
      desk_invalid_recipient: "Invalid email address: {{email}}",
      desk_reply_sent: "Reply sent.",
      desk_note_saved: "Note saved.",
      desk_share_done: "Card shared.",
      desk_unshare_done: "Sharing removed.",
      desk_share_user_no_desk: "{{name}} has no access to Desk and was removed from the list.",
      desk_share_user_not_in_company: "{{name}} is not a member of this company and was removed from the list.",
      desk_send_failed_use_retry: "Sending failed. The reply is kept in the timeline — use “Retry” on the red row instead of sending again.",
      desk_merge_conversation: "Merge conversation",
      desk_card_fields_toggle: "Project, snooze and planning",
      desk_merge_confirm: "Merge #{{source}} into #{{target}} — {{title}}? All messages move there and this cannot be undone.",
      desk_merge_done: "Merged into #{{number}}.",
      desk_merge_same_card: "A card cannot be merged into itself.",
      desk_merge_target_not_found: "Card #{{number}} was not found.",
      desk_snoozed_until: "Snoozed until {{date}}",
      desk_unsnooze: "Unsnooze",
      desk_preview_unavailable: "Preview unavailable.",
      desk_images_blocked: "Images in this message are not shown ({{count}}).",
      desk_show_images: "Show images",
      desk_blocked_image: "Image",
      desk_show_quoted: "Show quoted text",
      desk_hide_quoted: "Hide quoted text",
      desk_event_status_changed: "Status: {{from}} → {{to}}",
      desk_event_project_moved: "Moved to project {{to}}",
      desk_event_assigned: "Assignee changed",
      desk_event_snoozed: "Snoozed until {{until}}",
      desk_event_archived: "Archived",
      desk_event_unarchived: "Returned from the archive",
      desk_event_published: "Published from drafts",
      desk_event_restored: "Restored from the trash",
      desk_event_deleted: "Moved to the trash",
      desk_event_reopened: "Reopened by a new reply",
      desk_event_shared: "Shared with {{names}}",
      desk_event_unshared: "Sharing removed for {{names}}",
      desk_event_merged_from: "Merged from card #{{sourceCardNumber}}",
      desk_event_forwarded: "Forwarded to {{to}}",
      desk_event_created_manual: "Task created",
      desk_event_created_draft: "Draft created",
      desk_address_change_warning: "You are changing the address of a connected mailbox. Enter the app password of the new account — collection starts again from the newest mail.",
      desk_password_required_address_change: "Enter the app password of the new address.",
      desk_app_password_required: "An app password is required.",
      desk_address_held: "This address belongs to a disconnected mailbox that still has {{count}} cards.",
      desk_awaiting_first_sync: "Awaiting first sync",
      desk_ingest_errors_7d: "Processing errors (7 d.)",
      desk_recent_ingest_errors: "Recent processing errors",
      desk_err_auth_failed: "The mail server rejected the password — generate a new app password.",
      desk_err_host_unreachable: "The mail server could not be reached — check the host names.",
      desk_err_timeout: "The mail server did not answer in time.",
      desk_imap_host_port: "IMAP host & port",
      desk_smtp_host_port: "SMTP host & port",
      desk_invalid_port: "The port must be a number between 1 and 65535.",
      desk_ingest_mode_label_gmail_only: "Collecting by label works only with Gmail.",
      desk_connection_ok_sent: "Connection OK (Sent folder: {{folder}})",
      desk_connection_failed_hint: "Check the address, the app password and the host names.",
      desk_mailbox_danger_zone: "Disconnecting the mailbox",
      desk_mailbox_danger_hint: "Disconnecting erases the saved password and stops mail collection; the cards stay. Deleting removes the mailbox itself and is possible only while no card belongs to it.",
      desk_mailbox_disconnect: "Disconnect",
      desk_mailbox_delete: "Delete mailbox",
      desk_mailbox_disconnect_confirm: "Disconnect {{address}}? The saved password is erased and no new mail is collected. The mailbox and its cards stay readable.",
      desk_mailbox_delete_confirm: "Delete {{address}} for good? This removes the mailbox itself and works only while no card belongs to it.",
      desk_mailbox_disconnected: "Mailbox disconnected",
      desk_mailbox_deleted: "Mailbox deleted",
      desk_mailbox_has_cards: "This mailbox still has {{count}} cards — disconnect it instead of deleting.",
      desk_guide_title: "Mailbox setup guide",
      desk_guide_tab_password: "App password",
      desk_guide_config_title: "{{provider}} settings:",
      desk_guide_imap_host: "IMAP host",
      desk_guide_imap_port: "IMAP port",
      desk_guide_smtp_host: "SMTP host",
      desk_guide_smtp_port: "SMTP port",
      desk_guide_yandex_warning: "Important: do not use the .lt hosts (imap.yandex.lt) — always use .com.",
      desk_guide_gmail_imap: "First enable IMAP access in Gmail: Settings → Forwarding and POP/IMAP.",
      desk_guide_password_title: "Generating an app password:",
      desk_guide_password_intro: "Do not enter your main email password. Generate a 16-character app password:",
      desk_guide_password_yandex: "Account settings → App passwords → Create new → pick “Mail” to get the 16-character code.",
      desk_guide_password_gmail: "Google Account Security → 2-Step Verification → App passwords → generate the 16-character code.",
      desk_pick_existing_client: "Client (from the customer list)",
      desk_customer_list_truncated: "Showing the first {{shown}} of {{total}} customers — if yours is missing, type its name instead.",
      desk_no_customers_found: "No customers match.",
      desk_no_clients: "No clients yet.",
      desk_no_clients_hint: "A client groups the domains its email arrives from, so new cards land on the right client and its projects.",
      desk_clients_load_failed: "Could not load clients. Please try again.",
      desk_client_added: "Client added",
      desk_project_added: "Project added",
      desk_err_card_forbidden: "You do not have access to this card.",
      desk_err_card_read_only: "This card is shared with you for reading only.",
      desk_err_mailbox_owner_only: "Only the mailbox owner can send from this mailbox.",
      desk_err_card_not_shareable: "Publish the card before sharing it.",
      desk_err_not_retryable: "This message can no longer be sent.",
      desk_err_retry_in_progress: "This message is already being sent.",
      desk_mailbox_disconnect_first: "Disconnect the mailbox before deleting it.",
      desk_client_replied: "Client replied",
      desk_show_done: "Show closed",
      close_document: "Close document",
      reopen_document: "Reopen",
      document_outdated: "Outdated",
      update_document_status_failed: "Unable to update document status. Please try again.",
      create_role: "Create Role",
      manage_groups: "Manage Groups",
      group: "Group",
      no_group: "No group",
      without_group: "Without Group",
      all_groups: "All Groups",
      filter_by_group: "Filter by Group",
      filter_by_assignment: "Filter by Assignment",
      roles_with_users: "With Assigned Users",
      roles_without_users: "Without Assigned Users",
      search_roles: "Search Roles",
      search_roles_placeholder: "Search by role name or description...",
      no_roles_match_filters: "No roles match your filters",
      no_roles_match_filters_description: "Try adjusting your search or filter criteria.",
      create_group: "Create Group",
      group_name: "Group Name",
      group_name_placeholder: "e.g., Warehouse",
      group_delete_hint:
        "Deleting a group does not delete its roles — they simply become ungrouped.",
      no_groups_yet: "No groups yet. Create the first one above.",
      roles_count: "Roles",
      rename: "Rename",
      delete: "Delete",
      failed_load_groups: "Failed to load groups.",
      failed_create_group: "Failed to create group.",
      failed_update_group: "Failed to rename group.",
      failed_delete_group: "Failed to delete group.",
      roles_load_failed: "Unable to refresh roles. Please try again.",
      roles_load_failed_title: "Unable to Load Roles",
      roles_load_failed_description: "We couldn't load roles. Please try again.",
      no_roles: "No Roles",
      no_roles_description: "Create a role to start defining rules and signing requirements.",
      create_first_role: "Create First Role",
      rules_count: "Rules",
      workers_assigned: "workers assigned",
      show_users: "Show users",
      hide_users: "Hide users",
      show_signers: "Show signers",
      hide_signers: "Hide signers",
      signers_count_signed: "signed",
      signers_count_pending: "pending",
      signers_count_total: "total",
      and_n_more: "+{{count}} more",
      no_description: "No description",
      assign_user_roles: "Assign Roles",
      assign_roles_to_user: "Assign Roles to User",
      assigned_roles: "Assigned Roles",
      no_roles_assigned: "No roles assigned",
      manage_roles: "Manage Roles",
      role_assignments_dashboard: "Role Assignments",
      assignments_load_failed: "Unable to load role assignments. Please try again.",
      search_users: "Search Users",
      search_by_name_or_email: "Search by name or email...",
      filter_by_role: "Filter by Role",
      all_roles: "All Roles",
      assigned_roles_load_failed: "Unable to load assigned roles. Please try again.",
      no_assigned_roles: "No assigned roles found.",
      assigned_work_security_roles: "Assigned Roles",
      signed: "Signed",
      pending_signature: "Pending Signature",
      signed_on: "Signed on",
      no_document_yet_for_role: "No procedure document generated for this role yet.",
      // --- Onboarding work-security step ---
      ws_signed_count: "Signed {{signed}} of {{total}}",
      ws_manage_roles_hint:
        "Assigning roles requires the 'Access work security assignments' permission — ask a responsible colleague to enroll the employee.",
      ws_docless_roles_warning:
        "These roles have no active document — nothing will be signed:",
      ws_docless_roles_ack: "I understand these roles have no documents to sign",
      ws_send_login_link_hint:
        "The employee signs the procedure documents in My Onboarding — send a login link if they cannot log in.",
      ws_complete_step_confirm_no_roles:
        "No roles required at hiring are assigned to this employee. Complete the step without required procedure documents?",
      ws_unsigned_docs_warning: "Unsigned procedure documents:",
      ws_reopen_step: "Reopen procedures step",
      ws_all_signed_waiting:
        "All procedure documents are signed — waiting for the administrator to confirm the step.",
      ws_declined_ask_hr:
        "Declined — ask HR to re-send the signature request.",
      ws_load_failed: "Failed to load procedures data.",
      ws_error_unsigned: "There are unsigned procedure documents.",
      ws_error_no_roles:
        "No roles assigned — confirm completing the step without roles.",
      ws_error_docless_roles:
        "Some roles have no active documents — acknowledge the warning to continue.",
      ws_error_conflict:
        "The onboarding status has changed. Refresh and try again.",
      ws_error_roles_not_applied:
        "Required work-safety roles are not assigned yet — try again in a minute or contact support.",
      onboarding_cancel_conflict:
        "The hire changed meanwhile — reloaded, try again.",
      ws_required_now: "Required now",
      ws_other_instructions: "Other",
      search_your_boards: "Search your boards",
      "project-board-column-create": "Create project column",
      "project-name": "Project name",
      project_outcome: "Outcome",
      project_outcome_open: "Open",
      project_outcome_won: "Won",
      project_outcome_lost: "Lost",
      project_outcome_deleted: "Deleted",
      project_value_eur: "Value (EUR)",
      not_set: "Not set",
      project_contact: "Client contact",
      project_contact_empty: "No client contact details yet.",
      linkedin: "LinkedIn",
      whatsapp: "WhatsApp",
      viber: "Viber",
      project_drop_delete: "DELETE",
      project_drop_lost: "LOST",
      project_drop_won: "WON",
      project_drop_move_to: "MOVE TO",
      project_move_select_board: "Move to board",
      project_move_no_boards: "No other boards available.",
      project_move_no_columns: "That board has no lists yet.",
      move: "Move",
      project_won_celebration: "Won celebration",
      project_rotting: "Idle",
      project_rotting_idle: "Idle for {{n}} days",
      project_rotting_days: "Rotting after (days)",
      project_rotting_days_help:
        "Cards idle longer than this turn red. Leave empty to disable.",
      project_stage_of: "{{current}}/{{total}}",
      pinned: "Pinned",
      starred: "Starred",
      recent: "Recent",
      all_boards: "All boards",
      search_results: "Search results",
      no_results: "No results",
      loading: "Loading…",
      color: "Color",
      done: "Done",
      board_history: "History",
      board_load_failed: "Couldn't load this board.",
      share: "Share",
      share_board: "Share board",
      copy_link: "Copy link",
      link_copied: "Link copied",
      copy_failed: "Copy failed",
      board_members: "Board members",
      sending: "Sending…",
      email_sent: "Email sent",
      email_send_failed: "Could not send email",
      share_no_users: "No users found",
      share_access_hint: "Only people who can access the project module are shown.",
      // --- Work security incidents (v1) ---
      incidents: "Incidents",
      incident: "Incident",
      register_incident: "Register Incident",
      edit_incident: "Edit Incident",
      incident_number: "No.",
      incident_occurred_at: "Date and time",
      incident_type: "Type",
      incident_type_incident: "Incident (no health damage)",
      incident_type_event_at_work: "Event at work (injury)",
      incident_severity: "Severity",
      incident_severity_lengvas: "Light",
      incident_severity_sunkus: "Serious",
      incident_severity_mirtinas: "Fatal",
      incident_status_registered: "Registered",
      incident_status_pending_signatures: "Pending signatures",
      incident_status_signed: "Signed",
      incident_status_closed: "Closed",
      incident_status_cancelled: "Cancelled",
      incident_victim: "Affected employee",
      incident_location: "Location / unit",
      incident_time_since_shift: "Time since shift start",
      incident_description: "What happened",
      incident_activity_before: "Activity before the event",
      incident_causing_factor: "Causing factor / object",
      incident_injury_nature: "Injury nature",
      incident_body_part: "Injured body part",
      incident_witnesses: "Witnesses",
      incident_witness_name: "Name",
      incident_witness_notes: "Notes",
      incident_add_witness: "Add witness",
      incident_causes_prevention: "Causes and preventive measures",
      incident_causes: "Causes",
      incident_prevention: "Preventive measures",
      incident_general_info: "General information",
      incident_circumstances: "Circumstances",
      incident_investigation_deadline: "Investigation deadline",
      incident_actions: "Corrective actions",
      incident_action_description: "Action",
      incident_action_owner: "Owner",
      incident_action_due: "Due date",
      incident_action_placeholder: "e.g. Provide additional training",
      incident_no_actions: "No corrective actions yet.",
      incident_open_actions: "{{count}} open",
      incident_documents: "Documents",
      incident_no_documents: "No act generated yet.",
      incident_doc_act: "Act",
      incident_doc_attachment: "Attachment",
      incident_deadline_overdue: "Investigation overdue",
      incident_deadline_overdue_banner:
        "The 10-working-day investigation deadline for a light accident has passed.",
      incident_deadline_due: "Due",
      incident_severe_banner_title: "Serious/fatal accident — VDI investigates",
      incident_severe_banner_body:
        "Notify the prosecutor's office, the VDI territorial unit and the family immediately, preserve the scene, and submit the accident notification (Pranešimas apie įvykį darbe). The company must not draw up its own act — attach VDI's act as a file instead.",
      incident_severe_form_hint:
        "Serious/fatal accidents are investigated by VDI. You can register the record, but the system will not let you generate or sign an internal act.",
      generate_act: "Generate act",
      regenerate_act: "Regenerate act",
      send_incident_for_signature: "Send for Signature",
      incident_send_intro:
        "The act will be sent for click-signature to the affected employee and the selected manager.",
      incident_manager: "Manager",
      incident_manager_required: "Manager is required.",
      incident_manager_same_as_victim: "Manager must be different from the affected employee.",
      cancel_signing: "Cancel signing",
      close_incident: "Close incident",
      reopen_incident: "Reopen",
      mark_done: "Mark done",
      mark_open: "Mark open",
      incidents_load_failed: "Unable to load incidents. Please try again.",
      no_incidents: "No incidents registered",
      no_incidents_description: "Register a workplace incident to start the record.",
      no_incidents_match_filters: "No incidents match your filters",
      no_incidents_match_filters_description: "Try adjusting or clearing the filters.",
      status_archived: "Archived",
      search_incidents: "Search Incidents",
      search_incidents_placeholder: "Search by number, employee, location...",
      filter_by_type: "Type",
      filter_by_status: "Status",
      filter_by_archived: "Archived",
      archived_only: "Archived only",
      incident_load_failed: "Unable to load this incident.",
      incident_action_failed: "Action failed. Please try again.",
      incident_save_failed: "Failed to save the incident.",
      incident_send_failed: "Failed to send for signature.",
      incident_victim_required: "Affected employee is required.",
      incident_description_required: "Description is required.",
      select_existing_document: "Select Document",
      select_existing_document_help:
        "Browse the upload category (from Settings) and its subfolders, or search across all of them. Documents already attached to a role are hidden.",
      search_all_documents: "Search all documents…",
      all_documents: "All documents",
      no_documents_match_search: "No documents match your search.",
      no_documents_in_folder: "No documents in this folder.",
      // mobile: orders
      order_steps_jump: "Signing and invoice steps",
      selectable_documents_load_failed: "Unable to load documents. Please try again.",
      attach_document: "Attach Document",
      attaching: "Attaching...",
      associate_document_failed: "Unable to attach the selected document. Please try again.",
      document_already_attached_to_role:
        "This document is already attached to another role and cannot be attached again.",
      confirm_attach_document: "Confirm attach document",
      confirm_attach_document_intro:
        "Please review the signature impact for this file before attaching it to the role.",
      existing_signatures_on_file: "Signatures already on this file",
      no_existing_signatures_on_file: "No signatures on this file yet.",
      signatures_will_be_added: "Signatures that will be added",
      no_users_assigned_to_role_for_signatures:
        "No users are assigned to this role yet. Attach the document, then assign workers to send signature requests.",
      no_new_signatures_to_add:
        "All assigned workers already have a signature on this file. No new invites will be sent.",
      signature_emails_will_be_sent:
        "{{count}} signature request email(s) will be sent to these users.",
      already_have_signature_on_file:
        "Assigned workers already on this file (no new email)",
      existing_signatures_kept_notice:
        "Existing signatures on this file will be kept. New signature requests are only added for assigned workers who are not already on the file.",
      attach_and_send_requests: "Attach & send signature requests",
      associate_preview_failed: "Unable to load signature preview. Please try again.",
      // Work security — training / tests
      training: "Training",
      training_test: "Training test",
      create_training_test: "Create training test",
      training_col_questions: "Questions",
      training_col_roles: "Roles",
      training_col_passed: "Passed",
      training_col_duration: "Duration",
      training_status_draft: "Draft",
      training_status_active: "Active",
      training_status_archived: "Archived",
      training_tests_load_failed: "Unable to load training tests.",
      search_training_tests: "Search by name or description…",
      no_training_tests: "No training tests yet",
      no_training_tests_hint:
        "Create a test, attach materials, add questions, then link roles.",
      pass_percent: "Pass %",
      duration_minutes: "Duration (min)",
      max_attempts: "Max attempts (empty = unlimited)",
      name_required: "Name is required",
      create_failed: "Failed to create test",
      load_failed: "Failed to load",
      ai_generate_failed: "Could not generate questions",
      activate_test: "Activate test",
      training_step_basics: "Basics",
      training_step_materials: "Materials",
      training_step_questions: "Questions",
      training_step_audience: "Audience",
      training_step_review: "Review",
      training_step_progress: "Step {{current}} of {{total}}",
      training_materials_optional_hint:
        "Optional — attach documents workers can review before the test.",
      select_training_material_help:
        "Browse the upload category (from Settings) and its subfolders, or search across all of them. Documents already attached to this test are hidden.",
      attach_material_failed:
        "Unable to attach the selected document. Please try again.",
      training_audience_hint:
        "Link at least one role or assign users manually before activating.",
      training_activate_requirements:
        "Complete basics, save at least one valid question, and link roles or assign users before activating.",
      training_unassign_hint:
        "You can remove users who have not submitted any attempts yet.",
      unassign_failed: "Failed to remove user",
      cannot_unassign_has_attempts: "Already attempted",
      assignments: "Assignments",
      assigned_users: "Assigned users",
      user_already_assigned_to_test: "This user is already assigned to this test.",
      review: "Review",
      save_settings: "Save settings",
      training_materials: "Training materials",
      no_materials_yet: "No materials attached yet.",
      search_files: "Search company files",
      attach: "Attach",
      add_question: "Add question",
      ai_generate_hint:
        "Select attached materials (PDF/TXT with text). Questions are generated in Lithuanian. Review before saving.",
      source_text: "Extra source text (optional)",
      source_text_help: "Optional paste if a document has no text layer.",
      ai_select_materials: "Documents to use",
      ai_attach_materials_first:
        "Attach training materials in the Materials step so AI can read document content.",
      ai_materials_skipped:
        "{{used}} document(s) used; {{skipped}} skipped (no readable text): {{names}}",
      ai_materials_used: "Generated from {{count}} document(s).",
      ai_materials_used_pdf_scan:
        "Generated from {{count}} document(s), including scanned PDF(s) read by AI.",
      generate_with_ai: "Generate with AI",
      question_n: "Question {{n}}",
      question: "Question",
      questions: "Questions",
      previous: "Previous",
      mark_correct_hint:
        "Tick one or more options as correct. Workers can select multiple when more than one is correct.",
      mark_correct: "Mark as correct",
      option: "Option",
      option_placeholder: "Answer option…",
      add_option: "Add option",
      save_questions: "Save questions",
      linked_roles: "Linked roles",
      linked_roles_hint:
        "Users assigned to these roles are auto-enrolled when the test is active.",
      save_roles: "Save role links",
      manual_assign: "Assign extra users",
      attempts: "Attempts",
      last_score: "Last score",
      no_assignments_yet: "No assignments yet.",
      my_training: "Training tests",
      training_open_count: "{{count}} test(s) still required",
      training_all_clear: "You are up to date on assigned tests.",
      training_meta:
        "{{duration}} min · pass {{pass}}% · attempts {{attempts}}",
      continue_test: "Continue test",
      start_test: "Start test",
      view_history: "History",
      no_training_assigned: "No training tests assigned to you yet.",
      start_failed: "Could not start the test",
      submit_failed: "Could not submit the test",
      test_passed: "Passed",
      test_failed: "Failed",
      score_summary:
        "{{score}}% · {{correct}}/{{total}} correct · pass mark {{pass}}%",
      start_training: "Start training",
      open_test: "Open",
      mark_training_completed: "Mark training completed",
      go_to_test: "Go to test",
      worker_training_steps_hint:
        "Complete training materials first. The test unlocks after you mark training as completed.",
      worker_training_materials_hint:
        "Review the documents below, then mark training as completed to unlock the test.",
      no_materials_for_training:
        "No training documents were attached. You can continue to the test.",
      training_already_completed:
        "Training is marked as completed. You can take the test.",
      complete_training_to_unlock_test:
        "Complete the training step first to unlock the test.",
      back_to_training_step: "Back to training",
      complete_training_failed: "Could not mark training as completed",
      cannot_start_test: "You cannot start this test right now.",
      view_submitted_answers: "View submitted answers",
      submitted_answers: "Submitted answers",
      submitted_answers_hint:
        "Questions and options from this attempt. Your selected answer(s) are highlighted.",
      back_to_training: "Back to training tests",
      reattempt: "Reattempt",
      answer_review: "Answer review",
      your_answer: "your answer",
      correct: "correct",
      question_progress:
        "Question {{current}} of {{total}} · {{answered}} answered",
      time_remaining: "Time remaining",
      select_all_that_apply: "Select all that apply",
      select_one_answer: "Select one answer",
      submit_test: "Submit test",
      no_questions: "This test has no questions.",
      attempt_history: "Attempt history",
      attempt_n: "Attempt {{n}}",
      hide_answers: "Hide answers",
      show_answers: "Show answers",
      no_answer: "No answer",
      no_attempts: "No attempts yet.",
      min: "min",
      submitted_at: "Submitted",
      started_at: "Started",
      training_status_pending: "Pending",
      training_status_in_progress: "In progress",
      training_status_timed_out: "Timed out",
      online_test: "Online Test",
      time_left: "Time Left",
      hours: "hours",
      minutes: "minutes",
      seconds: "seconds",
      mark_for_review: "Mark for review",
      unmark_review: "Unmark review",
      submitting: "Submitting…",
      exam_legend_current: "Current",
      exam_legend_not_attempted: "Not Attempted",
      exam_legend_answered: "Answered",
      exam_legend_not_answered: "Not Answered",
      exam_legend_review: "Review",
      question_editor: "Question editor",
      work_security_ai_questions_settings: "Training questions with AI",
      work_security_ai_questions_settings_help:
        "Managers can generate test questions from the instruction text. Requires an active <assistantLink>AI assistant</assistantLink>.",
      work_security_ai_questions_assistant_required:
        "The AI assistant is off or has no API key, so this cannot be turned on.",
      enabled: "Enabled",
      disabled: "Disabled",
      show_ai_generate: "Generate with AI",
      hide_ai_generate: "Hide AI generate",
      ai_generate_optional_hint:
        "Optionally draft Lithuanian questions with AI from attached training documents.",
      configure_upload_category_to_select:
        "Configure the upload category in Settings before selecting an existing document.",
      select_user_to_view_signed_docs:
        "Select a user to view their signed procedure documents.",
      signed_documents_load_failed: "Unable to load signed documents. Please try again.",
      no_signed_documents_for_user: "This user has no signed procedure documents.",
      download_selected: "Download selected",
      download_all: "Download all",
      select_all: "Select all",
      work_security_role_document_template: "Role PDF Template Settings",
      configure_generation_settings_to_generate:
        "Configure document generation settings (template, series, document type, and category) in Settings before generating PDF documents.",
      approve_medical_check: "Approve medical check",
      enter_medical_validity: "Enter the period the medical check is valid for.",
      medical_valid_from: "Valid from",
      medical_valid_until: "Valid until",
      medical_validity: "Validity",
      medical_validity_invalid: "\"Valid from\" must not be after \"valid until\".",
      medical_check_history: "Medical check history",
      current_medical_check: "Current medical check",
      no_medical_check: "No medical check on file.",
      no_medical_checks_company: "No medical checks found.",
      medical_status_pending: "Awaiting approval",
      medical_status_approved: "Approved",
      medical_status_superseded: "Replaced",
      medical_check_approved_toast: "Medical check approved",
      medical_certificate_uploaded: "Medical certificate uploaded",
      confirm_delete_medical_draft: "Delete this uploaded medical check? The files will be removed.",
      upload_certificate: "Upload certificate",
      upload_new_certificate: "Upload new certificate",
      start_new_medical_check: "Start new medical check",
      medical_check_renew_started: "New medical check started. Upload your certificate(s).",
      medical_renew_pending_exists: "You already have a medical check awaiting approval.",
      medical_renew_too_early: "Renewal is available from {{date}} (30 days before expiry).",
      medical_renew_not_available: "A new medical check cannot be started yet.",
      medical_check_reopen: "Reopen for review",
      medical_check_reopened: "Medical check reopened for review",
      add_document: "Add document",
      delete_draft: "Delete",
      approved_by: "Approved by",
      uploaded: "Uploaded",
      add_workers_disabled_closed_document: "The latest document is closed. Generate or reopen a document to add more workers.",
      latest_document_closed: "latest document closed",
      medical_checks_pending: "Awaiting approval",
      medical_checks_approved: "Approved medical checks",
      medical_checks_approved_by_you: "Recently approved by you",
      medical_checks_search_placeholder: "Search by employee or file name...",
      no_medical_checks_match_filters: "No medical checks match your search.",
      approved_at: "Approved on",
      not_fetch: "Failed to load data",
      assets: "Assets",
      fuel_reports: "Fuel reports",
      uploaded_transactions: "Uploaded transactions",
      upload_fuel_report: "Upload report",
      // Result panel shown after a fuel CSV upload
      fuel_import_headline: "Imported: {{parts}}",
      fuel_import_inserted: "{{count}} new",
      fuel_import_updated: "{{count}} updated",
      fuel_import_skipped: "{{count}} skipped",
      fuel_import_converted_one:
        "{{count}} transaction converted to EUR at the Bank of Lithuania rate of the receipt date",
      fuel_import_converted_other:
        "{{count}} transactions converted to EUR at the Bank of Lithuania rate of the receipt date",
      fuel_import_missing_card_or_date:
        "Rows without a card number (e.g. commission fees) skipped: {{rows}}",
      fuel_import_missing_card_or_date_unnumbered:
        "Rows without a card number (e.g. commission fees) skipped",
      fuel_import_card_damaged:
        "Card number damaged (file opened in Excel?) — upload the original file.",
      fuel_import_fx_unavailable:
        "Could not get the exchange rate ({{pairs}}) — upload the file again later, these rows will then be added.",
      fuel_import_fx_unavailable_generic:
        "Could not get the exchange rate — upload the file again later, these rows will then be added.",
      fuel_import_save_failed: "Could not save: {{error}}",
      fuel_import_rows_label: "Rows: {{rows}}",
      fuel_import_rows_inline: "(rows: {{rows}})",
      fuel_import_unknown_error: "Unknown error",
      fuel_import_more_errors: "Other errors: {{count}}",
      fuel_import_rows_more: "and {{count}} more",
      fuel_import_failed: "Upload failed: {{message}}",
      fuel_import_failed_generic: "Upload failed. Please try again.",
      record_type: "Type",
      type_fuel: "Fuel",
      type_additional: "Additional",
      add_to_fuel_list: "Add to fuel list",
      add_to_fuel_list_success: "“{{value}}” added to the fuel list",
      add_to_fuel_list_reactivated:
        "“{{value}}” was inactive and has been re-enabled in the fuel list",
      add_to_fuel_list_error: "Could not add to the fuel list. Please try again.",
      add_to_fuel_list_master_required:
        "Only Master users can update the fuel list.",
      add_to_fuel_list_permission_required:
        "You need Master or Access fuel reports permission to update the fuel list.",
      in_fuel_list: "In fuel list",
      delete_fuel_record: "Delete",
      delete_fuel_record_title: "Delete transaction",
      delete_fuel_record_confirmation:
        "Delete the transaction of {{date}}, card {{card}}, {{amount}} EUR? Fuel reports for that card and month will be recalculated, but their documents have to be regenerated by hand.",
      delete_fuel_record_success: "Transaction deleted",
      delete_fuel_record_reports_recalculated:
        "Transaction deleted. {{count}} fuel report(s) recalculated — regenerate their documents.",
      delete_fuel_record_error: "Could not delete the transaction. Please try again.",
      records: "Records",
      fuel_records: "Fuel records",
      additional_expenses: "Additional expenses",
      card_user: "Card user",
      card_no: "Card no.",
      place: "Place",
      fuel_type: "Fuel type",
      work_purpose_km_required: "Work-hours mileage is required",
      work_purpose_km: "Mileage during work hours (km)",
      work_purpose_km_from_rate:
        "Calculated from kWh and the official rate (kWh/100 km). You can edit it.",
      winter_period_electric_rate:
        "Winter electricity rate (kWh/100 km, November–March)",
      summer_period_electric_rate:
        "Summer electricity rate (kWh/100 km, April–October)",
      work_purpose_km_exceeds_monthly_mileage:
        "Work-hours mileage cannot exceed monthly mileage",
      non_work_purpose_km: "Mileage outside work hours (km)",
      non_work_purpose_km_computed:
        "Outside work hours (calculated): {{km}} km",
      amount: "Amount (EUR)",
      create: "Create",
      ok: "Saved",
      departments: "Departments",
      department: "Department",
      head: "Head",
      members: "Members",
      company_schema: "Company schema",
      no_departments: "No departments yet",
      select_departments: "Select departments",
      update_departments: "Update departments",
      departments_updated: "Departments updated",
      no_departments_assigned: "No departments assigned",
      onboarding_department_required: "Select at least one department",
      onboarding_department_not_in_scope:
        "You can only choose departments you head. Reload the page and try again.",
      onboarding_no_department_message:
        "Only HR or the head of a department that leads hiring can create onboarding records.",
      onboarding_department_load_failed:
        "Failed to load departments. Please retry before saving.",
      no_head: "No head",
      head_help: "The head must be one of the selected members",
      dependency_graph: "Dependency graph",
      view_list: "List",
      view_graph: "Graph",
      reports_to: "Reports to",
      no_members_to_graph: "No members to visualize yet",
      subgroups: "Subgroups",
      subgroup: "Subgroup",
      add_subgroup: "Add subgroup",
      edit_subgroup: "Edit subgroup",
      delete_subgroup: "Delete subgroup",
      no_subgroups: "No subgroups yet",
      subgroup_name: "Subgroup name",
      subgroup_head: "Subgroup head",
      subgroup_head_help: "Optional. Must be one of the subgroup members.",
      subgroup_members_help:
        "Create a child department under this one. It has its own head and members.",
      department_members: "Department members",
      document_cart: "Download cart",
      document_cart_subtitle: "Review files, then download as ZIP",
      document_cart_add: "Add to cart",
      document_cart_added: "Added to cart",
      document_cart_already_in: "Already in cart",
      document_cart_in_cart: "In cart",
      document_cart_removed: "Removed from cart",
      document_cart_remove_failed: "Could not remove from cart",
      document_cart_add_failed: "Could not add to cart",
      document_cart_full: "Cart is full (500 files max)",
      document_cart_too_large:
        "Download cart is limited to {{limit}}. Remove some files and try again.",
      document_cart_file_too_large:
        "This file is larger than {{limit}} and cannot be added to the cart.",
      document_cart_file_size_unknown:
        "Could not verify this file’s size, so it was not added.",
      document_cart_added_children_partial:
        "Added to cart ({{count}} child files skipped because the cart limit was reached)",
      document_cart_add_no_access: "{{count}} not added — no access",
      document_cart_folder_added_size_partial:
        "Added {{count}} files (stopped at the {{limit}} limit)",
      document_cart_size_limit_hint: "Max pack size: {{limit}}",
      document_cart_size_summary: "Size summary:",
      document_cart_current_size: "Current cart size:",
      document_cart_adding_size: "Adding files size:",
      document_cart_estimated_total_size: "Estimated total size:",
      document_cart_total_size_limit: "{{total}} MB / {{limit}} MB limit",
      document_cart_clear_all: "Clear all",
      document_cart_cleared: "Cart cleared",
      document_cart_clear_failed: "Could not clear cart",
      document_cart_empty: "Your download cart is empty",
      document_cart_browse: "Browse documents",
      document_cart_unavailable: "Unavailable",
      document_cart_unavailable_banner:
        "{{count}} file(s) unavailable and won’t be included",
      document_cart_uncategorized: "Uncategorized",
      document_cart_preparing_zip_hint:
        "We are packing your files into a ZIP. This may take a few moments. Please keep this drawer open.",
      document_cart_download_ready_title: "ZIP Pack Ready!",
      document_cart_download_ready_desc:
        "If your file does not download automatically, click the button below.",
      document_cart_ready_summary: "{{ready}} of {{total}} ready to download",
      document_cart_download_all: "Download all as ZIP",
      document_cart_download_coming_soon:
        "Bulk download is coming in the next step",
      document_cart_tab_files: "Files",
      document_cart_tab_folders: "Folders",
      document_cart_no_individual_files: "No individually added files",
      document_cart_no_folders: "No folders in cart yet",
      document_cart_folder_file_count: "{{count}} files",
      document_cart_folder_removed: "Removed folder ({{count}} files)",
      document_cart_add_folder: "Add folder to cart",
      document_cart_add_folder_title: "Add folder “{{name}}” to cart?",
      document_cart_add_folder_body:
        "{{count}} accessible files in selection · {{newCount}} will be added",
      document_cart_add_folder_includes_subfolders:
        "Includes files from subfolders you can access",
      document_cart_add_folder_select_hint:
        "Select the folders to add. Checked folders will appear in your cart.",
      document_cart_folder_select_all: "Select all",
      document_cart_folder_deselect_all: "Deselect all",
      document_cart_folder_none_selected: "Select at least one folder",
      document_cart_folder_already_short: "{{count}} already in cart",
      document_cart_folder_no_direct_files: "No files directly in this folder",
      document_cart_add_folder_confirm: "Add selected",
      document_cart_folder_added: "Added {{count}} files from folder",
      document_cart_folder_added_partial:
        "Added {{count}} files (cart limit reached)",
      document_cart_folder_already_in: "Those files are already in the cart",
      document_cart_folder_empty: "This folder has no files you can access",
      document_cart_folder_preview_failed: "Could not preview folder",
      document_cart_folder_some_already:
        "{{count}} file(s) already in cart will be skipped",
      document_cart_folder_would_exceed:
        "Adding this folder would exceed the {{max}} file cart limit",
      document_cart_folder_samples: "Examples",
      document_cart_download_ready: "Download {{number}} is ready",
      document_cart_download_failed: "Download pack failed",
      document_cart_download_started: "Your download is starting",
      document_cart_preparing_zip: "Preparing your ZIP…",
      document_cart_checkout_failed: "Could not start download",
      document_cart_nothing_to_download: "Nothing left to download",
      document_cart_partial_skipped:
        "{{count}} unavailable file(s) were skipped",
      document_cart_downloads_tab: "Downloads",
      document_cart_history_empty: "No downloads yet",
      document_cart_history_empty_hint:
        "Packs you download from the cart will appear here",
      document_cart_history_snapshot_hint:
        "Each pack is a snapshot of the files you downloaded that day — not whatever the folder contains now.",
      document_cart_history_load_failed: "Could not load download history",
      document_cart_history_loading: "Loading download history…",
      document_cart_show_files: "Show files",
      document_cart_hide_files: "Hide files",
      document_cart_files_loading: "Loading files…",
      document_cart_no_files_in_pack: "No files in this pack",
      document_cart_downloading: "Downloading…",
      document_cart_status_ready: "Ready",
      document_cart_status_failed: "Failed",
      document_cart_status_processing: "Preparing",
      document_cart_status_pending: "Pending",
      document_cart_status_expired: "Expired",
      document_cart_page_hint:
        "Review your cart, download as ZIP, or open past download packs.",
      document_cart_open: "Open cart",
      document_cart_view_history: "View download history",
      document_cart_add_selected: "Add selected to cart",
      document_cart_selected_count: "{{count}} selected",
      document_cart_clear_selection: "Clear selection",
      job_leave: "Job Leave",
      employment_leave: "Employment leave",
      onboarding_status: "Onboarding status",
      left_company: "Left company",
      start_job_leave: "Start leave",
      tab_onboarding: "Onboarding",
      read_only: "read-only",
      leave_locked_until_onboarding_complete:
        "Leave can only start after onboarding is completed.",
      employee_leave_from_company: "Employee leave from company",
      employee_leave_from_company_hint:
        "Start the quit checklist: return assets, cancel leaves, clear signatures and permissions, then lock this company membership.",
      onboarding_locked_during_leave:
        "Onboarding is locked while the employment leave process is open.",
      employment_leave_empty:
        "No leave process yet. Start leave when this employee is quitting.",
      employment_leave_membership_disabled:
        "This company membership is already disabled.",
      employment_leave_start_from_onboarding:
        "Start employment leave from the completed onboarding record.",
      job_leave_create_failed: "Could not start leave",
      create_job_leave: "Create Job Leave",
      complete_job_leave: "Complete quit",
      cancel_job_leave: "Cancel job leave",
      quit_date: "Quit date",
      started_by: "Started by",
      completed_by: "Completed by",
      leave_started_on: "Started on",
      leave_completed_on: "Completed on",
      job_leave_status_in_progress: "In progress",
      job_leave_status_completed: "Completed",
      job_leave_status_cancelled: "Cancelled",
      job_leave_created: "Job leave created",
      job_leave_completed: "Job leave completed — user locked",
      job_leave_cancelled: "Job leave cancelled",
      job_leave_completed_message:
        "This quit process is complete. The user has been locked in this company.",
      job_leave_not_ready:
        "Complete all pending signatures and return all assets before finishing the quit.",
      job_leave_ready:
        "All signatures and assets are clear. You can complete the quit.",
      job_leave_assets_not_ready:
        "Return all assigned assets before completing this step.",
      job_leave_assets_ready:
        "All assets are returned. You can complete this step.",
      job_leave_signatures_not_ready:
        "Cancel or finish all pending signatures before completing this step.",
      job_leave_signatures_ready:
        "No pending signatures left. You can complete this step.",
      job_leave_permissions_not_ready:
        "Remove all manager links and other assignments before completing quit.",
      job_leave_permissions_ready:
        "Manager links and other assignments are cleared. You can complete the quit.",
      job_leave_permissions_end_with_leave:
        "When the employee leaves, all their rights in this company end automatically.",
      confirm_remove_all_permissions:
        "Clear all permission groups, manager links for direct reports, and other live assignments for this user in this company?",
      remove_all_permissions: "Clear access assignments",
      permissions_removed: "Access assignments cleared",
      job_leave_direct_reports: "Direct reports",
      no_direct_reports: "No direct reports with this user as manager",
      clear_manager_link: "Clear manager",
      confirm_clear_manager_link:
        "Clear manager for \"{{name}}\"? They will no longer report to this user.",
      manager_link_cleared: "Manager link cleared",
      job_leave_other_assignments: "Other assignments",
      no_other_assignments: "No other live assignments",
      no_category_assignments:
        "Not assigned as responsible user or review required by on any category",
      remove_assignment: "Remove",
      confirm_remove_assignment:
        "Remove \"{{label}}\": {{name}}?",
      confirm_remove_assignment_from_section:
        "Remove from {{section}} — {{label}}: {{name}}?",
      assignment_removed: "Assignment removed",
      job_leave_tab_permissions: "Permissions",
      job_leave_tab_managers: "Managers",
      job_leave_tab_categories: "Categories",
      job_leave_tab_departments: "Departments",
      job_leave_tab_other: "Other",
      job_leave_removal_list: "Assignments to remove",
      job_leave_removal_list_hint:
        "Each row shows where the assignment comes from, what it is, and the role. Remove items one by one.",
      job_leave_removal_list_empty: "Nothing left to remove",
      job_leave_removal_from: "From",
      job_leave_removal_item: "Name",
      job_leave_removal_role: "Role",
      job_leave_tab_permissions_hint:
        "Permission groups that grant module access for this user.",
      job_leave_tab_managers_hint:
        "Employees who still have this user as their manager.",
      job_leave_tab_categories_hint:
        "Users assigned on a file category as Responsible user or Review required by. Shows the category name.",
      job_leave_tab_departments_hint:
        "Departments where this user is a member or the department head.",
      job_leave_tab_other_hint:
        "Customers, company roles, medical approver, and open tasks assigned to this user.",
      no_department_assignments:
        "Not a member or head of any department",
      job_leave_manager_of: "Reports to this user as manager",
      responsible_user: "Responsible user",
      review_required_by: "Review required by",
      job_leave_other_assignments_hint:
        "These live assignments still point at this user. Remove them one by one.",
      job_leave_leaves_not_ready:
        "Cancel all open leave requests before completing this step.",
      job_leave_leaves_ready:
        "No open leave requests left. You can complete this step.",
      job_leave_step_completed: "Step completed",
      job_leave_step_reopened: "Step reopened",
      confirm_complete_job_leave:
        "Complete this quit? Any remaining leave requests will be cancelled and the user will be locked in this company.",
      confirm_complete_job_leave_step:
        "Mark this step as done and unlock the next step?",
      confirm_reopen_job_leave_step:
        "Reopen to \"{{step}}\"? You can work on that step again.",
      confirm_cancel_job_leave:
        "Cancel this job leave process? The user will not be locked.",
      confirm_force_return_asset:
        "Mark this asset as returned without a return document and clear the assignment?",
      confirm_cancel_signature: "Cancel this pending signature?",
      confirm_remove_signature:
        "Remove this pending signer? If everyone else has already signed, the final signed document will be fetched/regenerated and saved (Click/Dokobit). SignOnTab cancels the whole signing request.",
      confirm_cancel_leave_request: "Cancel this leave request?",
      force_return_asset: "Force return",
      return_asset: "Return asset",
      cancel_signature: "Cancel signature",
      remove_signature: "Remove signature",
      cancel_leave_request: "Cancel leave",
      leave_request_cancelled: "Leave request cancelled",
      signature_cancelled: "Signature cancelled",
      signature_removed: "Signature removed",
      sign_type: "Sign type",
      signers: "Signers",
      no_signers: "No signers",
      this_signer: "this signer",
      will_be_removed: "will be removed",
      job_leave_remove_signer_outcome_fully_signed:
        "Removing {{name}} ({{signType}}). Everyone else has already signed — the final signed document will be fetched/regenerated and the file will be marked fully signed.",
      job_leave_remove_signer_outcome_remove_only:
        "Removing {{name}}. Other pending signers remain — the file will stay unsigned.",
      job_leave_remove_signer_outcome_only_signer:
        "Removing {{name}} (only signer). The signature request will be cleared; the file will not be marked fully signed.",
      job_leave_remove_signer_outcome_signontab:
        "SignOnTab does not support removing a single signer. The whole signing request will be cancelled and all signers on this file will be cleared. The file will not be marked fully signed.",
      job_leave_remove_signer_outcome_unknown_signers:
        "Removing {{name}} ({{signType}}). Signer list could not be loaded — check the document after remove.",
      asset_returned: "Asset returned",
      complete_assets_step: "Complete assets step",
      complete_leaves_step: "Complete leave requests step",
      complete_signatures_step: "Complete signatures step",
      reopen_step: "Reopen step",
      current_step: "Current",
      locked: "Locked",
      open_asset: "Open asset",
      open_leave: "Open leave",
      assigned_assets: "Assigned assets",
      no_assigned_assets: "No assigned assets",
      no_pending_signatures: "No pending signatures",
      pending_signatures: "Pending signatures",
      not_returned: "Not returned",
      notes: "Notes",
      email: "Email",
      open_leave_requests: "Open leave requests",
      open_leave_requests_hint:
        "Cancel leave requests below, or they will be cancelled automatically when you complete the quit.",
      no_open_leave_requests: "No open leave requests",
      bank_swift: "SWIFT code",
      bank_account_heading: "Account {{number}}",
      bank_account_currency: "Currency",
      bank_account_currency_help: "optional, e.g. EUR",
      bank_account_comment: "Comment",
      bank_account_primary: "Primary",
      bank_account_add: "+ Add account",
      bank_account_remove: "Remove",

      // Desk #76: document annulment + notices to signers.
      annulled_badge: "ANNULLED",
      annul_document: "Annul document",
      annul_document_confirm_title: "Annul this document?",
      annul_document_effect_kept:
        "The document stays in the ERP, marked ANNULLED — the signed original is kept as evidence and is never deleted.",
      annul_document_effect_notice:
        "Everyone who signed it, and everyone it was emailed to, will get a notice by email.",
      annul_document_effect_renamed:
        "“(ANULIUOTA)” will be added to the document name.",
      annul_document_effect_leave:
        "The linked leave request will be cancelled.",
      annul_document_effect_trip:
        "The linked business trip will be cancelled.",
      annul_document_effect_trip_report:
        "The trip report will be unlinked and the business trip will wait for a new report.",
      annul_document_reason_label: "Reason for annulment",
      annul_document_reason_placeholder:
        "Describe why this document is being annulled",
      annul_document_success: "Document annulled",
      document_annulled: "This document has been annulled.",
      document_not_fully_signed: "The document is not fully signed yet.",
      annul_reason_required: "Please provide a reason for the annulment.",
      document_signed: "The document is already signed.",
      // Refusals of the signer endpoints (utils/signer-edit-errors) and of
      // the shared-account and onboarding-form checks.
      signatures_collected:
        "Someone has already signed this document, and this change would erase their signature.",
      replacement_not_fresh_upload:
        "Only a file you have just uploaded can replace this document. Upload the signed copy again.",
      signer_edit_forbidden:
        "You do not have rights to manage the signers of this document.",
      user_has_other_companies:
        "This person also works in other companies, so only they or a Master of each of those companies may change their email, name, phone or gender.",
      prefill_employee_form: "Fill in the form for the employee",
      prefill_employee_form_note:
        "Fill in what you know. The employee will check, complete and submit the form after logging in.",
      prefill_employee_form_locked:
        "The employee has already submitted the form; it can no longer be changed.",
      employee_form_locked:
        "You have already submitted this form, so its data and documents can no longer be changed. If something needs fixing, contact the person handling your hiring.",
      file_not_a_fresh_upload:
        "This file is already signed or sent for signing, so it cannot be marked as the signed scan. Upload the scan again.",
      onboarding_document_already_signed: "This document is already signed. The page has been refreshed.",
      signed_contract_locked:
        "This onboarding's contract is already signed — it can no longer be changed this way.",
      access_denied: "Access denied",
      forbidden: "You do not have permission to do this.",
      annulment_not_found: "Annulment record not found",
      invalid_replacement: "That document cannot be used as a replacement",

      // Owner's signing rule: a document generated from a template cannot
      // have a signature/signature request removed one by one — only the
      // whole document can be withdrawn while it is not yet fully signed.
      template_signatures_locked:
        "Signatures on a document generated from a template cannot be removed — withdraw the document instead.",
      withdraw_document: "Withdraw document",
      withdraw_document_confirm_title: "Withdraw this document?",
      withdraw_document_effect_unsigned: "The document will not be signed.",
      withdraw_document_effect_notice:
        "Signers who have not yet signed will be notified.",
      withdraw_document_effect_permanent: "This cannot be undone.",
      withdraw_document_reason_label: "Reason (optional)",
      withdraw_document_reason_placeholder:
        "Describe why this document is being withdrawn",
      withdraw_document_success: "Document withdrawn",
      withdraw_forbidden: "You do not have permission to withdraw this document.",
      withdraw_not_template:
        "Only documents generated from a template can be withdrawn.",
      withdraw_not_supported:
        "This document cannot be withdrawn.",
      document_withdrawn: "This document has been withdrawn.",
      withdrawn_badge: "WITHDRAWN",
      signer_status_withdrawn: "Withdrawn",
      template_signers_locked_hint:
        "This document was generated from a template — signers already invited cannot be removed here. You can still add new signers; to undo the request entirely, withdraw the document.",

      reset_signatures_fully_signed_notice:
        'This document is fully signed. Everyone who signed it will be notified that it will be re-signed. If it is no longer valid, use "Annul document" instead.',
      reset_signatures_reason_placeholder:
        "Optionally describe why the document is being re-signed",
      annulment_reason_label: "Reason",
      annulment_panel_title: "Annulment history",
      annulment_panel_resign_title: "Signatures were reset for re-signing",
      annulment_panel_unknown_actor: "Unknown",
      annulment_panel_replaced_by: "Replaced by document:",
      annulment_panel_change_replacement: "Change",
      annulment_panel_remove_replacement: "Remove link",
      annulment_panel_set_replacement: "Set replacement document",
      annulment_panel_replaces: "Replaces annulled document:",
      annulment_panel_resend: "Resend notices",
      annulment_panel_download_original:
        "Download original without stamp (evidence)",
      annulment_notices_resent: "Notices resent",
      annulment_recipient_role: "Role",
      annulment_recipient_role_signer: "Signed",
      annulment_recipient_role_receiver: "Received copy",
      annulment_recipient_status_sent: "Sent",
      annulment_recipient_status_failed: "Failed",
      annulment_recipient_status_pending: "Pending",
      annulment_recipient_status_not_sent: "Not sent",
      annulment_panel_load_error: "Could not load the annulment history.",
      status_cancelled: "Cancelled",
      business_trip_cancelled: "This business trip is cancelled",
      business_trip_cancelled_banner_title: "This business trip is cancelled",
      business_trip_cancelled_banner_body:
        "The trip's main document was annulled. The report, its document, and leave requests can no longer be created or edited.",
      // Pre-existing keys used by "Remove signed document" (files/reset-signatures)
      // — missing from en; only present in lt below.
      remove_signed_document: "Remove signed document",
      remove_signed_document_description:
        "Removes the uploaded/signed document and restores the original unsigned file and signature state.",
      remove_signed_document_confirm:
        "Are you sure you want to remove the signed document? This cancels active signing requests and restores the original file.",
      remove_signed_document_success: "Signed document removed",
      // Positions catalogue («Pareigos») — docs/prd/positions-catalogue.md
      positions_title: "Positions",
      positions_tab_onboardings: "Employment contracts",
      positions_page_hint: "The company's job positions. Employees get them from here; each position can bring its internal documents (procedure roles).",
      positions_picker_search: "Search positions",
      positions_picker_empty: "No positions found",
      positions_picker_create: "New position…",
      positions_name_lt: "Name (LT)",
      positions_name_en: "Name (EN)",
      positions_name_lt_required: "Enter the name in Lithuanian",
      positions_create: "Create",
      positions_archived_badge: "archived",
      positions_move_left: "Move earlier",
      positions_move_right: "Move later",
      positions_load_failed: "Could not load positions.",
      positions_order_hint: "Documents list the positions in this order.",
      positions_none_selected: "No positions selected",
      positions_unknown: "Unknown position",
      positions_saved: "Position saved",
      positions_edit_title: "Edit position",
      positions_new_title: "New position",
      positions_rename_hint: "Renaming updates the position text of current holders; signed documents keep the old text.",
      positions_roles_title: "Documents",
      positions_roles_hint: "Every holder of this position gets these internal documents at once.",
      positions_permissions_title: "Permissions",
      positions_permissions_hint: "Every holder of this position gets these rights.",
      positions_permissions_applies_at_once: "A change applies at once to every employee who holds this position.",
      positions_permissions_none: "This position gives no rights.",
      positions_area_no_roles: "No active pareigybės in this sphere.",
      positions_roles_read_only: "Spheres you do not manage (read-only):",
      positions_roles_none_manageable: "You do not manage any sphere, so pareigybės cannot be linked here.",
      positions_holders_title: "Holders",
      positions_no_holders: "Nobody holds this position.",
      positions_holders_count: "holders: {{count}}",
      positions_no_roles: "No pareigybės",
      positions_merge: "Merge",
      positions_merge_title: "Merge «{{name}}» into…",
      positions_merge_pick_hint: "Choose the position that stays. The chosen one keeps its name; this one is archived.",
      positions_merge_next: "Next",
      positions_merge_action: "Merge",
      positions_merge_confirm_text: "«{{source}}» will be merged into «{{target}}»: its holders ({{count}}) will hold «{{target}}», and «{{source}}» will be archived. Signed documents keep their text.",
      positions_merge_union_title: "«{{target}}» will bring these pareigybės:",
      positions_merge_union_warning: "«{{target}}» gains pareigybės it did not have — its current holders get them (and their documents to sign) right away.",
      positions_merge_done: "«{{source}}» merged into «{{target}}»",
      positions_archive_confirm: "Archive «{{name}}»? It will no longer be offered for new employees.",
      positions_archive_confirm_holders: "Archive «{{name}}»? {{count}} employee(s) still hold it and keep it until changed; it will no longer be offered.",
      positions_show_archived: "Show archived",
      // Per-sphere approval of position-derived pareigybės (positions catalogue §1 rules 7–8)
      ws_approvals_tab: "Awaiting approval",
      ws_approvals_intro: "Employees whose positions bring pareigybės in your spheres. Nothing is assigned in a sphere until it is approved.",
      ws_approvals_empty: "Nothing is waiting for your approval.",
      ws_approvals_load_failed: "Could not load the approvals.",
      ws_approvals_forbidden: "This approval belongs to a sphere you do not manage.",
      ws_approvals_not_found: "This approval no longer exists.",
      ws_approvals_col_area: "Sphere",
      ws_approvals_kind_hire: "Hiring",
      ws_approvals_kind_amendment: "Contract amendment",
      ws_approvals_kind_profile: "Profile",
      ws_approvals_status_label: "Pareigybės approval",
      ws_approvals_auto: "approved automatically",
      ws_approvals_waiting: "waiting",
      // Probation + second salary (docs/prd/probation-salary-review.md)
      onboarding_planned_salary_change: "New salary from {{date}}: <amount/>",
      salary_change_invalid: "The second salary's date/amount is invalid.",
      salary_change_invalid_custom_template:
        "This company uses a custom contract template that does not support a second salary. Contact the administrator.",
      amendment_cancels_planned_salary_change:
        "Signing this amendment cancels the planned salary change from {{date}} (<amount/>).",
      personnel_planned_salary_change: "Planned change",
      personnel_planned_salary_change_value: "From {{date}}: <amount/>",
      // Salary figures stay hidden until the viewer clicks the eye
      show_amount: "Show amount",
      hide_amount: "Hide amount",
      show_hidden_values: "Show hidden values",
      hide_hidden_values: "Hide values",
      // Asmens kodas on the employee card: masked like a salary, editable by HR
      show_personal_code: "Show personal code",
      hide_personal_code: "Hide personal code",
      edit_personal_code: "Edit personal code",
      personal_code_invalid: "Invalid personal code — enter the 11 digits of a Lithuanian personal code, or leave it empty.",
      personal_code_save_failed: "The personal code was not saved. Try again.",
      personnel_tile_probation: "Probation",
      probation_status_ongoing: "Ongoing until {{endDate}}",
      probation_status_awaiting_review: "Awaiting review until {{deadline}}",
      probation_status_passed: "Passed",
      probation_status_failed: "Not passed — notice must be handed by {{deadline}}",
      probation_status_passed_unreviewed: "Considered passed (not reviewed)",
      probation_review_action_submit: "Evaluate",
      probation_review_action_view: "View",
      probation_reviews_intro: "Employees whose probation you need to review.",
      probation_reviews_empty: "No reviews waiting right now.",
      probation_reviews_load_failed: "Failed to load the list.",
      probation_review_reason: "Reason",
      probation_review_reason_manager: "Direct manager",
      probation_review_reason_no_manager: "No manager",
      probation_review_reason_escalated: "Escalated to HR",
      probation_review_dialog_title: "Probation review",
      probation_end_date_field: "Probation end date",
      probation_decision_deadline: "Decision deadline",
      probation_notice_deadline: "Notice deadline",
      probation_end_date_label: "End date",
      probation_end_date_invalid: "The end date cannot be earlier than today.",
      probation_absence_hint: "Approved leave during probation: {{days}} d. Extend the end date if needed.",
      probation_read_only_hint: "View only — you cannot submit this review.",
      probation_decision_label: "Decision",
      probation_decision_option_passed: "Passed",
      probation_decision_option_failed: "Failed",
      probation_comment_label: "Comment",
      probation_comment_required_min: "A comment is required when failed (at least 10 characters).",
      probation_criterion_quality: "Quality of work",
      probation_criterion_workload: "Workload and deadlines",
      probation_criterion_independence: "Independence and initiative",
      probation_criterion_discipline: "Discipline and internal rules",
      probation_criterion_teamwork: "Teamwork and communication",
      probation_criterion_trainings: "Required trainings (contract 3.2)",
      probation_criterion_targets: "Set targets (contract 3.2)",
      probation_rating_meets: "Meets",
      probation_rating_partly: "Partly",
      probation_rating_not_meets: "Does not meet",
      probation_rating_na: "N/A",
      probation_review_invalid: "Check the review fields.",
      probation_review_forbidden: "You do not have permission for this action.",
      probation_review_closed: "The review is already closed or its deadline has passed.",
      probation_not_applicable: "Probation does not apply.",
      ws_approvals_status_superseded: "Replaced by a newer approval",
      ws_approvals_approved_by: "Approved",
      ws_approvals_proposal_title: "Proposed pareigybės",
      ws_approvals_proposal_hint: "They come from the employee's positions. To change the proposal, change which pareigybės the position brings.",
      ws_approvals_proposal_empty: "The positions bring no pareigybės in this sphere any more.",
      ws_approvals_required_at_hiring: "Required at hiring",
      ws_approvals_no_document: "no document",
      ws_approvals_individual_title: "Individual pareigybės in this sphere",
      ws_approvals_individual_none: "None.",
      ws_approvals_add_individual: "Add individually",
      ws_approvals_add_individual_hint: "Added on top of the positions; they stay until removed by hand.",
      ws_approvals_individual_selected: "Individual to add: {{count}}",
      ws_approvals_approve: "Approve",
      ws_approvals_approved_toast: "Approved: {{name}}",
      ws_approvals_already_decided: "This approval was already decided or replaced — showing its current state.",
      // Positions picker in the hiring form, amendments and the profile form
      positions_legacy_text_hint: "Previously entered as text: «{{text}}». Pick the matching position from the list.",
      positions_required: "Choose at least one position",
      positions_new_positions: "New positions",
      positions_via_amendment_hint: "Changed through a contract amendment",
      // Pareigybės panel embedded in the employee edit form
      user_form_roles_title: "Pareigybės",
      user_form_roles_hint:
        "Applied immediately — this is independent of the Save button below.",
      // Personalas card, employee card and pareigybė page — positions-driven pareigybės
      ws_step_waiting_approvals: "Waiting for the spheres to approve the pareigybės. The step completes by itself once they are approved and the required documents are signed.",
      ws_step_auto_complete_hint: "The step completes by itself once the required documents are signed.",
      onboarding_employee_already_active: "This person already works in the company. Ask HR to handle it.",
      onboarding_already_employed_here: "This email belongs to {{name}}, who already works in this company. A new hire is not possible: register the existing employment contract under “Contract Registration”.",
      ws_role_source_positions: "from positions: {{names}}",
      ws_role_source_positions_plain: "from positions",
      ws_role_source_individual: "individual",
      ws_individual_remove: "Remove individual",
      ws_individual_remove_confirm: "Remove the individual pareigybė «{{name}}»? If a position also brings it, it stays.",
      ws_individual_removed: "Individual pareigybė removed",
      ws_individual_added: "Individual pareigybės added",
      ws_individual_nothing_to_add: "Every pareigybė of your spheres is already assigned individually.",
      ws_individual_add_action: "Add",
      positions_role_none: "No position brings this pareigybė.",
      positions_role_link_hint: "Linking applies at once to everyone holding the position: they get the pareigybė and its documents to sign. Unlinking removes it from them unless they hold it individually.",
      // Positions / approvals backend refusals
      ws_error_approvals_pending: "Some spheres have not approved the pareigybės yet — wait for their approval.",
      positions_error_name_taken: "A position with this name already exists.",
      positions_error_area_forbidden: "You do not manage the sphere of this pareigybė.",
      positions_error_permission_not_grantable: "This right can't be given through a position.",
      positions_error_merge_permissions_master_only: "These positions give different rights — only an administrator can merge them.",
      positions_error_merge_area_forbidden: "The merge would add pareigybės of spheres you do not manage: {{areas}}. Ask their responsibles or a Master.",
      positions_error_merge_area_forbidden_plain: "The merge would add pareigybės of spheres you do not manage. Ask their responsibles or a Master.",
      // Gendered position titles (positions catalogue §8)
      positions_name_lt_female: "Feminine name (LT)",
      positions_name_lt_female_placeholder: "e.g. Buhalterė",
      positions_merge_as_female: "Use «{{source}}» as the feminine name of «{{target}}»",
      user_gender: "Gender",
      user_gender_male: "Male",
      user_gender_female: "Female",
      user_gender_unset: "Not specified",
      user_gender_hint: "Documents print the feminine position name for women, when the position has one.",
      // Hiring questionnaire step 1: gender field
      onboarding_gender_hint: "Used to print the position title in the correct form in the contract.",
      invalid_gender: "Please select a valid gender.",
      // Merge: holders whose gender the merge set
      positions_merge_gender_set: "Gender set to female for {{count}} employee(s).",
      // Position created, its pareigybės not saved
      positions_created_roles_failed: "The position was created, but its pareigybės were not saved — press Save to retry.",
      // Personalas → Darbuotojai list and the darbuotojo kortelė (employee card)
      personnel_tab_employees: "Employees",
      personnel_list_hint: "Employed people you may see. Open a row for the employee card.",
      personnel_search_placeholder: "Search by name, email or position…",
      personnel_status_filter: "Status",
      personnel_status_active: "Employed",
      personnel_status_left: "Left",
      personnel_status_left_one: "Left",
      personnel_status_hiring: "Being hired",
      personnel_all_departments: "All departments",
      personnel_all_positions: "All positions",
      personnel_filter_no_onboarding_record: "No hiring record",
      personnel_load_failed: "Could not load the employees.",
      personnel_empty: "No employees match these filters.",
      personnel_pagination: "{{from}}–{{to}} of {{total}}",
      personnel_page_previous: "Previous",
      personnel_chip_ws_unsigned: "{{n}} unsigned procedure doc(s)",
      personnel_chip_pending_approvals: "{{n}} awaiting approval",
      personnel_chip_medical_expired: "Medical check expired {{date}}",
      personnel_chip_medical_expiring: "Medical check expires {{date}}",
      personnel_chip_job_leave: "Leaving: {{status}}",
      personnel_chip_no_onboarding_record: "No hiring record",
      personnel_card_title: "Employee card",
      personnel_card_forbidden: "You do not have access to this employee's card.",
      personnel_card_load_failed: "Could not load the employee card.",
      personnel_employed_since: "Employed since {{date}}",
      personnel_contract_no: "Contract No. {{number}}",
      personnel_new_amendment: "New contract amendment",
      personnel_start_leave: "Start leaving",
      personnel_opens_record_hint: "Opens the employee's hiring record",
      personnel_tab_summary: "Summary",
      personnel_tab_procedures: "Procedures",
      personnel_tab_health: "Health",
      personnel_tab_leave: "Leaving",
      personnel_tab_records: "Hiring records",
      personnel_tab_history: "History",
      personnel_tile_open: "Open",
      personnel_tile_terms: "Employment terms",
      personnel_salary: "Salary",
      personnel_ws_required_unsigned: "Required documents unsigned",
      personnel_ws_unsigned: "All unsigned documents",
      personnel_ws_pending_approvals: "Pareigybės awaiting approval",
      personnel_medical_valid_until: "Valid until",
      personnel_medical_none: "No valid medical check.",
      personnel_medical_renewal_open: "Renewal in progress",
      personnel_no_job_leave: "No leaving process.",
      personnel_no_records: "No hiring records.",
      personnel_record_hire: "Hiring",
      personnel_signed_documents: "Signed procedure documents",
      personnel_tab_contract: "Contract & amendments",
      personnel_tab_leaves: "Time off",
      personnel_tab_assets: "Assets",
      personnel_tab_businessTrips: "Business trips",
      personnel_tab_fuelReports: "Fuel reports",
      personnel_tab_expenses: "Expenses",
      personnel_contract_record: "Record",
      personnel_open_record: "Open record",
      personnel_terms_other_record: "The current terms come from another record — open this record to see its terms.",
      personnel_amendments_after_contract: "Contract amendments become available once the hire is past the employment contract.",
      personnel_assets_load_failed: "Could not load assets.",
      personnel_assets_current: "Issued now",
      personnel_assets_none: "Nothing is issued to this employee.",
      personnel_assets_history: "Issue and return history",
      personnel_assets_history_none: "No issue history.",
      personnel_asset_name: "Asset",
      personnel_asset_type: "Type",
      personnel_asset_serial: "Serial / inventory no.",
      personnel_asset_issued: "Issued",
      personnel_asset_returned: "Returned",
      personnel_asset_broken: "Broken",
      personnel_asset_still_issued: "Still issued",
      personnel_asset_status_in_use: "In use",
      personnel_asset_status_in_stock: "In stock",
      personnel_asset_act_signed: "Act signed",
      personnel_asset_act_pending: "Act awaiting signature",
      personnel_asset_act_annulled: "Act annulled",
      // Personalas card: business trips / fuel reports / manual expenses (phase 3)
      personnel_trips_load_failed: "Could not load business trips.",
      personnel_trips_none: "No business trips.",
      personnel_trip_destination: "Destination",
      personnel_trip_purpose: "Purpose",
      personnel_trip_dates: "Dates",
      personnel_trip_report: "Report",
      personnel_trip_number: "No. {{number}}",
      personnel_trip_order: "Order",
      personnel_trip_report_status_pending: "Awaiting signature",
      personnel_trip_report_status_signed: "Signed",
      personnel_trip_report_status_rejected: "Rejected",
      personnel_trip_report_status_annulled: "Annulled",
      personnel_fuel_load_failed: "Could not load fuel reports.",
      personnel_fuel_none: "No fuel reports.",
      personnel_fuel_period: "Period",
      personnel_fuel_asset: "Vehicle",
      personnel_fuel_km: "Km",
      personnel_fuel_consumed_litres: "Consumed (l)",
      personnel_fuel_amount: "Amount",
      personnel_fuel_status_draft: "Draft",
      personnel_fuel_status_pending: "Awaiting signature",
      personnel_fuel_status_signed: "Signed",
      personnel_fuel_status_annulled: "Annulled",
      personnel_expenses_load_failed: "Could not load expenses.",
      personnel_expenses_none: "No expenses.",
      personnel_expense_category: "Category",
      personnel_expense_category_fuel: "Fuel",
      personnel_expense_category_other: "Other",
      leave_calendar_redacted_note: "Details are visible only to the employee, their manager and the signers.",
      // Departments: head's access to employee data
      department_head_data_access: "Head leads hiring and sees the team's data",
      department_head_data_access_hint: "The head can hire into this department and its sub-departments, approve medical checks and sees these employees in Personalas, including salaries. Only a Master can turn this on.",
      department_head_data_access_badge: "Data access",
      department_head_data_access_master_only: "Only a Master can turn this on.",
      department_error_flagged_master_only: "This department's head has access to employee data — only a Master can change its head, members or parent department.",
      department_error_head_changed: "The department head has just changed — refresh the page and try again.",
      department_error_head_data_access_self_grant: "You can't grant yourself access to employee data or widen the department you head — ask a Master.",
      department_head_data_access_scope_count: "The head will see the data of this department's and its sub-departments' employees ({{n}} people), including salaries.",
      department_head_data_access_scope_generic: "The head will see the data of this department's and its sub-departments' employees, including salaries.",
      department_error_head_data_access_invalid_head: "Access cannot be granted to a guest, an authorised person or a disabled user.",
      department_head_data_access_regrant: "The head changed — grant access again if the new head should have it.",
      asset_requests_tab_assets: "Assets",
      asset_requests_tab_requests: "Requests",
      asset_requests_title: "Asset requests",
      asset_requests_page_hint: "Equipment people need. Issue it, then mark the request as done.",
      asset_requests_new: "New request",
      asset_requests_filter_pending: "Pending",
      asset_requests_filter_done: "Done",
      asset_requests_filter_rejected: "Rejected",
      asset_requests_status_pending: "Pending",
      asset_requests_status_done: "Done",
      asset_requests_status_rejected: "Rejected",
      asset_requests_col_source: "Source",
      asset_requests_col_needed_by: "Needed by",
      asset_requests_col_result: "Outcome",
      asset_requests_source_onboarding: "Hiring",
      asset_requests_source_manual: "Manual",
      asset_requests_source_self: "Employee request",
      asset_requests_overdue: "Overdue",
      asset_requests_created_by_system: "System",
      asset_requests_issue: "Issue asset",
      asset_requests_mark_done: "Mark done",
      asset_requests_reject: "Reject",
      asset_requests_empty_pending: "No pending requests.",
      asset_requests_empty_done: "No completed requests.",
      asset_requests_empty_rejected: "No rejected requests.",
      asset_requests_load_failed: "Could not load the requests.",
      asset_requests_create: "Create request",
      asset_requests_created: "Request created",
      asset_requests_search_employee: "Search employees",
      asset_requests_no_employee: "No employees found.",
      asset_requests_self_title: "Request equipment",
      asset_requests_self_hint: "Say what you need (a laptop, a phone, a uniform...). The person who issues equipment will see your request.",
      asset_requests_self_button: "Fill in an asset request",
      asset_requests_mine_title: "My requests",
      asset_requests_mine_empty: "You have no requests yet.",
      asset_requests_rejected_reason: "Reason: {{reason}}",
      asset_requests_complete_title: "Mark request as done",
      asset_requests_complete_note: "Note (optional)",
      asset_requests_reject_title: "Reject request",
      asset_requests_reject_reason: "Reason",
      asset_requests_for_employee: "For {{name}}",
      asset_requests_pick_asset_title: "Pick the asset to issue",
      asset_requests_pick_asset_hint: "Only assets in stock are listed.",
      asset_requests_pick_asset_search: "Search assets",
      asset_requests_pick_asset_empty: "No assets in stock.",
      asset_requests_pick_asset_next: "Continue",
      asset_requests_onboarding_label: "Asset request",
      asset_requests_onboarding_none: "Will be created after step 1",
      asset_requests_onboarding_absent: "None",
      asset_requests_onboarding_done: "Done {{date}}",
      asset_requests_onboarding_rejected: "Rejected: {{reason}}",
      asset_requests_open_queue: "Open the requests",
      asset_requests_error_generic: "The action failed. Try again.",
      asset_requests_error_employee_required: "Pick an employee.",
      asset_requests_error_employee_not_active: "This person is not an active employee of the company.",
      asset_requests_error_comment_required: "Say what you need.",
      asset_requests_error_comment_too_long: "The comment is too long.",
      asset_requests_error_reason_required: "Enter a reason.",
      asset_requests_error_not_pending: "Someone has already handled this request.",
      asset_requests_error_not_found: "The request no longer exists.",
      microsoft_secret_saved_placeholder: "Saved key ••••{{last4}} — leave empty to keep it",
      microsoft_secret_expires_at: "Key valid until",
      microsoft_secret_expires_at_hint:
        "The date is shown in the Azure portal (Certificates & secrets → Expires). Administrators will see a reminder 30 days before it.",
      microsoft_secret_expiring_banner_one:
        "The Microsoft (OneDrive) key expires on {{date}} ({{days}} day left). Renew it in Settings → <settingsLink>Microsoft Connect</settingsLink>.",
      microsoft_secret_expiring_banner_other:
        "The Microsoft (OneDrive) key expires on {{date}} ({{days}} days left). Renew it in Settings → <settingsLink>Microsoft Connect</settingsLink>.",
      microsoft_secret_expired_banner:
        "The Microsoft (OneDrive) key has not been valid since {{date}} – document generation and files are not working. Renew it in Settings → <settingsLink>Microsoft Connect</settingsLink>.",
      // Company settings: grouped navigation and the blocks that moved between sections
      settings_nav_page_title: "Settings",
      // mobile: settings
      settings_nav_pick_section: "Section",
      settings_nav_group_company: "Company",
      settings_nav_group_people: "People and access",
      settings_nav_group_documents: "Documents",
      settings_nav_group_finance: "Finance",
      settings_nav_group_modules: "Modules",
      settings_nav_group_tools: "Tools",
      settings_nav_company_label: "Details and logo",
      settings_nav_company_lead: "These details are printed on invoices, contracts and other documents.",
      settings_nav_roles_label: "Who approves and signs",
      settings_nav_roles_lead: "People the system adds to signing and approvals automatically.",
      settings_nav_holidays_label: "Calendar settings",
      settings_nav_holidays_lead: "Leave days are counted from this.",
      settings_holidays_year_title: "Holidays {{year}}",
      settings_holidays_year_lead: "Public and company holidays are not counted as leave days either.",
      settings_holidays_import: "Load public holidays",
      settings_holidays_imported: "Public holidays loaded.",
      settings_holidays_import_nothing: "All public holidays are already in the list.",
      settings_holidays_add: "Add a company holiday",
      settings_holidays_show_previous_year: "Show {{year}} holidays",
      settings_holidays_col_date: "Date",
      settings_holidays_col_name: "Holiday",
      settings_holidays_turned_off: "turned off",
      settings_holidays_turn_off: "Turn off",
      settings_holidays_turn_on: "Turn on",
      settings_holidays_empty: "No holidays for this year yet. Load the public holidays or add your own.",
      settings_holidays_past_note: "Past holidays can't be changed: leave days have already been counted from them.",
      settings_holidays_form_add_title: "New company holiday",
      settings_holidays_form_edit_title: "Change holiday",
      settings_holidays_field_name: "Name",
      settings_holidays_field_start: "Start date",
      settings_holidays_field_end: "End date",
      settings_holidays_form_incomplete: "Enter a name and both dates.",
      settings_holidays_start_wrong_year: "The start date must be in {{year}}.",
      settings_holidays_end_before_start: "The end date can't be before the start date.",
      settings_holidays_past_forbidden: "A past holiday can't be changed.",
      settings_holidays_load_failed: "Couldn't load the holidays.",
      settings_nav_users_label: "Users",
      settings_nav_users_lead: "Who can sign in to this company.",
      users_search_placeholder: "Search by name, email or phone",
      users_filter_active: "Active",
      users_filter_disabled: "Disabled",
      users_add: "New user",
      users_empty: "No users found.",
      settings_nav_permissions_label: "Permissions",
      settings_nav_permissions_lead: "Who has access to what: rights from positions and rights added by hand.",
      perm_from_position: "from position",
      perm_source_manual: "added by hand",
      perm_source_position: "from position: {{position}}",
      perm_nobody: "Nobody has this right",
      perm_add_person: "Add a person",
      perm_choose_person: "Who gets this right",
      perm_choose_person_placeholder: "Choose a person",
      perm_remove_person: "Take the right away from {{name}}",
      perm_error_last_master: "This is the company's last administrator; their right can't be removed.",
      perm_error_not_member: "This person is no longer a member of the company.",
      perm_error_unknown: "No such right exists.",
      perm_error_stale: "Someone has just changed this person's rights — I reloaded them, please try again.",
      perm_not_activated: "not activated yet",
      perm_position_rights_after_activation: "Rights from a position apply once the person has activated their account.",
      groups_retired_reload: "The system was updated and this page is out of date — reload the page and try again.",
      perm_module_management: "Management",
      perm_module_documents: "Documents",
      perm_module_sales: "Sales",
      perm_module_people: "People",
      perm_module_assets: "Assets and fuel",
      perm_module_incoming_invoices: "Incoming invoices",
      perm_module_other: "Other",
      perm_master_name: "Administrator",
      perm_master_desc: "Sees and can do everything, including settings and permissions.",
      perm_admin_name: "Manager",
      perm_admin_desc: "Sees debts and closes orders.",
      perm_access_document_name: "Documents",
      perm_access_document_desc: "Sees and manages the company's document tree.",
      perm_signature_name: "Signature",
      perm_signature_desc: "Approves and signs documents on behalf of the company.",
      perm_salesman_name: "Salesperson",
      perm_salesman_desc: "Orders, sales invoices and their own customers.",
      perm_access_all_customers_name: "All customers",
      perm_access_all_customers_desc: "Sees every customer, not only their own.",
      perm_access_project_name: "Projects",
      perm_access_project_desc: "Sees and manages project boards.",
      perm_access_onboarding_name: "HR",
      perm_access_onboarding_desc: "Hires employees and manages their contracts, contract amendments and positions.",
      perm_access_departments_name: "Departments",
      perm_access_departments_desc: "Creates and edits departments and their members.",
      perm_access_job_leave_name: "Job leave",
      perm_access_job_leave_desc: "Handles employees leaving: returned assets, signatures and ending their access.",
      perm_access_work_security_assignments_name: "Procedures",
      perm_access_work_security_assignments_desc: "Assigns roles and instruction areas to employees, sees and approves their health checks (the work safety specialist).",
      perm_access_business_trips_name: "Business trips",
      perm_access_business_trips_desc: "Sees and manages everyone's business trips.",
      perm_access_assets_name: "Assets",
      perm_access_assets_desc: "Sees all assets, hands them out and handles asset requests. New-request e-mails go to the company's assets responsible person; to holders of this right only when nobody is set.",
      perm_access_fuel_reports_name: "Fuel reports",
      perm_access_fuel_reports_desc: "Sees and manages everyone's fuel reports.",
      perm_access_invoice_inbox_name: "Incoming invoices",
      perm_access_invoice_inbox_desc: "Sees the register of incoming invoices and processes them.",
      perm_approve_invoices_as_accountant_name: "Invoice approval: accountant",
      perm_approve_invoices_as_accountant_desc: "Approves incoming invoices as the accountant.",
      perm_approve_invoices_as_manager_name: "Invoice approval: manager",
      perm_approve_invoices_as_manager_desc: "Approves incoming invoices as a manager.",
      perm_verify_supplier_bank_change_name: "Supplier bank check",
      perm_verify_supplier_bank_change_desc: "Confirms that a supplier's changed bank account is genuine.",
      perm_manage_invoice_inbox_settings_name: "Incoming invoice settings",
      perm_manage_invoice_inbox_settings_desc: "Connects the mailbox and sets the rules for incoming invoices.",
      perm_access_desk_name: "Desk",
      perm_access_desk_desc: "Works with email cards in Desk.",
      perm_feed_write_name: "Writing news",
      perm_feed_write_desc: "Posts and events in the news feed.",
      settings_nav_storage_label: "Document storage",
      settings_nav_storage_lead: "Every document in the system goes here: contracts, hiring documents, invoices and uploads.",
      settings_nav_signing_label: "E-signature",
      settings_nav_signing_lead: "The signing method is chosen when sending a document. The internal signature always works.",
      settings_nav_templates_label: "Document templates",
      settings_nav_templates_lead: "Layouts the system generates documents from.",
      settings_templates_title: "Templates",
      settings_templates_description: "Layouts the system generates contracts and other documents from.",
      settings_templates_new: "New template",
      settings_templates_edit: "Edit template",
      settings_templates_back: "All templates",
      settings_templates_col_name: "Name",
      settings_templates_col_category: "Category",
      settings_templates_col_type: "Document type",
      settings_templates_col_signing: "Signing",
      settings_templates_sign_click: "Internal signature",
      settings_templates_sign_manual: "By hand",
      settings_templates_empty: "No templates yet.",
      settings_templates_load_failed: "Couldn't load the template data. Try reloading the page.",
      settings_nav_series_label: "Document prefixes",
      settings_nav_series_lead: "A short code in front of a document number, e.g. SUT-0045.",
      settings_nav_file_names_label: "File names",
      settings_nav_file_names_lead: "How the system names a generated or uploaded file.",
      settings_nav_custom_fields_label: "Custom fields",
      settings_nav_custom_fields_lead: "Extra fields on a document card.",
      settings_nav_finvalda_label: "Finvalda",
      settings_nav_finvalda_lead: "The accounting system ERP takes customers, products, invoices and debts from.",
      settings_nav_customer_terms_label: "Customer credit terms",
      settings_nav_customer_terms_lead: "Yearly approval of a customer's credit terms and the checks before it.",
      settings_nav_sales_label: "Orders and invoices",
      settings_nav_sales_lead: "How invoices generated from orders are numbered and where they are filed.",
      settings_nav_incoming_invoices_label: "Incoming invoices",
      settings_nav_incoming_invoices_lead: "Purchase register rules: who approves, where invoices are collected from and the exceptions.",
      settings_nav_hr_label: "HR",
      settings_nav_hr_lead: "Where hiring documents are filed.",
      settings_nav_procedures_label: "Procedures",
      settings_nav_procedures_lead: "Procedure areas, their documents and training tests.",
      settings_nav_business_trips_label: "Business trips",
      settings_nav_business_trips_lead: "Documents generated for a business trip.",
      settings_nav_fuel_label: "Fuel reports",
      settings_nav_fuel_lead: "The fuel report document and what counts as fuel on card statements.",
      settings_nav_asset_types_label: "Asset types",
      settings_nav_asset_types_lead: "Types used to group company assets.",
      settings_nav_terminal_label: "Terminal",
      settings_nav_terminal_lead: "Link with the terminal app: loads, shipments and contracts.",
      terminal_delivery_accept: "Accept shipments and contracts from the terminal",
      terminal_delivery_accept_hint:
        "When on, the terminal app can send this company's shipments and contracts to the ERP. The company is recognised by its company code.",
      settings_nav_assistant_label: "AI assistant",
      settings_nav_assistant_lead: "The AI helper for this company.",
      settings_nav_activity_log_label: "Activity log",
      settings_nav_activity_log_lead: "Who changed what and when.",
      settings_nav_user_merge_label: "Merge accounts",
      settings_nav_user_merge_lead: "Merge two accounts of the same person into one.",
      settings_nav_form_errors_label: "Customer form errors",
      settings_nav_form_errors_lead: "Errors customers hit when filling in the form — for support.",
      // Shared by every settings page (src/containers/settings/ui)
      settings_change: "Change",
      settings_save: "Save",
      settings_cancel: "Cancel",
      settings_saved: "Saved",
      settings_save_failed: "Couldn't save. Try again.",
      settings_load_failed: "Couldn't load the list. Reload the page to try again.",
      settings_add: "Add",
      settings_none: "Not set",
      settings_master_only: "Only the company's Master user can change this.",
      settings_secret_entered: "Entered",
      settings_secret_entered_last4: "Entered · ••••{{last4}}",
      settings_secret_keep_placeholder: "Leave empty to keep the current one",
      settings_roles_director_hint: "Signs employment contracts and their amendments on behalf of the employer.",
      settings_roles_accountant_hint: "Receives copies of signed documents (when the template says so) and notices about incoming invoices.",
      settings_roles_invoice_approver: "Incoming invoice approver",
      settings_roles_invoice_approver_hint: "Approves supplier invoices in the purchase register by default.",
      settings_roles_unassigned: "Not assigned",
      settings_roles_assets_responsible: "Assets responsible",
      settings_roles_assets_responsible_hint: "E-mails about new asset requests (e.g. when hiring an employee) go only to this person. If nobody is assigned, they go to everyone with the “Assets” permission. To open the requests, this person needs the “Assets” permission.",
      settings_roles_assets_responsible_clear: "Remove assignment",
      settings_roles_assets_responsible_empty: "If left unassigned, the e-mails go to everyone with the “Assets” permission.",
      settings_roles_nobody: "— nobody —",
      settings_roles_may_be_empty: "May be left empty — then this step is skipped.",
      settings_roles_director_clear_warning: "Without a director there is nobody to sign employment contracts on the employer's behalf.",
      settings_roles_name_unknown: "Assigned (name could not be loaded)",
      settings_roles_error_not_member: "This person is not an active member of the company.",
      settings_roles_error_required: "Choose a person, or \"nobody\", and save again.",
      settings_roles_error_lacks_permission: "This person has no right to approve invoices (permission “Approve invoices as manager”). Give them that right first.",
      settings_storage_onedrive_heading: "OneDrive connection",
      settings_storage_connect_onedrive: "Connect OneDrive",
      settings_storage_permit_label: "Who can open the company folder in OneDrive",
      settings_storage_permit_hint: "Only this person gets direct access to the OneDrive folder. Everyone else sees documents through the system only.",
      settings_ms_card_description: "The Microsoft 365 app details. Your IT administrator issues them.",
      settings_ms_client_id: "Application ID (Client ID)",
      settings_ms_tenant_id: "Organization ID (Tenant ID)",
      settings_ms_secret: "Secret (Value)",
      settings_ms_secret_entered_until: "Entered · valid until {{date}}",
      settings_ms_save_and_check: "Save and check",
      settings_ms_error_data_required: "Enter the application ID, the organization ID and the secret.",
      settings_ms_error_expiry_invalid: "The date the key is valid until is not a real date.",
      settings_ms_check_connection: "Check connection",
      settings_ms_check_ok: "Checked just now: the connection works.",
      settings_ms_check_not_configured: "Save the Microsoft app details first (application ID, organization ID and secret).",
      settings_ms_check_expired: "The Microsoft key has expired — create a new one in the Azure portal and enter it here.",
      settings_ms_check_invalid: "Enter the key's value (Value), not its ID.",
      settings_ms_check_auth_failed: "Microsoft refused the saved details. Check the application ID, the organization ID and the secret.",
      settings_ms_check_timeout: "Microsoft did not answer within 10 seconds. Try again.",
      settings_ms_check_no_folder: "The company folder no longer exists in your OneDrive. Restore it or contact support.",
      settings_ms_check_folder_error: "The company folder in OneDrive could not be read. Try again.",
      settings_ms_check_request_failed: "Could not check the connection. Try again.",
      settings_customer_terms_approvals_label: "Approve customers' financial terms",
      settings_customer_terms_approvals_hint: "Each year the customer's financial terms are approved and the customer signs a document. When off, the customer card has no such section.",
      settings_customer_terms_document_card: "Document and questionnaire",
      settings_customer_terms_document_label: "Document the customer signs",
      settings_customer_terms_document_hint: "The template the financial terms document is generated from.",
      settings_customer_terms_template_required: "Choose the document the customer signs first.",
      settings_customer_terms_skip_questionnaire_label: "Don't ask for a new questionnaire if the customer already filled one in",
      settings_customer_terms_skip_questionnaire_hint: "If the customer filled in the questionnaire in any earlier year, they don't have to fill it in for a new year.",
      settings_customer_terms_checks_card: "Checks before approval",
      settings_customer_terms_checks_hint: "A check that is on needs proof attached before approval: a screenshot or a document.",
      settings_check_eu_sanctions: "EU sanctions list",
      settings_check_eu_sanctions_hint: "Check that the customer is not on the EU sanctions list.",
      settings_check_usa_sanctions: "US sanctions list (OFAC)",
      settings_check_usa_sanctions_hint: "Check that the customer is not on the US sanctions list.",
      settings_check_lt_sanctions: "Lithuanian sanctions list",
      settings_check_lt_sanctions_hint: "Check that the customer is not on the Lithuanian sanctions list.",
      settings_check_vat: "VAT payer code check",
      settings_check_vat_hint: "EU customers only: whether the VAT code is valid.",
      settings_check_proof_place: "Proof is filed in: {{place}}",
      settings_sales_numbering_missing_title: "No invoice numbering chosen",
      settings_sales_numbering_missing_detail: "Until there is one, invoices can't be generated from orders.",
      settings_sales_numbering_pick: "Choose numbering",
      settings_sales_numbering_hint: "Sales invoices get their numbers from this series, e.g. UA-000124.",
      settings_sales_manage_series: "Manage series",
      settings_sales_series_missing: "Nothing suitable?",
      settings_sales_series_current_number: "Current number",
      settings_sales_documents_card: "Documents",
      settings_sales_documents_hint: "How the generated documents look and where they are filed.",
      settings_sales_document_invoice: "Sales invoice",
      settings_sales_document_amendment: "Order amendment",
      settings_sales_template_system: "System template",
      settings_sales_template_custom: "Own template",
      settings_sales_filed_in: "{{source}} · filed in: {{category}}",
      settings_sales_registry_series_hint: "Registry series: the document's number in the file registry, not the invoice number.",
      settings_incoming_no_permission: "You do not have permission to see these settings.",
      settings_incoming_approver_label: "Who approves incoming invoices",
      settings_incoming_approver_description: "The department head approves an invoice. When there is none, or they are on leave, this person does; without one, the director.",
      settings_incoming_approver_none: "Not assigned",
      settings_incoming_approver_assign: "Assign",
      settings_incoming_approver_unknown: "Assigned (name unavailable)",
      settings_incoming_approver_inactive: "{{name}} (inactive)",
      settings_incoming_strict_label: "Separation of duties",
      settings_incoming_strict_description: "When on, the same person cannot both enter and approve an invoice or a supplier's new bank account. Changed by the system administrator.",
      settings_incoming_strict_on: "On",
      settings_incoming_strict_off: "Off",
      settings_incoming_mailboxes_label: "Mailboxes",
      settings_incoming_mailboxes_description: "Invoices are collected from them automatically. Managed by people who may change the purchase register settings.",
      settings_incoming_suppliers_title: "Suppliers with special rules",
      settings_incoming_suppliers_description: "Suppliers whose invoices arrive after payment, or are expected every month.",
      settings_incoming_suppliers_name: "Supplier",
      settings_incoming_suppliers_paid: "Invoice arrives after payment",
      settings_incoming_suppliers_monthly: "Expected every month",
      settings_incoming_suppliers_empty: "There are no such suppliers.",
      settings_incoming_suppliers_truncated: "Only the first 500 suppliers are shown.",
      settings_incoming_senders_title: "Blocked senders",
      settings_incoming_senders_description: "Mail from these senders does not reach the register.",
      settings_incoming_senders_empty: "No senders are blocked.",
      settings_incoming_senders_blocked_by: "Blocked by {{name}}, {{date}}",
      settings_incoming_senders_blocked_on: "Blocked {{date}}",
      settings_incoming_senders_unblock: "Unblock",
      settings_incoming_senders_unblock_confirm: "Mail from this sender will reach the register again. Mail already held stays in the list.",
      settings_incoming_senders_unblock_failed: "Couldn't unblock the sender. Try again.",
      settings_signing_tablets_link: "SignOnTab devices",
      settings_signing_click_title: "Internal signature",
      settings_signing_click_description: "A person signs in to the system and presses “Sign”.",
      settings_signing_always_on: "Always on",
      settings_signing_key_label: "Access key",
      settings_signing_dokobit_description: "Qualified electronic signature: Smart-ID, Mobile signature, ID card.",
      settings_signing_dokobit_switch: "Allow signing with Dokobit",
      settings_signing_dokobit_key_hint: "Issued in your Dokobit account.",
      settings_signing_dokobit_key_required: "Enter the Dokobit access key.",
      settings_signing_dokobit_key_too_short: "The key is too short. Enter the whole Dokobit access key.",
      settings_signing_signontab_description: "Handwritten signature on a tablet, e.g. in the office or the warehouse.",
      settings_signing_signontab_switch: "Allow signing with SignOnTab",
      settings_signing_signontab_login_label: "Connection",
      settings_signing_signontab_login_hint: "The address, client ID and secret from SignOnTab.",
      settings_signing_domain: "Address",
      settings_signing_client_id: "Client ID",
      settings_signing_secret: "Secret",
      settings_signing_signontab_data_required: "Enter the address, the client ID and the secret.",
      settings_signing_signontab_secret_required: "After changing the address or the client ID, enter the secret again.",
      settings_signing_signontab_secret_too_short: "The secret is too short. Enter the whole secret.",
      signontab_users_card_description: "Tablets that are signed on by hand (SignOnTab). When sending a document, you choose which tablet it goes to.",
      signontab_users_add: "New device",
      signontab_users_name: "Name",
      signontab_users_username: "Login name",
      signontab_users_password: "Password",
      signontab_users_password_edit_hint: "The current password is never shown. Enter the current or a new password to save the changes.",
      signontab_users_empty: "No SignOnTab devices yet.",

      // Cabinet leaves: the request sheet, the days used and cancelling a pending request
      leave_sheet_title: "New request",
      leave_sheet_other_types: "Other types",
      leave_sheet_no_template: "The company has no template for this request",
      leave_sheet_previous_month: "Previous month",
      leave_sheet_next_month: "Next month",
      leave_sheet_pick_days: "Tap the first and the last day",
      leave_sheet_picked: "Selected: {{dates}} · {{days}}",
      leave_sheet_working_days: "{{n}} working days",
      leave_sheet_counting: "Counting…",
      leave_sheet_duration_full: "Whole day",
      leave_sheet_duration_half: "Half a day",
      leave_sheet_duration_hourly: "Hours",
      leave_sheet_signer_manager: "Will be signed by: {{name}} (manager)",
      leave_sheet_signer_only_you: "Only you will sign this request",
      leave_sheet_submit: "Submit and sign",
      leave_sheet_sign_hint: "Check the request and sign it.",
      leave_sheet_unsigned_note: "If you close this without signing, the request stays unsigned. You can sign it later in the list of requests.",
      leave_sheet_submitted_waiting: "Request submitted. Waiting for the manager's signature.",
      leave_sheet_submitted_done: "Request submitted and approved.",
      leave_sheet_submitted: "Request submitted.",
      leave_sheet_template: "Template",
      leave_sheet_fields_unsupported: "This template has fields that cannot be filled in here. Fill in the request in the leave calendar.",
      leave_calendar_comment_too_long: "The comment is too long (up to 1000 characters).",
      leave_calendar_substitute_not_member: "The chosen substitute is not an active employee of this company",
      leave_sheet_error_sign: "Could not sign. The request is created and waits for your signature: try again, or sign it in the list.",
      leave_usage_used: "Used in {{year}}: {{types}}",
      leave_usage_type_days: "{{type}} {{days}} d.",
      leave_usage_none: "No leave used yet in {{year}}",
      leave_usage_no_balance_hint: "The balance will be shown once the company enters the yearly norms.",
      leave_row_comment: "Comment: {{comment}}",
      leave_cancel_action: "Cancel request",
      leave_cancel_action_short: "Cancel",
      leave_cancel_title: "Cancel the request?",
      leave_cancel_notice: "The people asked to sign it will be notified.",
      leave_cancel_keep: "No, keep it",
      leave_cancel_confirm: "Yes, cancel",
      leave_cancel_error_signed: "The request has already been signed and can no longer be cancelled.",
      leave_cancel_error_generic: "Could not cancel the request. Try again.",

      // Personal cabinet: the sidebar groups and the sections of the profile
      cabinet_group: "My cabinet",
      modules_group: "Modules",
      cabinet_assets: "Assets",
      cabinet_safety: "Employee internal documents",
      cabinet_about_me: "About me",
      cabinet_my_documents: "My documents",
      module_documents: "Company documents",
      module_fuel_reports: "Company fuel reports",
      module_business_trips: "Company business trips",
      cabinet_about_me_hint: "Your details and settings.",
      cabinet_leaves_hint: "Your leave and day-off requests.",
      cabinet_fuel_hint: "Monthly fuel reports for the car assigned to you.",
      cabinet_trips_hint: "Your business trips, their reports and expenses.",
      cabinet_assets_hint: "Items the company issued to you and your asset requests.",
      cabinet_documents_hint: "Documents you can see, your contract and hiring documents.",
      cabinet_safety_hint: "Work safety — the safety instructions of your role and trainings. Health check — your medical certificate.",
      cabinet_fill_leave_request: "Fill in a leave request",
      cabinet_fill_document: "Fill in a document",
      cabinet_download_history: "Download history",

      // Phone bottom bar and the guest member's banner
      phone_bar_label: "Main sections",
      phone_bar_menu: "Menu",
      cabinet_guest_banner: "You are a guest in {{company}}.",

      // Cabinet «Turtas», «Darbuotojo vidiniai dokumentai» and the «Darbas» block of «Apie mane»
      cabinet_assets_none: "No assets have been issued to you",
      cabinet_assets_count_one: "You have {{count}} item",
      cabinet_assets_count_other: "You have {{count}} items",
      cabinet_assets_acts_to_sign_one: "{{count}} act is waiting for your signature",
      cabinet_assets_acts_to_sign_other: "{{count}} acts are waiting for your signature",
      cabinet_assets_load_failed: "Could not load your assets",
      cabinet_assets_cards_title: "My assets",
      cabinet_asset_serial: "SN {{serial}}",
      cabinet_asset_held_since: "Yours since {{date}}",
      cabinet_asset_act_signed: "Act signed",
      cabinet_asset_act_to_sign: "Act waiting for your signature",
      cabinet_asset_act_waiting_others: "Act waiting for other signatures",
      cabinet_asset_act_none: "No act",
      cabinet_asset_act_open: "Review and sign",
      cabinet_safety_documents_to_sign_one: "{{count}} safety document is waiting for your signature",
      cabinet_safety_documents_to_sign_other: "{{count}} safety documents are waiting for your signature",
      cabinet_safety_upload_medical: "Upload your medical certificate",
      cabinet_safety_documents_check_failed: "Could not check the safety documents",
      cabinet_safety_trainings_waiting_one: "{{count}} training is waiting",
      cabinet_safety_trainings_waiting_other: "{{count}} trainings are waiting",
      cabinet_safety_all_in_order: "All in order",
      cabinet_safety_medical_valid_until: "medical check valid until {{date}}",
      cabinet_safety_block_instructions: "Safety instructions and documents",
      cabinet_safety_block_training: "Trainings",
      cabinet_safety_block_medical: "Medical check",
      cabinet_work_title: "Work",
      cabinet_work_department: "Department",
      cabinet_work_since: "Working here since",
      cabinet_work_contract_until: "Contract valid until",
      cabinet_work_hours: "Working hours per week",
      cabinet_work_probation_until: "Probation until",
      cabinet_work_contract: "Employment contract",
      cabinet_work_amendments: "Contract amendments ({{total}})",
      cabinet_work_terms_change: "Change of working terms",
      cabinet_work_all_documents: "All hiring documents",
      cabinet_work_no_terms: "There is no employment contract data in the system",
      cabinet_work_load_failed: "Could not load your work details",

      // «Užduotys» page: the cabinet summary, the work queues and the way to fill documents in
      tasks_status_waiting_one: "{{count}} task is waiting for you",
      tasks_status_waiting_other: "{{count}} tasks are waiting for you",
      tasks_status_all_clear: "All clear — nothing is waiting for you",
      tasks_all_my_companies: "All my companies",
      tasks_load_failed: "Could not load tasks",
      tasks_section_mine: "Mine",
      tasks_section_queues: "Work queues",
      tasks_section_fill_in: "Fill in",
      tasks_section_waiting_others: "Waiting for others",
      tasks_group_sign: "Waiting for your signature",
      tasks_group_do: "To do",
      tasks_do_medical: "Health check",
      tasks_do_training: "Training",
      tasks_do_pinned: "Pinned posts",
      tasks_do_trip_reports: "Trip reports",
      tasks_group_expiring: "Expiring soon",
      tasks_show_all: "Show all ({{count}})",
      tasks_all_of_kind: "All ({{count}})",
      tasks_not_in_app_one: "{{count}} document is signed on paper or on a tablet — it cannot be signed here.",
      tasks_not_in_app_other: "{{count}} documents are signed on paper or on a tablet — they cannot be signed here.",
      tasks_kind_asset_act: "Asset handover act",
      tasks_kind_work_safety: "Work safety instruction",
      tasks_kind_leave: "Leave request",
      tasks_kind_fuel: "Fuel report",
      tasks_kind_trip: "Business trip",
      tasks_kind_document: "Document",
      tasks_action_sign: "Sign",
      tasks_action_sign_dokobit: "Sign with Dokobit",
      tasks_action_start: "Start",
      tasks_action_read: "Read",
      tasks_action_fill_report: "Fill in the report",
      tasks_action_upload: "Upload",
      tasks_action_open: "Open",
      tasks_action_view: "View",
      tasks_medical_upload_needed: "Upload your health check certificate",
      tasks_valid_until: "Valid until {{date}}",
      tasks_expired_on: "Expired {{date}}",
      expiry_handled_action: "Dealt with",
      expiry_handled_confirm: "Mark as dealt with? The document will no longer be shown in this list.",
      expiry_handled_failed: "Could not mark the document. Please try again.",
      expiry_handled_changed: "The document has changed; the list has been refreshed.",
      expiring_no_match: "Nothing found for these filters",
      tasks_age_today: "today",
      tasks_age_days: "{{count}}d ago",
      tasks_queue_sign_work: "Company documents awaiting signature",
      tasks_queue_team: "Team requests",
      tasks_queue_probation: "Probation reviews",
      tasks_queue_invoices: "Invoice approvals",
      tasks_queue_ws: "Procedure approvals",
      tasks_queue_customer_finance: "Customer finance approvals",
      tasks_queue_medical: "Health checks",
      tasks_queue_asset_requests: "Asset requests",
      tasks_queue_review: "Documents to review",
      tasks_queue_sent: "My sent, waiting for others",
      tasks_queue_training: "Training",
      tasks_meta_sign_work: "{{click}} Click · {{dokobit}} Dokobit · oldest {{days}} days",
      tasks_meta_paper_one: "{{count}} more document is signed on paper",
      tasks_meta_paper_other: "{{count}} more documents are signed on paper",
      tasks_meta_team: "leave and remote work",
      tasks_meta_invoices: "oldest {{days}} days",
      tasks_meta_review: "oldest {{date}}",
      tasks_meta_sent: "not everyone has signed",
      tasks_review_not_counted: "Not included in the task number",
      tasks_fill_leave: "Leave request",
      tasks_fill_fuel: "Fuel report",
      tasks_fill_trip: "Business trip",
      tasks_fill_asset: "Asset request",
      tasks_fill_document: "Other document",
      tasks_waiting_approval: "Waiting for approval",

      // Cabinet: the month table of «Kuro ataskaitos», the next steps of «Komandiruotės» and the fuel task
      cabinet_action_fill: "Fill in",
      cabinet_action_continue: "Continue",
      cabinet_action_fix: "Fix",
      cabinet_fuel_month_01: "January",
      cabinet_fuel_month_02: "February",
      cabinet_fuel_month_03: "March",
      cabinet_fuel_month_04: "April",
      cabinet_fuel_month_05: "May",
      cabinet_fuel_month_06: "June",
      cabinet_fuel_month_07: "July",
      cabinet_fuel_month_08: "August",
      cabinet_fuel_month_09: "September",
      cabinet_fuel_month_10: "October",
      cabinet_fuel_month_11: "November",
      cabinet_fuel_month_12: "December",
      cabinet_fuel_all_filed: "All reports are filed",
      cabinet_fuel_missing_month: "The {{month}} {{year}} report is missing",
      cabinet_fuel_missing_count_other: "{{count}} reports are missing",
      cabinet_fuel_fill_month: "Fill in the {{month}} report",
      cabinet_fuel_fill: "Fill in a fuel report",
      cabinet_fuel_table_label: "Fuel reports by month",
      cabinet_fuel_col_month: "Month",
      cabinet_fuel_col_vehicle: "Vehicle",
      cabinet_fuel_col_status: "Status",
      cabinet_fuel_col_action: "Action",
      cabinet_fuel_status_missing: "Not filed",
      cabinet_fuel_status_current: "Current month",
      cabinet_fuel_status_draft: "In progress",
      cabinet_fuel_status_to_sign: "Waiting for your signature",
      cabinet_fuel_status_waiting_manager: "Waiting for your manager",
      cabinet_fuel_status_rejected: "Declined",
      cabinet_fuel_status_approved: "Approved",
      cabinet_fuel_status_annulled: "Annulled",
      cabinet_fuel_note: "Once you sign a report, it is sent to your manager automatically.",
      cabinet_fuel_load_failed: "Could not load the fuel reports",
      cabinet_trip_new: "New business trip",
      cabinet_trip_next_step: "Next step",
      cabinet_trips_waiting_report_single: "One business trip is waiting for a report",
      cabinet_trips_waiting_report_other: "{{count}} business trips are waiting for a report",
      cabinet_trips_waiting_signature_single: "One business trip is waiting for your signature",
      cabinet_trips_waiting_signature_other: "{{count}} business trips are waiting for your signature",
      cabinet_trips_all_in_order: "All business trips are in order",
      cabinet_trip_step_create_order: "Generate the business trip order",
      cabinet_trip_step_sign_order: "Sign the order",
      cabinet_trip_step_wait_order: "Waiting for signatures on the order",
      cabinet_trip_step_trip_ahead: "The trip has not ended yet",
      cabinet_trip_step_fill_report: "Fill in the report",
      cabinet_trip_step_sign_report: "Sign the report",
      cabinet_trip_step_wait_report: "Waiting for signatures on the report",
      cabinet_trip_step_fix_report: "Report declined — please fix it",
      cabinet_trip_step_done: "Completed",
      cabinet_trip_step_cancelled: "Cancelled",
      tasks_do_fuel_reports: "Fuel reports",
      tasks_fuel_report_title: "Fill in the {{month}} fuel report",

      // Queue lists («Pasirašyti dokumentus», «Peržiūrėti dokumentus») and the one-by-one sheet
      queue_sign_status_one: "{{count}} document is waiting for your signature",
      queue_sign_status_other: "{{count}} documents are waiting for your signature",
      queue_sign_oldest: "oldest {{days}} d.",
      queue_sign_all_signed: "Everything is signed",
      queue_sign_nothing_matches: "Nothing matches the filters",
      queue_sign_start: "Review and sign one by one",
      queue_filter_type: "Type",
      queue_filter_company: "Company",
      queue_filter_signature: "Signature",
      queue_filter_all: "All",
      queue_filter_all_companies: "All",
      queue_type_work: "Work",
      queue_type_mine: "Mine",
      queue_type_team: "Team requests",
      queue_signature_click: "Click",
      queue_signature_dokobit: "Dokobit",
      queue_filter_older: "Older than {{days}} d.",
      queue_search: "Search",
      queue_col_title: "Title",
      queue_col_type: "Type",
      queue_col_company: "Company",
      queue_col_owner: "Submitted by",
      queue_col_customer: "Customer",
      queue_col_waiting: "Waiting",
      queue_col_signature: "Signature",
      queue_col_received: "Received",
      sign_status: "Signing status",
      not_initiate: "Not initiated",
      queue_group_team: "Team",
      queue_waiting_days: "{{days}} d.",
      queue_paper_title: "Signed on paper ({{count}})",
      queue_paper_note: "These documents cannot be signed in the app. Once the customer has signed on paper and the document owner has uploaded the scanned copy, the document will appear in the list above for signing with Dokobit.",
      queue_load_failed: "Could not load the documents",
      queue_retry: "Try again",
      queue_review_status_one: "{{formatted}} document is waiting for review",
      queue_review_status_other: "{{formatted}} documents are waiting for review",
      queue_review_start: "Review one by one",
      queue_review_not_counted: "Documents to review are not included in the task number.",
      queue_page_range: "{{from}}–{{to}} of {{total}}",
      queue_prev_page: "Previous page",
      queue_next_page: "Next page",
      queue_sheet_word_sign: "Sign",
      queue_sheet_word_team: "Request",
      queue_sheet_word_review: "Review",
      queue_sheet_counter: "{{i}} of {{n}}",
      queue_sheet_open_document: "Open the whole document",
      queue_sheet_loading_more: "Loading the next documents…",
      queue_fact_owner: "Submitted by: {{name}}",
      queue_fact_customer: "Customer: {{names}}",
      queue_fact_waiting: "Waiting: {{days}} d.",
      queue_leave_employee: "Employee",
      queue_leave_dates: "Dates",
      queue_leave_hours: "Hours",
      queue_action_review: "Mark as reviewed",
      queue_action_skip: "Skip",
      queue_action_decline: "Decline…",
      queue_action_decline_confirm: "Decline",
      queue_action_next: "Continue",
      queue_decline_reason: "Reason for declining",
      queue_msg_signed: "Signed",
      queue_msg_signed_manager_asked: "Signed, the request was sent to the manager",
      queue_msg_declined: "Declined",
      queue_msg_reviewed: "Marked as reviewed",
      queue_msg_dokobit_opened: "Signing opened in a new tab. After signing, come back to this tab and press Continue. Confirmation from Dokobit can take up to 30 minutes.",
      queue_error_annulled: "The document was annulled",
      queue_error_withdrawn: "The document was withdrawn",
      queue_error_changed: "The state of this document has changed",
      queue_error_generic: "The action failed. Try again or skip the document.",
      queue_error_popup_blocked: "The browser blocked the new window. Allow pop-ups and try again.",
      queue_end_title: "Queue finished: {{summary}}",
      queue_end_signed: "signed {{n}}",
      queue_end_declined: "declined {{n}}",
      queue_end_skipped: "skipped {{n}}",
      queue_end_reviewed: "reviewed {{n}}",
      queue_end_opened: "opened in Dokobit {{n}}",
      queue_end_more_failed: "The next documents could not be loaded. Reload the list to continue.",
      needs_attention: "Needs attention",
    },
  },
  lt: {
    translation: {
      // Pagrindinės sutarties pasirašymas: ko dar trūksta ir kur tai padaryti
      manual_signing_awaiting_client: "Laukiama kliento parašo. Kai klientas grąžins ranka pasirašytą kopiją, įkelkite ją čia. Po to dokumentą per Dokobit pasirašys mūsų įmonė.",
      manual_signing_awaiting_company: "Klientas pasirašė. Dabar įkeltą kopiją per Dokobit turi pasirašyti mūsų įmonė. Iki tol sutartis negalioja, o užsakymų dokumentų kurti negalima.",
      manual_signing_awaiting_company_sent: "Klientas pasirašė. Laukiama mūsų įmonės parašo per Dokobit.",
      sign_request_company_side: "Siųsti pasirašyti mūsų įmonei",
      order_contract_no_finance: "Klientas neturi {{year}} m. pagrindinės sutarties. Sukurkite finansinį patvirtinimą kliento kortelėje.",
      order_contract_not_approved: "{{year}} m. pagrindinė sutartis dar nepatvirtinta.",
      order_contract_no_document: "{{year}} m. pagrindinės sutarties dokumentas dar nesugeneruotas.",
      order_contract_withdrawn: "{{year}} m. pagrindinės sutarties dokumentas atšauktas. Sugeneruokite naują sutarties puslapyje.",
      // mobile: shared
      open_pdf: "Atidaryti PDF",
      order_contract_awaiting_client: "Pagrindinė sutartis laukia kliento parašo. Gavę pasirašytą kopiją, įkelkite ją sutarties puslapyje.",
      order_contract_awaiting_company: "Klientas pasirašė pagrindinę sutartį. Liko ją pasirašyti mūsų įmonei per Dokobit sutarties puslapyje.",
      order_contract_awaiting_signatures: "Pagrindinė sutartis dar nepasirašyta visų šalių.",
      order_open_master_agreement: "Atidaryti sutartį",
      order_open_customer_card: "Atidaryti kliento kortelę",
      // Kliento kortelė → dokumentų skiltis: kategorijų medis šalia sąrašo
      "customer_documents_all": "Visi dokumentai",
      "customer_documents_uncategorized": "Be kategorijos",
      "customer_documents_show_all": "Rodyti visus",
      "customer_documents_select_all": "Pažymėti visus",
      "customer_documents_unselect_all": "Nužymėti visus",
      // Dokumentų sąrašo eilutės (features/files): būsena, informacija, pasirašantieji
      "files_status_annulled": "Anuliuota",
      "files_status_withdrawn": "Atšaukta",
      "files_status_signed": "Pasirašyta",
      "files_status_rejected": "Atmesta",
      "files_status_approval_required": "Reikia vadovo patvirtinimo",
      "files_status_progress": "Pasirašė {{signed}} iš {{total}}",
      "files_status_no_signing": "Be pasirašymo",
      "files_number": "Nr. {{number}}",
      "files_related": "Susiję ({{count}})",
      "files_signer_signed": "pasirašė",
      "files_signer_pending": "laukia",
      "files_signer_rejected": "atmetė",
      "files_signer_withdrawn": "atšaukta",
      "files_signer_since": "nuo {{date}}",
      "files_signer_decline_reason": "Priežastis: {{reason}}",
      "files_remind": "Priminti",
      "files_remind_by_email": "Priminti el. laišku",
      "files_reminder_sent": "Priminimas išsiųstas",
      "files_reminder_failed": "Nepavyko išsiųsti priminimo",
      "files_open_document_page": "Atidaryti dokumento puslapį",
      "files_empty_category": "Šioje kategorijoje dokumentų nėra",
      "files_empty": "Dokumentų nėra",
      "registry_details_withheld_short": "PVM kodas galioja",
      "registry_details_withheld": "Ši šalis neskelbia įmonės pavadinimo ir adreso (pavyzdžiui, Vokietija). PVM kodas patvirtintas kaip galiojantis — likusius laukus užpildykite ranka.",
      "registry_search_help_foreign": "Užsienio įmonei įveskite PVM kodą su šalies prefiksu, pvz. EE100594102.",
      "registry_already_exists": "Toks kontrahentas jau yra",
      "customer_exists_error": "Toks kontrahentas jau yra — PVM kodas gali priklausyti tik vienam klientui.",
      "registry_search_placeholder": "pvz. UAB Pavyzdys, 304237850 arba LT100010465613",
      "registry_search_label": "Rasti įmonę viešuosiuose registruose",
      "registry_search_help": "Įveskite įmonės pavadinimą, įmonės kodą arba PVM kodą — rekvizitai bus užpildyti automatiškai.",
      "registry_no_results": "Registruose nieko nerasta. Užpildykite ranka.",
      "registry_unavailable": "Vieši registrai neatsako. Užpildykite ranka.",
      "registry_failed": "Paieška nepavyko. Užpildykite ranka.",
      "registry_inactive": "(išregistruota)",
      "registry_not_vat_payer": "ne PVM mokėtojas",
      "registry_filled_from_public_data": "Rekvizitai užpildyti iš viešų registrų. Patikrinkite juos ir patys įrašykite banko bei komercines sąlygas.",
      "storage_quota_full": "Išnaudojote visą saugyklos vietą. Nauji įkėlimai bus atmesti, kol failai nebus pašalinti — susisiekite su mumis dėl didesnio limito.",
      "storage_quota_nearly_full": "Artėjate prie saugyklos limito.",
      "storage_loading": "Tikrinama…",
      "storage_unknown": "Nepavyko nustatyti",
      "storage_where_ours": "Dokumentai saugomi mūsų saugykloje",
      "storage_where_google": "Dokumentai saugomi jūsų Google Drive",
      "storage_where_microsoft": "Dokumentai saugomi jūsų OneDrive",
      "storage_own_cloud_note": "Failai yra jūsų pačių debesyje. Antros kopijos nesaugome, o vieta yra jūsų, ne mūsų.",
      "storage_used": "Užimta",
      "storage_of": "iš",
      "storage_choose": "Kur saugoti naujus dokumentus",
      "storage_option_ours": "Mūsų saugykla",
      "storage_option_google": "Mano Google Drive",
      "storage_option_microsoft": "Mano OneDrive",
      "storage_switch_note": "Pakeitimas galioja tik naujiems dokumentams. Jau įkelti lieka ten, kur yra, ir atsidaro kaip įprasta.",
      "storage_google_section": "Prijungti Google Drive",
      "storage_google_scope_note": "Prašome prieigos tik prie failų, kuriuos ši sistema sukuria jūsų Drive — ne prie viso jo.",
      "storage_google_connect": "Prijungti",
      "storage_google_reconnect": "Prijungti iš naujo",
      "storage_google_connected": "Google Drive prijungtas.",
      "storage_google_connect_failed": "Google Drive nebuvo prijungtas.",
      "storage_google_app_saved": "Išsaugota. Dabar spauskite Prijungti.",
      "storage_google_app_save_failed": "Nepavyko išsaugoti Google programos.",
      "storage_google_app_required": "Pirma įveskite ir išsaugokite Google programą.",
      "storage_google_not_connected": "Pirma prijunkite Google Drive.",
      "storage_microsoft_not_connected": "Pirma prijunkite OneDrive — mygtukas žemiau.",
      "storage_s3_not_configured": "Mūsų saugykla šiame serveryje nesukonfigūruota.",
      "storage_provider_changed": "Nauji dokumentai keliaus į pasirinktą saugyklą.",
      "storage_provider_change_failed": "Nepavyko pakeisti saugyklos.",
      "storage_load_failed": "Nepavyko gauti saugyklos informacijos.",
      "storage_files_count_one": "{{count, number}} failas",
      "storage_files_count_few": "{{count, number}} failai",
      "storage_files_count_other": "{{count, number}} failų",
      "storage_files_unknown_size_one": "{{count}} failo dydis nežinomas",
      "storage_files_unknown_size_few": "{{count}} failų dydis nežinomas",
      "storage_files_unknown_size_other": "{{count}} failų dydis nežinomas",
      "finvalda_pass_keep_placeholder": "Palikite tuščią, jei nekeičiate",
      "finvalda_password_required": "Pakeitus adresą, naudotoją ar įmonės ID, įveskite slaptažodį iš naujo.",
      "finvalda_save_failed": "Nepavyko išsaugoti Finvaldos nustatymų.",
      "finvalda_sync_active": "Parsiųsti duomenis iš Finvaldos automatiškai",
      "finvalda_sync_active_hint": "Kas 15 min. parsiunčiami klientai, prekės, sąskaitos, apmokėjimai ir skolos.",
      settings_finvalda_sync_on: "Duomenys atsinaujina automatiškai",
      settings_finvalda_sync_off: "Automatinis parsiuntimas išjungtas",
      settings_finvalda_last_sync: "Paskutinį kartą sėkmingai: {{when}}",
      settings_finvalda_never_synced: "dar nebuvo",
      settings_finvalda_check: "Patikrinti ryšį",
      settings_finvalda_checking: "Tikrinama...",
      settings_finvalda_check_ok: "Prisijungimas prie Finvaldos veikia.",
      settings_finvalda_check_not_configured: "Prisijungimo prie Finvaldos duomenys dar neišsaugoti. Užpildykite juos žemiau ir išsaugokite.",
      settings_finvalda_check_access_denied: "Finvalda atmetė prisijungimą. Patikrinkite naudotoją, slaptažodį ir įmonės ID.",
      settings_finvalda_check_timeout: "Finvalda neatsakė per 10 sekundžių. Pabandykite vėliau.",
      settings_finvalda_check_unreachable: "Nepavyko pasiekti Finvaldos serverio. Patikrinkite adresą.",
      settings_finvalda_check_failed: "Nepavyko patikrinti ryšio. Bandykite dar kartą.",
      settings_finvalda_save_connection_first: "Pirmiausia išsaugokite prisijungimą prie Finvaldos žemiau.",
      settings_finvalda_journal_group_label: "Pardavimų žurnalų grupė",
      settings_finvalda_journal_group_description: "Iš kurios Finvaldos žurnalų grupės parsiunčiamos pardavimo sąskaitos.",
      settings_finvalda_journal_group_hint: "Raidės be diakritikų, skaičiai, tarpas ir . _ $ - , iki 40 simbolių, pvz., ERP.PARD.",
      settings_finvalda_journal_group_invalid: "Grupės kode yra neleidžiamų simbolių.",
      settings_finvalda_connection_title: "Prisijungimas prie Finvaldos",
      settings_finvalda_connection_lead: "Šiuos duomenis duoda Finvaldos administratorius.",
      settings_finvalda_password_saved: "Įvestas",
      settings_finvalda_fields_required: "Užpildykite visus laukus.",
      settings_finvalda_address_not_allowed: "Šis serverio adresas netinka: jis turi rodyti į viešą serverį.",
      "last_master_error": "Įmonėje turi likti bent vienas administratorius (Master).",
      "outlook_connect_by_employee_hint": "Paštą prijungia pats darbuotojas savo profilyje.",
      "no_companies_yet": "Įmonės kol kas nėra",
      "no_companies_yet_hint": "Jūsų paskyra aktyvi, bet dar nesusieta su įmone. Susisiekite su tuo, kas jums suteikė prieigą.",
      "company_access_turned_off": "Jūsų prieiga prie šios įmonės išjungta.",
      "company_no_access": "Jūs neturite prieigos prie šios įmonės.",
      "no_access_to_any_company": "Jūs nebeturite prieigos prie jokios įmonės. Jei manote, kad tai klaida, kreipkitės į savo įmonės administratorių.",
      "companies_load_failed": "Nepavyko gauti įmonių sąrašo",
      "companies_load_failed_hint": "Užklausa nepavyko. Bandykite dar kartą — jei kartojasi, gali būti pasibaigusi sesija.",
      "try_again": "Bandyti dar kartą",
      "customer_invoices_load_failed": "Nepavyko gauti kliento sąskaitų. Esamos sąskaitos gali būti nerodomos — nekurkite naujos, kol sąrašas neįsikels.",
      // Gautos sąskaitos / pirkimų registras
      "invoice_inbox_confirming_account": "Patvirtinama",
      "supplier": "Tiekėjas",
      "iban": "IBAN",
      "amounts": "Sumos",
      "net": "Suma be PVM",
      "approvals": "Tvirtinimai",
      "sender": "Siuntėjas",
      "approve": "Patvirtinti",
      "reject": "Atmesti",
      "invoice_inbox_upload": "Įkelti dokumentą",
      "invoice_inbox_upload_failed": "Failas nepriimtas.",
      "invoice_mailboxes": "Sąskaitų pašto dėžutės",
      "invoice_mailboxes_intro": "Laiškai, atėję šiais adresais, tampa dokumentais registre. Adresas priklauso įmonei, ne jums — jį mato visi, kas tvarko nustatymus.",
      "invoice_mailbox_load_failed": "Nepavyko įkelti pašto dėžučių.",
      "invoice_mailbox_forbidden": "Neturite teisės tvarkyti sąskaitų pašto dėžučių.",
      "invoice_mailbox_start_delay": "Laiškai pradedami imti per minutę nuo išsaugojimo. Imami tik po to atėję laiškai — kas jau guli dėžutėje, netraukiama.",
      "invoice_mailbox_add": "Pridėti pašto dėžutę",
      "invoice_mailbox_edit": "Pašto dėžutės nustatymai",
      "invoice_mailbox_provider": "Pašto tiekėjas",
      "invoice_mailbox_provider_other": "Kitas (IMAP)",
      "invoice_mailbox_imap_host": "IMAP serveris",
      "invoice_mailbox_imap_port": "IMAP prievadas",
      "invoice_mailbox_folder": "Aplankas",
      "invoice_mailbox_folder_hint": "Palikite tuščią — bus renkamas visas gautųjų aplankas (INBOX). Pašto serverio taisyklė gali dėti sąskaitas į atskirą aplanką — renkami tik po pakeitimo gauti laiškai.",
      "invoice_mailbox_app_password": "Programėlės slaptažodis",
      "invoice_mailbox_password_stored": "Išsaugotas — palikite tuščią, kad nesikeistų",
      "invoice_mailbox_app_password_help": "Ne paskyros slaptažodis: pašto tiekėjo saugumo nustatymuose sukurkite atskirą programėlės slaptažodį.",
      "invoice_mailbox_ingest_mode": "Rinkti",
      "invoice_mailbox_ingest_all": "Visus gaunamus laiškus",
      "invoice_mailbox_ingest_label": "Tik vienos žymos laiškus",
      "invoice_mailbox_label_name": "Žyma",
      "invoice_mailbox_active": "Rinkti laiškus iš šio adreso",
      "invoice_mailbox_test": "Tikrinti ryšį",
      "invoice_mailbox_test_ok": "Pašto dėžutė atsiliepė.",
      "invoice_mailbox_test_failed": "Nepavyko prisijungti prie pašto dėžutės.",
      "invoice_mailbox_label_missing": "Prisijungta, bet tokios žymos nėra — nieko nebūtų surinkta.",
      "invoice_mailbox_folders_found": "Ryšio patikra rado {{count}} aplankų — pasirinkite iš sąrašo.",
      "invoice_mailbox_folder_missing": "Prisijungta, bet tokio aplanko nėra — nieko nebus renkama.",
      "invoice_inbox_no_mailbox_connected": "Nėra prijungtos pašto dėžutės — prijunkite ją nustatymuose.",
      "invoice_mailbox_check_now": "Tikrinti paštą dabar",
      "invoice_mailbox_swept_new": "Patikrinta — naujų laiškų: {{count}}.",
      "invoice_mailbox_swept_none": "Patikrinta — naujų laiškų nėra.",
      "invoice_mailbox_busy": "Patikrinimas jau vyksta.",
      "invoice_mailbox_not_checked": "Pašto dėžutė nebuvo patikrinta ({{status}}).",
      "invoice_mailbox_stop": "Nebeimti laiškų",
      "invoice_mailbox_stop_confirm": "Išsaugotas slaptažodis ištrinamas, nauji laiškai nebeimami. Viskas, kas jau gauta, lieka registre.",
      "invoice_mailbox_delete_confirm": "Pašto dėžutė pašalinama visam laikui. Galima tik tada, kai ji nieko negavo.",
      "invoice_mailbox_disabled": "Laiškai nebeimami.",
      "invoice_mailbox_deleted": "Pašto dėžutė pašalinta.",
      "invoice_mailbox_has_messages": "Į šią dėžutę jau atėjo laiškų — geriau tiesiog nebeimkite laiškų.",
      "invoice_mailbox_disconnect_first": "Prieš šalindami, sustabdykite laiškų ėmimą.",
      "invoice_mailbox_address_taken": "Šis adresas jau renkamas į registrą.",
      "invoice_mailbox_password_required": "Reikia programėlės slaptažodžio.",
      "invoice_mailbox_password_required_address_change": "Adresas pasikeitė — įveskite naujos paskyros programėlės slaptažodį.",
      "invoice_mailbox_label_gmail_only": "Žymų režimas veikia tik su Gmail.",
      "invoice_mailbox_host_not_allowed": "Šis pašto serveris neleidžiamas.",
      "invoice_mailbox_invalid_address": "Įveskite teisingą el. pašto adresą.",
      "invoice_mailbox_invalid_folder": "Netinkamas aplanko pavadinimas.",
      "invoice_mailbox_invalid_port": "Įveskite prievadą nuo 1 iki 65535.",
      "invoice_mailbox_collecting": "Renka",
      "invoice_mailbox_off": "Nerenka",
      "invoice_mailbox_error": "Klaida",
      "invoice_mailbox_lost": "Prarasta laiškų: {{count}}",
      "invoice_mailbox_silent": "Tylu {{count}} d.",
      "invoice_mailbox_health": "Būsena",
      "invoice_mailbox_also_desk": "Šis adresas taip pat renkamas į Desk — kiekviena sąskaita taps ir užduoties kortele.",
      "invoice_mailbox_lost_explained": "Per paskutines {{days}} d. atėjo laiškų, kurie netapo jokiu dokumentu: {{count}}. Registre jų nėra.",
      "invoice_mailbox_silent_explained": "Jau {{count}} d. nieko negauta, o šiai dėžutei tai neįprasta. Gali būti sugedusi persiuntimo taisyklė arba MX įrašas.",
      "invoice_mailbox_last_sync": "Paskutinį kartą tikrinta",
      "invoice_mailbox_last_received": "Paskutinis laiškas",
      "invoice_mailbox_traffic": "Laiškų per {{days}} d.",
      "invoice_inbox_empty_settings_link": "Nustatyti pašto dėžutę, kuria siunčiamos sąskaitos",
      "invoice_inbox_enter_by_hand": "Įvesti ranka",
      "invoice_inbox_delete_reason": "Kodėl šalinama?",
      "invoice_inbox_delete_reason_help": "Dokumentas išsaugomas ir gali būti atkurtas — tai paaiškins veiksmą tam, kas žiūrės vėliau.",
      "invoice_inbox_confirm_delete": "Patvirtinti šalinimą",
      "invoice_inbox_block_sender": "Blokuoti siuntėją",
      "invoice_inbox_blocked_notice": "Būsimi laiškai iš {{sender}} nebetaps dokumentais. Anksčiau iš šio siuntėjo gauta sąskaitų: {{count}}.",
      "invoice_inbox_doc_kind": "Dokumento tipas",
      "invoice_inbox_credit_note_hint": "Saugoma neigiama suma — ji mažina skolą.",
      "invoice_inbox_field_unverified": "Nepavyko patikrinti automatiškai",
      "invoice_inbox_changed_fields": "Pakeista laukų: {{count}}",
      "invoice_inbox_edit_invalidates": "Šį dokumentą jau patvirtino. Pakeitus sumą, sąskaitą ar numerį, tie patvirtinimai atšaukiami — jie apibūdino ankstesnę dokumento būklę.",
      "invoice_inbox_series": "Serija",
      "invoice_inbox_kind_invoice": "Sąskaita faktūra",
      "invoice_inbox_kind_credit_note": "Kreditinė",
      "invoice_inbox_kind_debit_note": "Debetinė",
      "invoice_inbox_kind_proforma": "Išankstinė",
      "invoice_inbox_kind_advance": "Avansinė",
      "invoice_inbox_kind_statement": "Suderinimo aktas",
      "invoice_inbox_kind_receipt": "Kvitas",
      "invoice_inbox_kind_not_a_document": "Ne dokumentas",
      "invoice_inbox": "Gautos sąskaitos",
      "invoice_inbox_tab_needs_review": "Tikrinti",
      "invoice_inbox_tab_awaiting": "Tvirtinamos",
      "invoice_inbox_tab_approved": "Patvirtintos",
      "invoice_inbox_tab_bookkept": "Įvestos",
      "invoice_inbox_waiting_for_me": "Laukia jūsų",
      "invoice_inbox_tab_rejected": "Atmestos",
      "invoice_inbox_tab_all": "Visos",
      "invoice_inbox_tab_deleted": "Ištrintos",
      "invoice_inbox_actors_needs_review_approveAccountant": "Tikrina ir siunčia tvirtinti (buhalteris)",
      "invoice_inbox_actors_needs_review_verifyBankChange": "Patvirtina pasikeitusią banko sąskaitą",
      "invoice_inbox_actors_awaiting_approval_approveManager": "Tvirtina apmokėjimą (vadovas)",
      "invoice_inbox_actors_awaiting_approval_approveAccountant": "Tvirtina duomenis (buhalteris)",
      "invoice_inbox_actors_approved_access": "Gali pažymėti „Įvesta“",
      "invoice_inbox_actors_bookkept_access": "Gali pažymėti „Apmokėta“",
      "invoice_inbox_actors_rejected_approveAccountant": "Pataiso ir siunčia iš naujo (buhalteris)",
      "invoice_inbox_actors_all_access": "Mato registrą",
      "invoice_inbox_actors_deleted_access": "Gali atkurti",
      "invoice_inbox_actors_nobody": "Niekas neturi teisės „{{permission}}“",
      "invoice_inbox_actors_assign": "Suteikite ją skiltyje „Teisės“",
      "invoice_inbox_actors_not_activated": "neaktyvuotas",
      "invoice_approvals_intro": "Pirkimo sąskaitos, laukiančios jūsų sprendimo. Vadovo patvirtinimas reiškia: sutinkame mokėti.",
      "invoice_approvals_empty": "Nėra sąskaitų, laukiančių jūsų patvirtinimo.",
      "invoice_approvals_load_failed": "Nepavyko įkelti jūsų laukiančių sąskaitų.",
      "invoice_approvals_role_manager": "Vadovas: sutinkame mokėti",
      "invoice_approvals_role_accountant": "Buhalteris: duomenys teisingi",
      "invoice_approvals_col_supplier": "Tiekėjas",
      "invoice_approvals_col_invoice": "Sąskaita",
      "invoice_approvals_col_due": "Apmokėti iki",
      "invoice_approvals_col_amount": "Suma",
      "invoice_approvals_col_role": "Jūsų sprendimas",
      "invoice_approvals_overdue": "Vėluoja",
      "invoice_approvals_bank_change": "Pasikeitė banko sąskaita",
      "invoice_approvals_duplicate": "Galimas dublikatas",
      "invoice_approvals_open": "Atidaryti",
      "invoice_approvals_approve": "Tvirtinti",
      "invoice_approvals_approve_confirm": "Patvirtinti sąskaitą {{number}} iš {{supplier}} už {{amount}}?",
      "invoice_approvals_reject": "Atmesti",
      "invoice_approvals_reject_reason": "Atmetimo priežastis",
      "invoice_approvals_reject_confirm": "Patvirtinti atmetimą",
      "invoice_approvals_cancel": "Atšaukti",
      "invoice_approvals_go_register": "Į registrą",
      "header_my_work_title": "Užduotys: laukia {{count}}",
      "invoice_inbox_col_preview": "Failas",
      "invoice_inbox_preview": "Peržiūrėti failą",
      "invoice_inbox_preview_open_doc": "Atidaryti dokumentą",
      "invoice_inbox_preview_open_file": "Atidaryti failą atskirai",
      "invoice_inbox_preview_unsupported": "Šio tipo failo naršyklėje peržiūrėti negalima.",
      "invoice_inbox_col_supplier": "Tiekėjas",
      "invoice_inbox_col_invoice_number": "Sąskaitos nr.",
      "invoice_inbox_col_date": "Data",
      "invoice_inbox_col_due": "Apmokėti iki",
      "invoice_inbox_col_status": "Būsena",
      "invoice_inbox_status_new": "Nauja",
      "invoice_inbox_status_needs_review": "Tikrinti",
      "invoice_inbox_status_awaiting_approval": "Tvirtinama",
      "invoice_inbox_status_approved": "Patvirtinta",
      "invoice_inbox_status_rejected": "Atmesta",
      "invoice_inbox_status_exported": "Perduota",
      "invoice_inbox_flag_bank_change": "Pasikeitė banko sąskaita",
      "invoice_inbox_flag_suspicious": "Įtartinas turinys",
      "invoice_inbox_flag_duplicate": "Galimas dublikatas",
      "invoice_inbox_unknown_supplier": "Neatpažintas",
      "invoice_inbox_supplier_unresolved": "nesusietas",
      "invoice_inbox_search_placeholder": "Tiekėjas, sąskaitos nr., failo pavadinimas…",
      "invoice_inbox_filter_flags": "Rodyti tik",
      "invoice_inbox_empty": "Kol kas dokumentų nėra",
      "invoice_inbox_empty_hint": "Į įmonės pašto dėžutę atsiųstos sąskaitos čia atsiranda per kelias minutes. Taip pat galite įkelti dokumentą ranka.",
      "invoice_inbox_empty_filtered": "Pagal šiuos filtrus nieko nerasta",
      "invoice_inbox_empty_filtered_hint": "Išvalykite filtrus, kad matytumėte visą registrą.",
      "invoice_inbox_load_doc_failed": "Nepavyko atidaryti šio dokumento.",
      "invoice_inbox_refresh_failed": "Nepavyko atnaujinti dokumento. Perkraukite puslapį.",
      "invoice_inbox_action_failed": "Veiksmas neįvyko.",
      "invoice_inbox_banner_suspicious": "Šiame dokumente yra tekstas, skirtas skaitytojui. Vertinkite jo turinį atsargiai.",
      "invoice_inbox_banner_bank": "Šioje sąskaitoje nurodyta banko sąskaita nėra patvirtinta šiam tiekėjui. Prieš eidami toliau, paskambinkite tiekėjui numeriu iš savo įrašų — ne iš šios sąskaitos.",
      "invoice_inbox_banner_entity": "Ši sąskaita išrašyta kitai grupės įmonei.",
      "invoice_inbox_banner_duplicate": "Galbūt tas pats kaip",
      "invoice_inbox_reextract": "Skaityti iš naujo",
      "invoice_inbox_reextract_queued": "Skaitoma iš naujo — laukai netrukus atsiras.",
      "invoice_inbox_banner_unread": "Šio dokumento nepavyko perskaityti automatiškai. Failas yra — laukus galima užpildyti ranka.",
      "invoice_inbox_previous_account": "Anksčiau naudota",
      "invoice_inbox_verify_note": "Su kuo kalbėjote ir kokiu numeriu?",
      "invoice_inbox_confirm_account": "Patvirtinti šią sąskaitą",
      "invoice_inbox_cannot_dispatch": "Kad būtų galima siųsti tvirtinti:",
      "invoice_inbox_blocker_supplier_unresolved": "tiekėjas dar nesusietas",
      "invoice_inbox_blocker_bank_change_unverified": "banko sąskaita nepatvirtinta",
      "invoice_inbox_blocker_no_amount": "nėra sumos",
      "invoice_inbox_blocker_not_read_yet": "dokumentas dar neperskaitytas",
      "invoice_inbox_blocker_wrong_status": "dokumento būsena netinkama siuntimui",
      "invoice_inbox_blocker_deleted": "dokumentas ištrintas",
      "invoice_inbox_refusal_verifier_edited_the_iban": "Šią sąskaitą turi patvirtinti kitas asmuo: šį IBAN įvedėte jūs.",
      "invoice_inbox_refusal_verifier_is_an_approver": "Šią sąskaitą turi patvirtinti kitas asmuo: jūs esate sąskaitos faktūros, kurią ji stabdo, tvirtintojas.",
      "invoice_inbox_refusal_manager_lacks_permission": "Asmuo, kuris turėtų patvirtinti apmokėjimą, neturi teisės tvirtinti sąskaitų (teisė „Approve invoices as manager“).",
      "invoice_inbox_refusal_accountant_lacks_permission": "Buhalteris neturi teisės tvirtinti sąskaitų (teisė „Approve invoices as accountant“).",
      "invoice_inbox_refusal_missing_approver": "Šiam dokumentui nerastas tvirtintojas.",
      "invoice_inbox_refusal_same_person_both_slots": "Buhalteris ir apmokėjimo tvirtintojas yra tas pats asmuo — turi tvirtinti du skirtingi asmenys.",
      "invoice_inbox_refusal_dispatcher_would_approve_alone": "Būtumėte vienintelis savo išsiųsto dokumento tvirtintojas — jį turi patvirtinti ir kitas asmuo.",
      "invoice_inbox_refusal_DUPLICATE_FILE": "Toks failas jau pridėtas",
      "invoice_inbox_refusal_FILE_IS_SIGNED": "Pasirašyto failo pašalinti negalima.",
      "invoice_inbox_refusal_ATTACHMENT_REFUSED": "Šio failo pridėti negalima — naudokite PDF arba paveikslėlį (JPG, PNG, TIFF).",
      // Priedų filtro pačios priežastys (attachment-filter.js) — add-file.js
      // priežastį siunčia kaip `code`, o ne ATTACHMENT_REFUSED.
      "invoice_inbox_refusal_refused_type": "Šio tipo failas nepriimamas saugumo sumetimais",
      "invoice_inbox_refusal_inline_image": "Mažas į laiško tekstą įterptas paveikslėlis (logotipas ar parašas), o ne dokumentas",
      "invoice_inbox_refusal_decorative_name": "Failas atrodo kaip logotipas ar parašo paveikslėlis, o ne dokumentas",
      "invoice_inbox_refusal_unsupported_type": "Priimami tik PDF ir paveikslėlių failai",
      "invoice_inbox_refusal_no_extension": "Failas neturi plėtinio, todėl jo tipo nepavyko atpažinti",
      "invoice_inbox_refusal_unsupported_mime": "Failo turinys neatitinka palaikomo tipo",
      "invoice_inbox_refusal_too_large": "Failas didesnis nei 25 MB",
      "invoice_inbox_refusal_too_small": "Paveikslėlis per mažas, kad būtų tikras dokumentas",
      "invoice_inbox_refusal_over_limit": "Viename laiške daugiau nei 20 priedų; likusieji neapdoroti",
      "invoice_inbox_refusal_DOC_DELETED": "Dokumentas pašalintas.",
      "invoice_inbox_refusal_SOURCE_NOT_MERGEABLE": "Prijungti galima tik dar neišsiųstą tvirtinti dokumentą",
      "invoice_inbox_refusal_TARGET_DELETED": "Pasirinktas dokumentas ištrintas",
      "invoice_inbox_refusal_TARGET_NOT_FOUND": "Pasirinktas dokumentas nerastas",
      "invoice_inbox_refusal_SAME_DOC": "Dokumento negalima prijungti prie jo paties",
      "invoice_inbox_refusal_TARGET_REQUIRED": "Pasirinkite dokumentą, prie kurio prijungti",
      "invoice_inbox_role_accountant": "Buhalterė — duomenys teisingi",
      "invoice_inbox_role_manager": "Patvirtino — sutinkame mokėti",
      "invoice_inbox_decision_pending": "Laukiama",
      "invoice_inbox_decision_approved": "Patvirtinta",
      "invoice_inbox_decision_rejected": "Atmesta",
      "invoice_inbox_decision_invalidated": "Nebegalioja",
      "invoice_inbox_delegated": "perduota (atostogos)",
      "invoice_inbox_trail_title": "Kas ką atliko",
      "invoice_inbox_trail_dispatched": "Patikrino ir išsiuntė tvirtinti",
      "invoice_inbox_trail_sent_voided": "Siuntimas atšauktas arba pasikeitė duomenys",
      "invoice_inbox_trail_bookkept": "Įvedė į apskaitą",
      "invoice_inbox_trail_marked_paid": "Pažymėjo apmokėtą",
      "invoice_inbox_trail_paid_by_import": "Mokėjimų importas",
      "invoice_inbox_trail_paid_auto": "Pažymėta automatiškai: tiekėjo sąskaitos atkeliauja apmokėtos",
      "invoice_inbox_trail_waiting_for": "Laukiama: {{name}}",
      "invoice_inbox_trail_rejected_by": "Atmetė: {{name}}",
      "invoice_inbox_trail_delegated_from": "pavaduoja {{name}} (atostogos)",
      "invoice_inbox_send_for_approval": "Siųsti tvirtinti",
      "invoice_inbox_bulk_mark_bookkept": "Pažymėti įvesta",
      "invoice_inbox_bulk_mark_not_bookkept": "Pažymėti neįvesta",
      "invoice_inbox_bulk_mark_paid": "Pažymėti apmokėtomis",
      "invoice_inbox_bulk_nothing_applies": "Pažymėtiems dokumentams netinka nė vienas bendras veiksmas.",
      "invoice_inbox_bulk_confirm": "{{action}}: {{count}} dok.?",
      "invoice_inbox_bulk_flagged_not_approved": "{{count}} su raudonu įspėjimu — juos tvirtinkite atsidarę dokumentą.",
      "invoice_inbox_bulk_done": "Atlikta: {{count}} dok.",
      "invoice_inbox_bulk_partial": "Atlikta: {{done}}. Nepavyko: {{failed}} —",
      "invoice_inbox_bulk_error_missing_approver": "nerastas tvirtintojas (įmonės nustatymai)",
      "invoice_inbox_bulk_error_same_person_both_slots": "buhalteris ir vadovas — tas pats asmuo",
      "invoice_inbox_bulk_error_dispatcher_would_approve_alone": "būtumėte vienintelis savo išsiųsto dokumento tvirtintojas",
      "invoice_inbox_bulk_error_accountant_lacks_permission": "buhalteris neturi teisės tvirtinti",
      "invoice_inbox_bulk_error_manager_lacks_permission": "vadovas neturi teisės tvirtinti",
      "invoice_inbox_bulk_error_NOT_YOUR_DECISION": "jis nelaukia jūsų patvirtinimo",
      "invoice_inbox_bulk_error_NOT_AWAITING_APPROVAL": "jis nebelaukia tvirtinimo",
      "invoice_inbox_bulk_error_MISSING_APPROVAL_PERMISSION": "nebeturite teisės tvirtinti",
      "invoice_inbox_bulk_error_DOCUMENT_CHANGED": "dokumentas pasikeitė po išsiuntimo — išsiųskite iš naujo",
      "invoice_inbox_bulk_error_ALREADY_EXPORTED": "jau perduotas buhalterijai",
      "invoice_inbox_bulk_error_DOC_DELETED": "dokumentas ištrintas",
      "invoice_inbox_bulk_error_DOC_NOT_FOUND": "dokumentas nerastas",
      "invoice_inbox_bulk_error_EMPLOYEE_NOT_IN_COMPANY": "šis asmuo nėra įmonės darbuotojas",
      "invoice_inbox_bulk_error_EMPLOYEE_REQUIRED": "nepasirinktas darbuotojas",
      "invoice_inbox_recall": "Atšaukti siuntimą",
      "invoice_inbox_reject_reason": "Kodėl atmetama?",
      "invoice_inbox_reject_reason_help": "Tai matys buhalterė — be priežasties ji nežinos, ką taisyti.",
      "invoice_inbox_confirm_reject": "Patvirtinti atmetimą",
      "invoice_inbox_no_notes": "Pastabų kol kas nėra.",
      "invoice_inbox_note_placeholder": "Apmokėta avansu, laukiame važtaraščio…",
      "invoice_inbox_add_note": "Pridėti pastabą",
      "invoice_inbox_needs_check": "Gintaro spalva pažymėtų laukų nepavyko patikrinti automatiškai — peržiūrėkite juos.",
      "invoice_inbox_file_pending": "Failas dar dedamas į vietą — perkraukite po akimirkos.",
      "invoice_inbox_files": "Failai",
      "invoice_inbox_file_primary": "Dokumentas",
      "invoice_inbox_file_add": "Pridėti failą",
      "invoice_inbox_file_added": "Failas pridėtas",
      "invoice_inbox_file_remove": "Pašalinti failą",
      "invoice_inbox_file_remove_confirm": "Pašalinti failą {{name}} iš šio dokumento?",
      "invoice_inbox_file_removed": "Failas pašalintas",
      "invoice_inbox_file_download": "Atsisiųsti",
      "invoice_inbox_file_signed": "Pasirašyta",
      "invoice_inbox_file_uploaded_by": "Pridėjo {{name}}, {{date}}",
      "invoice_inbox_file_cannot_preview": "Šio failo čia parodyti negalima — atsisiųskite jį.",
      "invoice_inbox_merge": "Prijungti prie kitos sąskaitos",
      "invoice_inbox_merge_hint": "Sąskaita ir darbų aktas, atsiųsti vienu laišku, atkeliauja dviem eilutėmis. Suraskite dokumentą, prie kurio priklauso šis.",
      "invoice_inbox_merge_search": "Ieškoti dokumentų",
      "invoice_inbox_merge_no_results": "Nieko nerasta",
      "invoice_inbox_merge_confirm_text": "Dokumentas bus prijungtas prie №{{number}} kaip papildomi failai ir dings iš registro.",
      "invoice_inbox_merge_done": "Prijungta prie №{{number}}",
      "invoice_inbox_signatures_title": "Parašai",
      "invoice_inbox_signature_awaiting_me": "Laukia jūsų parašo",
      "invoice_inbox_sign_none": "Parašų dar neprašyta.",
      "invoice_inbox_sign_request": "Prašyti parašo",
      "invoice_inbox_sign_request_deleted": "Dokumentas pašalintas — atkurkite jį, kad galėtumėte prašyti parašų.",
      "invoice_inbox_sign_state_pending": "Pasirašoma",
      "invoice_inbox_sign_state_rejected": "Atsisakyta",
      "invoice_inbox_sign_type_Dokobit": "Dokobit (kvalifikuotas el. parašas)",
      "invoice_inbox_sign_type_Click": "Click (pasirašoma ERP)",
      "invoice_inbox_sign_ref_employee": "Darbuotojas",
      "invoice_inbox_sign_ref_contact": "Tiekėjo kontaktas",
      "invoice_inbox_sign_now": "Pasirašyti",
      "invoice_inbox_sign_cancel": "Atšaukti pasirašymą",
      "invoice_inbox_sign_cancel_confirm": "Atšaukti failo {{name}} pasirašymą? Dar nepasirašiusiųjų nebeprašysime.",
      "invoice_inbox_sign_cancelled": "Pasirašymas atšauktas",
      "invoice_inbox_cancel_signing_cancel_signing_forbidden": "Atšaukti gali tik prašęs asmuo arba Master",
      "invoice_inbox_cancel_signing_nothing_to_cancel": "Nebėra ką atšaukti — niekas nebelaukia parašo.",
      "invoice_inbox_sign_which_file": "Kurį failą",
      "invoice_inbox_sign_how": "Parašo tipas",
      "invoice_inbox_sign_file_already_signed": "jau pasirašyta",
      "invoice_inbox_sign_file_in_progress": "pasirašoma",
      "invoice_inbox_sign_file_not_pdf": "ne PDF — pasirašyti galima tik PDF",
      "invoice_inbox_sign_file_not_ready": "failas dar dedamas į vietą",
      "invoice_inbox_sign_type_dokobit_hint": "kvalifikuotas el. parašas — darbuotojai ir tiekėjo kontaktai",
      "invoice_inbox_sign_type_click_hint": "paprastas parašas ERP viduje — tik darbuotojai",
      "invoice_inbox_sign_dokobit_unavailable": "Dokobit šiai įmonei nesukonfigūruotas",
      "invoice_inbox_sign_click_unavailable": "Click pasirašymas šiai įmonei neprieinamas",
      "invoice_inbox_sign_employees": "Darbuotojai",
      "invoice_inbox_sign_supplier_contacts": "Tiekėjo kontaktai",
      "invoice_inbox_sign_no_supplier": "Pirmiausia priskirkite tiekėją, kad būtų galima prašyti jo kontaktų",
      "invoice_inbox_sign_send": "Siųsti prašymą",
      "invoice_inbox_sign_request_sent": "Prašymas pasirašyti išsiųstas",
      "invoice_inbox_sign_selected_count": "Pasirinkta: {{count}}",
      "invoice_inbox_sign_search_employees": "Ieškoti darbuotojų",
      "invoice_inbox_refusal_FILE_NOT_FOUND": "Šio failo prie dokumento nebėra.",
      "invoice_inbox_refusal_FILE_NOT_AVAILABLE": "Failas dar neišsaugotas — pabandykite po akimirkos.",
      "invoice_inbox_refusal_NOT_A_PDF": "Pasirašyti galima tik PDF failą.",
      "invoice_inbox_refusal_INVALID_SIGN_TYPE": "Pasirinkite Dokobit arba Click.",
      "invoice_inbox_refusal_NO_SIGNERS": "Pasirinkite bent vieną pasirašantį asmenį.",
      "invoice_inbox_refusal_CLICK_USERS_ONLY": "Click parašu gali pasirašyti tik darbuotojai — tiekėjo kontaktų prašykite per Dokobit.",
      "invoice_inbox_refusal_USER_NOT_MEMBER": "Vienas iš pasirinktų asmenų nėra šios įmonės darbuotojas.",
      "invoice_inbox_refusal_SUPPLIER_REQUIRED": "Pirmiausia priskirkite tiekėją, kad būtų galima prašyti jo kontaktų.",
      "invoice_inbox_refusal_CONTACT_NOT_SUPPLIER": "Vienas iš pasirinktų kontaktų nepriklauso šio dokumento tiekėjui.",
      "invoice_inbox_refusal_ALREADY_SIGNED": "Šis failas jau pasirašytas.",
      "invoice_inbox_refusal_DOCUMENT_ANNULLED": "Failas anuliuotas — jo pasirašyti negalima.",
      "invoice_inbox_refusal_SIGNING_IN_PROGRESS": "Šio failo parašų jau paprašyta — pirmiausia atšaukite tą prašymą.",
      "invoice_inbox_refusal_PREVIOUS_REQUEST_OPEN": "Ankstesnis prašymas pasirašyti šį failą dar neužbaigtas (atsisakyta arba nebaigta) — pirmiausia jį atšaukite.",
      "invoice_inbox_refusal_FILE_SIGNING_IN_PROGRESS": "Failas išsiųstas pasirašyti, jo pašalinti negalima — pirmiausia atšaukite pasirašymą.",
      "invoice_inbox_refusal_SOURCE_SIGNING_IN_PROGRESS": "Šio dokumento failas išsiųstas pasirašyti — prieš prijungiant prie kito dokumento atšaukite pasirašymą.",
      "invoice_inbox_refusal_CONTACT_NO_EMAIL": "Pasirinktas kontaktas neturi el. pašto arba vardo — pirmiausia papildykite tiekėjo kortelę.",
      "invoice_inbox_refusal_MERGED_INTO": "Šis dokumentas buvo prijungtas prie kito ir atskirai atkurti jo negalima.",
      "invoice_inbox_blocker_state_changed": "dokumentas tuo metu pasikeitė — perkraukite ir bandykite dar kartą",
      "invoice_inbox_refusal_DOKOBIT_NOT_CONFIGURED": "Dokobit šiai įmonei nesukonfigūruotas.",
      "invoice_inbox_refusal_DOKOBIT_FAILED": "Dokobit prašymo nepriėmė — pabandykite vėliau.",
      "invoice_inbox_suggestion_label": "Perskaityta iš dokumento",
      "invoice_inbox_suggestion_accept": "Priimti",
      "invoice_inbox_suggestion_reason_not_grounded": "nerasta dokumento tekste (gali būti paveikslėlyje)",
      "invoice_inbox_suggestion_reason_arithmetic": "nesutampa su kitomis sumomis",
      "invoice_inbox_suggestion_reason_amount_unparsed": "neaiškus skaičiaus formatas",
      "invoice_inbox_suggestion_reason_default": "nepatvirtinta",
      "invoice_inbox_flag_not_entered": "Dar neįvesta į buhalteriją",
      "invoice_inbox_col_bookkept": "Įvesta",
      "invoice_inbox_bookkept_toggle_on": "Įvesta — spustelėkite, kad atšauktumėte",
      "invoice_inbox_bookkept_toggle_off": "Pažymėti kaip įvestą",
      "invoice_inbox_col_payment": "Apmokėjimas",
      "invoice_inbox_paid_toggle_on": "Apmokėta — spustelėkite, kad atšauktumėte",
      "invoice_inbox_paid_toggle_on_by": "Apmokėta — pažymėjo {{name}}, {{date}}. Spustelėkite, kad atšauktumėte",
      "invoice_inbox_paid_toggle_import": "Apmokėta — iš mokėjimų importo",
      "invoice_inbox_paid_toggle_off": "Pažymėti kaip apmokėtą",
      "invoice_inbox_period_unassigned": "Laikotarpis nenustatytas",
      "invoice_inbox_period_docs_count": "Dokumentų: {{count}}",
      "invoice_inbox_period_tab_count": "{{tab}}: {{count}}",
      "invoice_inbox_period_entered_of": "Įvesta {{entered}} iš {{total}}",
      "invoice_inbox_period_missing_amounts": "Be sumos be PVM / PVM: {{count}} dok.",
      "invoice_inbox_period_month_total": "Šį mėnesį iš viso {{count}}:",
      "invoice_inbox_period_month_total_currency": "Mėnesio suma, {{currency}}",
      "invoice_inbox_period_year_docs": "{{count}} dok.",
      "invoice_inbox_period_total_eur": "Viskas eurais",
      "invoice_inbox_period_unconverted": "dar be kurso, neįskaičiuota: {{count}}",
      "invoice_inbox_fx_pending_short": "EUR: kurso dar nėra",
      "invoice_inbox_fx_rate_line": "Kursas 1 EUR = {{rate}} {{currency}}, {{date}}",
      "invoice_inbox_fx_source_lb": "Lietuvos bankas",
      "invoice_inbox_fx_source_manual": "įvestas rankiniu būdu",
      "invoice_inbox_fx_pending": "Lietuvos bankas dar nepaskelbė sąskaitos datos kurso — sumos eurais bus apskaičiuotos automatiškai.",
      "invoice_inbox_fx_no_date": "Įveskite sąskaitos datą, kad sumos būtų perskaičiuotos eurais.",
      "invoice_inbox_fx_rate_field": "Valiutos kursas (1 EUR = …)",
      "invoice_inbox_pvm_code": "PVM kodas",
      "invoice_inbox_pvm_auto": "Automatiškai",
      "invoice_inbox_pvm_saved": "PVM kodas išsaugotas",
      "invoice_inbox_pvm_save_failed": "Nepavyko išsaugoti PVM kodo",
      "invoice_inbox_supply_kind": "Prekės ar paslaugos",
      "invoice_inbox_supply_kind_unset": "Nenustatyta",
      "invoice_inbox_supply_kind_goods": "Prekės",
      "invoice_inbox_supply_kind_services": "Paslaugos",
      "invoice_inbox_supply_kind_mixed": "Prekės ir paslaugos",
      "invoice_inbox_pvm_reason_lt_standard": "Lietuvos PVM mokėtojas, tarifas pagal sąskaitą",
      "invoice_inbox_pvm_reason_lt_rate_no_vat_code": "Tiekėjo PVM kodas neperskaitytas – patikrinkite",
      "invoice_inbox_pvm_reason_lt_reverse_charge": "Atvirkštinis apmokestinimas Lietuvoje (PVMĮ 96 str.)",
      "invoice_inbox_pvm_reason_lt_exempt": "Neapmokestinamas tiekimas",
      "invoice_inbox_pvm_reason_lt_zero_rated": "0 % iš Lietuvos tiekėjo – patikrinkite pagrindą",
      "invoice_inbox_pvm_reason_lt_farmer_compensation": "Kompensacinis 6 % tarifas",
      "invoice_inbox_pvm_reason_lt_outside_scope": "Ne PVM objektas – patikrinkite",
      "invoice_inbox_pvm_reason_lt_not_vat_payer": "Tiekėjas be PVM kodo – ne PVM sąskaita faktūra?",
      "invoice_inbox_pvm_reason_eu_goods_acquisition": "Prekių įsigijimas iš ES PVM mokėtojo",
      "invoice_inbox_pvm_reason_eu_services_reverse_charge": "Paslaugos iš ES PVM mokėtojo, PVM apskaičiuoja pirkėjas",
      "invoice_inbox_pvm_reason_eu_supply_kind_unknown": "ES tiekėjas – neaišku, prekės ar paslaugos",
      "invoice_inbox_pvm_reason_eu_goods_services_conflict": "Pardavėjas pažymėjo kaip prekes, čia – paslaugos; patikrinkite",
      "invoice_inbox_pvm_reason_eu_exempt_services": "Neapmokestinamos paslaugos iš ES – patikrinkite",
      "invoice_inbox_pvm_reason_eu_foreign_vat_charged": "Sąskaitoje užsienio PVM",
      "invoice_inbox_pvm_reason_eu_lt_rate_vat_charged": "ES tiekėjas pritaikė PVM tarifą kaip Lietuvoje – patikrinkite",
      "invoice_inbox_pvm_reason_eu_outside_scope": "Ne PVM objektas (ES tiekėjas) – patikrinkite",
      "invoice_inbox_pvm_reason_foreign_goods_import": "Prekės iš trečiosios šalies (importas)",
      "invoice_inbox_pvm_reason_foreign_services_reverse_charge": "Paslaugos iš ne ES, PVM apskaičiuoja pirkėjas",
      "invoice_inbox_pvm_reason_foreign_supply_kind_unknown": "Ne ES tiekėjas – neaišku, prekės ar paslaugos",
      "invoice_inbox_pvm_reason_foreign_exempt_services": "Neapmokestinamos paslaugos iš ne ES – patikrinkite",
      "invoice_inbox_pvm_reason_foreign_vat_charged": "Sąskaitoje užsienio šalies PVM",
      "invoice_inbox_pvm_reason_foreign_outside_scope": "Ne PVM objektas (ne ES tiekėjas) – patikrinkite",
      "invoice_inbox_pvm_reason_supplier_origin_unknown": "Nežinoma tiekėjo šalis – nustatykite kodą",
      "invoice_inbox_pvm_reason_not_an_invoice": "Ne PVM sąskaita faktūra",
      "invoice_inbox_pvm_reason_unmapped": "Derinys neatpažintas – nustatykite kodą",
      "invoice_inbox_pvm_reason_rate_unknown": "Neįprastas tarifas – nustatykite kodą",
      "invoice_inbox_pvm_reason_supplier_learned": "Pagal ankstesnį šio tiekėjo pasirinkimą",
      "invoice_inbox_pvm_reason_foreign_lt_rate_vat_charged": "Ne ES tiekėjas pritaikė PVM tarifą kaip Lietuvoje – patikrinkite",
      "invoice_inbox_pvm_reason_eu_zero_rated_services": "0 % paslaugos iš ES – patikrinkite pagrindą",
      "invoice_inbox_pvm_reason_foreign_zero_rated_services": "0 % paslaugos iš ne ES – patikrinkite pagrindą",
      "invoice_inbox_pvm_reason_supplier_learned_mismatch": "Ankstesnis šio tiekėjo kodas netinka šiai eilutei – patikrinkite",
      "invoice_inbox_pvm_reason_model_suggested": "Pagal skaitytuvo pasiūlymą – patikrinkite",
      "invoice_inbox_pvm_reason_model_disagrees": "Skaitytuvas siūlo {{code}} – patikrinkite",
      "invoice_inbox_pvm_reason_manual": "Nustatyta rankiniu būdu",
      "pvm_code_PVM1": "21 % – prekės/paslaugos Lietuvoje",
      "pvm_code_PVM2": "9 % – prekės/paslaugos Lietuvoje",
      "pvm_code_PVM3": "5 % – prekės/paslaugos Lietuvoje",
      "pvm_code_PVM58": "12 % – paslaugos Lietuvoje (nuo 2026 m.)",
      "pvm_code_PVM5": "Neapmokestinama PVM (PVMĮ 20–33 str.)",
      "pvm_code_PVM14": "0 % – kiti sandoriai (PVMĮ 42–53 str.)",
      "pvm_code_PVM25": "21 % – atvirkštinis PVM Lietuvoje (PVMĮ 96 str.)",
      "pvm_code_PVM26": "9 % – atvirkštinis PVM Lietuvoje (PVMĮ 96 str.)",
      "pvm_code_PVM27": "5 % – atvirkštinis PVM Lietuvoje (PVMĮ 96 str.)",
      "pvm_code_PVM16": "21 % – prekių įsigijimas iš ES",
      "pvm_code_PVM17": "9 % – prekių įsigijimas iš ES",
      "pvm_code_PVM18": "5 % – prekių įsigijimas iš ES",
      "pvm_code_PVM35": "0 % – prekių įsigijimas iš ES",
      "pvm_code_PVM36": "Neapmokestinamas prekių įsigijimas iš ES",
      "pvm_code_PVM19": "Trikampė prekyba (tarpininkas)",
      "pvm_code_PVM21": "21 % – paslaugos iš ES (atvirkštinis PVM)",
      "pvm_code_PVM40": "5 % – paslaugos iš ES (atvirkštinis PVM)",
      "pvm_code_PVM57": "9 % – paslaugos iš ES (atvirkštinis PVM)",
      "pvm_code_PVM41": "0 % – paslaugos iš ES",
      "pvm_code_PVM42": "Neapmokestinamos paslaugos iš ES",
      "pvm_code_PVM20": "21 % – paslaugos iš ne ES (atvirkštinis PVM)",
      "pvm_code_PVM37": "5 % – paslaugos iš ne ES (atvirkštinis PVM)",
      "pvm_code_PVM54": "9 % – paslaugos iš ne ES (atvirkštinis PVM)",
      "pvm_code_PVM38": "0 % – paslaugos iš ne ES",
      "pvm_code_PVM39": "Neapmokestinamos paslaugos iš ne ES",
      "pvm_code_PVM43": "21 % – užsienio tiekėjas Lietuvoje (PVMĮ 95 str. 3–5 d.)",
      "pvm_code_PVM44": "9 % – užsienio tiekėjas Lietuvoje (PVMĮ 95 str. 3–5 d.)",
      "pvm_code_PVM45": "5 % – užsienio tiekėjas Lietuvoje (PVMĮ 95 str. 3–5 d.)",
      "pvm_code_PVM60": "12 % – užsienio tiekėjas Lietuvoje (PVMĮ 95 str. 5 d.)",
      "pvm_code_PVM46": "0 % – užsienio tiekėjas Lietuvoje",
      "pvm_code_PVM47": "Neapmokestinama – užsienio tiekėjas Lietuvoje",
      "pvm_code_PVM48": "Įsigyta už Lietuvos ribų (užsienio PVM, importas, viešbučiai)",
      "pvm_code_PVM32": "21 % – maržos schema",
      "pvm_code_PVM52": "9 % – maržos schema",
      "pvm_code_PVM53": "5 % – maržos schema",
      "pvm_code_PVM33": "0 % – maržos schema",
      "pvm_code_PVM49": "6 % – kompensacinis PVM ūkininkams",
      "pvm_code_PVM51": "0 % – PVMĮ 19 str. 5 d.",
      "pvm_code_PVM55": "0 % – parama nelaimių aukoms (PVMĮ 50¹ str.)",
      "pvm_code_PVM56": "Parama nelaimių aukoms – įsigijimas iš ES",
      "pvm_code_PVM23": "Sumokėtas importo PVM (ne i.SAF)",
      "pvm_code_PVM24": "Importo PVM, įskaitomas per VMI (ne i.SAF)",
      "pvm_code_PVM100": "Kiti atvejai (baudos, delspinigiai, rinkliavos, SVS)",
      "invoice_inbox_fx_rate_help": "Palikite tuščią — bus naudojamas Lietuvos banko sąskaitos datos kursas. Pildykite tik norėdami jį pakeisti.",
      "invoice_inbox_period_download": "Atsisiųsti mėnesį",
      "invoice_inbox_period_register_pdf": "PDF sąrašas",
      "invoice_inbox_period_load_failed": "Nepavyko įkelti laikotarpių. Niekas nedingo — bandykite dar kartą.",
      "invoice_inbox_period_docs_load_failed": "Nepavyko įkelti šio mėnesio dokumentų.",
      "invoice_inbox_export_too_many": "Šį mėnesį yra {{count}} dokumentų — daugiau, nei galima supakuoti vienu atsisiuntimu (limitas {{limit}}). Susiaurinkite laikotarpį arba atsisiųskite dalimis.",
      "invoice_inbox_export_too_large": "Šio mėnesio failai užima daugiau vietos, nei galima supakuoti vienu atsisiuntimu (limitas {{limit}} MB). Susiaurinkite laikotarpį arba atsisiųskite dalimis.",
      "invoice_inbox_export_invalid_period": "Šio laikotarpio nepavyko eksportuoti.",
      "invoice_inbox_export_failed": "Nepavyko paruošti atsisiuntimo. Bandykite dar kartą.",
      "invoice_inbox_supplier_unlinked": "Šis tiekėjas dar nesusietas su kliento kortele.",
      "invoice_inbox_create_supplier": "Sukurti tiekėją",
      "invoice_inbox_supplier_form_title": "Sukurti arba susieti tiekėją",
      "invoice_inbox_supplier_legal_form": "Teisinė forma",
      "invoice_inbox_supplier_vat_payer": "PVM mokėtojas",
      "invoice_inbox_supplier_bank_name": "Bankas",
      "invoice_inbox_supplier_iban_note": "Išsaugoma kartu su tiekėju — nauja banko sąskaita vis tiek turi būti patvirtinta atskirai, kad pagal šį dokumentą būtų galima mokėti.",
      "invoice_inbox_supplier_submit": "Sukurti ir susieti",
      "invoice_inbox_supplier_conflict": "Toks kontrahentas jau yra",
      "invoice_inbox_supplier_link_it": "Susieti",
      "invoice_inbox_supplier_unlink": "Ne tas tiekėjas? Atsieti",
      "invoice_inbox_supplier_unlink_confirm": "Atsieti šį tiekėją? Sąskaitos su šiuo tiekėjo pavadinimu daugiau nebus automatiškai susiejamos su juo.",
      "invoice_inbox_supplier_unlink_yes": "Atsieti",
      "invoice_inbox_supplier_iban_warning": "Šiame dokumente nurodytos sąskaitos nėra to kliento kortelėje.",
      "invoice_inbox_supplier_iban_ignore": "Palikti kortelę kaip yra",
      "invoice_inbox_supplier_iban_add": "Pridėti šią sąskaitą",
      "invoice_inbox_supplier_iban_replace": "Padaryti ją pagrindine sąskaita",
      "invoice_inbox_supplier_doc_deleted": "Šis dokumentas pašalintas.",
      "invoice_inbox_supplier_already_linked": "Šis dokumentas jau turi susietą tiekėją.",
      "invoice_inbox_supplier_matched_vat_code": "Sutapo pagal šio kontrahento PVM kodą.",
      "invoice_inbox_supplier_matched_document_vat_code": "Sutapo pagal šiame dokumente nurodytą PVM kodą.",
      "invoice_inbox_supplier_matched_company_code": "Sutapo pagal jo įmonės kodą.",
      "invoice_inbox_supplier_primary_bank_hint": "Šio kliento sutartyse ir užsakymuose spausdinamas pagrindinės sąskaitos bankas — nauja sąskaita dažniausiai yra kitame banke, todėl patvirtinkite arba įveskite jį iš naujo žemiau.",
      "invoice_inbox_supplier_bank_details_required": "Padarius šią sąskaitą pagrindine, dingtų banko pavadinimas ir SWIFT kodas, spausdinami šio kliento sutartyse ir užsakymuose — įveskite juos, kad patvirtintumėte, arba pasirinkite kitą variantą aukščiau.",
      "invoice_inbox_supplier_too_many_accounts": "Šis klientas jau turi didžiausią leistiną banko sąskaitų skaičių (20) — niekas nebuvo pakeista.",
      "invoice_inbox_payment_source_title": "Kaip apmokėta",
      "invoice_inbox_payment_card": "Apmokėjimas",
      "invoice_inbox_document_card": "Dokumentas",
      "invoice_inbox_more_actions": "Kiti veiksmai",
      "invoice_inbox_sender_auth_title": "Siuntėjas (DKIM/SPF)",
      "invoice_inbox_sender_passed": "Patikrinta",
      "invoice_inbox_sender_partly_checked": "Patikrinta iš dalies",
      "invoice_inbox_sender_check": "Patikrinkite",
      "invoice_inbox_payment_source_unset": "Nenurodyta",
      "invoice_inbox_payment_source_company": "Apmokėta iš įmonės sąskaitos",
      "invoice_inbox_payment_source_employee": "Apmokėjo darbuotojas",
      "invoice_inbox_payment_source_employee_picker": "Kuris darbuotojas?",
      "invoice_inbox_payment_source_current_employee": "Šiuo metu pažymėta, kad apmokėjo {{name}} — įmonė jam(-ai) skolinga.",
      "invoice_inbox_payment_source_company_short": "Įmonė",
      "invoice_inbox_marked_paid_label": "Apmokėta",
      "invoice_inbox_marked_paid_by": "Apmokėtu pažymėjo {{name}}, {{date}}",
      "invoice_inbox_marked_paid_auto": "Pažymėta automatiškai: tiekėjo sąskaitos atkeliauja apmokėtos, {{date}}",
      "invoice_inbox_filter_payment_source": "Apmokėjo",
      "invoice_inbox_supplier_invoices_arrive_paid": "Šio tiekėjo sąskaitos atkeliauja jau apmokėtos",
      "invoice_inbox_supplier_invoices_arrive_paid_help": "Pakeičia, kaip nuo šiol tvirtinamos šio tiekėjo sąskaitos — vadovo tvirtinimo žingsnis praleidžiamas, buhalterės patikra lieka. Jau esantiems registre dokumentams tai įtakos neturi.",
      "invoice_inbox_supplier_create_arrive_paid_help": "Nuo šiol vadovo tvirtinimo žingsnis šio tiekėjo sąskaitoms praleidžiamas — buhalterės patikra lieka.",
      "invoice_inbox_supplier_settings_permission_required": "Norint pažymėti, kad sąskaitos atkeliauja apmokėtos, reikia sąskaitų gavimo nustatymų valdymo teisės.",
      "invoice_inbox_supplier_expects_monthly": "Šis tiekėjas sąskaitą išrašo kas mėnesį",
      "invoice_inbox_supplier_expects_monthly_help": "Registras įspės, jei šio tiekėjo mėnesinė sąskaita neatkeliaus iki įprastos dienos.",
      "invoice_inbox_expectations_title": "Negautos mėnesinės sąskaitos ({{count}})",
      "invoice_inbox_expectations_intro": "Šie tiekėjai sąskaitas išrašo kas mėnesį, tačiau nurodyto mėnesio sąskaita jau vėluoja ir registre jos nėra.",
      "invoice_inbox_expectations_unnamed_supplier": "Tiekėjas be pavadinimo",
      "invoice_inbox_expectations_expected_by": "turėjo atkeliauti iki {{date}}",
      "invoice_inbox_expectations_last_seen": "paskutinės gautos sąskaitos laikotarpis: {{period}}",
      "invoice_inbox_expectations_waive": "Šio mėnesio sąskaitos nebus",
      "invoice_inbox_expectations_waive_explain": "Šiam tiekėjui praleidžiamas tik šis mėnuo ({{period}}). Tiekėjas lieka pažymėtas kaip sąskaitą išrašantis kas mėnesį, o kiti mėnesiai tikrinami kaip įprasta.",
      "invoice_inbox_expectations_note": "Pastaba (neprivaloma)",
      "invoice_inbox_expectations_note_placeholder": "pvz., tą mėnesį paslauga buvo sustabdyta",
      "invoice_inbox_expectations_waive_confirm": "Praleisti šį mėnesį",
      "invoice_inbox_expectations_waived": "{{supplier}}, {{period}}: sąskaitos nelaukiama.",
      "invoice_inbox_expectations_undo": "Atšaukti",
      "invoice_inbox_expectations_restored": "{{supplier}}, {{period}}: sąskaitos vėl laukiama.",
      "invoice_inbox_expectations_month_summary": "Kas mėnesį laukiama: {{expected}} · gauta {{received}}",
      "invoice_inbox_expectations_chip_pending": "{{supplier}} (iki {{date}})",
      "invoice_inbox_expectations_chip_missing": "{{supplier}} — vėluoja (turėjo būti iki {{date}})",
      "invoice_inbox_expectations_waived_count": "nebus: {{count}}",
      "invoice_inbox_mail_without_documents_summary": "Laiškai be dokumento per {{days}} d.: {{count}}",
      "invoice_inbox_mail_without_documents_show": "Rodyti",
      "invoice_inbox_mail_without_documents_hide": "Slėpti",
      "invoice_inbox_mail_without_documents_no_subject": "(be temos)",
      "invoice_inbox_mail_without_documents_unknown_sender": "(nežinomas siuntėjas)",
      "invoice_inbox_mail_without_documents_why_blocked": "Užblokuota pagal siuntėjo taisyklę",
      "invoice_inbox_mail_without_documents_why_quarantined": "Sulaikyta pagal siuntėjo taisyklę",
      "invoice_inbox_mail_without_documents_why_no_attachments": "Laiške nėra priedų",
      "invoice_inbox_mail_without_documents_why_auto_mail": "Automatinis atsakymas arba pristatymo ataskaita, priedų nėra",
      "invoice_inbox_mail_without_documents_why_attachments_rejected": "Priedai nepriimti:",
      "invoice_inbox_mail_without_documents_why_processing_failed": "Priedai priimti, bet dokumento sukurti nepavyko (apdorojimo klaida)",
      "invoice_inbox_mail_without_documents_reason_unknown": "Priežastis neužfiksuota (senesnis laiškas)",
      "invoice_inbox_mail_without_documents_shown_of_total": "Rodomi naujausi {{shown}} iš {{total}}",
      "invoice_inbox_mail_without_documents_hint": "Nepriimtą failą galima įkelti į registrą rankiniu būdu.",
      "not_checked": "nepatikrinta",
      assistant_title: "Tomas",
      // mobile: cabinet-tasks
      training_open_pdf: "Atidaryti PDF",
      training_submit_unanswered: "Neatsakyta klausimų: {{count}}. Vis tiek pateikti testą?",
      training_submit_all_answered: "Atsakyta į visus klausimus. Pateikti testą?",
      assistant_settings_hint: "Kiekviena įmonė naudoja savo Anthropic API raktą — naudojimas apmokestinamas šiai įmonei.",
      assistant_settings_used_by:
        "Naudoja: Pirkimų registras (sąskaitų atpažinimas), Tvarkos (mokymų klausimai).",
      assistant_api_key: "Anthropic API raktas",
      assistant_api_key_stored: "Raktas išsaugotas. Palikite lauką nepakeistą, kad jį išlaikytumėte, arba įklijuokite naują.",
      assistant_api_key_empty: "Raktas dar neišsaugotas — asistentas neveiks, kol jo nepridėsite.",
      assistant_model_default: "Numatytasis (Sonnet 5)",
      assistant_model_sonnet: "Sonnet 5 — greičio ir kainos balansas (rekomenduojama)",
      assistant_model_opus: "Opus 5 — stipriausias mąstymas, lėtesnis ir brangesnis",
      assistant_model_haiku: "Haiku 4.5 — greičiausias ir pigiausias, paprastesni atsakymai",
      assistant_model: "Modelis",
      assistant_settings_load_failed: "Nepavyko įkelti asistento nustatymų",
      assistant_settings_save_failed: "Nepavyko išsaugoti asistento nustatymų",
      assistant_placeholder: "Klauskite Tomo…",
      assistant_intro: "Paklauskite, kur rasti įrašą, arba kodėl sistema neleidžia ko nors padaryti.",
      assistant_thinking: "Galvoju…",
      assistant_searching: "Ieškau…",
      assistant_error: "Asistentui nepavyko atsakyti. Bandykite dar kartą.",
      assistant_new_conversation: "Naujas pokalbis",
      assistant_disclaimer: "Tik skaitymas. Atsakymai remiasi jūsų įmonės duomenimis — pasitikrinkite prieš veikdami.",
      Login: "Prisijungti",
      Email: "El. paštas",
      Password: "Slaptažodis",
      "Selected company": "Pasirinkta įmonė",
      create_company: "Sukurti įmonę",
      company_created_successfully: "Įmonė sukurta sėkmingai",
      tasks: "Užduotys ir prašymai",
      create_task: "Sukurti užduotį",
      update_task: "Atnaujinti užduotį",
      title: "Pavadinimas",
      reporter: "Sukurė",
      assigned: "Priskirta",
      resolution: "Būsena",
      is_resolved: "Padaryta",
      not_resolved: "Nepadaryta",
      due_date: "Iki kada",
      select_task_from_list: "Pasirinkite užduoti iš sąrašo",
      resolved: "Atlikta",
      description: "Aprašymas",
      select_user: "Pasirinkite darbuotoją",
      log_out: "Atsijungti",
      left: "liko",
      search: "Paieška",
      search_tags: "Paieška",
      no_data: "Nėra duomenų",
      owner: "Autorius",
      assignedTo: "Priskirta",
      users: "Darbuotojai",
      company_settings: "Įmonės nustatymai",
      name: "Vardas",
      restore: "Atstatyti",
      create_user: "Sukurti vartotoją",
      update_user: "Atnaujinti vartotoją",
      user_status: "Būsena",
      is_disabled: "Išjungtas",
      not_disabled: "Aktyvus",
      company_name: "Įmonės/veiklos pavadinimas",
      company_code: "Įm. Kodas",
      company_vat: "PVM kodas",
      company_address: "Adresas",
      company_description: "Aprašymas",
      isDisabled: "Išjungtas",
      news: "Naujienos",
      Accounts: "Paskyros",
      user_position: "Pareigos",
      customers: "Klientai",
      street: "Gatvė",
      house_number: "Namo numeris",
      city: "Miestas",
      region: "Rajonas",
      legal_form: "Teisinė forma",
      postal_code_letters: "Pašto kodas (Raidės)",
      history: "Istorija",
      postal_code_figures: "Pašto kodas (Skaičiai)",
      postal_code: "Pašto kodas",
      country: "Šalis",
      country_of_registration: "Šalis (kur registruota)",
      create_customer: "Sukurti klientą",
      update_customer: "Atnaujinti klientą",
      customer_code: "Kliento kodas",
      sales_turnover_excl_vat: "Apyvarta pard. be PVM",
      purchase_turnover_excl_vat: "Apyvarta pirk. be PVM",
      debt_incl_vat: "Skola su PVM",
      overdue_debt_incl_vat: "Pradelsta skola su PVM",
      settlements: "Atsiskaitymai",
      receivable: "Mums skolingi",
      payable: "Mes skolingi",
      // debt / overdue_debt reused from the existing keys defined further
      // down this section ("Skola" / "Pradelsta skola") — not redefined here
      // to avoid a duplicate object key silently shadowing the original.
      kind: "Tipas",
      ledger_kind_all: "Visi",
      ledger_kind_sale: "Pardavimas",
      ledger_kind_sale_return: "Pardavimo grąžinimas",
      ledger_kind_purchase: "Pirkimas",
      ledger_kind_purchase_return: "Pirkimo grąžinimas",
      reconciled_with_finvalda: "Sutampa su Finvalda",
      not_reconciled_with_finvalda: "Nesutampa su Finvalda: Finvalda {{balance}}",
      unexplained_amount: "Nepaaiškinta suma",
      finvalda_mismatch_hint:
        "Skirtumą dažniausiai sudaro nepaskirstyti mokėjimai, avansai ar paskolos, kurių Finvalda kol kas neperduoda į ERP.",
      finvalda_balance_unknown: "Finvalda likutis nežinomas",
      only_unpaid: "Tik neapmokėti",
      only_finvalda_mismatch: "Tik nesutampantys su Finvalda",
      finvalda_mismatch_tooltip: "Finvalda: {{balance}} · skirtumas {{difference}}",
      excluded_from_turnover: "neįtraukta į apyvartą",
      settlements_not_synced_yet:
        "Apskaitos dokumentai atsiras, kai apskaitos veidrodis bus sinchronizuotas.",
      ledger_journals_title: "Žurnalai, neįtraukiami į apyvartą",
      ledger_journals_hint:
        "Neįtraukti žurnalai neskaičiuojami į apyvartą; skola visada skaičiuojama iš visų dokumentų, kad sutaptų su Finvalda.",
      overdue_receivable_payable_line: "gautina {{receivable}} / mokėtina {{payable}}",
      pagination_range: "{{start}}–{{end}} iš {{total}}",
      ledger_col_date: "Data",
      ledger_col_kind: "Tipas",
      ledger_col_journal: "Žurnalas",
      ledger_col_series_number: "Serija / Nr.",
      ledger_col_due_date: "Terminas",
      ledger_col_amount_doc: "Suma",
      ledger_col_amount_eur: "Suma EUR",
      ledger_col_paid: "Apmokėta",
      ledger_col_debt: "Skola",
      // Document lines expander (pr7-contract.md §Frontend/1).
      ledger_line_col_no: "Nr.",
      ledger_line_col_item: "Prekė",
      ledger_line_col_qty: "Kiekis",
      ledger_line_col_unit_price: "Vnt. kaina",
      ledger_line_col_net: "Suma be PVM",
      ledger_line_col_vat: "PVM",
      ledger_line_col_gross: "Suma su PVM",
      ledger_no_lines: "nėra eilučių",
      ledger_lines_truncated_note: "…rodomos ne visos eilutės",
      settlements_load_failed: "Nepavyko įkelti atsiskaitymų",
      // Mokėjimų rodinys „Atsiskaitymai" kortelėje: pinigų judėjimas ir jame
      // esantys avansai.
      settlements_view: "Rodinys",
      settlements_view_documents: "Dokumentai",
      settlements_view_payments: "Mokėjimai",
      settlement_kind_all: "Visi",
      settlement_kind_payment_in: "Gauta",
      settlement_kind_payment_out: "Sumokėta",
      settlements_paid_in: "Gauta",
      settlements_paid_out: "Sumokėta",
      settlements_advance_received: "Gauti avansai",
      settlements_advance_received_hint:
        "Dar nepadengti dokumentais — didina mūsų skolą",
      settlements_advance_paid: "Sumokėti avansai",
      settlements_advance_paid_hint:
        "Dar nepadengti dokumentais — didina kliento skolą mums",
      settlements_only_open_advances: "Tik neužskaityti avansai",
      settlements_col_description: "Paskirtis",
      settlements_col_allocated: "Paskirstyta",
      settlements_col_open: "Avansas",
      settlements_col_document: "Dokumentas",
      settlements_col_allocation_source: "Užskaityta kaip",
      settlements_source_advance: "Avanso užskaitymas",
      settlements_source_payment: "Tiesioginis apmokėjimas",
      settlements_no_allocations:
        "Nepaskirstyta jokiam dokumentui — visa suma yra avansas.",
      settlements_allocations_truncated: "Rodomi tik pirmi 200 užskaitymų.",
      settlements_payments_load_failed: "Nepavyko įkelti mokėjimų.",
      settlements_payments_not_synced_yet:
        "Mokėjimai atsiras, kai bus baigtas pirmasis pilnas šios įmonės mokėjimų importas.",
      debt_advances_line: "iš jų avansai: sumokėta {{paid}} / gauta {{received}}",
      // Customer card "Rezervacijos" tab (pr7-contract.md §Frontend/2).
      reservations_load_failed: "Nepavyko įkelti rezervacijų.",
      reservations_only_active: "Tik aktyvios",
      reservation_col_date: "Data",
      reservation_col_due_date: "Terminas",
      reservation_col_title: "Pavadinimas",
      reservation_col_series_number: "Serija / Nr.",
      reservation_col_items: "Eilučių",
      reservation_col_status: "Būsena",
      reservation_status_active: "Aktyvi",
      reservation_status_inactive: "Neaktyvi",
      reservation_no_items: "nėra eilučių",
      reservation_items_truncated_note: "…rodomos ne visos eilutės",
      reservation_items_col_item: "Prekė",
      reservation_items_col_qty: "Kiekis",
      ledger_journals_load_failed: "Nepavyko įkelti žurnalų sąrašo",
      ledger_journals_save_failed: "Nepavyko išsaugoti žurnalų",
      finvalda_mismatch_label: "Skola nesutampa su Finvalda",
      selected_count: "Pažymėta: {{count}}",
      selected_hidden_count: "(nerodoma: {{count}})",
      show_only_selected: "Rodyti tik pažymėtus",
      show_all_rows: "Rodyti visus",
      clear_selection: "Išvalyti",
      select_all_rows: "Pažymėti visus rodomus",
      select_row: "Pažymėti",
      selection_totals_failed: "Nepavyko apskaičiuoti sumų",
      selection_removed_missing:
        "{{count}} pažymėti klientai nebepasiekiami ir pašalinti",
      save: "Išsaugoti",
      saved_successfully: "Sėkmingai išsaugota",
      json_view: "JSON rodinys",
      builder_view: "Kūrėjo rodinys",
      json_must_be_array: "JSON turi būti masyvas",
      invalid_json: "Neteisingas JSON",
      not_saved: "Neišsaugota",
      update: "Atnaujinti",
      cancel: "Atšaukti",
      error: "Error",
      error_getting_data: "Duomenis nepasiekiami",
      vat_code: "PVM kodas",
      vat_code_letters: "PVM kodas (Raidės)",
      vat_code_figures: "PVM kodas (Skaičiai)",
      valid_to: "Galioja iki",
      date_picker: "Kalendorius",
      contact_person: "Kontaktinis asmuo",
      orders: "Sutartys",
      create_order: "Sukurti sutartį",
      orders_search_placeholder: "Ieškoti sutarčių",
      expires: "Galioja iki",
      date: "Data",
      number: "Numeris",
      select: "Pasirinkimas",
      unexpected_error: "Nutiko klaida",
      vats: "PVM",
      create_vat: "Sukurti PVM",
      percent: "Procentai",
      products: "Produktai",
      create_product: "Sukurti produktą",
      sku: "Kodas",
      supplier_sku: "Tiekėjo kodas",
      unitPrice: "Vieneto kaina",
      type: "Tipas",
      vat: "PVM",
      is_active: "Aktyvus",
      product: "Produktas",
      service: "Paslauga",
      inactive: "Neaktyvus",
      bills: "Sąskaitos",
      invoices: "Sąskaitos",
      requisites: "Rekvizitai",
      create_invoice: "Sukurti sąskaitą",
      // Sąskaitos kūrimo langas (klientas → Sąskaitos)
      create_invoice_modal_hint:
        "Šio kliento visiškai pasirašyti užsakymai, kuriems dar nėra sąskaitos. Ilgalaikiai užsakymai apmokestinami pagal savo mėnesinį grafiką ir čia nerodomi. Kiekvienam pasirinktam užsakymui sukuriama atskira sąskaita.",
      create_invoice_actions_hint:
        "Atidarykite užsakymą, kad prieš išrašydami pakeistumėte prekes, kiekius ir kainas. „Juodraštis“ išsaugo redaguojamus juodraščius be numerių. „Sukurti sąskaitas“ patvirtina iš karto: suteikia sąskaitos numerį ir sugeneruoja PDF; pažymėkite langelį, jei norite kartu išsiųsti klientui.",
      create_invoice_actions_hint_no_build:
        "Atidarykite užsakymą, kad prieš išrašydami pakeistumėte prekes, kiekius ir kainas. „Juodraštis“ išsaugo redaguojamus juodraščius be numerių — norint suteikti numerį, PDF ir el. laišką, reikia Master, Admin, Signature arba „Access all customers“ teisės.",
      invoice_lines_edited: "Redaguota",
      create_invoice_no_orders:
        "Nėra užsakymų, kuriems galima išrašyti sąskaitą. Užsakymas turi būti visiškai pasirašytas ir dar neapmokestintas.",
      create_invoice_partial_failure:
        "Kai kuriems užsakymams sąskaitų išrašyti nepavyko",
      invoice_order_line_count_one: "{{count}} prekė",
      invoice_order_line_count_few: "{{count}} prekės",
      invoice_order_line_count_other: "{{count}} prekių",
      selected_of_orders: "Pasirinkta {{selected}} iš {{total}} užsakymų",
      select_order_for_invoice: "Pasirinkti šį užsakymą sąskaitai",
      save_as_draft_count: "Juodraštis ({{count}})",
      build_invoices_count: "Sukurti sąskaitas ({{count}})",
      invoices_drafted: "Sukurta juodraščių: {{count}}",
      invoices_built: "Sukurta ir patvirtinta sąskaitų: {{count}}",
      // Juodraščio trynimas — užsakymas grįžta į sąrašą
      delete_draft_invoice: "Ištrinti sąskaitos juodraštį",
      delete_draft_invoice_confirm:
        "Šis juodraštis neturi sąskaitos numerio ir klientui ({{customer}}) niekas nebuvo išsiųsta. Jo užsakymas vėl bus prieinamas sąskaitai išrašyti.",
      draft_invoice_deleted: "Sąskaitos juodraštis ištrintas",
      draft_invoice_deleted_period_skipped:
        "Ištrinta. {{month}} šiam užsakymui sąskaita nebus išrašyta.",
      delete_draft_invoice_confirm_no_customer:
        "Šis juodraštis neturi sąskaitos numerio ir klientui niekas nebuvo išsiųsta. Jo užsakymas vėl bus prieinamas sąskaitai išrašyti.",
      deleting: "Trinama…",
      invoice_existing_draft_loaded:
        "Šis užsakymas jau turi sąskaitos juodraštį, todėl jūsų pakeitimai jam nebuvo pritaikyti. Dabar jis rodomas čia — peržiūrėkite, tada redaguokite ir išsaugokite.",
      invoice_line_quantity_required: "Daugiau nei 0",
      invoice_line_price_required: "0 arba daugiau",
      invoice_lines_need_fixing: "Reikia pataisyti",
      create_invoice_lines_invalid:
        "{{count}} pasirinktų užsakymų turi prekę be kiekio. Įveskite kiekį, didesnį nei 0, pašalinkite eilutę arba atžymėkite užsakymą.",
      create_invoice_lines_invalid_one:
        "{{count}} pasirinktas užsakymas turi prekę be kiekio. Įveskite kiekį, didesnį nei 0, pašalinkite eilutę arba atžymėkite užsakymą.",
      create_invoice_lines_invalid_few:
        "{{count}} pasirinkti užsakymai turi prekę be kiekio. Įveskite kiekį, didesnį nei 0, pašalinkite eilutę arba atžymėkite užsakymą.",
      create_invoice_lines_invalid_other:
        "{{count}} pasirinktų užsakymų turi prekę be kiekio. Įveskite kiekį, didesnį nei 0, pašalinkite eilutę arba atžymėkite užsakymą.",
      create_invoice_already_invoiced: "šiam užsakymui sąskaita jau sukurta",
      // Užsakymo uždarymas
      order_ended_badge: "Pasibaigęs",
      order_external_contract: "Išorinė sutartis",
      order_external_contract_help:
        "Sutartis parengta ir pasirašyta ne sistemoje (sena sutartis arba kliento parengta). Ji išlaiko savo numerį, o pasirašytą PDF prisegate sutarties puslapyje, užuot generavę naują.",
      order_external_number: "Sutarties numeris",
      order_external_number_help: "Numeris, nurodytas pasirašytoje sutartyje. Jį nurodo sąskaitos.",
      order_external_number_required: "Įveskite išorinės sutarties numerį.",
      order_external_number_too_long: "Sutarties numeris gali būti ne ilgesnis nei 36 simboliai.",
      order_external_number_duplicate:
        "Kita sutartis jau turi numerį {{number}}. Patikrinkite, ar ta pati sutartis neimportuojama du kartus:",
      order_external_origin_locked:
        "To pakeisti nebegalima: sutarties dokumentas jau išsiųstas pasirašyti arba prisegta pasirašyta sutartis.",
      order_external_invalid_origin:
        "Užsakymas gali būti arba ERP užsakymas, arba išorinė sutartis.",
      order_external_badge: "Išorinė sutartis",
      billing_start_before_import:
        "Importuota sutartis negali apmokestinti mėnesių iki jos įvedimo į sistemą. Apmokestinkite nuo {{month}} arba vėliau.",
      external_billing_finvalda_hint:
        "Finvaldoje jau išrašytos mėnesių sąskaitos neaptinkamos. Laukelyje „Apmokestinti nuo“ nurodykite pirmą dar neapmokestintą mėnesį.",
      signed_order_edit_forbidden:
        "Šios sutarties dokumentas pasirašytas. Redaguoti gali tik naudotojas, turintis parašo teisę.",
      external_contract_document: "Pasirašyta sutartis",
      external_contract_date: "Sutarties data",
      external_contract_date_help: "Data, nurodyta pasirašytoje sutartyje. Ji tampa sutarties data sistemoje.",
      external_document_missing: "Pasirašyta sutartis dar neprisegta.",
      attach_external_document: "Prisegti pasirašytą sutartį",
      attach_external_document_intro:
        "Įkelkite ne sistemoje pasirašytos sutarties PDF. Jis taps šios sutarties dokumentu ir bus pažymėtas kaip pasirašytas.",
      replace_external_document: "Pakeisti",
      replace_external_document_confirm:
        "Prisegtas dokumentas bus pakeistas nauju PDF. Ankstesnis failas lieka sutarties istorijoje.",
      external_document_file: "Pasirašytas PDF",
      external_document_choose_file: "Pasirinkite PDF failą",
      external_document_attached: "Pasirašyta sutartis prisegta",
      external_document_replaced: "Pasirašyta sutartis pakeista",
      external_document_not_pdf: "Pasirašyta sutartis turi būti PDF failas.",
      external_document_already_sent:
        "Šios sutarties dokumentas jau išsiųstas pasirašyti arba pasirašytas, todėl jo pakeisti negalima.",
      external_document_forbidden:
        "Prisegti pasirašytą sutartį gali tik naudotojas, turintis parašo teisę.",
      external_document_file_attached:
        "Šis failas jau priklauso kitam dokumentui. Įkelkite pasirašytą sutartį iš naujo.",
      external_document_order_not_external:
        "Prieš prisegdami pasirašytą dokumentą, pažymėkite sutartį kaip išorinę.",
      external_document_annulled:
        "Šis dokumentas anuliuotas, jo pakeisti negalima.",
      external_document_order_not_found:
        "Šis užsakymas nerastas. Galbūt jis buvo ištrintas.",
      external_document_invalid_file_type: "Šis failo tipas nerastas.",
      external_document_invalid_category: "Ši kategorija nerasta.",
      external_document_invalid_date: "Sutarties data yra neteisinga.",
      external_document_no_signatures_to_reset:
        "Šis dokumentas buvo prisegtas kaip pasirašyta išorinė sutartis, o ne pasirašytas sistemoje — atstatyti nėra ko. Prisekite naują failą.",
      amendment_slot_required:
        "Išorinės sutarties priedai numeruojami įmonės priedų serijoje. Nustatykite ją: Sutarčių nustatymai → Sutarties priedas.",
      order_invalid_contract_end: "Sutarties pabaigos data yra neteisinga.",
      external_contract_not_found:
        "Nerasta. Galbūt buvo ištrinta arba perkelta.",
      invoice_settings_locked:
        "Kad pakeistumėte sąskaitų nustatymus, atidarykite užsakymą iš naujo",
      close_order_confirm_intro: "Uždarius šį užsakymą:",
      close_order_confirm_recurring:
        "Sutartis baigiasi šiandien: vėlesni mėnesiai nebebus apmokestinami.",
      close_order_arrears_warning:
        "Šis užsakymas apmokestinamas už praėjusį laikotarpį, todėl sąskaita už {{month}} dar bus išrašyta — juodraštis bus sukurtas kitą numatytą dieną. Uždarymas jos neatšaukia.",
      close_order_confirm_settings:
        "Jo sąskaitų nustatymai taps neredaguojami.",
      close_order_confirm_list:
        "Jis nebebus rodomas kuriant šio kliento sąskaitas.",
      close_order_confirm_reopen:
        "Jau išrašytoms sąskaitoms tai įtakos neturi. Uždarytą užsakymą atidaryti iš naujo gali tik administratorius.",
      close_order_confirm_reopen_same_people:
        "Jau išrašytoms sąskaitoms tai įtakos neturi. Kas gali uždaryti užsakymą, gali jį ir atidaryti iš naujo.",
      close_order_confirm_terminal:
        "Jis nebebus rodomas terminale kuriant pakrovimo užsakymą.",
      invoice_lines_out_of_sync: "Ši sąskaita buvo pakeista kitur. Uždarykite ir atidarykite ją iš naujo prieš redaguodami eilutes.",
      invoice_form_line_invalid:
        "Prekės eilutėje nenurodytas kiekis arba nurodyta neigiama kaina. Ištaisykite prieš išsaugodami ar patvirtindami šią sąskaitą.",
      invoice_order_changed_reloaded:
        "Kol forma buvo atidaryta, užsakymas pasikeitė. Eilutės įkeltos iš naujo — patikrinkite ir bandykite dar kartą.",
      invoice_err_no_items: "Sąskaitoje turi būti bent viena eilutė.",
      invoice_err_nothing_to_bill:
        "Nėra ką išrašyti: visi mėnesiai iki dabar jau išrašyti arba praleisti.",
      invoice_err_invalid_amount: "Viena iš eilutės sumų neteisinga.",
      invoice_err_invalid_line:
        "Viena sąskaitos eilutė yra neteisinga — patikrinkite, ar nėra pasikartojančios eilutės arba per ilgo pavadinimo / aprašymo.",
      invoice_err_invalid_date:
        "Viena iš datų neteisinga. Patikrinkite sąskaitos datą ir apmokėjimo terminą.",
      invoice_err_no_vat: "Šiam produktui nenustatytas PVM tarifas.",
      invoice_err_vat_foreign: "Šis PVM tarifas priklauso kitai įmonei.",
      invoice_err_no_product: "Šios įmonės produktas nerastas.",
      invoice_err_order_not_signed:
        "Prieš išrašant sąskaitą, užsakymas turi būti pilnai pasirašytas.",
      invoice_err_order_closed:
        "Šis užsakymas uždarytas, todėl sąskaitos jam išrašyti nebegalima.",
      invoice_err_order_contract_ended:
        "Šio užsakymo sutarties laikotarpis pasibaigė, todėl sąskaitos išrašyti nebegalima.",
      invoice_err_order_contract_annulled:
        "Šio užsakymo sutartis anuliuota, todėl sąskaitos išrašyti nebegalima.",
      invoice_err_order_billing_changed:
        "Šio užsakymo apmokestinimo nustatymai pasikeitė — atidarykite jį iš naujo, kad pamatytumėte dabartinį laikotarpį.",
      invoice_err_order_not_found: "Užsakymas nerastas.",
      invoice_err_customer_not_found: "Klientas nerastas.",
      invoice_err_invoice_not_found: "Sąskaita nerasta.",
      invoice_err_access_denied: "Neturite prieigos prie šio užsakymo kliento.",
      invoice_err_not_draft:
        "Redaguoti ar trinti galima tik juodraštines sąskaitas.",
      invoice_err_not_erp: "Patvirtinti galima tik ERP sąskaitas.",
      invoice_err_lock_timeout:
        "Šiai sąskaitai jau vyksta kitas patvirtinimas — bandykite dar kartą po kelių akimirkų.",
      invoice_err_series_changed:
        "Įmonės naudojama sąskaitų serija pasikeitė — bandykite dar kartą.",
      invoice_err_series_not_configured:
        "Šiai įmonei nenustatyta sąskaitų numeracijos serija. Sukurkite ją Užsakymų nustatymuose.",
      invoice_err_series_shared_finvalda:
        "Ši numeracijos serija taip pat naudojama importuotoms Finvalda sąskaitoms — pasirinkite seriją, skirtą tik ERP sąskaitoms.",
      invoice_err_invalid_number_template:
        "Sąskaitų numeracijos serijos formatas neteisingas.",
      invoice_err_date_in_future:
        "Sąskaitos data yra vėlesnė nei šiandien. Pakeiskite datą arba palaukite.",
      invoice_err_number_taken:
        "Šis numeris jau priskirtas kitai įmonės sąskaitai. Patikrinkite seriją.",
      invoice_file_locked:
        "Ši sąskaita jau išrašyta, todėl jos PDF nebegalima keisti.",
      invoice_err_invalid_period:
        "Šis apmokestinimo laikotarpis šiai sąskaitai netinka.",
      invoice_err_period_not_allowed:
        "Šios sąskaitos užsakymas neapmokestinamas laikotarpiais.",
      invoice_err_period_not_yet_billable:
        "Šio mėnesio dar negalima apmokestinti.",
      invoice_err_period_before_billing_start:
        "Šis laikotarpis yra ankstesnis nei užsakymo apmokestinimo pradžia.",
      invoice_err_date_before_last_issued:
        "Ši serija jau išrašė sąskaitas laikotarpiu {{period}}, todėl ši data sutrikdytų jos seką. Pakeiskite sąskaitos datą arba naudokite seriją, kurios numeryje nėra datos.",
      invoice_err_date_before_last_issued_unknown_period:
        "Ši data sutrikdytų serijos numerių seką. Pakeiskite sąskaitos datą arba naudokite seriją, kurios numeryje nėra datos.",
      invoice_already_exists: "Šiam užsakymui sąskaita jau sukurta",
      invoice_needs_products:
        "Prieš generuodami sąskaitą pridėkite prekes į užsakymą",
      invoice_needs_signed_order:
        "Prieš kuriant sąskaitą užsakymas turi būti visiškai pasirašytas",
      invoice_needs_attached_external_contract:
        "Prieš kuriant sąskaitą prisekite pasirašytos sutarties PDF",
      contract_deferred: "Sutartis bus pasirašyta vėliau",
      contract_deferred_help:
        "Sąskaitas galima išrašyti dar nepasirašius sutarties. Kai sutartis bus pasirašyta, ši žymė nebeturės įtakos.",
      contract_deferred_save_failed: "Nepavyko išsaugoti. Bandykite dar kartą.",
      sales_invoice_order_schedule_hint:
        "Mėnesinės sąskaitos valdomos užsakymo nustatymuose (ilgalaikis užsakymas), ne čia.",
      invoice_settings: "Sąskaitos nustatymai",
      invoice_settings_hint:
        "Nustatykite, kaip šiam užsakymui generuojamos pardavimo sąskaitos. Užsakymo prekės ir dokumentas redaguojami atskirai.",
      invoice_settings_permission_error:
        "Sąskaitų išrašymo nustatymus gali keisti tik sąskaitas tvarkantys naudotojai.",
      order_closed_billing_locked_hint:
        "Šis užsakymas uždarytas, todėl jo apmokestinimo nustatymai negali būti keičiami. Norėdami juos keisti, atidarykite užsakymą iš naujo — likusią formos dalį vis tiek galima išsaugoti.",
      order_is_recurring: "Ilgalaikė sutartis (mėnesinės sąskaitos)",
      order_is_recurring_help:
        "Kiekvieną mėnesį kuriama viena pardavimo sąskaita, kol užsakymas uždaromas arba baigiasi sutarties terminas.",
      order_invoice_schedule_mode: "Sąskaitos generavimo diena",
      order_invoice_schedule_last_day: "Paskutinę mėnesio dieną",
      order_invoice_schedule_specific_day: "Konkrečią mėnesio dieną",
      order_invoice_schedule_day: "Mėnesio diena (1–28)",
      order_invoice_schedule_day_invalid: "Įveskite dieną nuo 1 iki 28 — vėlesnių dienų yra ne kiekviename mėnesyje.",
      contract_term: "Sutarties terminas",
      contract_term_indefinite: "Neterminuota sutartis",
      contract_term_indefinite_help:
        "Sąskaitos išrašomos kiekvieną mėnesį, kol uždarysite sutartį.",
      contract_term_fixed: "Terminuota iki",
      contract_term_end_date: "Pabaigos data",
      contract_term_date_required:
        "Pasirinkite pabaigos datą arba nurodykite, kad sutartis neterminuota.",
      contract_valid_indefinite: "Galioja: neterminuota",
      contract_valid_until: "Galioja iki {{date}}",
      order_form_title_edit: "Redaguoti sutartį",
      order_form_section_customer: "Klientas ir data",
      order_form_section_items: "Prekės ir paslaugos",
      order_form_section_invoices: "Sąskaitos",
      order_draft_found: "Turite neišsaugotą juodraštį (išsaugota {{time}}).",
      order_draft_restore: "Atkurti",
      order_draft_discard: "Atmesti",
      order_line_incomplete:
        "Užpildykite eilutės „{{title}}“ kiekį ir kainą arba ją pašalinkite",
      create_product_option: "Sukurti „{{text}}“",
      invoice_billing_period_mode: "Kiekviena sąskaita apima",
      invoice_billing_period_current_month: "Mėnesį, kurį išrašoma",
      invoice_billing_period_previous_month: "Praėjusį mėnesį (už atliktus darbus)",
      invoice_billing_period_current_month_help:
        "Numatytą dieną išrašyta sąskaita apima tą patį mėnesį — išrašyta spalio 31 d., ji apima spalį.",
      invoice_billing_period_previous_month_help:
        "Numatytą dieną išrašyta sąskaita apima praėjusį mėnesį — išrašyta lapkričio 5 d., ji apima spalį. Tinka darbams, apmokestinamiems juos atlikus.",
      invoice_billing_start: "Apmokestinti nuo",
      invoice_billing_start_help:
        "Pirmas apmokestinamas mėnuo. Mėnesiai apmokestinami visi — pirmasis ir paskutinis taip pat pilnai. Palikite tuščią, kad pradėtų nuo šiandien apmokestinamo mėnesio; ankstesni mėnesiai apmokestinami tik juos pasirinkus.",
      invoice_billing_start_backfill:
        "Apmokestinant nuo {{from}}, bus sukurti visi mėnesiai iki {{to}}, kurie dar neturi sąskaitos — iki {{n}} sąskaitų kito paleidimo metu.",
      invoice_billing_start_backfill_open:
        "Apmokestinimo pradžia {{from}} yra ankstesnė nei numatytoji. Bus sukurti visi mėnesiai nuo tada, kurie dar neturi sąskaitos — praėję kito paleidimo metu.",
      month_short_1: "Saus",
      month_short_2: "Vas",
      month_short_3: "Kov",
      month_short_4: "Bal",
      month_short_5: "Geg",
      month_short_6: "Birž",
      month_short_7: "Liep",
      month_short_8: "Rugp",
      month_short_9: "Rugs",
      month_short_10: "Spal",
      month_short_11: "Lapkr",
      month_short_12: "Gruod",
      this_month: "Šis mėnuo",
      previous_year: "Ankstesni metai",
      next_year: "Kiti metai",
      invoice_period: "Laikotarpis",
      invoice_period_column: "Laikotarpis",
      invoice_due_column: "Mokėti iki",
      invoice_last: "Paskutinė",
      invoices_all: "Visos sąskaitos",
      invoices_none_yet: "Sąskaitų dar nėra",
      invoice_period_help: "Mėnuo, už kurį išrašoma ši sąskaita. Jos data gali būti bet kokia — apimamą laikotarpį lemia šis laukas.",
      invoice_service_act_add: "Pridėti paslaugų atlikimo aktą",
      invoice_service_act_title: "Paslaugų atlikimo aktas",
      invoice_service_act_text: "Atlikti darbai",
      invoice_service_act_help:
        "Spausdinama antrame sąskaitos PDF puslapyje — tame pačiame faile ir tame pačiame el. laiške.",
      invoice_service_act_required:
        "Įrašykite atliktus darbus arba nuimkite paslaugų atlikimo akto žymėjimą.",
      invoice_err_invalid_service_act:
        "Paslaugų atlikimo akto tekstas netinkamas — jis gali būti ne ilgesnis nei 20 000 simbolių.",
      invoice_period_already_billed:
        "Už šį mėnesį jau išrašyta kita šio užsakymo sąskaita.",
      invoice_period_already_billed_by:
        "Už {{month}} jau išrašyta kita šio užsakymo sąskaita: {{invoice}}.",
      invoice_next_period_hint: "Kita sąskaita bus už {{month}}.",
      invoice_all_periods_billed: "Visi mėnesiai iki šiol jau apmokestinti.",
      invoice_billing_not_started: "Apmokestinama nuo {{month}}.",
      close_order: "Uždaryti užsakymą",
      reopen_order: "Iš naujo atidaryti užsakymą",
      order_closed: "Užsakymas uždarytas",
      order_reopened: "Užsakymas vėl atidarytas",
      order_recurring_badge: "Kas mėnesį",
      order_closed_badge: "Uždarytas",
      invoice_order_closed_hint:
        "Šis užsakymas uždarytas — naujos sąskaitos nebus kuriamos.",
      invoice_contract_ended_hint:
        "Sutarties laikotarpis baigėsi — naujos sąskaitos nebus kuriamos. Pratęskite jį sąskaitos nustatymuose arba uždarykite užsakymą.",
      download_invoice: "Atsisiųsti sąskaitos PDF",
      invoice_type: "Tipas",
      invoice_type_erp: "ERP",
      invoice_type_finvalda: "Finvalda",
      confirm_invoice: "Patvirtinti sąskaitą",
      invoice_number: "Sąskaitos numeris",
      invoice_contract: "Sutartis",
      customer_invoices_drafts_heading: "Juodraščiai ({{count}})",
      invoice_confirmed: "Sąskaita patvirtinta",
      invoice_confirmed_emailed: "Sąskaita patvirtinta ir išsiųsta el. paštu",
      invoice_email_skipped_no_address:
        "Sąskaita patvirtinta, bet el. laiškas neišsiųstas — klientas neturi sąskaitų el. pašto.",
      invoice_email_skipped_pdf:
        "Sąskaita patvirtinta, bet el. laiškas neišsiųstas — nepavyko sugeneruoti PDF.",
      invoice_email_skipped_invalid:
        "Patvirtinta, tačiau sąskaitų el. pašto adresas neteisingas. Ištaisykite jį pas klientą ir naudokite „Siųsti dar kartą“.",
      invoice_email_skipped_invalid_with_reason:
        "Patvirtinta, tačiau sąskaitų el. pašto adresas neteisingas — {{reason}}. Ištaisykite jį pas klientą ir naudokite „Siųsti dar kartą“.",
      invoice_email_skipped_send:
        "Sąskaita patvirtinta, bet el. laiško išsiųsti nepavyko. Patikrinkite pašto nustatymus / žurnalus.",
      invoice_email_skipped_send_with_reason:
        "Patvirtinta, tačiau el. laiško išsiųsti nepavyko — {{reason}}. Kai bus ištaisyta, naudokite „Siųsti dar kartą“.",
      invoice_already_confirmed:
        "Sąskaita jau buvo patvirtinta (el. laiškas pakartotinai nesiunčiamas).",
      outgoing_invoices: "Išsiunčiamos sąskaitos",
      outgoing_invoices_subtitle:
        "Pardavimo sąskaitos: patvirtinkite juodraščius, o patvirtintas peržiūrėkite ir išsiųskite.",
      outgoing_invoices_tab_draft: "Paruoštos",
      outgoing_invoices_tab_complete: "Patvirtintos",
      outgoing_invoices_tab_register: "Registras",
      sales_register_empty: "Išrašytų sąskaitų dar nėra.",
      sales_register_load_failed: "Nepavyko įkelti sąskaitų registro.",
      sales_register_month_load_failed: "Nepavyko įkelti šio mėnesio sąskaitų.",
      sales_register_pdf: "PDF registras",
      sales_register_pdf_failed: "Nepavyko atsisiųsti registro PDF.",
      sales_register_vat_classifier: "PVM klasifikatorius",
      sales_register_company_code: "Įm. k. {{code}}",
      sales_register_vat_code: "PVM k. {{code}}",
      outgoing_invoices_complete_hint:
        "Patvirtintos pardavimo sąskaitos su suteiktais numeriais. Iš čia galite jas išsiųsti klientams.",
      outgoing_invoices_complete_empty: "Nėra patvirtintų pardavimo sąskaitų",
      outgoing_invoices_complete_empty_body:
        "Patvirtintos sąskaitos čia atsiras po juodraščių patvirtinimo.",
      sales_invoices_confirmation_hint:
        "Tvarkaraščio dieną sukurti juodraščiai. Patvirtinus suteikiamas numeris; siuntimas klientui el. paštu — pasirinktinai.",
      sales_invoices_drafts_empty: "Nėra pardavimo sąskaitų juodraščių",
      sales_invoices_drafts_empty_body:
        "Kai automatinis kūrimas sukurs juodraščius pasirašytiems užsakymams, jie atsiras čia patvirtinimui.",
      sales_invoices_confirm_all: "Patvirtinti visas",
      sales_invoices_confirm_all_title: "Patvirtinti visas pardavimo sąskaitas",
      sales_invoices_confirm_selected: "Patvirtinti pasirinktas ({{count}})",
      sales_invoices_confirm_all_body:
        "Patvirtinti {{count}} pasirinktą(-as) juodraščio sąskaitą(-as): kiekvienai suteikiamas numeris ir PDF. Pažymėkite langelį žemiau, jei norite kartu išsiųsti ir klientams. Atžymėkite tas, kurias norite palikti juodraščiu.",
      sales_invoices_bulk_selected_count: "Pasirinkta {{selected}} iš {{total}}",
      sales_invoices_bulk_progress: "Patvirtinama {{current}} iš {{total}}…",
      exclude: "Išimti",
      include: "Įtraukti",
      deselect_all: "Atžymėti visas",
      failed: "Nepavyko",
      sales_invoices_bulk_success: "Patvirtinta sąskaitų: {{count}}",
      sales_invoices_bulk_partial: "Patvirtinta: {{ok}}, nepavyko: {{fail}}",
      sales_invoices_bulk_missing_email_warn:
        "{{count}} sąskaita(-os) neturi sąskaitų el. pašto — jos bus patvirtintos, bet neišsiųstos.",
      sales_invoices_bulk_results: "Rezultatai",
      sales_invoices_bulk_not_attempted:
        "Nebandyta — sustabdyta po ankstesnės klaidos.",
      sales_invoices_bulk_skipped: "Nebandyta",
      sales_invoices_bulk_partial_stopped:
        "{{ok}} patvirtinta, {{fail}} nepavyko, {{skipped}} nebandyta",
      invoice_email_missing: "Nėra sąskaitų el. pašto",
      invoice_send_status_sent: "Išsiųsta",
      invoice_send_status_not_sent: "Neišsiųsta",
      invoice_send_status_failed: "Nepavyko išsiųsti",
      invoice_send_filter_all: "Visos",
      invoice_send_filter_not_sent: "Neišsiųstos",
      // mobile: company
      leave_calendar_add_leave: "Pridėti atostogas",
      leave_calendar_legend: "Legenda",
      leave_calendar_tap_last_day: "Bakstelėkite paskutinę atostogų dieną",
      leave_calendar_previous: "Ankstesnis",
      leave_calendar_next: "Kitas",
      invoice_send_filter_sent: "Išsiųstos",
      invoice_send_filter_failed: "Nepavyko",
      invoice_send_column: "Išsiuntimas",
      invoice_send_again: "Siųsti dar kartą",
      invoice_send_title: "Siųsti sąskaitą {{number}}",
      invoice_send_recipient: "Gavėjas",
      invoice_send_recipient_help:
        "Palikite tuščią, kad būtų siunčiama kliento sąskaitų el. paštu. Kelis adresus atskirkite kableliu.",
      invoice_send_already_sent: "Jau išsiųsta {{date}}{{who}}. Siųsti dar kartą?",
      invoice_send_done: "Išsiųsta: {{to}}",
      invoice_send_not_accepted: "Nepavyko išsiųsti el. laiško: {{reason}}",
      invoice_send_to_customer: "Siųsti klientui el. paštu",
      invoice_send_to_customers: "Siųsti klientams el. paštu",
      invoice_preview_pdf: "Peržiūrėti PDF",
      invoice_preview_save_first: "Išsaugokite, kad peržiūrėtumėte pakeitimus",
      invoice_buyer: "Pirkėjas",
      invoice_refresh_buyer: "Atnaujinti pirkėjo duomenis",
      invoice_buyer_refreshed: "Pirkėjo duomenys atnaujinti",
      invoice_period_one_off_help:
        "Neprivaloma. Pasirinkite mėnesį, už kurį išrašoma sąskaita; jis bus nurodytas sąskaitoje.",
      invoice_number_short: "Nr.",
      invoice_status_confirmed: "Patvirtinta",
      invoice_confirmed_not_emailed:
        "Sąskaita patvirtinta. Klientui el. paštu nesiųsta — išsiųskite ją skiltyje „Išsiunčiamos sąskaitos“.",
      invoice_err_not_confirmed:
        "Klientui el. paštu galima siųsti tik patvirtintas sąskaitas.",
      invoice_err_already_sent: "Ši sąskaita klientui jau išsiųsta el. paštu.",
      invoice_err_missing_email:
        "Klientas neturi sąskaitų el. pašto. Įveskite gavėjo adresą.",
      invoice_err_invalid_email: "El. pašto adresas neteisingas.",
      invoice_err_popup_blocked:
        "Leiskite iššokančius langus, kad peržiūrėtumėte PDF.",
      settlements_erp_invoices_title:
        "Išrašytos ERP sąskaitos (dar ne apskaitoje)",
      invoice_confirm_needs_permission:
        "Tvirtinimui reikia Master, Admin, Signature arba „Prieiga prie visų klientų“ teisės. Save išsaugo kaip juodraštį.",
      invoice_confirmed_readonly:
        "Ši sąskaita patvirtinta ir jos redaguoti nebegalima.",
      edit_invoice: "Redaguoti sąskaitą",
      view_invoice: "Peržiūrėti sąskaitą",
      select_order: "Pasirinkti aktyvų užsakymą",
      orders_settings: "Užsakymai",
      orders_settings_err_master_required: "Šiuos nustatymus keisti gali tik įmonės Master naudotojas.",
      orders_settings_err_amendment_invalid_source: "Pasirinkite tinkamą užsakymo pakeitimo šablono šaltinį.",
      orders_settings_err_amendment_template_missing: "Pasirinkite užsakymo pakeitimo individualų šabloną arba grįžkite prie sisteminio.",
      orders_settings_err_amendment_template_not_found: "Pasirinkto užsakymo pakeitimo šablono nebėra.",
      orders_settings_err_amendment_series_not_found: "Pasirinktos užsakymo pakeitimo serijos nebėra.",
      orders_settings_err_amendment_file_type_not_found: "Pasirinkto užsakymo pakeitimo failo tipo nebėra.",
      orders_settings_err_amendment_category_not_found: "Pasirinktos užsakymo pakeitimo kategorijos nebėra.",
      orders_settings_err_amendment_metadata_required: "Prieš išsaugant užsakymo pakeitimui reikia nurodyti seriją, failo tipą ir kategoriją.",
      orders_settings_err_invoice_invalid_source: "Pasirinkite tinkamą sąskaitos faktūros šablono šaltinį.",
      orders_settings_err_invoice_template_missing: "Pasirinkite sąskaitos faktūros individualų šabloną arba grįžkite prie sisteminio.",
      orders_settings_err_invoice_template_not_found: "Pasirinkto sąskaitos faktūros šablono nebėra.",
      orders_settings_err_invoice_series_not_found: "Pasirinktos sąskaitos faktūros serijos nebėra.",
      orders_settings_err_invoice_number_series_not_found: "Pasirinktos sąskaitos faktūros numeracijos serijos nebėra.",
      orders_settings_err_invoice_file_type_not_found: "Pasirinkto sąskaitos faktūros failo tipo nebėra.",
      orders_settings_err_invoice_category_not_found: "Pasirinktos sąskaitos faktūros kategorijos nebėra.",
      orders_settings_err_invoice_metadata_required: "Prieš išsaugant sąskaitai faktūrai reikia nurodyti seriją, failo tipą ir kategoriją.",
      invoice_number_format: "Sąskaitos numerio formatas",
      invoice_series: "Sąskaitų serijos",
      invoice_series_choose: "— pasirinkite seriją —",
      invoice_series_subtitle: "Kaip numeruojamos pardavimo sąskaitos. Sukurkite čia, tada pasirinkite Užsakymų nustatymuose.",
      invoice_series_numbering: "Sąskaitų numeracija",
      invoice_series_create: "Nauja sąskaitų serija",
      invoice_series_edit: "Redaguoti sąskaitų seriją",
      invoice_series_name: "Pavadinimas",
      invoice_series_name_hint: "Žmonėms. Sąskaitoje niekada nerodomas, todėl visada galima keisti.",
      invoice_series_name_required: "Pavadinimas privalomas",
      invoice_series_label: "Žymuo",
      invoice_series_label_hint: "Kodas, spausdinamas sąskaitoje. Tik raidės ir skaitmenys — bus spausdinama kaip {{example}}.",
      invoice_series_next_number: "Kitas numeris",
      invoice_series_issued: "Išrašyta",
      invoice_series_active_label: "Naudojama serija",
      invoice_series_active_hint: "Nuo šiol patvirtintos sąskaitos bus numeruojamos šia serija. Jau išrašytos išsaugo savo numerius.",
      invoice_series_in_use: "Naudojama",
      invoice_series_saved: "Sąskaitų serija išsaugota",
      invoice_series_save_failed: "Nepavyko išsaugoti sąskaitų serijos.",
      invoice_series_label_taken:
        "Kita šios įmonės serija jau spausdinama šiuo žymeniu. Pasirinkite kitą.",
      invoice_series_label_prefix:
        "Šis žymuo ir kitos serijos žymuo prasideda vienodai, todėl jų sąskaitų numeriai gali sutapti. Pasirinkite žymenį, kuris neprasideda kitos serijos žymeniu ir nėra jo pradžia.",
      invoice_series_label_finvalda:
        "Ši žymė sutampa su serija, kurią naudoja iš Finvaldos importuotos sąskaitos — pasirinkite kitą žymę.",
      invoice_series_load_failed: "Nepavyko įkelti sąskaitų serijų.",
      invoice_series_not_found: "Tokios sąskaitų serijos nebėra.",
      invoice_series_action_failed: "Nepavyko atlikti veiksmo.",
      invoice_series_none: "Sąskaitų serijų dar nėra. Pardavimo sąskaitų išrašyti negalima, kol viena nesukurta ir nepasirinkta Užsakymų nustatymuose.",
      invoice_series_locked: "Ši serija jau išrašė {{count}} sąskaitą (-ų), todėl jos žymens, formato ir pradinio numerio keisti nebegalima. Norėdami pradėti kitą formatą, sukurkite naują seriją — jau išrašytos sąskaitos išsaugo savo numerius.",
      invoice_number_format_locked_badge: "Naudojamas",
      invoice_number_format_locked: "Ši serija jau išrašė {{count}} sąskaitą (-ų), todėl jos formato keisti nebegalima. Norėdami pradėti naują formatą — pavyzdžiui, nuo sausio 1 d. — sukurkite naują seriją ir pasirinkite ją aukščiau. Jau išrašytos sąskaitos išsaugo savo numerius.",
      invoice_number_reset: "Skaitiklį pradėti iš naujo kas",
      invoice_number_reset_hint: "Be datos — paprasčiausias variantas: numeriai eina išrašymo tvarka, todėl praėjusiu mėnesiu datuotą juodraštį galima patvirtinti ir šiandien. Formatas su data to neleidžia.",
      invoice_number_preset_none: "Be datos — viena nenutrūkstama seka",
      invoice_number_preset_year: "Metai",
      invoice_number_preset_month: "Mėnuo",
      invoice_number_preset_day: "Diena",
      invoice_number_preset_custom: "Kitas",
      invoice_number_template: "Formatas",
      invoice_number_template_hint: "Žymos: {SERIES}, {YYYY} arba {YY}, {MM}, {DD} ir {N} arba {N:4} skaitikliui papildyti nuliais.",
      invoice_number_error_counter: "Formate turi būti lygiai vienas {N}.",
      invoice_number_error_series: "Formate turi būti {SERIES}.",
      invoice_number_error_token: "{{token}} nėra viena iš žemiau išvardytų žymų.",
      invoice_number_start: "Pradėti nuo",
      invoice_number_start_hint: "Nuo kurio numerio pradedama — įrašykite 1051, jei tęsiate seriją iš kitos sistemos. Formatas be datos jį naudoja vieną kartą, pirmajai sąskaitai; formatas su data nuo jo pradeda kiekvienus naujus metus, mėnesį ar dieną.",
      invoice_number_preview: "Kitos sąskaitos bus: {{example}}",
      invoice_number_preview_one: "Kita sąskaita bus: {{example}}",
      invoice_number_format_saved: "Numerio formatas išsaugotas",
      invoice_number_format_save_failed: "Nepavyko išsaugoti numerio formato.",
      invoice_number_format_load_failed: "Nepavyko įkelti šios serijos numerio formato.",
      sales_invoice_custom_template_warning:
        "Pasirinktiniame sąskaitos šablone turi būti numatyti serijos, numerio, kliento ir eilučių laukai.",
      serial: "Serija",
      series: "Serija",
      series_card_description: "Trumpas kodas prieš dokumento numerį, pvz., SUT-0045. Prefiksas nenumeruoja — numerį suteikia sistema.",
      series_add: "Naujas prefiksas",
      series_prefix: "Prefiksas",
      series_empty: "Prefiksų dar nėra.",
      series_already_exists: "Toks prefiksas jau yra.",
      series_rename_warning: "Pervadinus prefiksą pasikeis ir jau išduotų dokumentų rodomi numeriai. Tęsti?",
      series_rename_confirm_button: "Taip, pervadinti",
      series_invoice_numbering_note: "Sąskaitų numeracija nustatoma puslapyje <salesLink>Užsakymai ir sąskaitos</salesLink>.",
      user: "Darbuotojas",
      order: "Sutartis",
      quantity: "Kiekis",
      unit_price: "Vnt. kaina",
      add_invoice_item: "Pridėti prekę",
      email_incorrect: "El. paštas nerastas",
      category_not_found: "kategorija nerasta",
      user_exists: "Nurodytas el.paštas jau yra uzregistruotas.",
      add_order_item: "Pridėti prekę",
      is_period: "Siųsti periodiškai",
      next_invoice_date: "Sekančios sąskaitos data",
      month: "Mėnesis",
      day: "Diena",
      menu_item_settings_title: "Nustatymai",
      company_form_is_vat: "PVM mokėtojas",
      company_form_is_vat_help:
        "Bus aktyvuotas funkcionalumas skirtas PVM mokėtojams.",
      login_page_sent_title: "Prisijungimas",
      login_page_sent_text: "Prisijungimo nuoroda buvo issiusta el. pastu",
      your_company_operating_system: "Jūsų įmonės operacinė sistema",
      complete_solution_description:
        "Pilnas sprendimas CRM, HR, dokumentams, materialinėms vertybėms ir komandos bendradarbiavimui vienoje sistemoje.",
      crm_contracts_invoices_client_management:
        "CRM, sutartys, sąskaitos faktūros ir klientų valdymas",
      hr_automation_employee_requests_document_flow:
        "HR automatizavimas, darbuotojų užklausos ir dokumentų srautas",
      asset_tracking_fuel_management_expense_control:
        "Materialinių vertybių sekimas, kuro valdymas ir išlaidų kontrolė",
      task_management_team_collaboration_gamification:
        "Užduočių valdymas, komandos bendradarbiavimas ir žaidimifikacija",
      sign_in_to_your_account: "Prisijunkite prie savo paskyros",
      enter_email_receive_secure_login_link:
        "Įveskite el. paštą, kad gautumėte saugią prisijungimo nuorodą",
      email_address: "El. pašto adresas",
      how_it_works: "Kaip tai veikia",
      we_will_send_secure_link:
        "Mes išsiųsime saugią nuorodą į jūsų el. paštą. Spustelėkite nuorodą, kad akimirksniu prisijungtumėte – slaptažodžio nereikia.",
      check_your_email: "Patikrinkite savo el. paštą",
      we_have_sent_login_link_to: "Mes išsiuntėme prisijungimo nuorodą į",
      link_expire_warning:
        "Nuoroda baigs galioti po 15 minučių dėl saugumo priežasčių. Jei jos nematote, patikrinkite šlamšto aplanką.",
      mail: "Paštas",
      use_different_email: "Naudoti kitą el. paštą",
      having_trouble_signing_in: "Kyla problemų prisijungiant?",
      privacy_policy: "Privatumo politika",
      terms_of_service: "Naudojimo sąlygos",
      files: "Dokumentai",
      file: "Dokumentai",
      customer_details: "Informacija",
      project_details: "Projekto informacija",
      contacts: "Kontaktai",
      edit: "Redaguoti",
      no_contact_person_provided: "Kontaktinis asmuo nenurodytas",
      no_email_address_provided: "El. paštas nenorodytas",
      no_invoice_email_address_provided: "Sąskaitos el. paštas nenurodytas",
      no_secondary_email_address_provided: "Papildomas el. paštas nenurodytas",
      no_phone_number_provided: "Telefonas nenurodytas",
      no_address_provided: "Adresas nenurodytas",
      no_name_provided: "Pavadinimas nenurodytas",
      no_bank_iban_provided: "Banko IBAN nenurodytas",
      no_bank_name_provided: "Banko pavadinimas nenurodytas",
      no_payment_delay_provided: "Mokėjimo atidėjimas nenurodytas",
      no_prepayment_percentage_provided:
        "Išankstinio mokėjimo procentas nenurodytas",
      no_fine_provided: "Bauda nenurodyta",
      bank_details: "Banko duomenys",
      payment_delay: "Mokėjimo atidėjimas",
      prepayment_percentage: "Išankstinio mokėjimo procentas",
      fine: "Bauda",
      no_registration_code_provided: "Įmonės kodas nenurodytas",
      no_vat_code_provided: "PVM kodas nenurodytas",
      valid_email_address_is_required_we_will_send_authentication_link_to_this_email:
        "Į nurodyta el. paštą gausite vienkartinę prisijungimo nuorodą",
      get_auth_link: "Gauti nuorodą",
      max_allowed_debt: "Maksimali skolos suma",
      other: "Kita",
      no_max_allowed_debt_provided: "Maksimali skolos suma nenurodyta",
      assigned_user: "Priskirtas darbuotojas",
      external_code: "Išorinis kodas",
      external_code_hint: "Kodas, pagal kurį darbuotojas susiejamas su kitomis sistemomis (pvz., buhalterine programa).",
      shared_across_companies:
        "Bendra visoms įmonėms, kurioms priklauso šis vartotojas",
      debt: "Skola",
      no_assigned_person: "Darbuotojas nepriskirtas",
      value: "Reikšmė",
      overdue_debt: "Pradelsta skola",
      payment_due_date: "Sumokėti iki",
      debt_invoices: "Skolos",
      total_quantity: "Kiekis",
      total_amount: "Suma",
      last_invoice_quantity: "PS kiekis",
      last_invoice_amount: "PS suma",
      last_invoice_date: "PS data",
      last_edit: "Redaguota",
      make_a_comment: "Parašyti komentarą",
      invoice_count: "Pirkta kartų",
      turnover: "Apyvarta",
      download: "Parsisiųsti",
      upload: "Įkelti",
      category: "Kategorija",
      file_category_user: "Kategorija",
      file_name: "Pavadinimas",
      no_files: "Kol kas dokumentų nėra",
      customer: "Klientas",
      files_categories: "Dokumentų kategorijos",
      files_categories_subject: "Objektas",
      files_categories_title: "Pavadinimas",
      files_categories_create: "Sukurti kategoriją",
      files_categories_subject_customer: "Klientas",
      files_templates: "Dokumentų šablonai",
      files_build_pdf: "Generuoti dokumentą",
      file_template_select: "Pasirinkti šabloną",
      files_template_custom_name: "Pavadinimas",
      files_template_custom_label: "Žyma šablone",
      files_template_custom_type: "Tipas",
      files_template_custom_add: "Pridėti lauką",
      files_template_custom_remove: "Pašalinti",
      files_template_custom_type_string: "Trumpas tekstas",
      files_template_custom_type_textarea: "Ilgas tekstas",
      files_template_custom_type_date: "Data",
      files_template_custom_remove_option: "Trinti variantą",
      files_template_custom_add_option: "Pridėti variantą",
      files_template_custom_required: "Būtinas laukelis",
      files_template_custom_type_select: "Pasirinkimas",
      files_template_custom_type_select_option: "Variantas",
      files_template_custom_type_select_select_an_option: "Pasirinkite reikšmę",
      files_template_custom_type_products: "Prekės",
      files_template_custom_type_products_or_groups: "Prekės arba produktų grupės",
      files_template_custom_type_product_groups: "Produktų grupės",
      files_template_custom_enable_group_option: "Įjungti produktų grupes",
      files_template_custom_type_user: "Pasirinkite darbuotoją",
      files_template_custom_min_length: "Minimalus simbolių skaičius",
      files_template_custom_number_min: "Minimali reikšmė",
      files_template_custom_number_max: "Maksimali reikšmė",
      field_must_be_between_min_and_max:
        "{{label}} turi būti nuo {{min}} iki {{max}}",
      field_must_be_at_least_min: "{{label}} turi būti bent {{min}}",
      field_must_be_at_most_max: "{{label}} turi būti ne daugiau kaip {{max}}",
      must_be_between_min_and_max: "Turi būti nuo {{min}} iki {{max}}",
      must_be_at_least_min: "Turi būti bent {{min}}",
      must_be_at_most_max: "Turi būti ne daugiau kaip {{max}}",
      number_min_must_be_less_than_or_equal_to_max:
        "Minimali reikšmė turi būti mažesnė arba lygi maksimaliai reikšmei.",
      files_template_custom_type_number: "Skaičius",
      files_template_custom_type_checkbox: "Žymimasis laukelis",
      files_template_custom_checkbox_multi: "Leisti kelis pasirinkimus",
      files_template_custom_type_signature: "Parašas",
      field_must_be_at_least_characters:
        "Laukelis turi būti bent {{minLength}} simbolių",
      field_must_be_at_least_characters_label:
        "{{label}} turi būti bent {{minLength}} simbolių",
      signontab_select_user: "Pasirinkti SignOnTab įrangą",
      manager_should_be_assigned_first:
        "Pirmiausia turi būti priskirtas vadovas",
      reservations: "Rezervacijos",
      reservation: "Rezervacija",
      projects: "Projektai",
      "project-boards": "Projektų grupės",
      "project-boards-create": "Sukurti projektų grupę",
      "project-board-name": "Projektų grupės pavadinimas",
      "project-board-column-create": "Sukurti projekto etapą",
      "project-board-column-name": "Etapo pavadinimas",
      "project-board-column-order": "Eiliškumas",
      "project-create": "Sukurti projektą",
      project_column: "Projekto etapas",
      "project-name": "Projekto pavadinimas",
      project_outcome: "Rezultatas",
      project_outcome_open: "Atvira",
      project_outcome_won: "Laimėta",
      project_outcome_lost: "Pralaimėta",
      project_outcome_deleted: "Ištrinta",
      project_value_eur: "Vertė (EUR)",
      not_set: "Nenustatyta",
      project_contact: "Kliento kontaktas",
      project_contact_empty: "Kliento kontaktų dar nėra.",
      linkedin: "LinkedIn",
      whatsapp: "WhatsApp",
      viber: "Viber",
      project_drop_delete: "IŠTRINTI",
      project_drop_lost: "PRALAIMĖTA",
      project_drop_won: "LAIMĖTA",
      project_drop_move_to: "PERKELTI",
      project_move_select_board: "Perkelti į lentą",
      project_move_no_boards: "Kitų lentų nėra.",
      project_move_no_columns: "Toje lentoje dar nėra sąrašų.",
      move: "Perkelti",
      project_won_celebration: "Laimėjimo animacija",
      project_rotting: "Neaktyvi",
      project_rotting_idle: "Neaktyvi {{n}} d.",
      project_rotting_days: "Senėjimas po (dienų)",
      project_rotting_days_help:
        "Kortelės, neaktyvios ilgiau nei šis limitas, pažymimos raudonai. Palikite tuščią, jei nenaudoti.",
      project_stage_of: "{{current}}/{{total}}",
      "project-description": "Projekto aprašymas",
      "project-order": "Prioritetas",
      project_board_column_edit: "Redaguoti",
      customer_select: "Pasirinkti klientą",
      price: "Kaina",
      totalPrice: "Bendra kaina",
      remove: "Pašalinti",
      search_products: "Prekių paieška",
      at_least_one_product_or_product_group_required:
        "Būtina pridėti bent vieną produktą arba produktų grupę su kiekiu ir kaina",
      meta_data: "Meta duomenys",
      product_stock: "Prekės likučiai",
      product_reservations: "Prekės reservacijos",
      select_warehouse: "Pasirinkti sandėlį",
      warehouse: "Sandėlis",
      customer_form: "Kliento anketa / Customer form",
      "customer_form-general_info": "Bendra informacija / General information",
      "customer_form-name": "Pirkėjo pavadinimas / Customer name",
      "customer_form-name_help": "",
      "customer_form-reg_address":
        "Registracijos adresas / Registration address",
      "customer_form-country": "Šalis / Country",
      "customer_form-country_help": "",
      "customer_form-city": "Miestas / City",
      "customer_form-city_help": "",
      "customer_form-address": "Adresas / Address",
      "customer_form-address_help": "",
      "customer_form-phone": "Telefonas / Phone",
      "customer_form-phone_help": "",
      "customer_form-email": "El. paštas / Email",
      "customer_form-email_help": "",
      "customer_form-vatCode": "PVM kodas / VAT code",
      "customer_form-vatCode_help": "",
      "customer_form-vatCode_required":
        "PVM kodas yra privalomas / VAT code is required",
      "customer_form-vatCode_letters_required":
        "PVM kodo raidės yra privalomos / VAT code letters are required",
      "customer_form-vatCode_figures_required":
        "PVM kodo skaičiai yra privalomi / VAT code figures are required",
      "customer_form-vatCode_letters_must_be_two":
        "PVM kodo raidės turi būti tiksliai 2 raidės / VAT code letters must be exactly 2 letters",
      "customer_form-vatCode_letters_invalid":
        "PVM kodo raidės turi būti tik raidės (A-Z) / VAT code letters must be letters only (A-Z)",
      "customer_form-vatCode_figures_invalid":
        "PVM kodo skaičiai turi būti tik skaičiai ir raidės / VAT code figures must be numbers and letters only",
      "customer_form-zipCode": "Pašto kodas / Zip code",
      "customer_form-zipCode_help": "",
      "customer_form-office_address":
        "Faktinis (veiklos) adresas / Office address",
      "customer_form-office_address_help":
        "Nurodoma jeigu skiriasi adresas / If different",
      "customer_form-iban": "IBAN sąskaitos numeris / IBAN account number",
      "customer_form-iban_help": "",
      "customer_form-iban2": "Kitas ne IBAN numeris / Other than IBAN",
      "customer_form-iban2_placeholder": "",
      "customer_form-iban2_help":
        "pildoma tik tuo atveju, jeigu nėra IBAN / fill only if no IBAN",
      "customer_form-bankName": "Banko pavadinimas / Bank name",
      "customer_form-bankName_help": "",
      "customer_form-companyCode": "Įmonės kodas / Company code",
      "customer_form-companyCode_help": "",
      "customer_form-vatCode2": "Kitas PVM kodas / Other VAT code",
      "customer_form-vatCode2_help": "",
      "customer_form-website": "Interneto svetainė / Website",
      "customer_form-website_help": "",
      "customer_form-swiftCode": "SWIFT kodas / SWIFT code",
      "customer_form-swiftCode_help": "",
      "customer_form-currency": "Valiuta / Currency",
      "customer_form-currency_help": "neprivaloma / optional",
      "customer_form-currency_invalid":
        "Valiutos kodas turi būti iš 3 raidžių, pvz. EUR / Currency code must be 3 letters, e.g. EUR",
      "customer_form-account_comment": "Pastaba / Comment",
      "customer_form-account_comment_help":
        "neprivaloma, pvz. kam naudojama ši sąskaita / optional, e.g. what this account is used for",
      "customer_form-comment_too_long":
        "Pastaba per ilga(maks. 255 simboliai) / Comment is too long(max. 255 characters)",
      "customer_form-account_heading":
        "{{number}} sąskaita / Account no. {{number}}",
      "customer_form-account_add": "+ Pridėti sąskaitą / Add account",
      "customer_form-account_remove": "Pašalinti / Remove",
      "customer_form-account_primary": "Pagrindinė sąskaita / Primary account",
      "customer_form-account_primary_help":
        "Ją naudosime atsiskaitymams pagal nutylėjimą / We will use it for settlements by default",
      important: "Svarbu",
      comment: "Komentaras",
      "customer_form-error_heading":
        "Anketos nuoroda negaliojanti / Form link is invalid",
      "customer_form-error_message":
        "Prašome susisiekti su vadybininku / Please contact your manager",
      "customer_form-contacts": "Kontaktiniai duomenys / Contact details",
      "customer_form-contact_fullName":
        "Kontaktinis asmuo (vardas, pavardė) / Contact person (full name)",
      "customer_form-contact_fullName_help": "",
      "customer_form-contact_position": "Pareigos / Position",
      "customer_form-contact_position_help": "",
      "customer_form-contact_phone_help": "",
      "customer_form-contact_email_help": "",
      "customer_form-contact_phone": "Telefonas / Phone",
      "customer_form-contact_email": "El. paštas / E-mail",
      "customer_form-other_details": "Kita informacija / Other details",
      "customer_form-invoice_email":
        "El. paštas sąskaitų siuntimui / Invoice email",
      "customer_form-invoice_email_help": "",
      "customer_form-signature_details":
        "Vadovo arba asmens kuris pasirašys sutartį duomenys / Data of the person who will sign the contract",
      "customer_form-signature_fullName": "Vardas, pavardė / Full name",
      "customer_form-signature_fullName_help": "",
      "customer_form-signature_position": "Pareigos / Position",
      "customer_form-signature_position_help": "",
      "customer_form-signature_email":
        "El. paštas sutarties pasirašymui / Email for signing the contract",
      "customer_form-signature_email_help": "",
      "customer_form-signature_basis_of_representation":
        "Atstovavimo pagrindas",
      "customer_form-signature_basis_of_representation_help":
        "(nurodyti įstatai arba kitą pagrindą/Specify the Articles of Association or other legal basis \n *Jei pasirašys ne įmonės vadovas - pateikti atstovavimo pagrindą pagrindžiantį  dokumentą/ If the Signatory is not the Company’s Manager, please provide a document substantiating the  basis of representation.) ",
      "customer_form-payments":
        "Atsakingas už mokėjimus / Responsible for payments",
      "customer_form-payments_fullName": "Vardas, pavardė / Full name",
      "customer_form-payments_fullName_help": "",
      "customer_form-payments_position": "Pareigos / Position",
      "customer_form-payments_position_help": "",
      "customer_form-payments_email": "El. paštas / Email",
      "customer_form-payments_email_help": "",
      "customer_form-payments_phone": "Telefonas / Phone",
      "customer_form-payments_phone_help": "",
      "customer_form-signer-positionAndFullName":
        "Pareigos, vardas, pavardė / Position, full name",
      "customer_form-sign": "Pasirašyti ir siųsti / Sign and send",
      "customer_form-confirm": "Tvirtinu / Confirm",
      "customer_form-confirm_disclaimer":
        "Paspausdamas tvirtinu pateiktų duomenų teisingumą / By clicking, I confirm that the provided information is correct.",
      "customer_form-name_required":
        "Prašome įvesti pavadinimą / Please enter the name",
      "customer_form-companyCode_required":
        "Prašome įvesti įmonės kodą / Please enter the company code",
      "customer_form-phone_required":
        "Prašome įvesti telefono numerį / Please enter the phone number",
      "customer_form-email_required":
        "Prašome įvesti el. pašto adresą / Please enter the email address",
      "customer_form-legal_name_required":
        "Prašome įvesti teisinį pavadinimą / Please enter the legal name",
      "customer_form-address_required":
        "Prašome įvesti adresą / Please enter the address",
      "customer_form-city_required":
        "Prašome įvesti miestą / Please enter the city",
      "customer_form-country_required":
        "Prašome pasirinkti šalį / Please select the country",
      "customer_form-zipCode_required":
        "Prašome įvesti pašto kodą / Please enter the zip code",
      "customer_form-street_required":
        "Prašome įvesti gatvę / Please enter the street",
      "customer_form-bankName_required":
        "Prašome įvesti banko pavadinimą / Please enter the bank name",
      "customer_form-iban_required":
        "Prašome įvesti IBAN kodą / Please enter the IBAN code",
      "customer_form-iban_or_iban2_required":
        "Privalomas IBAN arba kitas numeris / IBAN or alternative number is required",
      "customer_form-contact_fullName_required":
        "Prašome įvesti vardą ir pavardę / Please enter the full name",
      "customer_form-contact_phone_required":
        "Prašome įvesti telefono numerį / Please enter the phone number",
      "customer_form-contact_position_required":
        "Prašome įvesti pareigas / Please enter the position",
      "customer_form-contact_email_required":
        "Prašome įvesti el. paštą / Please enter the email",
      "customer_form-signature_fullName_required":
        "Prašome įvesti vardą ir pavardę / Please enter the full name",
      "customer_form-signature_position_required":
        "Prašome įvesti pareigas / Please enter the position",
      "customer_form-signature_email_required":
        "Prašome įvesti el. paštą / Please enter the email",
      "customer_form-signature_basis_of_representation_required":
        "Prašome įvesti atstovavimo pagrindą / Please enter the basis of representation",
      "customer_form-invoice_email_required":
        "Prašome įvesti sąskaitų faktūrų el. paštą / Please enter the invoice email",
      "customer_form-payments_fullName_required":
        "Prašome įvesti vardą ir pavardę / Please enter the full name",
      "customer_form-payments_phone_required":
        "Prašome įvesti telefono numerį / Please enter the phone number",
      "customer_form-payments_position_required":
        "Prašome įvesti pareigas / Please enter the position",
      "customer_form-payments_email_required":
        "Prašome įvesti el. paštą / Please enter the email",
      "customer_form-signer_fullName_required":
        "Prašome įvesti pasirašančio asmens vardą ir pavardę / Please enter the full name of the signing person",
      "customer_form-zipCode_figures_required":
        "Skaičiai privalomas/ Figures required",
      "customer_form-zipCode_letters_required":
        "Raidės privalomas/ Letters required",
      "customer_form-submit_error":
        "Prašome ištaisyti anketos klaidas / Please correct the form errors",
      "customer_form-success_heading":
        "Anketa sėkmingai pateikta / Form submitted successfully",
      "customer_form-success_text":
        "Netrukus su Jumis susisieksime / We will contact you soon",
      documents: "Dokumentai",
      action: "Veiksmas",
      audit_action_create: "Sukurti",
      audit_action_update: "Atnaujinti",
      audit_action_delete: "Ištrinti",
      audit_action_view: "Peržiūra",
      audit_action_review: "Peržiūra",
      audit_action_signature: "Pasirašymas",
      audit_action_signature_complete: "Pasirašymas baigtas",
      audit_action_download: "Parsisiųsti",
      audit_action_unknown: "Kita",
      audit_subject_Customer: "Klientas",
      audit_subject_File: "Dokumentas",
      audit_subject_Asset: "Mat. vertybė",
      audit_subject_FuelReport: "Kuro ataskaita",
      audit_subject_FuelBarcode: "Kuro barkodas",
      audit_subject_BusinessTrip: "Komandiruotė",
      audit_subject_Order: "Sutartis",
      audit_subject_Project: "Projektas",
      audit_subject_ProjectBoard: "Projektų grupė",
      audit_subject_ProjectBoardColumn: "Projekto etapas",
      audit_subject_User: "Vartotojas",
      audit_subject_UserMembership: "Vartotojo priklausomybė",
      audit_subject_Company: "Įmonė",
      audit_subject_FileCategory: "Dokumentų kategorija",
      audit_subject_Onboarding: "Įdarbinimas",
      audit_subject_Department: "Skyrius",
      audit_subject_Expense: "Išlaidos",
      audit_subject_TripExpense: "Kelionės išlaidos",
      audit_subject_PointTransaction: "Įvertinimai",
      audit_subject_CompanyHoliday: "Šventė",
      audit_subject_CompaniesSignOnTab: "SignOnTab nustatymai",
      audit_subject_PermissionsGroup: "Teisių grupė",
      audit_subject_CustomField: "Papildomas laukas",
      audit_subject_Series: "Serija",
      audit_subject_FileType: "Dokumento tipas",
      audit_subject_AssetType: "Mat. vertybės tipas",
      audit_subject_Template: "Šablonas",
      audit_subject_SignontabUser: "SignOnTab įranga",
      audit_subject_CustomerFinance: "Kliento finansai",
      audit_open_entity: "Atidaryti",
      performed_by: "Atliko",
      audit_actor_system: "Sistema",
      activity_log: "Veiklos istorija",
      customer_questionnaire: "Kliento anketa",
      "customer_form-different_contact_person":
        "Kontaktinis asmuo skiriasi, nurodyti kontaktinį asmenį / Contact person is different, specify the contact person",
      "customer_form-different_payments_person":
        "Už apmokėjimus atsakingas kitas asmuo, nurodyti kontaktinį asmenį / Another person is responsible for payments, specify the contact person",
      "customer_questionnaire-generated":
        "Kliento anketa sugeneruota ir išsiusta:",
      "customer_questionnaire-signed":
        "Kliento anketa pateikta ir pasirašyta: / Customer form submitted and signed:",
      "customer_form-documents": "Dokumentai / Documents",
      "customer_form-delete_confirmation":
        "Ar tikrai norite ištrinti dokumentą? / Are you sure you want to delete the document?",
      "customer_form-delete": "Ištrinti / Delete",
      "customer_questionnaire-not_signed": "Kliento anketa nepasirašyta",
      add: "Pridėti",
      files_category_title: "Kategorijos pavadinimas",
      createdAt: "Sukūrimo data",
      updatedAt: "Atnaujinta",
      contact_add: "Pridėti kontaktinį asmenį",
      "contact-name": "Vardas Pavardė",
      email: "El. paštas",
      "is-authorized-to-sign": "Įgaliotas pasirašyti sutartį",
      contact_disabled: "Išjungti kontaktą",
      "customer_questionnaire-generate": "Generuoti ir siųsti kliento anketą",
      send_questionnaire: "Siųsti anketą",
      next_expected_action: "Tolimesnis veiksmas",
      questionnaire_required_before_finance:
        "Prieš tęsiant su pagrindine sutartimi, kliento anketa turi būti užpildyta.",
      questionnaire_satisfied_from_previous_year:
        "Anketa įvykdyta (užpildyta ankstesniais metais). Galite pereiti prie kitų žingsnių.",
      regenerate_questionnaire_pdf: "Pergeneruoti anketos PDF",
      questionnaire_sent: "Išsiųsta",
      questionnaire_signed_at: "Pasirašyta",
      new_version_available: "Atnaujinti programą (puslapis bus užkrautas iš naujo)",
      email_required_for_questionnaire:
        "El. pašto adresas yra būtinas, norint išsiųsti anketos formą.",
      save_email: "Išsaugoti el. paštą",
      questionnaire_sent_waiting_signature:
        "Anketa išsiųsta. Laukiama kliento parašo.",
      send_questionnaire_to_customer:
        "Paspauskite mygtuką žemiau, norint išsiųsti anketos formą klientui.",
      questionnaire_cross_company_confirm_title:
        "Kopijuoti anketą iš kitos įmonės?",
      questionnaire_cross_company_confirm_message:
        "Užpildyta anketa šiam PVM kodui jau yra įmonėje „{{company}}“. Formos laukai{{attachments}} bus nukopijuoti į šį kvietimą, Tęsti?",
      questionnaire_cross_company_attachments_suffix:
        " ir {{count}} prisegtas (-i) failas (-ai)",
      questionnaire_cross_company_attachments_none: "",
      confirm_copy_and_send:
        "Taip, kopijuoti ir siųsti",
      questionnaire_send_fresh_form:
        "Siųsti tuščią formą (nekopijuoti iš kitos įmonės)",
      invalid_email: "Neteisingas el. paštas",
      error_saving_email: "Klaida išsaugant el. paštą",
      upload_document_1: "Įkelti dokumentą 1",
      upload_document_2: "Įkelti dokumentą 2",
      upload_document_3: "Įkelti dokumentą 3",
      click_to_upload: "Spustelėkite čia, norint įkelti failą",
      file_uploaded: "Failas sėkmingai įkeltas",
      manager_approval: "Vadovo patvirtinimas",
      waiting_for_manager_approval: "Laukiama vadovo patvirtinimo",
      generate_document_description:
        "Sugeneruokite ir išsiųskite finansinį dokumentą",
      collect_signatures: "Rinkti parašus",
      order_creation_unlocked:
        "Visi žingsniai užbaigti. Dabar galite kurti užsakymus šiam klientui.",
      complete_previous_step: "Pirmiausia užbaikite ankstesnį žingsnį",
      complete_all_steps_to_unlock:
        "Užbaikite visus ankstesnius žingsnius, norint atrakinti užsakymų kūrimą",
      eu_sanctions_check: "ES sankcijų patikra",
      usa_sanctions_check: "JAV sankcijų patikra",
      lt_sanctions_check: "LT sankcijų patikra",
      sanctions_file_category: "Failų kategorija",
      sanctions_file_type: "Failų tipas",
      eu_sanctions_check_description:
        "Paspauskite žemiau esančią nuorodą, norint patikrinti ES sankcijas, tada įkelkite ekrano kopiją su rezultatu.",
      usa_sanctions_check_description:
        "Paspauskite žemiau esančią nuorodą, norint patikrinti JAV sankcijas, tada įkelkite ekrano kopiją su rezultatu.",
      lt_sanctions_check_description:
        "Paspauskite žemiau esančią nuorodą, norint patikrinti LT sankcijas, tada įkelkite ekrano kopiją su rezultatu.",
      upload_screenshot_description:
        "Prašome įkelti ekrano kopiją arba PDF failą su sankcijų patikros rezultatu.",
      custom_field_code: "Kodas",
      // mobile: public
      onboarding_file_delete_confirm: "Ištrinti šį dokumentą?",
      custom_field_label: "Pavadinimas",
      custom_field_type: "Tipas",
      email_connect: "El. paštas prijungimas",
      not_connected: "Ne prijungta",
      connected: "Prijungta",
      connect: "Prijungti",
      external: "Išorinė",
      internal: "Vidinė",
      about_company: "Apie įmonę",
      select_series: "Pasirinkite seriją",
      externalNumber: "Įšorinis numeris",
      document_date: "Dokumento data",
      select_existing_customer: "Pasirinkti esamą klientą",
      save_customer: "Įšsaugoti klientą",
      customer_name: "Kliento pavadinimas",
      category_order: "Eiliškumas",
      email_messages: "El. paštas",
      legal_name: "Teisinis pavadinimas",
      is_shared_category: "Visoms įmonėms matoma kategorija",
      responsible_user: "Atsakingas darbuotojas",
      text: "Tekstas",
      checkbox: "Varnelė",
      settings: "Nustatymai",
      the_file_was_uploaded_by: "Failą įkėlė",
      select_field: "pasirinkti lauką",
      add_Field: "pridėti lauką",
      save_field: "išsaugoti lauką",
      ok: "gerai",
      financials: "Finansai",
      no_sku_provided: "SKU nenurodytas",
      no_description_provided: "aprašymas nenurodytas",
      notes_placeholder: "Pridėti pastabą",
      no_legal_name_provided: "juridinis pavadinimas nenurodytas",
      no_vat_provided: "PVM kodas nenurodytas",
      no_code_provided: "kodas nenurodytas",
      custom_field_card_description: "Laukai rodomi dokumento kortelėje, pvz., sutarties pabaigos data.",
      custom_field_add: "Naujas laukas",
      custom_field_type_text: "Tekstas",
      custom_field_type_number: "Skaičius",
      custom_field_type_date: "Data",
      custom_field_type_select: "Pasirinkimas iš sąrašo",
      custom_field_type_checkbox: "Žymimasis langelis",
      custom_field_options: "Pasirinkimai",
      custom_field_option: "Pasirinkimas",
      custom_field_add_option: "Pridėti pasirinkimą",
      custom_field_remove_option: "Pašalinti pasirinkimą",
      custom_field_required: "Privalomas",
      custom_field_required_hint: "Dokumento negalima išsaugoti, kol laukas neužpildytas.",
      custom_field_visible_in_list: "Rodomas dokumento formoje",
      custom_field_visible_in_list_hint: "Jei išjungta, pildant dokumentą laukas nerodomas.",
      custom_field_empty: "Papildomų laukų dar nėra.",
      finvalda: "Finvalda",
      assignedUser: "priskirtas darbuotojas",
      document_name: "dokumento pavadinimas",
      file_name_is_required: "būtinas nurodyti failo pavadinimą",
      category_is_required: "būtina nurodyti kategoriją",
      user_is_required: "būtina nurodyti darbuotoją",
      customer_is_required: "būtina nurodyti klientą",
      files_template_name: "šablono pavadinimas",
      files_template_serial: "šablono serija",
      files_template_html: "šablono HTML",
      reserved: "rezervuota",
      client_id: "kliento ID",
      tenant_id: "tenant ID",
      secret: "slaptas raktas",
      finvaldaUser: "Finvaldos naudotojas",
      finvaldaPass: "Finvaldos slaptažodis",
      finvaldaAddress: "Finvaldos serverio adresas",
      finvaldaCompanyId: "Įmonės ID Finvaldoje",
      no_external_code_provided: "nėra išorinio kodo",
      customer_portal: "Klientų portalas",
      customer_portal_generate_link: "Generuoti prisijungimo nuorodą",
      customer_portal_send_link: "Siųsti prisijungimo nuorodą",
      customer_portal_copy_link: "Kopijuoti nuorodą",
      customer_portal_link_copied: "Nukopijuota!",
      customer_portal_link_error: "Nepavyko sugeneruoti nuorodos.",
      customer_portal_send_link_success: "Prisijungimo nuoroda išsiųsta.",
      customer_portal_send_link_error: "Nepavyko išsiųsti prisijungimo nuorodos.",
      customer_portal_email_missing: "Kliento el. paštas nenurodytas.",
      disconnect: "atsijungti",
      bank_iban: "banko IBAN",
      bank_name: "banko pavadinimas",
      bank_swift: "SWIFT kodas",
      bank_account_heading: "{{number}} sąskaita",
      bank_account_currency: "Valiuta",
      bank_account_currency_help: "neprivaloma, pvz. EUR",
      bank_account_comment: "Pastaba",
      bank_account_primary: "Pagrindinė",
      bank_account_add: "+ Pridėti sąskaitą",
      bank_account_remove: "Pašalinti",
      next_order_date: "kito užsakymo data",
      "Select assigned user": "Priskirtas darbuotojas",
      label: "Pavadinimas",
      template: "Šablonas",
      files_types_card_description: "Kiekvienas dokumento tipas turi taisyklę, pagal kurią sistema pavadina jo failus.",
      files_types_add: "Nauja taisyklė",
      files_types_document: "Dokumentas",
      files_types_document_hint: "Kokio tipo dokumentas, pvz., Darbo sutartis. Šis pavadinimas rodomas renkantis dokumento tipą.",
      files_types_rule: "Pavadinimo taisyklė",
      files_types_rule_help: "Rašykite tekstą, o laukus rašykite riestiniuose skliaustuose — sistema juos pakeis dokumento duomenimis:",
      files_types_rule_template_fields: "Dokumentai, sukurti pagal šabloną, gali naudoti ir paties šablono formos laukus, pvz., {customFields.firstName}.",
      files_types_rule_example: "Pavyzdys",
      files_types_empty: "Failų pavadinimo taisyklių dar nėra.",
      files_types_placeholder_date: "dokumento data (metai-mėnuo-diena)",
      files_types_placeholder_number: "dokumento numeris",
      files_types_placeholder_series: "dokumento prefiksas",
      files_types_placeholder_customer: "kliento pavadinimas (keli klientai jungiami „_“)",
      files_types_placeholder_user: "darbuotojo vardas (keli darbuotojai jungiami „_“)",
      files_types_placeholder_company: "jūsų įmonės pavadinimas",
      files_types_placeholder_project: "projekto pavadinimas",
      files_types_placeholder_asset: "turto pavadinimas",
      files_types_placeholder_template: "šablono pavadinimas",
      files_types_placeholder_context: "tekstas iš dokumento lauko „Failo kontekstas“",
      files_types_placeholder_fuel_period: "kuro ataskaitos mėnuo",
      files_types_select: "Pasirinkite dokumento tipą",
      enter_file_context: "Įveskite objektą/kontekstą",
      groups_management: "Grupių valdymas",
      permissions: "Teisės",
      create: "Sukurti",
      manager: "Vadovas",
      totalWithVat: "Suma su PVM",
      totalWithoutVat: "Suma be PVM",
      period: "Laikotarpis",
      unknown_period: "Nenurodytas laikotarpis",
      expand_all: "Išskleisti viską",
      collapse_all: "Suskleisti viską",
      turnoverWithoutVat: "Apyvarta be PVM",
      debtWithVat: "Skola su PVM",
      sales_returns: "Grąžinimai",
      is_approval_required: "Reikalingas vadovo patvirtinimas",
      approval_required: "Reikalingas vadovo patvirtinimas",
      Are_you_sure_you_want_to_generate_questionnaire:
        "Ar tikrai norite generuoti ir siųsti anketą klientui?",
      save_and_approve: "Išsaugoti ir patvirtinti",
      Yes: "Taip",
      No: "Ne",
      approval_request: "Patvirtinti klientą",
      Are_you_sure_you_want_to_approve_customer:
        "Ar tikrai norite patvirtinti klientą",
      "customer_form-signer-position": "Pareigos / Position",
      "customer_form-signer-firstName": "Vardas / First name",
      "customer_form-signer-lastName": "Pavardė / Last name",
      "customer_form-signer-signerFullName":
        "Vardas, pavardė/ First and last name",
      "customer_form-signer_position_required":
        "Būtina nurodyti pareigas / Position is required",
      "customer_form-signer_firstName_required":
        "Būtina nurodyti vardą / First name is required",
      "customer_form-signer_lastName_required":
        "Būtina nurodyti pavardę / Last name is required",
      "customer_form-isVatPayer_required":
        "Privaloma pasirinkti PVM mokėtojo statusą / VAT payer status selection is required",
      "customer_form-invoice_valid_email_required":
        "Būtinas galiojantis el. pašto adresas / Valid email is required",
      "customer_form-invoice_secondary_email_invalid":
        "Įveskite galiojantį el. pašto adresą / Please enter a valid email address",
      "customer_form-contact_valid_email_required":
        "Būtinas galiojantis el. pašto adresas / Valid email is required",
      advance_invoice_deferral_days: "Avansinės sąskaitos atidėjimo dienos",
      invoice_deferral_days: "Sąskaitos atidėjimas, dienos",
      advance_payment_percent: "Avanso mokėjimo procentas",
      debt_limit: "Skolos limitas, Eur",
      penalty_percent: "Baudos procentas",
      storage_costs_per_unit: "Sandėliavimo išlaidos už vienetą",
      non_performance_percent: "Neįvykdymo procentas",
      dateTo: "Iki datos",
      Are_you_sure_you_want_to_send_document_signature_request:
        "Ar tikrai norite išsiųsti dokumento pasirašymo užklausą?",
      Are_you_sure_you_want_to_generate_and_send_finance_file_for_customer_sign:
        "Ar tikrai norite sugeneruoti ir išsiųsti pagrindinę sutartį?",
      generate_form_and_send_for_customer:
        "Sugeneruoti formą ir išsiųsti klientui",
      Finance: "Finansai",
      document_signature: "Dokumento pasirašymas",
      select_contact: "Pasirinkti kliento kontaktą",
      document_send_signature_request: "Siųsti pasirašymo prašymą",
      document_status: "Dokumento būsena",
      sign_status: "Pasirašymo būsena",
      contact_signer: "Kliento kontaktas",
      selected_user: "Pasirinktas darbuotojas",
      customer_contact: "Kliento kontaktas",
      select_assigned_user: "Pasirinkite priskirtą darbuotoją",
      is_valid_financial_approval_required:
        "Reikalingas finansinis patvirtinimas",
      signature_pending: "Laukiama parašo",
      finance_activated: "Pasirašyta",
      master_agreement: "Pagrindinė sutartis",
      master_agreement_description:
        "Pagrindinė sutartis yra dokumentas, kuriame nustatomos bendrosios sąlygos, taisyklės ir įsipareigojimai, taikomi šalims, sudarant tarpusavio sandorius.",
      master_agreement_approved: "Patvirtinta",
      master_agreement_not_approved: "Nepatvirtinta",
      Are_you_sure_you_want_to_request_to_sign_file:
        "Ar tikrai norite pateikti prašymą pasirašyti failą",
      no_manager_provided: "Vadovas nenurodytas",
      invalid_email_address: "Neteisingas el.paštas",
      // NEW: Annual Finance System translations
      finance_approvals: "Finansiniai patvirtinimai",
      create_new_year_approval: "Sukurti naujų metų patvirtinimą",
      year: "Metai",
      valid_until: "Galioja iki",
      view_details: "Peržiūrėti detales",
      view_details_for: "Peržiūrėti duomenis: {{name}}",
      active: "Aktyvus",
      expired: "Pasibaigęs",
      approved: "Patvirtinta",
      no_finance_approvals: "Nėra finansinių patvirtinimų",
      no_finance_approvals_description: "Sukurkite pirmąjį finansinį patvirtinimą šiam klientui",
      create_first_approval: "Sukurti pirmąjį patvirtinimą",
      create_new_year_approval_confirm: "Sukurti naujų metų patvirtinimą {{year}}?",
      finance_approval_expired: "Šis finansinis patvirtinimas pasibaigė",
      cannot_create_order: "Negalima sukurti sutarties",
      no_valid_finance_approval: "Nerasta galiojančio finansinio patvirtinimo",
      finance_approval: "Finansinis patvirtinimas",
      finance_year_invalid: "Nurodyti neteisingi finansiniai metai",
      sign_type: "Pasirašymo tipas",
      manual_sign: "Rankinis pasirašymas",
      upload_signed_document: "Įkelti pasirašytą dokumentą",
      sign_request: "Pasirašymo prašymas",
      select_signers: "Pasirinkite kas pasirašys",
      select_sign_permission_user: "Pasirinkite vadovą",
      select_contact_user: "Pasirinkite kontaktinį asmenį",
      contact_user: "Pardavėjo kontaktinis asmuo",
      sign_permission_user: "Pardavėjas",
      no_pending_approvals: "Nėra laukiančių patvirtinimų",
      addresses: "Adresai",
      address_add: "Sukurti adresą",
      address: "Pilnas adresas",
      subject: "Objektas",
      address_name: "Trumpas adreso pavadinimas",
      files_template_custom_type_address: "Adresas",
      files_template_custom_type_country: "Šalis",
      files_template_custom_type_business_trip: "Komandiruotė",
      files_template_custom_helper_text: "Pagalbinis tekstas",
      files_template_custom_helper_text_help: "Šis tekstas bus rodomas po įvesties lauku",
      enable_category_tree_rule: "Įjungti kategorijų medžio taisykles",
      membership_kind: "Narystės tipas",
      membership_kind_employee: "Darbuotojas",
      membership_kind_employee_hint: "Dirba pagal darbo sutartį. Matomas „Apie įmonę“ ir Personale.",
      membership_kind_authorized: "Įgaliotas asmuo",
      membership_kind_authorized_hint: "Dirba ne pagal darbo sutartį. Nematomas darbuotojų sąrašuose, bet gali pasirašyti dokumentus ir tvarkas.",
      membership_kind_guest: "Svečias",
      membership_kind_guest_hint: "Nematomas darbuotojų sąrašuose ir negali būti pasirinktas pasirašyti.",
      user_form_permissions_title: "Ką gali",
      user_form_permissions_hint: "Teisės iš pareigų suteikiamos automatiškai. Čia pažymėkite tik papildomas teises.",
      select_manager: "Pasirinkite vadovą",
      company_phone: "Darbinis telefonas",
      select_address: "Pasirinkite adresą",
      address_type: "Adreso tipas",
      company: "Įmonė",
      category_permission: "Kategorijų teisės",
      customer_permission: "Klientų teisės",
      cancel_form: "Atšaukti",
      Are_you_sure_you_want_to_cancel_questionnaire:
        "Ar tikrai norite atšaukti anketą?",
      email_to: "Gavėjas",
      email_subject: "Tema",
      email_resend: "Persiųsti",
      duplicate_signer_selected_choose_a_different_user:
        "Pasikartojantis pasirašytojas pasirinktas. Pasirinkite kitą vartotoją",
      selected_user_is_required: "Pasirinktas vartotojas yra privalomas",
      sign_type_is_required: "Pasirašymo tipas yra privalomas",
      contact_signer_is_required: "Kontaktinis pasirašantysis yra privalomas",
      date_is_required: "Data yra privaloma",
      template_is_required: "Šablonas yra privalomas",
      send_email: "Siųsti el. laišką",
      file_type_is_required: "Failo tipas yra privalomas",
      Are_you_sure_you_want_to_send_document_to_customer_by_email:
        "Ar tikrai norite išsiųsti dokumentą klientui el. paštu?",
      documents_signature_request: "Dokumento pasirašymo prašymas",
      Are_you_sure_you_want_to_cancel_signature_request:
        "Ar tikrai norite atšaukti pasirašymo prašymą?",
      cancel_sign_request: "Atšaukti pasirašymo prašymą",
      is_visible_in_profile: "Matomas asmeniniame kabinete",
      are_you_sure_you_want_to_sign_the_file:
        "Ar tikrai norite pasirašyti dokumentą?",
      sign: "Pasirašyti",
      are_you_sure_you_want_to_decline_document_signature_request:
        "Ar jūs tikrai norite atmesti dokumento pasirašymo užklausą",
      decline: "Atmesti",
      declined: "Atmesta",
      sign_request_to_manager: "Pasirašymo užklausa vadovui",
      manager_is_not_assigned_to_the_user: "Vartotojui nepriskirtas vadovas",
      "customer_form-signature_valid_email_required":
        "Būtinas galiojantis el. pašto adresas / Valid email is required",
      emails: "El. laiškai",
      resend: "Persiųsti el. laišką",
      repeat_email: "Pakartoti el. laišką",
      admin_actions: "Administratoriaus veiksmai / Admin actions",
      remove_signed_document: "Pašalinti pasirašytą dokumentą",
      remove_signed_document_description: "Pašalina įkeltą/pasirašytą dokumentą ir atstato originalų nepasirašytą failą bei parašų būseną..",
      remove_signed_document_confirm: "Ar tikrai norite pašalinti pasirašytą dokumentą? Šis veiksmas atšauks aktyvias pasirašymo užklausas ir atstatys pradinį failą.",
      remove_signed_document_success: "Pasirašytas dokumentas sėkmingai pašalintas",
      cancel_signer_request: "Atšaukti užklausą",
      cancel_signer_request_confirm:
        "Atšaukti pasirašymo užklausą {{name}}?",
      cancel_signer_request_signatures_kept:
        "Pasirašė: {{signed}} iš {{total}}. Jau surinkti parašai bus išsaugoti.",
      cancel_signer_request_success: "Pasirašymo užklausa atšaukta",
      cancel_signing_confirm:
        "Atšaukti visas laukiančias „{{name}}“ pasirašymo užklausas?",
      cancel_signing_hint:
        "Dokumentas dings iš nepasirašytų sąrašo. Jau surinkti parašai išsaugomi.",
      cancel_signing_success: "Pasirašymas atšauktas",
      cancel_signing_completed:
        "Laukiančios užklausos pašalintos — visi likę jau buvo pasirašę, todėl dokumentas dabar užbaigtas",
      cancel_signing_withdrawn:
        "Pasirašymas atšauktas. Dokumentą jau buvo pasirašę, todėl jis pažymėtas kaip atšauktas.",
      cancel_signing_failed:
        "Pasirašymo atšaukti nepavyko. Pabandykite dar kartą arba kreipkitės į administratorių.",
      cancel_signing_session_gone:
        "Pasirašymas atšauktas. Dokobit sesija jau buvo pasibaigusi, todėl dokumentą reikia pateikti pasirašyti iš naujo.",
      cancel_signing_partial:
        "Atšaukta {{removed}} iš {{total}} pasirašymo užklausų.",
      signing_history: "Priminimų istorija",
      file_not_found: "Dokumentas nerastas",
      // Document parent/attach (Desk #237) — codes returned by
      // PATCH /files/:id/parent, keyed by the same name as the code.
      parent_file_not_found: "Pasirinktas dokumentas nerastas",
      file_parent_self: "Dokumento negalima priskirti pačiam sau",
      file_parent_is_child:
        "Pasirinktas dokumentas pats yra vaikinis — pasirinkite pagrindinį dokumentą.",
      file_has_children:
        "Šis dokumentas turi savo vaikinių dokumentų, todėl jo negalima priskirti kitam dokumentui.",
      file_parent_managed_document:
        "Šis dokumentas valdomas modulio (užsakymas, komandiruotė, kuro ataskaita, įdarbinimas ar finansai) — jo perkelti negalima.",
      file_not_child:
        "Šis dokumentas neturi pagrindinio dokumento, nuo kurio būtų galima atsieti",
      file_category_required: "Pasirinkite bent vieną kategoriją.",
      invalid_category: "Ši kategorija netinkama naudoti",
      attach_to_document: "Priskirti prie dokumento",
      attach_to_document_search_placeholder:
        "Ieškokite dokumento pagal pavadinimą ar numerį",
      attach_to_document_confirm: "Priskirti",
      attach_to_document_suggestions: "Siūlomi dokumentai",
      attach_to_document_none_found: "Nerasta dokumentų",
      attach_to_document_type_more: "Įveskite bent 2 simbolius paieškai",
      attach_to_document_load_failed: "Nepavyko įkelti dokumentų",
      attach_to_document_success: "Priskirta: {{count}}",
      attach_to_document_failed: "Nepavyko priskirti: {{count}}",
      attach_to_document_failures_title: "Nepavyko priskirti:",
      make_main_document: "Padaryti pagrindiniu dokumentu",
      make_main_document_confirm: "Padaryti pagrindiniu",
      // Per-child-row document tree actions (Desk #237 follow-up) — same
      // move, phrased from the parent document's child list instead of the
      // document's own page.
      move_to_another_document: "Perkelti prie kito dokumento",
      make_separate_document: "Padaryti atskiru dokumentu",
      make_separate_document_confirm: "Padaryti atskiru",
      make_separate_document_hint:
        "Užpildykite laukus, kurių šiam dokumentui trūksta, prieš padarant jį atskiru dokumentu — čia palikti tušti laukai dokumente ir liks tušti.",
      make_separate_document_signed_note:
        "Dokumentas pasirašytas — laukų keisti negalima.",
      make_separate_document_patch_failed:
        "Dokumentas tapo atskiru, bet laukų išsaugoti nepavyko:",
      reminder_recipient_unknown: "Gavėjas nebežinomas",
      cancel_signing_forbidden:
        "Pasirašymą atšaukti gali tik dokumento savininkas, priskirtas naudotojas arba Master",
      cancel_signing_unsupported:
        "Šio tipo dokumento pasirašymo atšaukti negalima",
      nothing_to_cancel: "Laukiančių pasirašymo užklausų nėra",
      signers_progress: "Pasirašė",
      edit_sign_request_disabled_partial:
        "Dalis pasirašančiųjų jau pasirašė, todėl užklausos nebegalima redaguoti visos iš karto. Šalinkite arba pridėkite pasirašančiuosius po vieną.",
      click_sign_contacts_switch_hint:
        "„Click“ pasirašymas skirtas tik darbuotojams. Pažymėjus kliento kontaktą, pasirašymo būdas pasikeis į {{type}}.",
      customer_inherited_from_parent: "(iš pagrindinio dokumento)",
      signature_not_found: "Pasirašymo užklausa nerasta",
      signer_already_signed: "Šis asmuo jau pasirašė dokumentą",
      document_already_signed: "Dokumentas jau pilnai pasirašytas",
      batch_signature_not_supported:
        "Šis parašas yra grupinio pasirašymo dalis ir čia negali būti pašalintas",
      assets: "Materialinės vertybės",
      asset_name: "Pavadinimas",
      asset_type: "Tipas",
      asset_brand: "Gamintojas",
      asset_model: "Modelis",
      asset_serial: "Unikalus numeris",
      asset_in_use: "Naudojamas",
      asset_in_stock: "Sandėlyje",
      asset_broken: "Sugadintas",
      asset_purchase_date: "Įsigijimo data",
      asset_assign_user: "Priskirti darbuotoją",
      asset_assigned_to: "Priskirtas darbuotojas",
      asset_create: "Sukurti materialinę vertybę",
      asset_notes: "Pastabos",
      previous_assigned_user: "Prieš tai priskirtas darbuotojas",
      asset_assigned_user: "Priskirtas darbuotojas",
      assigned_date: "Priskyrimo data",
      asset_assigned_tracks: "Naudojimosi istorija",
      asset_status: "Turto statusas",
      checksum_files: "Rastos dokumento kopijos",
      pending_signatures: "Laukiančios parašų",
      no_pending_signatures: "Nėra laukiančių parašų",
      notification: "Pranešimas",
      asset_type_is_required: "Turto tipas yra privalomas",
      assets_types_select: "Pasirinkite turto tipą",
      assets_types_add: "Naujas tipas",
      assets_types_type: "Tipas",
      assets_types_empty: "Turto tipų dar nėra.",
      assets_types_requests_note: "Laiškus apie naujus turto prašymus gauna įmonės „Atsakingas už turtą“ (Nustatymai → Personalas); jei jis nepaskirtas – žmonės su teise „Turtas“.",
      notify_accountancy: "Pranešti buhalterijai",
      accountancy_user: "Buhalterijos vartotojas",
      select_accountancy_user: "Pasirinkti buhalterijos vartotoją",
      company_director: "Įmonės direktorius",
      select_director: "Pasirinkti direktorių",
      board_member: "Valdybos narys",
      select_board_member: "Pasirinkti valdybos narį",
      board_member_hint:
        "Pasirašo darbdavio pusėje, kai darbuotojas yra įmonės direktorius — tiek įdarbinant, tiek keičiant darbo sutartį",
      company_logo_title: "Logotipas",
      company_logo_hint: "Rodomas pardavimo sąskaitų viršuje kairėje. Geriausia PNG, 352 × 128 px, iki 300 KB.",
      company_logo_none: "Logotipas neįkeltas",
      company_logo_upload: "Įkelti",
      company_logo_remove: "Pašalinti",
      company_logo_wrong_type: "Naudokite PNG, JPEG arba SVG paveikslėlį.",
      company_logo_too_large: "Logotipas turi būti ne didesnis kaip 300 KB.",
      company_logo_load_failed: "Nepavyko įkelti logotipo.",
      company_logo_save_failed: "Nepavyko atnaujinti logotipo.",
      settings_company_details_title: "Įmonės duomenys",
      settings_company_details_lead: "Pardavėjo ar darbdavio duomenys dokumentuose.",
      settings_company_name_label: "Pavadinimas sistemoje",
      settings_company_name_hint: "Rodomas meniu ir sąrašuose.",
      settings_company_legal_name_label: "Teisinis pavadinimas",
      settings_company_legal_name_hint: "Spausdinamas dokumentuose.",
      settings_company_code_label: "Įmonės kodas",
      settings_company_vat_label: "PVM mokėtojo kodas",
      settings_company_address_label: "Adresas",
      settings_company_contact_email_label: "El. paštas",
      settings_company_contact_email_hint: "Rodomas sąskaitų laiškuose; klientų atsakymai ateina čia.",
      settings_company_contact_email_invalid: "Įveskite teisingą el. pašto adresą",
      settings_company_contact_phone_label: "Telefonas",
      settings_company_contact_phone_hint: "Rodomas sąskaitų laiškuose.",
      settings_company_bank_label: "Bankas",
      settings_company_iban_label: "Banko sąskaita (IBAN)",
      settings_company_description_label: "Aprašymas",
      settings_company_field_required: "Privaloma užpildyti",
      email_sent_successfully: "El. laiškas sėkmingai išsiųstas",
      no_files_to_review: "Nėra failų peržiūrai",
      pending_signature: "Dokumentas pasirašymui",
      no_expiring_documents: "Nėra pasibaigiančių dokumentų",
      expiring_documents_description:
        "Jums priskirti dokumentai, kurie pasibaigs per artimiausius 30 dienų",
      expiring_soon: "Greitai pasibaigia",
      expiring: "Pasibaigia",
      no_date: "Nėra datos",
      expiration_date: "Pasibaigimo data",
      are_you_sure_you_want_mark_as_reviewed:
        "Ar tikrai norite pažymėti kaip peržiūrėtą?",
      to_review: "Peržiūrai",
      edit_sign_request: "Redaguoti pasirašymo užklausą",
      mark_as_reviewed: "Pažymėti kaip peržiurėtą",
      signature: "pasirašyti",
      review_by: "Peržiūrėjo",
      no_review_required: "Peržiūra_nereikalinga",
      review_required_by: "Siųsti peržiūrai",
      OrderForm: "Užsakymo forma",
      customer_hide: "Paslėpti klientus",
      is_hide: "Paslėptas",
      required_within_days: "Dokumentai įkeliami per",
      finance_document_should_be_sign:
        "Pagrindinė sutartis turi būti pasirašyta.",
      not_initiate: "Neinicijuota",
      document_is_signed_edit_is_not_allowed:
        "Dokumentas pasirašytas – redaguoti neleidžiama",
      select_products: "Pasirinkti prekes",
      generate_order_document: "Sugeneruoti užsakymo dokumentą",
      sign_the_order: "Pasirašyti užsakymą",
      invoice_customer: "Išrašyti sąskaitą",
      soon: "Jau greitai ;)",
      product_name: "Pavadinimas",
      no_documents_found: "Dokumentų nerasta",
      internal_order_number: "Numeris",
      are_you_sure_you_want_in_stock_asset:
        "Ar tikrai norite grąžinti materialinės į sandėlį",
      assign_asset: "Priskirti",
      signature_status: "Pasirašymo būsena",
      assignation_info: "Priskyrimo informacija",
      not_assigned: "Ne priskirta",
      the_asset_will_be_assigned_once_the_document_is_signed:
        "Materialinės bus priskirtas, kai dokumentas bus pasirašytas",
      return_asset: "Grąžinti",
      edit_asset: "Koreguoti",
      return_info: "Grąžinti informaciją",
      not_returned: "Negrąžinta",
      "customer_form-name_too_long":
        "Pavadinimas per ilgas(maks. 255 simboliai) / Name is too long(max. 255 characters)",
      "customer_form-companyCode_too_long":
        "Įmonės kodas per ilgas(maks. 250 simbolių) / Company code is too long(max. 250 characters)",
      "customer_form-phone_too_long":
        "Telefono numeris per ilgas(maks. 20 simbolių) / Phone number is too long(max. 20 characters)",
      "customer_form-email_too_long":
        "El. paštas per ilgas(maks. 255 simboliai) / Email is too long(max. 255 characters)",
      "customer_form-address_too_long":
        "Adresas per ilgas(maks. 255 simboliai) / Address is too long(max. 255 characters)",
      "customer_form-bankName_too_long":
        "Banko pavadinimas per ilgas(maks. 100 simbolių) / Bank name is too long(max. 100 characters)",
      "customer_form-iban_too_long":
        "IBAN per ilgas(maks. 100 simbolių) / IBAN is too long(max. 100 characters)",
      "customer_form-signatureFullName_too_long":
        "Pavadinimas per ilgas(maks. 100 simbolių) / Name is too long(max. 100 characters)",
      "customer_form-signaturePosition_too_long":
        "Pareigos per ilgos(maks. 100 simbolių) / Position is too long(max. 100 characters)",
      "customer_form-signatureEmail_too_long":
        "El. paštas per ilgas(maks. 255 simboliai) / Email is too long(max. 255 characters)",
      "customer_form-contactFullName_too_long":
        "Pavadinimas per ilgas(maks. 50 simbolių) / Name is too long(max. 50 characters)",
      "customer_form-contactPhone_too_long":
        "Telefono numeris per ilgas(maks. 20 simbolių) / Phone number is too long(max. 20 characters)",
      "customer_form-contactPosition_too_long":
        "Pareigos per ilgos(maks. 255 simboliai) / Position is too long(max. 255 characters)",
      "customer_form-contactEmail_too_long":
        "El. paštas per ilgas(maks. 255 simboliai) / Email is too long(max. 255 characters)",
      "customer_form-paymentsFullName_too_long":
        "Pavadinimas per ilgas(maks. 50 simbolių) / Name is too long(max. 50 characters)",
      "customer_form-paymentsPhone_too_long":
        "Telefono numeris per ilgas(maks. 20 simbolių) / Phone number is too long(max. 20 characters)",
      "customer_form-paymentsPosition_too_long":
        "Pareigos per ilgos(maks. 255 simboliai) / Position is too long(max. 255 characters)",
      "customer_form-paymentsEmail_too_long":
        "El. paštas per ilgas(maks. 255 simboliai) / Email is too long(max. 255 characters)",
      "customer_form-iban2_too_long":
        "IBAN2 per ilgas(maks. 100 simbolių) / IBAN2 is too long(max. 100 characters)",
      "customer_form-vatCode_too_long":
        "PVM kodas per ilgas(maks. 100 simbolių) / VAT code is too long(max. 100 characters)",
      "customer_form-website_too_long":
        "Interneto svetainės adresas per ilgas(maks. 255 simboliai) / Website address is too long(max. 255 characters)",
      "customer_form-officeAddress_too_long":
        "adresas per ilgas(maks. 255 simboliai) / Address is too long(max. 255 characters)",
      "customer_form-region_too_long":
        "Rajonas per ilgas(maks. 255 simbolių) / Region is too long(max. 255 characters)",
      "customer_form-swiftCode_too_long":
        "SWIFT kodas per ilgas(maks. 100 simbolių) / SWIFT code is too long(max. 100 characters)",
      "customer_form-valid_iban2_required":
        "Būtinas laukelis / This field is required",
      "operation not allowed: asset is currently assigned":
        "Operacija neleidžiama: turtas šiuo metu yra priskirtas.",
      acceptance_transfer_act: "Priėmimo-perdavimo aktas",
      select_the_user: "Pasirinkti darbuotoją",
      related_files: "Susiję failai",
      document_permit_settings: "Dokumento leidimo nustatymai",
      email_must_be_correct: "El. paštas turi būti teisingas",
      create_company_form: "Sukurti įmonę",
      asset_force_return: "Grąžinti priverstinai",
      show_more: "Rodyti daugiau",
      select_signature_types: "Pasirinkite parašų tipus",
      upload_fuel_report: "Įkelti ataskaitą",
      create_fuel_report: "Pildyti ataskaitą",
      edit_fuel_report: "Atnaujinti kuro ataskaitą",
      generate_fuel_report: "Sugeneruoti kuro dokumentą",
      sign_the_fuel_report: "Pasirašyti kuro dokumentą",
      fuel_consumption: "Sunaudota kuro (ltr)",
      mileage: "Nuvažiuota rida (km)",
      ev_charge_kw: "EV įkrovos kWh",
      amount: "Suma (EUR)",
      fuel_records: "Kuro įrašai",
      fuel_reports: "Kuro ataskaitos",
      uploaded_transactions: "Įkeltos operacijos",
      // Rezultatų juosta po kuro CSV įkėlimo
      fuel_import_headline: "Įkelta: {{parts}}",
      fuel_import_inserted_one: "{{count}} nauja",
      fuel_import_inserted_few: "{{count}} naujos",
      fuel_import_inserted_other: "{{count}} naujų",
      fuel_import_updated_one: "{{count}} atnaujinta",
      fuel_import_updated_few: "{{count}} atnaujintos",
      fuel_import_updated_other: "{{count}} atnaujintų",
      fuel_import_skipped_one: "{{count}} praleista",
      fuel_import_skipped_few: "{{count}} praleistos",
      fuel_import_skipped_other: "{{count}} praleistų",
      fuel_import_converted_one:
        "{{count}} operacija perskaičiuota į EUR pagal Lietuvos banko kursą čekio dieną",
      fuel_import_converted_few:
        "{{count}} operacijos perskaičiuotos į EUR pagal Lietuvos banko kursą čekio dieną",
      fuel_import_converted_other:
        "{{count}} operacijų perskaičiuota į EUR pagal Lietuvos banko kursą čekio dieną",
      fuel_import_missing_card_or_date:
        "Eilutės be kortelės numerio (pvz. komisiniai mokesčiai) praleistos: {{rows}}",
      fuel_import_missing_card_or_date_unnumbered:
        "Eilutės be kortelės numerio (pvz. komisiniai mokesčiai) praleistos",
      fuel_import_card_damaged:
        "Sugadintas kortelės numeris (failas atidarytas Excel?) — įkelkite originalų failą.",
      fuel_import_fx_unavailable:
        "Nepavyko gauti valiutos kurso ({{pairs}}) — įkelkite failą vėliau, šios eilutės bus pridėtos.",
      fuel_import_fx_unavailable_generic:
        "Nepavyko gauti valiutos kurso — įkelkite failą vėliau, šios eilutės bus pridėtos.",
      fuel_import_save_failed: "Nepavyko išsaugoti: {{error}}",
      fuel_import_rows_label: "Eilutės: {{rows}}",
      fuel_import_rows_inline: "(eilutės: {{rows}})",
      fuel_import_unknown_error: "Nežinoma klaida",
      fuel_import_more_errors: "Kitų klaidų: {{count}}",
      fuel_import_rows_more: "ir dar {{count}}",
      fuel_import_failed: "Nepavyko įkelti failo: {{message}}",
      fuel_import_failed_generic: "Nepavyko įkelti failo. Bandykite dar kartą.",
      record_type: "Tipas",
      type_fuel: "Kuras",
      type_additional: "Papildoma",
      add_to_fuel_list: "Pridėti į kuro sąrašą",
      add_to_fuel_list_success: "„{{value}}“ pridėta į kuro sąrašą",
      add_to_fuel_list_reactivated:
        "„{{value}}“ buvo neaktyvi ir vėl įjungta kuro sąraše",
      add_to_fuel_list_error:
        "Nepavyko pridėti į kuro sąrašą. Bandykite dar kartą.",
      add_to_fuel_list_master_required:
        "Kuro sąrašą gali keisti tik Master vartotojai.",
      add_to_fuel_list_permission_required:
        "Kuro sąrašą gali keisti Master arba Access fuel reports teises turintys vartotojai.",
      in_fuel_list: "Kuro sąraše",
      delete_fuel_record: "Ištrinti",
      delete_fuel_record_title: "Ištrinti operaciją",
      delete_fuel_record_confirmation:
        "Ištrinti {{date}} operaciją, kortelė {{card}}, {{amount}} EUR? Tos kortelės ir mėnesio kuro ataskaitos bus perskaičiuotos, bet jų dokumentus reikės sugeneruoti iš naujo.",
      delete_fuel_record_success: "Operacija ištrinta",
      delete_fuel_record_reports_recalculated:
        "Operacija ištrinta. Perskaičiuota kuro ataskaitų: {{count}} — sugeneruokite jų dokumentus iš naujo.",
      delete_fuel_record_error: "Nepavyko ištrinti operacijos. Bandykite dar kartą.",
      records: "Įrašai",
      asset: "Materialinės vertybės",
      end_of_month_km: "Mėnesio pabaigos rida (km)",
      end_of_month_ltr: "Mėnesio pabaigos kuras (ltr)",
      asset_select: "Pasirinkite turtą",
      year_month_select: "Metai/Mėnuo",
      asset_select_car: "Pasirinkite automobilį",
      fuel_card_select: "Pasirinkite kuro kortelę",
      asset_is_required: "Materialinės vertybės yra privalomas",
      fuel_card_is_required: "Kuro kortelė yra privaloma",
      end_of_month_km_required: "Mėnesio pabaigos rida yra privaloma",
      end_of_month_ltr_required: "Mėnesio pabaigos kuras yra privalomas",
      start_of_month_km: "Mėnesio pradžiai (km)",
      start_of_month_ltr: "Mėnesio pradžiai (ltr)",
      start_of_month_km_required: "Mėnesio pradžios km yra privalomas",
      start_of_month_ltr_required: "Mėnesio pradžios ltr yra privalomas",
      end_km_must_be_greater_than_start:
        "Mėnesio pabaigos km turi būti didesnis nei pradžios",
      card_user: "Kortelės naudotojas",
      card_no: "Kortelės numeris",
      place: "Vieta",
      receipt_number: "Kvito numeris",
      fuel_type: "Kuro tipas",
      // mobile: documents-modules
      category_access_subcategories: "Subkategorijos",
      fuel_type_benzinas: "Benzinas",
      fuel_type_benzinas_elektra: "Benzinas + Elektra",
      fuel_type_dyzelinas: "Dyzelinas",
      fuel_type_dyzelinas_elektra: "Dyzelinas + Elektra",
      fuel_type_elektra: "Elektra",
      manual_fuel_expenses: "Rankiniai kuro išlaidų įrašai",
      add_manual_expense: "Pridėti rankinį išlaidų įrašą",
      edit_manual_expense: "Redaguoti rankinį išlaidų įrašą",
      delete_manual_expense: "Pašalinti rankinį išlaidų įrašą",
      expense_type: "Išlaidų tipas",
      expense_type_fuel: "Kuras",
      expense_type_additional: "Papildomos išlaidos",
      expense_type_other: "Kitos išlaidos",
      manual_expenses: "Rankinės išlaidos",
      measurement_unit: "Matavimo vienetas",
      upload_file: "Įkelti failą",
      file_upload_empty:
        "Failas tuščias (0 KB). Atsidarykite jį savo kompiuteryje, patikrinkite ir įkelkite iš naujo.",
      document_file_empty:
        "Dokumento failas tuščias (0 KB), todėl jo negalima siųsti pasirašyti. Įkelkite failą iš naujo ir bandykite dar kartą.",
      owner_must_sign_first: "Pirmiausia dokumentą turi pasirašyti darbuotojas.",
      replace_file: "Pakeisti failą",
      manual_fuel_records: "Rankiniai kuro įrašai",
      manual_additional_expenses: "Rankinės papildomos išlaidos",
      no_manual_expenses: "Rankinių išlaidų nerasta",
      no_manual_expenses_please_add: "Rankinių išlaidų dar nepridėta. Spustelėkite 'Pridėti rankinį išlaidų įrašą', norint pridėti.",
      is_fuel_details_required: "Reikalinga degalų informacija",
      fuel_consumption_per_month_ltr: "Sunaudota kuro per mėnesį (ltr)",
      mileage_per_month_km: "Rida per mėnesį (km)",
      winter_period_fuel_rate:
        "Žiemos laikotarpio kuro norma(lapkričio-kovo mėnesiai)",
      summer_period_fuel_rate:
        "Vasaros laikotarpio kuro norma(balandžio-spalio mėnesiai)",
      winter_period_electric_rate:
        "Žiemos laikotarpio elektros norma (kWh/100 km, lapkričio-kovo mėnesiai)",
      summer_period_electric_rate:
        "Vasaros laikotarpio elektros norma (kWh/100 km, balandžio-spalio mėnesiai)",
      work_purpose_km_required: "Nuvažiuota darbo laiku yra privaloma",
      work_purpose_km: "Nuvažiuota darbo laiku (km)",
      work_purpose_km_from_rate:
        "Apskaičiuota iš kWh ir elektros normos (kWh/100 km). Galima taisyti.",
      work_purpose_km_exceeds_monthly_mileage:
        "Darbo laiku nuvažiuota rida negali viršyti mėnesio ridos",
      non_work_purpose_km: "Nuvažiuota kitu (ne darbo) metu (km)",
      non_work_purpose_km_computed:
        "Kitu (ne darbo) metu (apskaičiuota): {{km}} km",
      ev_charge_amount: "Suma (EUR)",
      add_more_signers: "Pridėti parašų",
      Are_you_sure_you_want_add_signers: "Ar tikrai norite pridėti parašus",
      invoice: "sąskaita",
      grounds_for_representation: "Atstovavimo pagrindas",
      invoice_email: "El. paštas sąskaitų siuntimui",
      secondary_email: "Papildomas el. paštas",
      reason_for_decline_signature: "Atsisakymo priežastis",
      annul_report: "Anuliuoti ataskaitą",
      are_you_sure_you_want_to_annul_report:
        "Ar tikrai norite anuliuoti šią ataskaitą?",
      annul_report_warning:
        "Jei ataskaitos dokumentas buvo iki galo pasirašytas, jis lieka sistemoje pažymėtas ANULIUOTA, o visi pasirašiusieji gauna pranešimą el. paštu; priešingu atveju jis ištrinamas. Bet kuriuo atveju ataskaitos duomenys išliks – juos bus galima sugeneruoti ir pasirašyti iš naujo.",
      annul_report_reason: "Anuliavimo priežastis",
      annul_report_reason_placeholder:
        "Nurodykite, kodėl ataskaita anuliuojama",
      report_annulled_success_title: "Ataskaita anuliuota",
      report_annulled_success_instruction:
        "Jei ataskaitos dokumentas buvo iki galo pasirašytas, jis liko sistemoje pažymėtas ANULIUOTA, o pasirašiusieji gavo pranešimą; priešingu atveju jis ištrintas. 3 žingsnyje sugeneruokite ataskaitos dokumentą iš naujo ir jį turi pasirašyti visos šalys.",
      please_provide_a_reason_for_declining_the_signature_request:
        "Prašome nurodyti atsisakymo priežastį",
      show_limited: "Rodyti ribotus klientus",
      show_all_customers: "Rodyti visus klientus",
      signontab_select_tablet_user: "Pasirinkite SignOnTab įrangą",
      username: "Vartotojo vardas",
      password: "Slaptažodis",
      requiredFields: "Prašome užpildyti visus privalomus laukus.",
      signontab_users_card_description: "Planšetės, ant kurių pasirašoma ranka (SignOnTab). Siunčiant dokumentą pasirenkama, į kurią planšetę jį siųsti.",
      signontab_users_add: "Nauja įranga",
      signontab_users_name: "Pavadinimas",
      signontab_users_username: "Prisijungimo vardas",
      signontab_users_password: "Slaptažodis",
      signontab_users_password_edit_hint: "Esamas slaptažodis nerodomas. Norėdami išsaugoti pakeitimus, įveskite esamą arba naują slaptažodį.",
      signontab_users_empty: "SignOnTab įrangos dar nėra.",
      additional_expenses: "Papildomos išlaidos",
      edit_email: "Redaguoti el. paštą",
      update_email: "Atnaujinti el. paštą",
      email_updated_successfully: "El. paštas sėkmingai atnaujintas",
      email_confirmation_sent:
        "Patvirtinimo nuoroda išsiųsta adresu {{email}}. El. paštas pasikeis, kai ją atidarysite.",
      error_updating_email:
        "Nepavyko atnaujinti el. pašto. Bandykite dar kartą.",
      error_loading_user: "Nepavyko įkelti vartotojo duomenų",
      email_required: "El. paštas yra privalomas",
      email_already_exists: "Šis el. paštas jau naudojamas",
      network_error:
        "Ryšio problema. Patikrinkite interneto ryšį ir bandykite dar kartą.",
      refuse_report: "Atmesti ataskaitą",
      refuse_fuel_report_confirmation_message:
        "Ar tikrai norite atmesti šią kuro ataskaitą?",
      error_refusing_fuel_report:
        "Nepavyko atmesti kuro ataskaitos. Bandykite dar kartą.",
      no_permission_to_refuse: "Neturite teisių atmesti šios ataskaitos",
      fuel_report_not_found: "Kuro ataskaita nerasta",
      missing_required_data: "Trūksta privalomų duomenų",
      refuse_only_after_signed:
        "Ataskaitą galima atmesti tik tada, kai ji yra pasirašyta",
      are_you_sure_you_want_to_remove: "Ar tikrai norite pašalinti",
      are_you_sure_you_want_to_add: "Ar tikrai norite pridėti",
      from_favorites: "iš mėgstamųjų",
      to_favorites: "į mėgstamuosius",
      add_to_favorites: "Pridėti į mėgstamuosius",
      remove_from_favorites: "Pašalinti iš mėgstamųjų",
      favorite_categories: "Mėgstamosios kategorijos",
      filters: "Filtras",
      apply_filters: "Taikyti filtrus",
      clear: "Išvalyti",
      preparing_filters: "Ruošiami filtrai…",
      user_search: "Ieškoti darbuotojo…",
      customer_search: "Ieškoti kliento…",
      applied_filters: "Taikomi filtrai",
      clear_all_filters: "Išvalyti visus filtrus",
      unsigned_assigned_documents: "Nepasirašyti priskirti dokumentai",
      no_unsigned_documents: "Nėra nepasirašytų dokumentų",
      not_signed: "Nepasirašyta",
      signature_request_date: "Pasirašymo prašymo data",
      are_you_sure_you_want_to_save_finance_approval_and_notify_manager:
        "Ar tikrai norite išsaugoti finansinį patvirtinimą ir pranešti vadovui?",
      request_sent_to_manager_for_approval:
        "Užklausa išsiųsta vadovui patvirtinimui.",
      are_you_sure_you_want_to_save_and_approve_finance:
        "Ar tikrai norite išsaugoti ir patvirtinti sąlygas?",
      finance_terms_approved: "Sąlygos patvirtintos",
      finance_document_regenerate_failed:
        "Sąlygos patvirtintos, bet dokumento atnaujinti nepavyko. Bandykite dar kartą.",
      reminder: "Priminti",
      reminders: "Priminimai",
      reminder_schedule: "Priminimų periodiškumas",
      next_reminder_date: "Kitas priminimas",
      reminders_sent_count: "Išsiųsta priminimų",
      reminders_disabled_short: "Išjungta",
      next_reminder_short: "Kitas:",
      sent_short: "Išsiųsta",
      reminder_overdue: "Vėluoja",
      waiting_days: "Laukia",
      days_short: "d.",
      dokobit_session_expiring: "Dokobit sesija baigsis po {{count}} d.",
      dokobit_session_expired: "Dokobit sesija baigėsi",
      dokobit_session_expires_at: "Dokobit saugo dokumentą iki {{date}}",
      product_group_code_help: "Trumpas grupės kodas (unikalus įmonėje).",
      amendments: "Užsakymo pakeitimai",
      reminder_settings: "Priminimų nustatymai",
      enable_automatic_reminders: "Įjungti automatinius priminimus",
      days_between_reminders: "Dienos tarp priminimų",
      select_days: "Pasirinkite dienas",
      days: "dienos",
      reminder_day: "diena",
      reminder_days: "dienos",
      sent_reminders: "Išsiųsti priminimai",
      reminder_number: "Nr.",
      reminder_date: "Data",
      reminder_recipients: "Gavėjai",
      no_reminders_sent_yet: "Priminimų dar neišsiųsta",
      failed_to_load_reminder_data:
        "Nepavyko įkelti priminimų duomenų. Bandykite dar kartą.",
      days_between_reminders_validation:
        "Dienų tarp priminimų skaičius turi būti nuo 1 iki 7.",
      days_between_reminders_required:
        "Įjungus automatinius priminimus, būtina pasirinkti dienas tarp priminimų.",
      reminder_settings_updated_successfully:
        "Priminimų nustatymai sėkmingai atnaujinti",
      failed_to_save_settings:
        "Nepavyko išsaugoti nustatymų. Bandykite dar kartą.",
      vat_check: "PVM patikra",
      vat_check_description:
        "Spustelėkite mygtuką žemiau, kad atliktumėte automatinę PVM patikrą, tada įkelkite patikros rezultato ekrano kopiją.",
      vat_check_automatic: "Automatinė PVM patikra",
      vat_check_manual: "Patikrinti PVM išorinėje sistemoje",
      vat_check_manual_upload: "Įkelti PVM patikros rezultatą",
      vat_check_upload_description:
        "Prašome įkelti ekrano kopiją arba PDF failą su PVM patikros rezultatu.",
      vat_check_confirmed: "PVM galioja",
      vat_check_pending: "PVM patikra laukiama",
      vat_check_invalid: "PVM negalioja",
      perform_vat_check: "Atlikti automatinę PVM patikrą",
      status: "Statusas",
      datetime: "Data ir laikas",
      document: "Dokumentas",
      no_file_uploaded: "Failas neįkeltas",
      files_template_custom_type_file: "Failas",
      upload_files: "Įkelti failus",
      uploaded_files: "Įkelti failai",
      replace: "Pakeisti",
      close: "Uždaryti",
      view_products: "Peržiūrėti produktus",
      invoice_products: "Sąskaitos produktai",
      product_groups: "Produktų grupės",
      product_group: "Produktų grupė",
      create_product_group: "Sukurti produktų grupę",
      edit_product_group: "Redaguoti produktų grupę",
      select_type: "Pasirinkti tipą",
      search_product_groups: "Ieškoti produktų grupių",
      select_product_group: "Pasirinkite produktų grupę",
      search_product_groups_placeholder: "Ieškoti produktų grupių...",
      selected_product_groups: "Pasirinktos produktų grupės",
      products_from_group: "Produktai iš grupės",
      select_products_from_group: "Pasirinkti produktus",
      add_selected_products: "Pridėti pasirinktus produktus",
      select_products_from_group_description: "Pasirinkite produktus iš šios grupės, kuriuos norite pridėti prie užsakymo",
      no_products_in_group: "Šioje grupėje nėra produktų",
      code: "Kodas",
      // Feed/Posts translations
      feed_comment: "Komentaras",
      feed_comments: "Komentarai",
      feed_reply: "Atsakyti",
      feed_replies: "atsakymai",
      feed_reply_singular: "atsakymas",
      feed_edit: "Redaguoti",
      feed_delete: "Ištrinti",
      feed_confirm_delete: "Patvirtinti ištrynimą",
      feed_deleting: "Ištrinama...",
      feed_cancel: "Atšaukti",
      feed_show_more: "Rodyti daugiau",
      feed_show_less: "Rodyti mažiau",
      feed_show_more_capital: "Rodyti daugiau",
      feed_show_less_capital: "Rodyti mažiau",
      feed_view_reply_singular: "Rodyti {{count}} atsakymą",
      feed_view_replies_plural: "Rodyti {{count}} atsakymus",
      feed_hide_replies: "Slėpti atsakymus",
      feed_posting: "Paskelbiama...",
      feed_updating: "Atnaujinama...",
      feed_reply_to: "Atsakyti {{name}}...",
      feed_edit_comment: "Redaguoti komentarą...",
      feed_edit_comment_max: "Redaguoti komentarą... (maks. {{limit}} simbolių)",
      feed_write_comment: "Rašyti komentarą...",
      feed_write_comment_max: "Rašyti komentarą... (maks. {{limit}} simbolių)",
      feed_edited: "(redaguota)",
      feed_no_comments_yet: "Dar nėra komentarų. Būkite pirmas, kuris pakomentuoja!",
      feed_load_more_comments: "Įkelti daugiau komentarų",
      feed_loading: "Kraunama...",
      feed_more_options: "Daugiau parinkčių",
      feed_close: "Uždaryti",
      feed_previous: "Ankstesnis",
      feed_next: "Kitas",
      feed_post_image: "Pranešimo vaizdas {{index}}",
      feed_thumbnail: "Miniatiūra {{index}}",
      feed_comment_length_error: "Komentaras turi būti ne ilgesnis nei {{limit}} simbolių. Dabar: {{current}}",
      feed_reply_length_error: "Atsakymas turi būti ne ilgesnis nei {{limit}} simbolių. Dabar: {{current}}",
      feed_user: "Vartotojas",
      feed_whats_on_mind: "Ką galvojate?",
      feed_photo: "Nuotrauka",
      feed_post: "Paskelbti",
      feed_group_post: "Grupės pranešimas",
      feed_save: "Išsaugoti",
      feed_saving: "Išsaugoma...",
      feed_only_images_allowed: "Leidžiami tik vaizdo failai (JPG, PNG, WEBP)",
      feed_file: "Failas {{index}}",
      feed_failed_to_load_posts: "Nepavyko įkelti pranešimų",
      feed_failed_to_load_news_context: "Nepavyko įkelti srauto nustatymų",
      feed_reply_placeholder: "Atsakyti {{name}}... (maks. {{limit}} simbolių)",
      feed_recently: "neseniai",
      feed_refresh: "Atnaujinti",
      feed_failed_to_create_post: "Nepavyko sukurti pranešimo",
      feed_failed_to_upload_files: "Nepavyko įkelti failų. Bandykite dar kartą.",
      feed_failed_to_update_comment: "Nepavyko atnaujinti komentaro",
      feed_no_posts_yet: "Pranešimų dar nėra",
      feed_be_first_to_share: "Būkite pirmas, kuris pasidalins kažkuo su komanda!",
      feed_all_caught_up: "Viskas peržiūrėta! 🎉",
      feed_editing: "redaguojama...",
      feed_permission_required: "Reikalingas leidimas",
      feed_feed_write_permission_required: "Šiam veiksmui atlikti reikalingas 'Feed Write' leidimas",
      feed_filter_label: "Rodyti įrašus",
      feed_filter_whole_group: "Visa grupė",
      company_selector_group_companies: "Grupės įmonės",
      about_visitor_legal_name: "Teisinis pavadinimas",
      about_visitor_employees: "Darbuotojai",
      about_visitor_no_employees: "Nėra darbuotojų, kuriuos būtų galima rodyti",
      about_visitor_work_phone: "Darbinis telefonas",
      // News page: header and sidebar
      news_greeting_morning: "Labas rytas",
      news_greeting_day: "Laba diena",
      news_greeting_evening: "Labas vakaras",
      news_absent_summary_one: "šiandien nėra {{count}} kolegos",
      news_absent_summary_few: "šiandien nėra {{count}} kolegų",
      news_absent_summary_other: "šiandien nėra {{count}} kolegų",
      news_sidebar_absent_title: "Šiandien nėra",
      news_sidebar_new_colleagues_title: "Nauji kolegos",
      news_sidebar_anniversaries_title: "Darbo metinės",
      news_absent_trip: "Komandiruotė",
      news_absent_leave: "Atostogos",
      news_until: "iki {{date}}",
      news_since: "nuo {{date}}",
      news_today: "šiandien",
      news_years_one: "{{count}} metai",
      news_years_few: "{{count}} metai",
      news_years_other: "{{count}} metų",
      news_more_people_one: "+{{count}} kitas",
      news_more_people_few: "+{{count}} kiti",
      news_more_people_other: "+{{count}} kitų",
      news_sidebar_events_title: "Renginiai",
      news_events_empty: "Artimiausių renginių nėra",
      news_events_create: "Sukurti renginį",
      news_event_composer_toggle: "Renginys",
      news_event_title_label: "Pavadinimas",
      news_event_date_label: "Data",
      news_event_time_label: "Laikas",
      news_event_location_label: "Vieta (nebūtina)",
      news_event_going: "Dalyvausiu",
      news_event_not_going: "Negalėsiu",
      news_event_going_count: "Dalyvauja {{count}}",
      news_event_past: "Įvyko",
      news_event_response_failed: "Nepavyko išsaugoti atsakymo",
      news_pinned_badge: "Prisegta",
      news_important_checkbox: "Svarbi informacija",
      news_important_badge: "Svarbu",
      news_details_add: "+ Pridėti išsamų aprašymą",
      news_details_placeholder: "Išsamus aprašymas – rodomas paspaudus „Rodyti daugiau“",
      news_details_remove: "Pašalinti išsamų aprašymą",
      news_pin_action: "Prisegti",
      news_unpin_action: "Atsegti",
      news_pin_dialog_title: "Prisegti pranešimą viršuje",
      news_pin_requires_ack: "Reikia susipažinti",
      news_pin_failed: "Nepavyko išsaugoti prisegimo",
      news_ack_button: "Susipažinau",
      news_ack_done: "Susipažinote",
      news_ack_count: "Susipažino {{done}} iš {{total}}",
      news_ack_failed: "Nepavyko išsaugoti pažymos",
      news_ack_pending_link: "Kas dar nesusipažino",
      news_ack_dialog_title: "Kas susipažino su pranešimu",
      news_ack_acknowledged_heading: "Susipažino ({{number}})",
      news_ack_pending_heading: "Dar nesusipažino ({{number}})",
      news_ack_nobody_acknowledged: "Kol kas niekas",
      news_ack_nobody_pending: "Visi susipažino",
      news_ack_load_failed: "Nepavyko įkelti sąrašo",
      news_reaction_like: "Patinka",
      news_reaction_celebrate: "Sveikinu",
      news_reaction_love: "Myliu",
      news_reactions_who: "Kas reagavo",
      news_reactions_none_yet: "Dar nėra reakcijų",
      news_reactions_load_failed: "Nepavyko įkelti sąrašo",
      news_reaction_failed: "Nepavyko išsaugoti reakcijos",
      news_sidebar_birthdays_title: "Gimtadieniai",
      news_birthday_summary_one: "{{count}} gimtadienis šiandien",
      news_birthday_summary_few: "{{count}} gimtadieniai šiandien",
      news_birthday_summary_other: "{{count}} gimtadienių šiandien",
      birthday_card_title: "Gimtadienis",
      birthday_card_hint: "Saugoma tik diena ir mėnuo, niekada metai ar amžius.",
      birthday_month_label: "Mėnuo",
      birthday_day_label: "Diena",
      birthday_not_set: "Nenurodyta",
      birthday_show_to_colleagues: "Rodyti kolegoms naujienose",
      birthday_saved: "Gimtadienis išsaugotas",
      birthday_save_failed: "Nepavyko išsaugoti gimtadienio",
      birthday_load_failed: "Nepavyko įkelti gimtadienio",

      // Deliveries
      deliveries: "Pristatymai",
      deliveries_create: "Sukurti pristatymą",
      deliveries_edit: "Redaguoti pristatymą",
      deliveries_view: "Peržiūrėti pristatymą",
      deliveries_number: "Pristatymas #{{number}}",
      deliveries_date: "Pristatymo data",
      deliveries_items: "Prekės",
      deliveries_items_count: "{{count}} prekės",
      deliveries_no_deliveries: "Pristatymų dar nėra",
      deliveries_no_deliveries_description: "Sukurkite pirmą pristatymą šiam užsakymui.",
      deliveries_create_first: "Sukurti pirmą pristatymą",
      deliveries_summary: "Pristatymų suvestinė",
      delivered: "Pristatyta",
      remaining: "Liko",
      remaining_to_deliver: "Likutis",
      deliveries_no_items: "Šiame pristatyme nėra prekių",
      deliveries_error_loading: "Nepavyko įkelti pristatymų",
      deliveries_error_saving: "Nepavyko išsaugoti pristatymo",
      deliveries_delete_confirm: "Ar tikrai norite ištrinti šį pristatymą?",
      deliveries_status_draft: "Juodraštis",
      deliveries_status_planned: "Suplanuotas",
      deliveries_status_shipped: "Išsiųstas",
      deliveries_status_delivered: "Pristatytas",
      deliveries_status_cancelled: "Atšauktas",
      deliveries_add_from_order: "Pridėti prekes iš užsakymo",
      deliveries_add_selected: "Pridėti pasirinktas",
      deliveries_add_any_product: "Pridėti bet kurią prekę",
      deliveries_add_any_product_description: "Ieškokite ir pridėkite prekes, kurių nėra užsakyme (pvz., iš prekių grupių)",
      deliveries_add_from_reservations: "Pridėti iš rezervacijų",
      deliveries_add_from_reservations_description: "Pasirinkite prekes iš patvirtintų rezervacijų pristatymui",
      deliveries_no_available_reservations: "Nėra galimų rezervacijų. Pirmiausia sukurkite ir patvirtinkite rezervaciją.",
      deliveries_reserved: "Rezervuota",
      deliveries_delivered: "Pristatyta",
      deliveries_available: "Galima pristatyti",
      deliveries_max_quantity: "maks.: {{max}}",
      carrier: "Vežėjas",
      select_carrier: "Pasirinkite vežėją",
      carrier_pristatymas_a: "Pristatymas A",
      carrier_pristatymas_b: "Pristatymas B",
      deliveries_error_no_items: "Pridėkite bent vieną prekę į pristatymą",
      deliveries_error_missing_reservations: "Visos prekės turi būti susietos su rezervacijomis",
      deliveries_error_legacy_mix: "Senų pristatymų prekių negalima maišyti su rezervacijomis. Sukurkite naują pristatymą rezervacijoms.",

      // Deliveries — užsakymo pristatymų lentelė
      deliveries_col_number: "Nr.",
      deliveries_col_date: "Data",
      deliveries_col_vehicle: "Vilkikas",
      deliveries_col_products: "Prekės",
      deliveries_col_quantity_t: "Kiekis, t",
      deliveries_col_status: "Būsena",
      deliveries_col_source: "Šaltinis",
      deliveries_source_manual: "Rankinis",
      deliveries_items_more: "+{{count}}",
      deliveries_total: "Iš viso: {{count}} · {{tonnes}} t",
      deliveries_show_details: "Rodyti detales",
      deliveries_hide_details: "Slėpti detales",

      // Deliveries — sinchronizacija su terminalu (source: 'terminalas')
      deliveries_terminalas_badge: "Terminalas",
      deliveries_terminalas_managed_notice: "Valdoma terminalo — redaguoti negalima",
      deliveries_terminalas_plate: "Vilkikas/Valst. Nr.",
      deliveries_terminalas_driver: "Vairuotojas",
      deliveries_terminalas_carrier: "Vežėjas",
      deliveries_terminalas_loaded_at: "Pakrauta",
      deliveries_terminalas_gate_exit_at: "Išvyko",
      deliveries_terminalas_net_weight: "Neto svoris",
      deliveries_terminalas_order_code: "Terminalo užsakymas",
      deliveries_terminalas_warning_over_reserved: "Viršytas rezervuotas kiekis",
      deliveries_terminalas_warning_over_ordered: "Viršytas sutarties kiekis",
      deliveries_terminalas_warning_product_not_in_contract: "Prekės nėra sutartyje",
      deliveries_terminalas_warning_product_not_in_reservation: "Prekės nėra rezervacijoje",
      deliveries_terminalas_warning_product_unknown: "Nežinoma prekė",
      deliveries_terminalas_warning_order_not_sellable: "Sutartis nepasirašyta arba anuliuota",

      ordered: "Užsakyta",
      retry: "Bandyti dar kartą",
      expand: "Išskleisti",
      collapse: "Sutraukti",
      // Kliento kortelė → prekių skiltis: pardavimai pagal laikotarpį
      customer_products_search_placeholder: "Ieškoti prekės ar kodo",
      customer_products_quantity: "Kiekis",
      customer_products_no_unit: "be mat. vnt.",
      customer_products_net_amount: "Suma be PVM",
      customer_products_returned: "Grąžinta",
      customer_products_invoice_count: "Pirkta kartų",
      customer_products_count: "Prekių",
      customer_products_period: "Laikotarpis",
      customer_products_preset_this_month: "Šis mėnuo",
      customer_products_preset_last_month: "Praėjęs mėnuo",
      customer_products_preset_this_year: "Šie metai",
      customer_products_preset_last_year: "Praėję metai",
      customer_products_preset_last_12_months: "Paskutiniai 12 mėn.",
      customer_products_preset_all: "Visas laikotarpis",
      customer_products_preset_custom: "Pasirinkti…",
      customer_products_custom_from: "Nuo",
      customer_products_custom_to: "Iki",
      customer_products_custom_apply: "Rodyti",
      customer_products_period_with_dates: "{{label}} ({{from}} – {{to}})",
      customer_products_period_custom_label: "Pasirinktas laikotarpis",
      customer_products_unconverted: "Į sumas neįtraukti dokumentai kita valiuta, kurių nepavyko konvertuoti į EUR: {{value}}",
      customer_products_empty_customer: "Šiam klientui pardavimų nėra.",
      customer_products_empty_period: "Šiuo laikotarpiu pardavimų nėra.",
      customer_products_load_failed: "Nepavyko įkelti prekių.",
      // Products page (catalogue with the product's sales)
      products_page_search_placeholder: "Ieškoti pagal pavadinimą ar kodą",
      products_page_services: "Paslaugos",
      products_page_goods: "Prekės",
      products_page_new: "Nauja prekė / paslauga",
      products_page_type_product: "Prekė",
      products_page_type_service: "Paslauga",
      products_page_stock: "Likutis {{quantity}}",
      products_page_reserved_short: "rez. {{quantity}}",
      products_page_list_failed: "Nepavyko įkelti prekių ir paslaugų.",
      products_page_nothing_found: "Nieko nerasta",
      products_page_load_failed: "Nepavyko įkelti prekės.",
      products_page_pick_one: "Pasirinkite prekę ar paslaugą iš sąrašo.",
      products_page_back_to_list: "Atgal į sąrašą",
      products_page_price: "Kaina",
      products_page_in_stock: "Likutis",
      products_page_reserved: "Rezervuota",
      products_page_free: "Laisva",
      products_page_tab_sales: "Pardavimai",
      products_page_tab_stock: "Atsargos",
      products_page_tab_reservations: "Rezervacijos",
      products_page_tab_meta: "Finvalda duomenys",
      products_page_no_stock: "Likučių nėra.",
      products_page_no_reservations: "Rezervacijų nėra.",
      products_page_meta_field: "Laukas",
      products_page_meta_value: "Reikšmė",
      products_page_period: "Laikotarpis",
      products_page_period_this_year: "Šie metai",
      products_page_period_last_year: "Praėję metai",
      products_page_period_last_12_months: "12 mėn.",
      products_page_period_total: "Per pasirinktą laikotarpį",
      products_page_unconverted: "Į sumas neįtraukti dokumentai kita valiuta, kurių nepavyko konvertuoti į EUR: {{value}}",
      products_page_sales_failed: "Nepavyko įkelti pardavimų.",
      products_page_no_sales: "Šiuo laikotarpiu pardavimų nėra.",
      products_page_invoice: "Sąskaita",
      products_page_net_amount: "Suma be PVM",
      products_page_return: "Grąžinimas",
      // Reservations
      reservations_create: "Sukurti rezervaciją",
      reservations_edit: "Redaguoti rezervaciją",
      reservations_view: "Peržiūrėti rezervaciją",
      reservations_number: "Rezervacija #{{number}}",
      reservations_items: "Prekės",
      reservations_items_count: "{{count}} prekės",
      reservations_no_reservations: "Rezervacijų dar nėra",
      reservations_no_reservations_description: "Sukurkite pirmą rezervaciją šiam užsakymui.",
      reservations_create_first: "Sukurti pirmą rezervaciją",
      reservations_summary: "Rezervacijų suvestinė",
      reservations_no_items: "Šioje rezervacijoje nėra prekių",
      reservations_stock_warning: "Likučių įspėjimas",
      reservations_stock_warning_message: "Nepakankamas likutis: užsakyta {{requested}}, turima {{available}}",
      reservations_stock_warnings_title: "Kai kurioms prekėms trūksta likučių:",
      reservations_no_available_quantity: "Nebėra rezervuoti galimo kiekio",
      reservations_no_items_yet: "Dar nepridėta prekių",
      reservations_error_loading: "Nepavyko įkelti rezervacijų",
      reservations_error_saving: "Nepavyko išsaugoti rezervacijos",
      reservations_delete_confirm: "Ar tikrai norite ištrinti šią rezervaciją?",
      reservations_status_draft: "Juodraštis",
      reservations_status_confirmed: "Patvirtinta",
      reservations_status_cancelled: "Atšaukta",
      reservations_add_from_order: "Pridėti prekes iš užsakymo",
      reservations_add_selected: "Pridėti pasirinktas",
      reservations_add_any_product: "Pridėti bet kurią prekę",
      reservations_add_any_product_description: "Ieškokite ir pridėkite prekes, kurių nėra užsakyme",
      reservations_error_no_items: "Pridėkite bent vieną prekę į rezervaciją",
      reservations_customer_fills_delivery: "Klientas pildo pristatymo informaciją",
      reservations_customer_fills_delivery_help: "Klientas galės užpildyti transporto ir pristatymo duomenis klientų portale",
      reservations_select_warehouse_first: "Pirmiausia pasirinkite sandėlį",
      available_stock: "Turimas kiekis",

      // Fulfillment
      fulfillment: "Vykdymas",
      fulfillment_summary: "Vykdymo suvestinė",
      fulfillment_group_line: "{{name}} (grupė {{code}})",
      shipped: "Išsiųsta",
      ship: "Siųsti",
      reserve: "Rezervuoti",
      complete: "Baigta",
      confirmed: "Patvirtinta",
      draft: "Juodraštis",
      new: "Naujas",
      delete: "Ištrinti",
      date_range: "Laikotarpis",
      date_range_placeholder: "YYYY-MM-DD – YYYY-MM-DD",
      date_range_open_calendar: "Atidaryti kalendorių ir pasirinkti laikotarpį",
      date_range_input_help:
        "Įveskite datas formatu metai–mėnuo–diena (tik skaitmenys, kaip ir kitur) arba pasirinkite laikotarpį kalendoriuje. Paryškintos dienos rodo pasirinkimą.",
      date_from: "Data nuo",
      date_to: "Data iki",
      business_trips: "Komandiruotės",
      leave_calendar: "Atostogų kalendorius",
      // The company-wide calendar's menu item and page title; «leave_calendar» stays for the employee's own wall calendar.
      team_calendar: "Komandos kalendorius",
      leave_calendar_all_teams: "Visos komandos",
      leave_calendar_view: "Rodinys",
      leave_calendar_monthly: "Mėnesio",
      leave_calendar_yearly: "Metų",
      leave_calendar_year: "Metai",
      leave_calendar_month: "Mėnuo",
      leave_calendar_team: "Komanda",
      leave_calendar_search_employees: "Ieškoti darbuotojų",
      leave_calendar_today: "Šiandien",
      leave_calendar_employee: "Darbuotojas",
      leave_calendar_vacation: "Atostogos",
      leave_calendar_holidays: "Šventės",
      leave_calendar_weekend_holidays: "Savaitgalio poilsis",
      leave_calendar_rules_today_bg: "Žiedas žalsvai mėlynas = šiandien",
      leave_calendar_sick: "Liga",
      leave_calendar_business_trip: "Komandiruotė",
      leave_calendar_type_vacation: "Atostogos",
      leave_calendar_type_sick: "Liga",
      leave_calendar_type_business_trip: "Komandiruotė",
      leave_calendar_type_remote_work: "Nuotolinis darbas",
      leave_calendar_modal_create_title: "Naujas prašymas",
      leave_calendar_modal_edit_title: "Redaguoti",
      leave_calendar_modal_create_hint:
        "Pasirinkite darbuotoją, datas ir tipą. Kiekvienam tipui reikia failo tipo, kurio laukas „template“ arba „label“ sutampa su kodu, ir naudotojo šablono su tuo failo tipu. Pateikiant sugeneruojamas PDF; prašymas laukia patvirtinimo.",
      leave_calendar_leave_VACATION: "Kasmetinės atostogos",
      leave_calendar_leave_UNPAID_LEAVE: "Nemokamos atostogos",
      leave_calendar_leave_ADDITIONAL_DAY_OFF: "Papildoma poilsio diena (tėvams)",
      leave_calendar_leave_ADDITIONAL_REST_TIME: "Papildomas poilsio laikas (rugsėjo 1 d.)",
      leave_calendar_leave_PATERNITY_LEAVE: "Tėvystės atostogos",
      leave_calendar_leave_BUSINESS_TRIP_LEAVE: "Komandiruotės atostogos",
      leave_calendar_leave_REMOTE_WORK: "Nuotolinis darbas",
      past: "Praėję",
      leave_calendar_template_resolve_error:
        "Šiam tipui nerastas šablonas. Sukurkite failo tipą, kurio „template“ arba „label“ sutampa su pasirinktu tipu, ir naudotojo šabloną su tuo tipu.",
      leave_calendar_error_invalid_type: "Netinkamas atostogų tipas.",
      leave_calendar_modal_edit_hint: "Prašymo detalės.",
      leave_calendar_modal_view_title: "Prašymas dėl atostogų",
      leave_calendar_modal_view_hint:
        "Peržiūrėkite prašymą. Tvirtintojai gali patvirtinti ar atmesti, kol laukiama.",
      leave_calendar_modal_employee: "Darbuotojas",
      leave_calendar_modal_start: "Pradžios data",
      leave_calendar_modal_end: "Pabaigos data",
      leave_calendar_modal_type: "Tipas",
      leave_calendar_modal_comment: "Komentaras (neprivaloma)",
      leave_calendar_submit: "Pateikti",
      leave_calendar_generate_document: "Generuoti dokumentą",
      leave_calendar_footer_hint:
        "Vilkite per dienas norėdami pateikti prašymą. Spustelėkite langelį – atsidarys prašymas..",
      leave_calendar_rules_title: "Kalendoriaus taisyklės",
      leave_calendar_rules_vacation: "Kasmetinės / Nemokamos / Tėvystės / Komandiruotės atostogos / Papildomos poilsio dienos",
      leave_calendar_rules_business_trip: "Komandiruotė",
      leave_calendar_rules_today_holiday: "Šiandien + šventinė diena",
      leave_calendar_rules_sick: "Ligos atostogos (seni įrašai)",
      leave_calendar_rules_trip: "Komandiruotė (seni įrašai)",
      leave_calendar_rules_pending: "Laukiama patvirtinimo",
      leave_calendar_rules_rejected_cancelled: "Atmesta arba atšaukta",
      leave_calendar_rules_holiday_dot: "Geltonas taškas = šventinė diena",
      leave_calendar_rules_holiday_bg: "Pilkas fonas = šventinė diena",
      leave_calendar_rules_weekend_bg: "Šviesiai violetinė = savaitgalio poilsio diena",
      leave_calendar_rules_half_day: "Pusės dienos juosta = 0,5 už kiekvieną darbo dieną",
      leave_calendar_rules_hourly:
        "Plona apatinė juosta = valandinis; suvestinėje skaičiuojama (valandos ÷ 8) už dieną",
      leave_calendar_hourly_single_date:
        "Valandiniam prašymui pradžios ir pabaigos data turi sutapti.",
      leave_calendar_duration_label: "Trukmė",
      leave_calendar_duration_full: "Visa diena (-os)",
      leave_calendar_duration_half: "Pusė dienos",
      leave_calendar_duration_hourly: "Valandinis",
      leave_calendar_start_time: "Pradžios laikas",
      leave_calendar_end_time: "Pabaigos laikas",
      leave_calendar_status_label: "Būsena",
      leave_calendar_status_draft: "Juodraštis",
      leave_calendar_status_pending_approval: "Laukiama patvirtinimo",
      leave_calendar_status_approved: "Patvirtinta",
      leave_calendar_status_rejected: "Atmesta",
      leave_calendar_status_cancelled: "Atšaukta",
      leave_calendar_approve: "Patvirtinti",
      leave_calendar_reject: "Atmesti",
      leave_calendar_reject_reason: "Atmetimo priežastis (nebūtina)",
      leave_calendar_open_document: "Atidaryti dokumentą",
      leave_calendar_validation_required:
        "Užpildykite datas ir tipą (ir prisijunkite, jei sesija neaktyvi).",
      leave_calendar_half_day_single_date:
        "Pusės dienos prašymui pradžios ir pabaigos data turi sutapti.",
      leave_calendar_half_day_times: "Nurodykite pradžios ir pabaigos laiką.",
      leave_calendar_template_required: "Prieš pateikdami pasirinkite šabloną.",
      leave_calendar_time_range_invalid: "Pradžios laikas turi būti ankstesnis už pabaigos laiką.",
      leave_calendar_no_template_for_type: "Šiam tipui nėra sukonfigūruoto šablono.",
      leave_calendar_error_not_configured: "Šis atostogų tipas nekonfigūruotas įmonei.",
      leave_calendar_error_template_missing: "Tipui nepriskirtas šablonas.",
      leave_calendar_error_pdf_failed:
        "Nepavyko sugeneruoti PDF. Patikrinkite šabloną ir bandykite dar kartą.",
      leave_calendar_error_generic: "Nepavyko pateikti prašymo.",
      // mobile: personnel
      scan_to_pdf_hint:
        "Galima įkelti tik PDF, ne nuotrauką. Telefone failo pasirinkimo lange pasirinkite „Nuskenuoti dokumentus“ (iPhone) arba nuskenuokite per „Google Drive“ (Android) ir pasirinkite PDF.",
      leave_calendar_action_failed: "Veiksmas nepavyko. Patikrinkite teises.",
      leave_calendar_open_file_failed:
        "Nepavyko atidaryti failo. Bandykite per darbuotojo profilio dokumentus.",
      leave_calendar_off_day_error_toast: "Negalite pridėti atostogų prašymo savaitgalį ar šventinę dieną",
      leave_calendar_start_off_day: "Pradžios data negali būti savaitgalis ar šventė",
      // mobile: products-projects
      project_summary: "Santrauka",
      leave_calendar_end_off_day: "Pabaigos data negali būti savaitgalis ar šventė",
      leave_calendar_overlap_error: "Šiuo laikotarpiu jau turite užregistruotas atostogas",
      leave_calendar_past_date_error: "Pradžios data negali būti praeityje",
      leave_calendar_start_after_end: "Pradžios data turi būti ne vėlesnė už pabaigos datą",
      leave_calendar_max_days_error: "Atostogų prašymas negali būti ilgesnis nei {{days}} dienų",
      leave_calendar_trip_required:
        "Šiam atostogų tipui būtina pasirinkti komandiruotę",
      leave_calendar_trip_select_dates_hint:
        "Pasirinkite pradžios ir pabaigos datas komandiruotėms įkelti.",
      leave_calendar_trip_not_found_for_dates:
        "Pasirinktam naudotojui pagal šį datų intervalą komandiruočių nerasta.",
      business_trip: "Komandiruotė",
      business_trip_settings: "Komandiruočių nustatymai",
      onboarding_contract_settings: "Darbo sutarties nustatymai",
      onboarding_contract_standard: "Standartinė darbo sutartis",
      onboarding_document_settings_hint:
        "Dokumentas be kategorijos sukuriamas ir randamas paieškoje, bet nematomas dokumentų medyje.",
      onboarding_generated_documents: "Sugeneruojami dokumentai",
      onboarding_generated_documents_hint: "Sistema juos sukuria įdarbinimo metu.",
      onboarding_uploaded_documents: "Darbuotojo įkeliami dokumentai",
      onboarding_uploaded_documents_hint:
        "Darbuotojas ar personalo specialistas juos įkelia įdarbinimo metu.",
      onboarding_hiring_questionnaire: "Įdarbinimo anketa",
      onboarding_esignature_agreement: "El. parašo susitarimas",
      onboarding_employee_questionnaire: "Darbuotojo anketa",
      onboarding_application: "Prašymas priimti į darbą",
      onboarding_gdpr_statement: "BDAR pareiškimas",
      onboarding_upload_other: "Kitas dokumentas",
      onboarding_signed_container: "Pasirašytas el. dokumentų paketas (ASiC-E)",
      onboarding_filed_in: "Dedama: {{path}}",
      onboarding_category_missing: "Nepasirinkta kategorija — dokumentas nepateks į medį",
      onboarding_asset_requests_link: "Teisių nustatymai",
      onboarding_contract_director: "Direktoriaus darbo sutartis",
      approve_medical: "Patvirtinti sveikatos patikrą",
      medical_approve_not_authorized: "Sveikatos patikrą gali patvirtinti tik Master, personalo skyrius, sveikatos patikrų atsakingi darbuotojai arba darbuotojo padalinio vadovas.",
      can_approve: "Gali patvirtinti",
      reminder_sent: "Priminimas išsiųstas",
      activation_pending_message: "Visi dokumentai pasirašyti. Jūsų paskyra netrukus bus aktyvuota administratoriaus.",
      employee_activation_setup: "Darbuotojo aktyvavimas",
      activate_employee: "Aktyvuoti darbuotoją",
      activation_permissions_title: "Ką gali",
      activation_permissions_hint: "Teisės iš pareigų suteikiamos automatiškai. Čia galite pridėti papildomų teisių (nebūtina).",
      activation_master_assign_forbidden: "Administratoriaus teisę gali suteikti tik administratorius.",
      activation_personal_area_only: "Darbuotojas gaus prieigą prie savo asmeninės srities. Kitas teises suteikia Master.",
      select_folder_access: "Prieiga prie aplankų",
      no_categories: "Nėra kategorijų",
      revoke_medical_approval: "Atšaukti sveikatos patikros patvirtinimą",
      generate_documents: "Generuoti dokumentus",
      send_for_signature: "Siųsti pasirašymui",
      regenerate_documents: "Pergeneruoti dokumentus",
      manual_signature: "Popierinis (rankinis)",
      amendment_signontab_tablet: "SignOnTab tabletė",
      amendment_signontab_no_tablets: "Įmonė neturi SignOnTab tablečių",
      amendment_signontab_tablets_failed: "Nepavyko įkelti SignOnTab tablečių.",
      amendment_signontab_waiting: "Laukiama parašų SignOnTab tabletėje",
      amendment_signontab_send_failed: "Nepavyko išsiųsti pakeitimo į SignOnTab",
      onboarding_signontab_send_failed: "Nepavyko išsiųsti dokumentų į SignOnTab",
      onboarding_signontab_still_on_tablet: "Kai kurie dokumentai gali būti likę tabletėje. Patikrinkite tabletę ir atšaukite juos ten arba vėliau paspauskite „Pergeneruoti dokumentus“.",
      onboarding_signontab_document_cancelled: "Dokumentas tabletėje buvo atšauktas. Pergeneruokite dokumentus ir siųskite iš naujo.",
      medical_check: "Sveikatos patikra",
      medical_check_pending: "Laukia patvirtinimo",
      medical_check_approved: "Patvirtinta",
      medical_certificate: "Sveikatos pažyma",
      upload_medical_files: "Įkelti sveikatos dokumentus",
      manager_required: "Vadovas yra privalomas",
      confirm_revoke_medical: "Ar tikrai norite atšaukti sveikatos patikros patvirtinimą?",
      medical_approval_revoked: "Sveikatos patikros patvirtinimas atšauktas",
      sent_for_signature: "Išsiųsta pasirašymui",
      reviewed: "Peržiūrėta",
      confirm_delete: "Ištrinti?",
      configured: "Sukonfigūruota",
      order_amendment_custom_template_warning:
        "Pasirinktiniai šablonai gali skirtis nuo naujausių sistemos ar teisinių pakeitimų. Jei siekiate vienodos ir aktualios formos, naudokite sistemos šabloną.",
      fuel_report_settings: "Kuro ataskaitos nustatymai",
      fuel_report_document_template: "Kuro ataskaitos dokumentas",
      fuel_report_custom_template_warning:
        "Pasirinktiniai šablonai gali skirtis nuo naujausių sistemos ar teisinių pakeitimų. Jei siekiate vienodos ir aktualios formos, naudokite sistemos šabloną.",
      fuel_report_document_already_created:
        "Šiai ataskaitai dokumentas jau sukurtas.",
      fuel_report_signatures_locked:
        "Šios ataskaitos dokumentas laukia parašo, kuris po šio pakeitimo būtų prarastas (pvz., tvirtinantis asmuo nebedirba). Kreipkitės į kuro ataskaitų administratorių.",
      fuel_report_signed_edit_forbidden:
        "Ataskaita pasirašyta — ją redaguoti gali tik kuro ataskaitų administratorius.",
      fuel_report_document_in_progress:
        "Ši ataskaita šiuo metu išsaugoma. Palaukite akimirką ir bandykite dar kartą.",
      fuel_barcode_panel_description:
        "Kuro kortelės išrašo eilutės, atitinkančios šį sąrašą, skaičiuojamos kaip kuras. Visos kitos — kaip papildomos išlaidos.",
      fuel_barcode_provider_hint:
        "Rotada išrašuose kuras atpažįstamas pagal barkodą, E100 — pagal produkto klasę, Korta — pagal paslaugos rūšį.",
      fuel_barcode_defaults_notice:
        "Nėra aktyvių kuro barkodų — nė vienas įrašas nebus laikomas kuru. Spustelėkite „Importuoti numatytuosius“ arba pridėkite įrašų.",
      fuel_barcode_import_defaults: "Importuoti numatytuosius",
      fuel_barcode_defaults_imported:
        "Numatytieji barkodai, produkto klasė ir paslaugų rūšys importuoti.",
      fuel_barcode_defaults_already_present:
        "Visi numatytieji barkodai jau pridėti.",
      fuel_barcode_no_data: "Kuro barkodų dar nėra.",
      fuel_barcode_value: "Barkodas",
      fuel_barcode_value_help:
        "Barkodas, kaip jis nurodytas degalinės eksporte. Priekiniai nuliai ignoruojami.",
      fuel_barcode_product_class_value: "Produkto klasė",
      fuel_barcode_service_type_value: "Paslaugos rūšis",
      fuel_barcode_service_type_help:
        "Korta (V3) CSV stulpelio „Paslaugos rūšis“ reikšmė, pvz. Benzinas 95.",
      fuel_barcode_type: "Tipas",
      fuel_barcode_type_barcode: "Barkodas",
      fuel_barcode_type_product_class: "Produkto klasė",
      fuel_barcode_type_service_type: "Paslaugos rūšis",
      fuel_barcode_description: "Aprašymas",
      fuel_barcode_active: "Aktyvus",
      fuel_barcode_resource_singular: "kuro barkodas",
      fuel_barcode_resource_plural: "kuro barkodai",
      fuel_barcode_duplicate: "Ši reikšmė jau egzistuoja pasirinktam tipui.",
      fuel_barcode_value_required: "Įveskite reikšmę.",
      fuel_barcode_error_loading: "Nepavyko įkelti kuro barkodų.",
      fuel_barcode_error_saving: "Nepavyko išsaugoti. Bandykite dar kartą.",
      fuel_barcodes_card_title: "Kas išraše laikoma kuru",
      fuel_barcode_provider: "Tiekėjas",
      fuel_barcode_recognised_by: "Atpažįstama pagal",
      fuel_barcode_column_value: "Reikšmė",
      business_trip_main_template: "Komandiruotės įsakymas",
      business_trip_report_template: "Komandiruotės ataskaita",
      business_trip_leave_template: "Prašymas dėl poilsio dienos komandiruotėje",
      business_trip_main_template_not_configured: "Komandiruotės dokumento šablonas nesukonfigūruotas. Nustatykite jį Įmonės nustatymuose → Komandiruočių nustatymai.",
      business_trip_report_template_not_configured: "Komandiruotės ataskaitos šablonas nesukonfigūruotas. Nustatykite jį Įmonės nustatymuose → Komandiruočių nustatymai.",
      business_trip_leave_template_not_configured: "Prašymo dėl poilsio / papildomos atostogų dienos šablonas nesukonfigūruotas. Nustatykite jį Įmonės nustatymuose → Komandiruočių nustatymai.",
      business_trip_custom_template_warning: "Pasirinktiniai šablonai gali skirtis nuo naujausių sistemos ar teisinių pakeitimų. Jei siekiate vienodos ir aktualios formos, naudokite sistemos šabloną.",
      use_custom_template: "Naudoti pasirinktinį šabloną",
      reset_to_system_template: "Grąžinti sistemos šabloną",
      select_template: "Pasirinkite šabloną",
      series_file_type_category_required:
        "Sisteminio šablono režimui privaloma pasirinkti seriją, dokumento tipą ir kategoriją.",
      required: "Privaloma",
      system: "Sisteminis",
      custom: "Pasirinktinis",
      template_slot_system: "Sistemos šablonas",
      template_slot_custom: "Savas šablonas",
      template_slot_placed_in: "dedama: {{category}}",
      template_slot_not_placed: "dar nenurodyta, kur dėti",
      template_slot_system_metadata_required:
        "Kiekvienam dokumentui, naudojančiam sistemos šabloną, pasirinkite seriją, dokumento tipą ir kategoriją.",
      template_slot_template_required:
        "Kiekvienam dokumentui, naudojančiam savo šabloną, pasirinkite šabloną.",
      template_slot_choice_missing: "Tai, ką pasirinkote, nebeegzistuoja. Pasirinkite iš naujo.",
      trip_updated_document_invalidated: "Komandiruotė atnaujinta. Pagrindinis dokumentas buvo pašalintas — prašome jį sugeneruoti iš naujo.",
      create_business_trip: "Sukurti komandiruotę",
      edit_business_trip: "Redaguoti komandiruotę",
      only_trip_creator_can_edit_trip:
        "Tik komandiruotės kūrėjas gali redaguoti komandiruotės duomenis.",
      generate_business_trip_document: "Sugeneruoti komandiruotės dokumentą",
      sign_the_business_trip: "Pasirašyti komandiruotės dokumentą",
      business_trip_document_empty_hint:
        "Sugeneruokite PDF dokumentą iš šios komandiruotės, kad galėtumėte atsisiųsti arba siųsti pasirašymui.",
      business_trip_signers_empty_hint:
        "Sugeneravus dokumentą, čia bus rodomi pasirašantys asmenys.",
      business_trip_report: "Komandiruotės ataskaita",
      business_trip_report_empty_hint:
        "Ataskaitos forma dar neužpildyta. Užpildykite komandiruotės rezultatus ir pastabas.",
      business_trip_report_fill_then_generate_hint:
        "Užpildykite ataskaitos formą ir sugeneruokite ataskaitos dokumentą.",
      report_form: "Ataskaitos forma",
      report_document: "Ataskaitos dokumentas",
      leaves_during_trip: "Prašymas skirti poilsio dieną arba papildomą atostogų dieną komandiruotės metu",
      add_leave_request: "Pridėti prašymą",
      generate_leave_document: "Generuoti prašymo dokumentą",
      leaves_during_trip_empty_hint:
        "Prašymas skirti poilsio dieną arba papildomą atostogų dieną komandiruotės metu.",
      create_report: "Sukurti ataskaitą",
      edit_report: "Redaguoti ataskaitą",
      edit_document: "Redaguoti dokumentą",
      generate_report_document: "Generuoti ataskaitos dokumentą",
      participation_events: "Dalyvavimas renginiuose / susitikimuose",
      trip_results: "Komandiruotės rezultatai",
      expenses: "Išlaidos",
      future_recommendations: "Rekomendacijos ateičiai",
      comments: "Pastabos",
      place_of_business_trip: "Komandiruotės vieta",
      transport_used: "Transporto priemonė",
      purpose: "Komandiruotės tikslas",
      advance_for_expenses: "Išmokėtas avansas",
      substitute_person: "Pavaduojantis asmuo",
      details: "Informacija",
      date_to_must_be_after_date_from: "Pabaigos data turi būti vėlesnė už pradžios datą",
      status_draft: "Juodraštis",
      status_pending_approval: "Laukia patvirtinimo",
      status_approved: "Patvirtinta",
      status_in_progress: "Vykdoma",
      status_pending_report: "Laukia ataskaitos",
      status_report_rejected: "Ataskaita atmesta",
      status_completed: "Užbaigta",
      all: "Visi",
      search_description: "Ieškoti aprašyme",
      // Business trip expenses
      add_expense: "Pridėti išlaidą",
      no_expenses_yet: "Išlaidų dar nėra. Pridėkite komandiruotės išlaidas, kad jos būtų įtrauktos į ataskaitą.",
      expense_category: "Kategorija",
      expense_category_transport: "Transportas",
      expense_category_fuel: "Kuras",
      expense_category_accommodation: "Apgyvendinimas",
      expense_category_food: "Maitinimas",
      expense_category_taxes: "Mokesčiai ir rinkliavos",
      expense_category_other: "Kita",
      amount_eur: "Suma EUR",
      amount_in_eur: "Suma eurais",
      receipt: "Kvitas",
      receipt_attached: "Kvitas pridėtas",
      receipt_missing: "Kvitas nepridėtas",
      receipt_upload_hint: "Įkelkite kvito nuotrauką arba PDF (maks. 10 MB)",
      missing_receipts_warning: "{{missing}} iš {{total}} išlaidų neturi kvitų",
      exchange_rate: "Valiutos kursas",
      exchange_rate_reference_link: "Lietuvos banko valiutų kursai",
      invalid_amount: "Netinkama suma",
      invalid_exchange_rate: "Netinkamas valiutos kursas",
      total: "Iš viso",
      difference: "Skirtumas",
      to_reimburse: "grąžintina darbuotojui",
      employee_returns: "darbuotojas grąžina",
      advance_fully_used: "avansas panaudotas pilnai",
      currency: "Valiuta",
      actions: "Veiksmai",
      // Onboarding
      onboarding: "Įdarbinimas",
      hr_module: "Personalas",
      create_onboarding: "Naujas įdarbinimas",
      hiring_questionnaire: "Įdarbinimo anketa",
      employee: "Darbuotojas",
      hiring_date: "Įdarbinimo data",
      created_at: "Sukurta",
      step: "Žingsnis",
      completed: "Baigta",
      cancelled: "Atšaukta",
      progress: "Progresas",
      administration: "Administracija",
      work_email: "Darbo el. paštas",
      company_car: "Tarnybinis automobilis",
      kiosk: "Kioskas",
      kiosk_code: "Kiosko kodas",
      kiosk_instructions: "Atidarykite /onboarding/kiosk planšetėje. Darbuotojas įveda savo asmens kodą ir šį kiosko kodą, kad užpildytų formas.",
      signing_method: "Pasirašymo būdas",
      complete_step: "Užbaigti žingsnį",
      step_completed: "Žingsnis sėkmingai užbaigtas",
      send_login_link: "Siųsti prisijungimo nuorodą",
      login_link_sent: "Prisijungimo nuoroda išsiųsta",
      complete_step_1: "Užbaigti 1 žingsnį",
      confirm_complete_step_1:
        "Pažymėti 1 žingsnį kaip užbaigtą ir pereiti į 2 žingsnį? Bus informuotas už materialines vertybes atsakingas asmuo.",
      confirm: "Patvirtinti",
      confirm_cancel_onboarding: "Ar tikrai norite atšaukti šį įdarbinimą?",
      first_name: "Vardas",
      last_name: "Pavardė",
      personal_email: "Asmeninis el. paštas",
      personal_phone: "Asmeninis telefonas",
      birth_year: "Gimimo metai",
      birth_date: "Gimimo data",
      work_location: "Darbo vieta",
      position_lt: "Pareigos (LT)",
      position_en: "Pareigos (EN)",
      target_company: "Tikslinė įmonė",
      salary: "Atlyginimas neatskaičius mokesčių",
      hours_per_week: "Valandos per savaitę",
      probation_months: "Bandomasis laikotarpis (mėn.)",
      contract_type: "Sutarties tipas",
      contract_variant: "Sutarties variantas",
      contract_end_date: "Sutarties pabaigos data",
      contract_type_other: "Sutarties tipas (kita)",
      contract_type_indefinite: "Neterminuota",
      contract_type_fixed_term: "Terminuota",
      contract_type_other_value: "Kita",
      contract_variant_standard: "Standartinė",
      contract_variant_summed: "Suminė",
      contract_variant_director: "Direktoriaus",
      my_onboarding: "Mano įdarbinimas",
      no_active_onboarding: "Neturite aktyvaus įdarbinimo proceso.",
      multiple_onboardings_select_company: "Turite įdarbinimo procesų keliose įmonėse. Pasirinkite vieną, kad tęstumėte.",
      continue: "Tęsti",
      data_saved: "Duomenys sėkmingai išsaugoti",
      waiting_for_signature_description: "Šis žingsnis laukia parašų. Gausite pranešimą, kai bus jūsų eilė pasirašyti.",
      onboarding_completed_message: "Jūsų įdarbinimas baigtas! Visi dokumentai pasirašyti.",
      activation_waiting: "Jūsų dokumentai pasirašyti. Administratorius baigia konfigūruoti jūsų paskyrą.",
      employee_activated: "Darbuotojas sėkmingai aktyvuotas",
      onboarding_documents: "Įdarbinimo dokumentai",
      upload_photo: "Įkelti nuotrauką",
      change_photo: "Pakeisti nuotrauką",
      remove_photo: "Pašalinti nuotrauką",
      avatar_updated: "Nuotrauka atnaujinta",
      avatar_removed: "Nuotrauka pašalinta",
      avatar_imported: "Nuotrauka importuota",
      avatar_import_failed: "Nepavyko importuoti nuotraukos",
      avatar_upload_failed: "Nepavyko įkelti nuotraukos",
      use_photo_from_other_company: "Naudoti mano nuotrauką iš kitos įmonės",
      use_this_photo: "Naudoti šią",
      avatar_must_be_image: "Failas turi būti paveikslėlis",
      avatar_file_too_large: "Paveikslėlis turi būti ne didesnis kaip 10 MB",
      select_image_to_upload: "Pasirinkite paveikslėlį įkelti",
      choose_file: "Pasirinkti failą",
      choose_another: "Pasirinkti kitą",
      zoom: "Mastelis",
      online: "Prisijungęs",
      online_count: "Prisijungę: {{count}}",
      no_one_online: "Niekas daugiau neprisijungęs",
      offline_section_title: "Atjungti",
      last_seen: "Paskutinį kartą matytas",
      open_full_profile: "Atidaryti pilną profilį",
      avatar_upload_prompt: "Įkelkite nuotrauką, kad kolegos jus atpažintų →",
      chats: "Pokalbiai",
      company_chat: "Bendras pokalbis",
      // pokalbių skambučiai (1:1 balsu)
      call_start: "Skambinti",
      call_incoming_title: "Įeinantis skambutis",
      call_accept: "Atsiliepti",
      call_decline: "Atmesti",
      call_hang_up: "Baigti",
      call_mute: "Išjungti mikrofoną",
      call_unmute: "Įjungti mikrofoną",
      call_ringing: "Skambinama…",
      call_connecting: "Jungiamasi…",
      call_declined: "Skambutis atmestas",
      call_busy: "Kolega kalba kitu skambučiu",
      call_missed: "Praleistas skambutis",
      call_no_answer: "Neatsiliepė",
      call_offline: "Kolega neprisijungęs",
      call_failed: "Skambutis nepavyko",
      call_mic_denied: "Nepavyko pasiekti mikrofono",
      call_already_in_call: "Jau kalbate kitu skambučiu",
      call_camera_denied: "Nepavyko pasiekti kameros",
      call_camera_on: "Įjungti kamerą",
      call_camera_off: "Išjungti kamerą",
      call_screen_share: "Rodyti ekraną",
      call_screen_stop: "Baigti rodyti",
      call_screen_unavailable: "Ekrano rodymas čia negalimas",
      call_add_person: "Pakviesti dalyvį",
      call_invite_title: "Kviečia į pokalbį",
      call_invited: "{{name}} pakviestas (-a)",
      call_group_title: "Grupinis skambutis",
      call_group_unavailable: "Grupiniai skambučiai negalimi",
      call_you: "Jūs",
      call_your_screen: "Jūsų ekranas",
      call_reconnecting: "Jungiamasi iš naujo…",
      call_everyone_left: "Visi kiti išėjo iš pokalbio",
      call_on_a_call: "Kalba telefonu",
      call_guest_link: "Nuoroda svečiui",
      call_guest_link_copied: "Nuoroda svečiui nukopijuota",
      call_guest_title: "Jus pakvietė į pokalbį",
      call_guest_name: "Jūsų vardas",
      call_guest_join: "Prisijungti",
      call_guest_link_invalid: "Ši nuoroda nebegalioja",
      call_guest_over: "Pokalbis jau baigėsi",
      call_guest_left: "Išėjote iš pokalbio",
      call_guest_mic_hint: "Prisijungus bus paprašyta mikrofono",
      call_enlarge: "Padidinti",
      call_fullscreen: "Visas ekranas",
      call_mic_permission: "Laukiama mikrofono leidimo…",
      call_peer_mic_permission: "{{name}} suteikia mikrofono leidimą…",
      call_the_other_side: "Pašnekovas",
      call_mic_permission_prompt: "Naršyklė prašo leidimo naudoti mikrofoną — spustelėkite „Leisti“.",
      call_mic_permission_hidden: "Nematote užklausos? Spustelėkite mikrofono arba svetainės piktogramą adreso juostoje arba perjunkite į šį skirtuką.",
      call_help_chrome_open: "Spustelėkite piktogramą adreso juostos kairėje (spynelę arba svetainės nustatymus)",
      call_help_set_allow: "Prie „Mikrofonas“ pasirinkite „Leisti“",
      call_help_safari_open: "Safari meniu pasirinkite „Settings for This Website“",
      call_help_safari_ios_open: "Adreso juostoje bakstelėkite „aA“, tada „Website Settings“",
      call_help_firefox_open: "Spustelėkite mikrofono (leidimų) piktogramą adreso juostoje",
      call_help_firefox_unblock: "Panaikinkite mikrofono blokavimą (× šalia „Užblokuota“)",
      call_help_generic: "Naršyklės svetainės nustatymuose leiskite šiai svetainei naudoti mikrofoną",
      call_help_reload: "Perkraukite puslapį",
      call_help_os_mac: "Jei naršyklei leista, bet mikrofono vis tiek nėra: „System Settings“ → „Privacy & Security“ → „Microphone“ → įjunkite naršyklę",
      call_help_os_windows: "Jei naršyklei leista, bet mikrofono vis tiek nėra: Windows „Parametrai“ → „Privatumas ir sauga“ → „Mikrofonas“ → įjunkite „Leisti darbalaukio programoms pasiekti mikrofoną“",
      call_help_os_ios: "Jei naršyklei leista, bet mikrofono vis tiek nėra: iPhone „Nustatymai“ → {{browser}} → „Mikrofonas“: įjungta",
      call_help_os_android: "Jei naršyklei leista, bet mikrofono vis tiek nėra: „Nustatymai“ → „Programos“ → {{browser}} → „Leidimai“ → „Mikrofonas“",
      call_help_this_browser: "jūsų naršyklė",
      call_fail_mic_title: "Mikrofonas neprieinamas",
      call_fail_mic_body: "Naršyklė neleido šiam puslapiui naudoti mikrofono. Kaip tai pataisyti:",
      call_fail_mic_pending_title: "Nesulaukta mikrofono leidimo",
      call_fail_mic_pending_body: "Į mikrofono užklausą taip ir nebuvo atsakyta — greičiausiai ji buvo paslėpta (skirtukas fone, uždarytas iššokantis langas, kitas langas viršuje). Spustelėkite mikrofono arba svetainės piktogramą adreso juostoje arba perjunkite į šį skirtuką ir leiskite mikrofoną:",
      call_fail_peer_title: "{{name}} neprisijungė",
      call_fail_peer_body: "Pašnekovo naršyklė nesuteikė mikrofono leidimo. Paprašykite leisti mikrofoną (užklausa rodoma šalia adreso juostos) ir paskambinkite dar kartą.",
      call_fail_network_title: "Nepavyko užmegzti ryšio",
      call_fail_network_body: "Greičiausiai skambučius blokuoja tinklas arba ugniasienė.",
      call_fail_dropped_title: "Ryšys nutrūko",
      call_fail_dropped_body: "Skambutis nutrūko — dingo tinklo ryšys.",
      call_check_mic: "Patikrinti mikrofoną",
      call_check_network: "Patikrinti tinklą",
      call_checking: "Tikrinama…",
      call_again: "Skambinti dar kartą",
      call_copy_report: "Kopijuoti ataskaitą",
      call_report: "Skambučio problemos ataskaita",
      call_report_copied: "Ataskaita nukopijuota",
      call_check_mic_ok: "Mikrofonas veikia",
      call_check_mic_ok_device: "Mikrofonas veikia: {{device}}",
      call_check_mic_silent: "…tačiau nieko negirdėti — patikrinkite įvesties įrenginį arba mikrofono išjungimo mygtuką.",
      call_check_mic_denied: "Šioje svetainėje mikrofonas užblokuotas",
      call_check_mic_missing: "Mikrofonas nerastas",
      call_check_mic_busy: "Mikrofoną naudoja kita programa",
      call_check_mic_failed: "Nepavyko patikrinti mikrofono",
      call_check_net_needs_call: "Tinklą galima patikrinti tik po skambučio bandymo — paskambinkite dar kartą ir tada patikrinkite.",
      call_check_net_blocked: "Jūsų tinklas blokuoja skambučius — nusiųskite šią ataskaitą IT administratoriui.",
      call_check_net_tls_only: "Veikia tik šifruotas TCP kelias; skambučiai vis tiek turėtų pavykti — bandykite dar kartą.",
      call_check_net_no_relay: "Tiesioginis ryšys gali veikti, bet tarpiniai serveriai nepasiekiami — jei skambučiai ir toliau nepavyksta, nusiųskite šią ataskaitą IT administratoriui.",
      call_check_net_ok: "Tinklas tvarkingas — bandykite paskambinti dar kartą.",
      call_check_net_no_turn: "Skambučių paslauga šiam skambučiui nepasiūlė tarpinio serverio — tai ne jūsų tinklo problema. Paskambinkite dar kartą; jei kartojasi, nusiųskite šią ataskaitą pagalbos tarnybai.",
      call_check_ok: "veikia",
      call_check_fail: "neveikia",
      user_profile: "Profilis",
      no_conversations: "Pokalbių dar nėra",
      no_messages_yet: "Žinučių dar nėra",
      message_deleted: "Žinutė ištrinta",
      edited: "redaguota",
      composer_coming_soon: "Žinutės rašymas — netrukus",
      new_messages_count: "Naujos žinutės: {{count}}",
      link_kind_asset: "Materialinė vertybė",
      link_kind_profile: "Profilis",
      link_kind_customer: "Klientas",
      link_kind_document: "Dokumentas",
      link_kind_onboarding: "Įdarbinimas",
      link_kind_business_trip: "Komandiruotė",
      link_kind_leave: "Atostogos",
      link_kind_link: "Nuoroda",
      new_message: "Nauja žinutė",
      new_dm_in_other_company: "Nauja žinutė įmonėje {{company}}",
      open: "Atidaryti",
      type_a_message: "Rašykite žinutę...",
      send: "Siųsti",
      send_message: "Siųsti žinutę",
      attach_file: "Prisegti failą",
      message_too_long: "Žinutė per ilga",
      file_upload_failed: "Nepavyko įkelti failo",
      cannot_edit_after_window: "Redagavimo laikas baigėsi",
      recognition: "Padėkos",
      give_kudos: "Padėkoti",
      send_kudos: "Siųsti padėką",
      kudos_sent: "Padėka išsiųsta",
      giving_kudos_to: "Dėkoji",
      kudos_reason_label: "Už ką?",
      kudos_reason_placeholder: "Padėjo išspręsti problemą, liko vėliau, kad ją užbaigtų.",
      kudos_reason_min: "Bent 3 simboliai",
      kudos_no_balance: "Šiandien padėkų nebeliko",
      kudos_no_balance_hint: "Šiandien padėkų nebeliko. Likutis atnaujinamas kasdien.",
      kudos_self_forbidden: "Negalite duoti padėkos sau",
      kudos_reason_too_short: "Per trumpas paaiškinimas",
      kudos_reason_too_long: "Per ilgas paaiškinimas",
      kudos_invalid_amount: "Netinkamas kiekis",
      kudos_amount: "Kiekis",
      kudos_balance_tooltip: "Šios dienos padėkos (atnaujinamos kasdien)",
      kudos_received_from: "{{name}} padėkojo jums",
      kudos_received_from_amount: "{{name}} padėkojo jums {{bolts}}",
      unread_kudos: "Turite neperskaitytų padėkų",
      gave_kudos_to: "padėkojo",
      no_kudos_yet: "Dar nėra padėkų šioje įmonėje — būk pirmas!",
      recent_kudos: "Paskutinės padėkos",
      karma_unit: "karma",
      balance: "Likutis",
      level_newbie: "Naujokas",
      level_helper: "Pagalbininkas",
      level_contributor: "Įdėjingas",
      level_star: "Žvaigždė",
      level_champion: "Čempionas",
      level_legend: "Legenda",
      last_seen_never: "Niekada",
      last_seen_just_now: "Ką tik",
      last_seen_minutes: "prieš {{count}} min.",
      last_seen_hours: "prieš {{count}} val.",
      last_seen_days: "prieš {{count}} d.",
      click_to_collapse: "Spauskite, kad sutrauktumėte",
      profile_leaves_tab: "Darbuotojo kalendorius",
      profile_leaves_list_toggle: "Sąrašas",
      profile_leaves_heading: "Prašymai dėl neatvykimo",
      profile_no_leave_requests: "Pasirinktu laikotarpiu prašymų nėra.",
      profile_leaves_load_error: "Nepavyko įkelti prašymų.",
      profile_leave_view_in_calendar: "Žiūrėti atostogų kalendoriuje",
      profile_leave_calendar_short: "Kalendorius",
      leave_calendar_deep_link_not_found:
        "Nepavyko atidaryti šio prašymo atostogų kalendoriuje.",
      leave_calendar_copy_link: "Kopijuoti nuorodą",
      leave_calendar_copy_link_success: "Atostogų kalendoriaus nuoroda nukopijuota.",
      leave_calendar_copy_link_error: "Nepavyko nukopijuoti nuorodos.",
      no_onboarding_documents: "Įdarbinimo dokumentų nerasta",
      contract_amendments: "Darbo sutarties pakeitimai",
      create_amendment: "Sukurti pakeitimą",
      amendment_number: "Pakeitimo numeris",
      effective_date: "Įsigaliojimo data",
      change_point: "Sutarties punktas",
      change_text: "Naujas tekstas",
      new_point: "Naujas punktas",
      change_existing: "Keičiamas punktas",
      remove_point: "Naikinamas punktas",
      generate: "Generuoti",
      signing: "Pasirašoma",
      changes: "Pakeitimai",
      add_change: "Pridėti pakeitimą",
      is_position_change: "Pareigų keitimas",
      is_position_change_hint:
        "Pažymėjus, išsaugojus bus atnaujintas naudotojo profilis ir vėl atidarytas tvarkų žingsnis.",
      is_employment_terms_change: "Pareigų / atlyginimo keitimas",
      is_employment_terms_change_hint:
        "Pridėkite tik tuos laukus, kuriuos norite keisti. Pašalintos sekcijos nebus atnaujintos pasirašius pakeitimą.",
      add_position_update: "Pareigų keitimas",
      add_salary_update: "Atlyginimo keitimas",
      add_hours_update: "Darbo valandų keitimas",
      salary_update_required: "Atlyginimo keitimui reikia nurodyti atlyginimą",
      hours_update_required: "Valandų keitimui reikia nurodyti valandas per savaitę",
      new_position_lt: "Naujos pareigos (LT)",
      new_position_en: "Naujos pareigos (EN)",
      new_position_lt_required: "Pareigų keitimui reikia nurodyti pareigas (LT)",
      amendment_position_reviews: "Pareigų keitimo peržiūros",
      amendment_position_reviews_hint:
        "Atlikite tvarkų peržiūrą šiam pareigų keitimui (kaip įdarbinime). Personalo įrašo statusas nesikeičia; pareigos pritaikomos užbaigus tvarkų peržiūrą.",
      amendment_ws_review: "Tvarkų peržiūra",
      amendment_ws_review_pending: "Laukia tvarkų peržiūros",
      amendment_ws_review_approved: "Tvarkų peržiūra patvirtinta",
      amendment_terms_applied: "Sąlygos pritaikytos",
      amendment_change_positions: "Pareigų keitimas",
      amendment_change_salary: "Atlyginimo keitimas",
      amendment_change_hours: "Darbo valandų keitimas",
      amendment_created: "Pakeitimas sukurtas",
      amendment_updated: "Pakeitimas atnaujintas",
      amendment_deleted: "Pakeitimas ištrintas",
      amendment_generated: "Dokumentas sugeneruotas",
      amendment_revoked: "Pasirašymas atšauktas",
      regenerate: "Pergeneruoti",
      revoke: "Atšaukti",
      confirm_delete_amendment: "Ar tikrai norite ištrinti šį pakeitimą?",
      confirm_revoke_amendment: "Aktyvūs parašai bus atšaukti ir pakeitimas grįš į sugeneruotą būseną. Tęsti?",
      // Seno pasirašyto pakeitimo registravimas, sąlygų nurodymas pasirašytam
      amendment_register_signed: "Registruoti pasirašytą pakeitimą",
      amendment_registered: "Pakeitimas užregistruotas",
      amendment_registered_scan: "Registruotas (skenuotas)",
      amendment_signed_scan: "Pasirašytas dokumentas (skenuotas)",
      amendment_set_terms: "Nurodyti naujas sąlygas",
      amendment_terms_not_set: "Sąlygos nenurodytos",
      amendment_terms_required: "Pridėkite bent vieną sąlygą: pareigas, atlyginimą arba darbo valandas",
      amendment_terms_saved: "Sąlygos išsaugotos",
      amendment_terms_hint:
        "Jei keičiate atlyginimą, pareigas ar darbo valandas, pridėkite jas mygtukais žemiau – tik tada atsinaujins „Sutarties informacija“.",
      amendment_number_required: "Įveskite pakeitimo numerį",
      amendment_effective_date_required: "Nurodykite įsigaliojimo datą",
      amendment_scan_required: "Pridėkite arba pasirinkite pasirašytą dokumentą",
      amendment_number_taken: "Pakeitimas su tokiu numeriu jau yra",
      amendment_scan_not_found: "Dokumentas nerastas – įkelkite jį iš naujo arba pasirinkite kitą",
      amendment_onboarding_not_found: "Įdarbinimo įrašas nerastas",
      amendment_not_signed: "Sąlygas galima nurodyti tik pasirašytam pakeitimui",
      amendment_not_found: "Pakeitimas nerastas",
      amendment_terms_already_set: "Šiam pakeitimui sąlygos jau nurodytos",
      contract_terms_updated_by_amendment: "Atnaujinta pagal pakeitimą {{number}} ({{date}})",
      amendment_number_too_long: "Pakeitimo numeris per ilgas (daugiausiai 100 simbolių)",
      amendment_scan_not_fresh: "Pasirinktas failas jau naudojamas – įkelkite naują skenuotą dokumentą",
      amendment_document_annulled: "Pakeitimo dokumentas anuliuotas arba atšauktas",
      amendment_file_choice_conflict: "Pasirinkite arba įkeltą failą, arba esamą dokumentą – ne abu",
      amendment_file_in_signing: "Dokumentas dar pasirašomas – pasirinkite pasirašytą dokumentą",
      amendment_file_already_used: "Šis dokumentas jau susietas su kitu įrašu",
      amendment_not_registered: "Redaguoti galima tik pagal pasirašytą dokumentą užregistruotus pakeitimus",
      amendment_edit_registered: "Redaguoti registruotą pakeitimą",
      amendment_document_upload: "Įkelti iš kompiuterio",
      amendment_document_from_tree: "Pasirinkti iš dokumentų medžio",
      amendment_document_change: "Keisti",
      amendment_document_locked: "Registruoto pakeitimo dokumento pakeisti negalima",
      document_tree_all_folders: "Visi aplankai",
      document_tree_open_folder_to_search: "Atidarykite aplanką, kad galėtumėte ieškoti jame",
      document_tree_pick: "Pasirinkti",
      amendment_positions_warning:
        "Jei šis pakeitimas naujausias pagal datą, darbuotojo pareigos bus pakeistos (su sričių patvirtinimu). Senuose pakeitimuose pareigų nenurodykite, jei vėliau jos keitėsi.",
      no_documents: "Dokumentų nėra",
      regenerate_document: "Pergeneruoti dokumentą",
      confirm_regenerate_document: "Esamas dokumentas bus ištrintas ir sugeneruotas naujas. Aktyvios pasirašymo užklausos bus atšauktos. Tęsti?",
      confirm_regenerate_document_no_sign: "Esamas dokumentas bus ištrintas ir sugeneruotas naujas. Tęsti?",
      generated: "Sugeneruota",
      id_document: "Asmens dokumentas",
      birth_certificate: "Gimimo liudijimas",
      drivers_license: "Vairuotojo pažymėjimas",
      health_certificate: "Sveikatos pažymėjimas",
      education_document: "Išsilavinimo dokumentas",
      other_documents: "Kiti dokumentai",
      upload_error: "Failo įkėlimas nepavyko",
      upload_partial_error: "Kai kurių failų įkelti nepavyko",
      drop_file_or_click: "Paspauskite norėdami įkelti failą",
      personal_code: "Asmens kodas",
      fill_all_fields: "Prašome užpildyti visus laukus",
      rate_limit_exceeded: "Per daug bandymų. Bandykite vėliau.",
      invalid_code: "Neteisingas kodų derinys",
      thank_you: "Ačiū!",
      kiosk_complete_message: "Jūsų formos pateiktos. Įmonės atstovas pasirūpins pasirašymu.",
      kiosk_no_pending_actions: "Šiuo metu jums nėra laukiamų veiksmų. Įmonės atstovas tvarko dabartinį žingsnį.",
      kiosk_work_security_message:
        "Turite pasirašyti tvarkų dokumentus — prisijungimo nuorodą rasite el. laiške arba kreipkitės į personalą.",
      start_over: "Pradėti iš naujo",
      no_steps_available: "Šiuo metu nėra prieinamų žingsnių.",
      saving: "Saugoma...",
      saved: "Išsaugota ✓",
      save_error: "Nepavyko išsaugoti",
      next: "Toliau",
      back: "Atgal",
      skip: "Praleisti",
      submit: "Pateikti",
      field_is_required: "Šis laukas privalomas",
      custom_field_required_message: "{{message}}",
      no_contacts_authorized_to_sign: "Nėra kontaktų, turinčių teisę pasirašyti",
      select_template_from_list:
        "Prašome pasirinkti šabloną iš sąrašo.",
      invalid_format: "Netinkamas formatas",
      value_too_small: "Reikšmė per maža",
      value_too_large: "Reikšmė per didelė",
      value_too_short: "Reikšmė per trumpa",
      value_too_long: "Reikšmė per ilga",
      login: "Prisijungti",
      signed: "Pasirašytas",
      view_pdf: "Peržiūrėti PDF",
      employee_documents: "Darbuotojo dokumentai",
      no_documents_uploaded: "Dokumentų nėra",
      attach_scanned_document: "Prisegti nuskenuotą dokumentą",
      employee_data: "Darbuotojo duomenys",
      education: "Išsilavinimas",
      education_institution: "Mokymo įstaiga",
      education_specialty: "Specialybė",
      declared_address: "Deklaruotas adresas",
      actual_address: "Faktinis adresas",
      emergency_contact: "Asmuo, su kuriuo galėtume susisiekti ypatingu atveju",
      id_document_issue_date: "Išdavimo data",
      id_document_expiry_date: "Galiojimo data",
      id_document_issue_place: "Išdavimo vieta",
      residence_permit: "Leidimas gyventi",
      has_disability: "Neįgalumas",
      disability_cert_number: "Pažymėjimo Nr.",
      disability_cert_expiry: "Galioja iki",
      work_capacity_percent: "Darbingumo lygis (%)",
      has_conflict_of_interest: "Interesų konfliktas",
      conflict_of_interest_details: "Konflikto aprašymas",
      additional_info_field: "Papildoma informacija",
      data_processing_consent: "Duomenų tvarkymo sutikimas",
      bank_account: "Banko sąskaita",
      payment_frequency: "Mokėjimo dažnumas",
      npd_option: "NPD",
      disability_level: "Neįgalumo lygis",
      // mobile: work-security
      incident_action_delete_confirm: "Ištrinti šią prevencinę priemonę?",
      ws_section_picker: "Skiltis",
      ws_filters_toggle: "Filtrai",
      children_info: "Vaikai",
      once_per_month: "Kartą per mėnesį",
      twice_per_month: "Du kartus per mėnesį",
      no_npd: "Netaikyti NPD",
      standard_npd: "Taikyti NPD",
      id_card: "Asmens tapatybės kortelė",
      passport_doc: "Pasas",
      agree: "Sutinku",
      disagree: "Nesutinku",
      primary_edu: "Pradinis",
      basic_edu: "Pagrindinis",
      secondary_edu: "Vidurinis",
      vocational: "Profesinis",
      vocational_secondary: "Profesinis vidurinis",
      higher_non_university: "Aukštasis neuniversitetinis",
      higher_university: "Aukštasis universitetinis",
      studying: "Studijuoja",
      children_under_12: "Vaikai iki 12 m.",
      children_under_14: "Vaikai iki 14 m.",
      disabled_children_under_18: "Neįgalūs vaikai iki 18 m.",
      employee_data_required: "Darbuotojas dar nepateikė reikiamų duomenų šiam žingsniui. Dokumentas negali būti sugeneruotas, kol darbuotojas neužpildys formos per kioską arba asmeninę paskyrą.",
      reopen_for_employee: "Grąžinti darbuotojui",
      reopen_to: "Grąžinti į",
      reopen_step_prompt: "Įveskite žingsnį, kurį norite atidaryti ({{steps}}):",
      confirm_reopen_step: "Bus ištrinti sugeneruoti dokumentai nuo šio žingsnio ir darbuotojas galės iš naujo redaguoti duomenis. Tęsti?",
      step_reopened: "Žingsnis atidarytas darbuotojo redagavimui",
      confirm_unlock_step: "Forma bus atrakinta ir darbuotojas galės redaguoti savo duomenis. Tęsti?",
      step_unlocked: "Žingsnis atrakintas darbuotojui",
      unlock_form: "Atrakinti formą",
      form_active: "Forma aktyvi",
      edit_data: "Redaguoti duomenis",
      activate_user: "Aktyvuoti vartotoją",
      confirm_activate_user: "Vartotojas gaus pilną prieigą prie įmonės. Tęsti?",
      user_activated: "Vartotojas sėkmingai aktyvuotas",
      signatures: "Parašai",
      waiting_for_document_generation: "Laukiama, kol administratorius paruoš dokumentą",
      data_submitted_waiting: "Jūsų duomenys pateikti. Laukiama, kol administratorius paruoš dokumentą.",
      gdpr_consents: "BDAR sutikimai",
      birthday_greeting: "Gimtadienio sveikinimas",
      photo_sessions: "Foto sesijos",
      website_team: "Svetainės komandos puslapis",
      social_media: "Socialiniai tinklai",
      client_presentations: "Klientų prezentacijos",
      internal_photo_video: "Vidinė foto/video medžiaga",
      internal_network: "Vidinis tinklas",
      no: "Ne",
      yes: "Taip",
      company_signer: "Įmonės pasirašantysis",
      computer_details: "Kompiuterio informacija",
      needs_server_access: "Reikia prieigos prie serverio",
      server_name: "Serverio pavadinimas",
      folder_access: "Prieiga prie aplankų",
      fuel_card: "Degalų kortelė",
      fuel_limit: "Degalų limitas",
      fuel_limit_amount: "Degalų limito suma",
      not_needed: "Nereikia",
      personal: "Asmeninis",
      any_paid: "Bet koks (apmokamas)",
      new_owned: "Naujas (nuosavas)",
      existing_owned: "Esamas (nuosavas)",
      rented: "Nuomojamas",
      personal_rent: "Asmeninis (nuoma)",
      phone_device: "Telefono aparatas",
      notes: "Pastabos",
      signed_documents: "Pasirašyti dokumentai",
      generate_document: "Generuoti dokumentą",
      signing_status: "Pasirašymo būsena",
      sign_document: "Pasirašyti",
      all_signed: "Visi parašai surinkti",
      download_signed_container: "Atsisiųsti pasirašytus dokumentus (.asice)",
      waiting_for_signatures: "Laukiama parašų",
      document_generated: "Dokumentas sugeneruotas",
      document_ready: "Dokumentas paruoštas",
      refresh: "Atnaujinti",
      document_uploaded: "Dokumentas įkeltas",
      edit_will_delete_document: "Išsaugojus pakeitimus esamas dokumentas bus ištrintas. Reikės sugeneruoti naują.",
      reactivate: "Atnaujinti",
      onboarding_reactivated: "Įdarbinimas atnaujintas",
      onboarding_reactivate_membership_disabled_activated:
        "Šis asmuo jau dirbo įmonėje ir jo prieiga išjungta — šio įdarbinimo atnaujinti negalima. Pradėkite naują įdarbinimą.",
      contract_registration: "Sutarties registracija",
      contract_registration_description: "Registruoti esamą darbo sutartį esamam darbuotojui",
      new_hire: "Naujas įdarbinimas",
      new_hire_description: "Pilnas įdarbinimo procesas naujam darbuotojui",
      original_contract_number: "Originalus sutarties numeris",
      original_contract_number_required: "Originalus sutarties numeris yra privalomas",
      personal_code_required: "Asmens kodas yra privalomas",
      contract_file: "Sutarties failas",
      contract_file_required: "Sutarties failas yra privalomas",
      contract_details: "Sutarties informacija",
      employee_required: "Darbuotojas yra privalomas",
      error_creating_registration: "Klaida registruojant sutartį",
      select_file: "Pasirinkti failą",
      no_file: "Failas neprisegtas",
      contract_category_not_configured: "Darbo sutarčių kategorija nenustatyta nustatymuose",
      activity: "Veikla",
      audit_log_total: "Iš viso veiksmų",
      audit_log_active_action: "Veiksmo filtras",
      audit_log_all_actions: "Visi veiksmai",
      audit_log_active_user: "Atlikėjo filtras",
      audit_log_all_users: "Visi naudotojai",
      audit_log_loading: "Kraunami veiklos įrašai...",
      audit_log_load_failed: "Nepavyko įkelti veiklos žurnalo.",
      audit_log_empty: "Veiklos įrašų nerasta",
      audit_log_empty_filtered_hint:
        "Pakeiskite arba išvalykite filtrus, kad pamatytumėte daugiau įrašų.",
      audit_log_empty_hint: "Visi sistemoje atlikti veiksmai bus rodomi čia pagal laiką.",
      audit_log_clear_filters: "Išvalyti filtrus",
      audit_log_refresh: "Atnaujinti",
      validation_attempt_customers_settings: "Klientų anketų validacijos problemos",
      validation_attempt_customers_help:
        "Klientai, kurie bandė pateikti anketą, bet nepavyko dėl formos validacijos.",
      validation_attempt_customers_empty: "Klaidų dar nebuvo",
      validation_attempt_forms_title: "Nepavykę anketos bandymai — {{name}}",
      validation_attempt_count: "Bandymai",
      validation_attempt_last: "Paskutinis bandymas",
      validation_attempt_at: "Bandymo laikas",
      validation_attempt_errors: "Validacijos klaidos",
      validation_attempt_detail_title: "Nepavykęs anketos bandymas",
      source_user_to_close: "Uždaroma paskyra",
      target_user_survivor: "Lieka paskyra",
      all_records_below_will_be_transferred: "Visi žemiau esantys įrašai bus perkelti",
      this_user_will_inherit_all_records: "Šis vartotojas paveldės visus įrašus",
      analyzing_data_structures: "Analizuojamos duomenų struktūros",
      merge_impact_analysis: "Kas bus perkelta",
      data_category: "Duomenų kategorija",
      source_transfer: "Perkeliama iš šaltinio",
      target_existing: "Egzistuoja tiksle",
      final_count: "Galutinis skaičius",
      confirm_and_start_transfer: "Sujungti paskyras",
      processing_merge: "Vykdomas apjungimas",
      merge_successful: "Apjungimas sėkmingas",
      all_records_have_been_successfully_migrated: "Visi įrašai buvo sėkmingai perkelti.",
      batch_id: "Partijos ID",
      return_to_settings: "Grįžti į nustatymus",
      error_analyzing_merge: "Klaida analizuojant apjungimą",
      error_performing_merge: "Klaida vykdant apjungimą",
      merge_completed_successfully: "Apjungimas užbaigtas sėkmingai",
      merge_intro:
        "Kai tas pats žmogus turi dvi paskyras: šios įmonės įrašai perkeliami į paliekamą paskyrą, o uždaryta paskyra šiai įmonei nebepriklausys. Atšaukti nebus galima.",
      merge_confirm_label: "Patvirtinkite įrašydami „{{word}}“",
      merge_confirm_word: "SUJUNGTI",
      merge_source_membership_closed:
        "Uždaryta paskyra šiai įmonei nebepriklauso. Jos narystės kitose įmonėse nepakeistos.",
      merge_tab_merge: "Sujungti",
      merge_tab_history: "Istorija",
      user_merge_history_subtitle: "Peržiūrėkite šios įmonės atliktus paskyrų apjungimus.",
      user_merge_history_detail: "Apjungimo audito detalės",
      merge_history_empty: "Apjungimų įrašų nėra.",
      merge_history_merged_at: "Apjungta",
      merge_history_source_user: "Šaltinio vartotojas",
      merge_history_target_user: "Tikslinis vartotojas",
      merge_history_actor: "Atliko",
      merge_history_steps: "Žingsnių",
      merge_history_back_to_list: "Atgal į sąrašą",
      merge_history_sequence: "Eil.",
      merge_history_table_column: "Lentelė",
      merge_history_column_column: "Stulpelis",
      merge_history_operation: "Operacija",
      merge_history_row_id: "Eilutės ID",
      merge_history_old_value: "Sena reikšmė",
      merge_history_new_value: "Nauja reikšmė",
      merge_history_load_error: "Nepavyko įkelti apjungimų istorijos.",
      merge_history_batch_not_found: "Šios apjungimo partijos nerasta.",
      select_users_to_begin_analysis: "Pasirinkite vartotojus analizei pradėti",
      merge_select_both_users:
        "Pasirinkite šaltinio ir tikslinio vartotojus, kad būtų paleista poveikio analizė.",
      merge_invalid_same_user:
        "Šaltinis ir tikslas negali būti tas pats asmuo. Pasirinkite du skirtingus vartotojus.",
      Are_you_sure_you_want_to_resend_email: "Ar tikrai norite persiųsti el. laišką?",
      access: "Prieiga",
      assetTypes: "Materialinių vertybių tipai",
      assets_types: "Materialinių vertybių tipai",
      cannot_select_same_category: "Negalima pasirinkti tos pačios kategorijos",
      click: "Spustelėkite",
      companies: "Įmonės",
      contact: "Kontaktas",
      created_by: "Sukūrė",
      default_today: "Pagal numatytuosius: šiandien",
      dokobit_acess_key: "Dokobit prieigos raktas",
      download_file: "Atsisiųsti failą",
      feed_max_files_exceeded: "Viršytas maksimalus failų skaičius",
      fetch_error: "Nepavyko įkelti duomenų",
      file_context: "Failo kontekstas",
      groups: "Grupės",
      hide: "Slėpti",
      info: "Informacija",
      must_be_number: "Turi būti skaičius",
      needs_computer: "Reikalingas kompiuteris",
      no_assigned_to_provided: "Priskyrimas nenurodytas",
      no_brand_provided: "Prekės ženklas nenurodytas",
      no_model_provided: "Modelis nenurodytas",
      no_notes_provided: "Pastabos nenurodytos",
      no_purchase_date_provided: "Pirkimo data nenurodyta",
      no_serial_provided: "Serijos numeris nenurodytas",
      no_status_provided: "Būsena nenurodyta",
      no_type_provided: "Tipas nenurodytas",
      user_permissions: "Teisės",
      no_user_permissions_provided: "Teisių nėra",
      order_required: "Užsakymas yra privalomas",
      pending: "Laukiama",
      phone: "Telefonas",
      please_fill_required_fields: "Užpildykite privalomus laukus",
      regenerate_code: "Sugeneruoti kodą iš naujo",
      search_templates: "Ieškoti šablonų",
      select_sign_type: "Pasirinkite pasirašymo būdą",
      select_stock: "Pasirinkite sandėlį",
      selected: "pasirinkta",
      sent: "Išsiųsta",
      stock: "Sandėlis",
      stock_select: "Pasirinkite sandėlį",
      subject_required: "Tema yra privaloma",
      title_required: "Pavadinimas yra privalomas",
      type_required: "Tipas yra privalomas",
      view: "Peržiūrėti",
      open_in_documents: "Atidaryti dokumentų modulyje",
      pending_onboarding_banner: "Jūsų laukia neužpildyta įdarbinimo anketa.",
      pending_onboarding_banner_with_company:
        "Jūsų laukia neužpildyta įdarbinimo anketa ({{companies}}).",
      pending_onboarding_action: "Pildyti anketą",
      visible_in_all_profile: "Matoma visuose profiliuose",
      year_month_required: "Reikia nurodyti metus ir mėnesį",
      existing: "Esamas",
      position: "Pareigos",
      "microsoft-connect": "Microsoft Connect",
      more: "Daugiau",
      upload_document_failed: "Nepavyko įkelti dokumento. Bandykite dar kartą.",
      generate_document_failed: "Nepavyko sugeneruoti dokumento. Bandykite dar kartą.",
      amend_role_rules: "Keisti taisykles",
      view_document_preview: "Dokumento peržiūra",
      assign_users_failed: "Nepavyko priskirti vartotojų. Bandykite dar kartą.",
      confirm_remove_user_title: "Pašalinti vartotoją iš pareigybės",
      role_load_failed: "Nepavyko įkelti pareigybės",
      role_load_failed_desc: "Nepavyko įkelti šios pareigybės. Bandykite dar kartą.",
      role_not_found: "Pareigybė nerasta",
      role_not_found_desc: "Prašoma pareigybė neegzistuoja arba buvo ištrinta.",
      back_to_roles: "Atgal į pareigybes",
      current_security_rules: "Galiojančios taisyklės",
      previous_versions: "Ankstesnės versijos",
      amend_rules: "Keisti taisykles",
      no_rules_defined: "Šiai pareigybei taisyklės dar neapibrėžtos.",
      no_previous_versions: "Ankstesnių versijų nėra.",
      earlier_version: "Versija",
      go_to_document: "Eiti į dokumentą",
      step_1_title: "Dokumento generavimas",
      step_1_description: "Sistemos šablonas automatiškai sugeneruoja taisykles į oficialią PDF dokumento versiją.",
      latest_version_doc: "Naujausia dokumento versija",
      generated_on: "Sugeneruota",
      no_document_yet: "Šiai pareigybei tvarkų dokumentas dar nesugeneruotas.",
      generating: "Generuojama...",
      generate_pdf_document: "Generuoti PDF dokumentą",
      uploading: "Įkeliama...",
      add_rule_to_generate: "Pridėkite bent vieną taisyklę, kad galėtumėte generuoti.",
      assigning: "Priskiriama...",
      assign: "Priskirti",
      no_users_assigned: "Šiai pareigybei šiuo metu nepriskirtas nei vienas vartotojas.",
      workers_signature_hint: "Priskirti darbuotojai gaus pasirašymo užklausas, kai bus sugeneruotas dokumentas.",
      failed_load_user_assignments: "Nepavyko įkelti esamų vartotojo pareigybių priskyrimų.",
      user_required: "Pirmiausia pasirinkite vartotoją.",
      failed_save_assignments: "Nepavyko išsaugoti vartotojo pareigybių priskyrimų.",
      choose_user: "Pasirinkite vartotoją...",
      select_user_to_assign: "Pasirinkite vartotoją",
      select_users_to_assign: "Pasirinkite priskiriamus vartotojus",
      select_roles_to_assign: "Pasirinkite pareigybes",
      no_roles_available: "Pareigybės dar neapibrėžtos.",
      failed_to_remove_user: "Nepavyko pašalinti vartotojo.",
      confirm_unassign_user_description: "Ar tikrai norite pašalinti {{userName}} iš šios pareigybės? Tai anuliuos laukiančius pasirašymo kvietimus, jei jie dar nepasirašė.",
      pointwise_security_rules: "Taisyklės punktuotiškai",
      add_rule: "Pridėti punktą",
      rule_text_placeholder: "Taisyklės tekstas (pvz., Visada dėvėti asmenines apsaugos priemones...)",
      rules_required: "Reikalinga bent viena taisyklė",
      failed_amend_role: "Nepavyko atnaujinti taisyklių.",
      amend_rules_warning_title: "Keisti taisykles ir anuliuoti parašus?",
      amend_rules_warning_desc: "Pakeitus taisykles reikės sugeneruoti naują PDF dokumentą. Visi esami šio vaidmens parašai bus anuliuoti ir vartotojams reikės pasirašyti naują dokumentą. Ar norite tęsti?",
      role_name_required: "Pareigybės pavadinimas yra privalomas",
      failed_create_role: "Nepavyko sukurti pareigybės.",
      role_name: "Pareigybės pavadinimas",
      role_name_placeholder: "pvz., Suvirinimo darbai",
      role_description: "Aprašymas",
      role_desc_placeholder: "Trumpas pareigybės reikalavimų aprašymas...",
      create_work_security_role: "Sukurti pareigybę",
      archive: "Archyvuoti",
      archived: "Archyvas",
      archived_at: "Archyvavimo data",
      edit_work_security_role: "Redaguoti pareigybę",
      archive_role: "Archyvuoti pareigybę",
      role_archived_banner: "Ši pareigybė yra archyve. Atstatykite ją, kad galėtumėte redaguoti ar priskirti darbuotojus.",
      confirm_archive_role_desc: "Archyvuoti „{{roleName}}“? Pareigybė bus paslėpta iš sąrašo, priskyrimų valdymo ir darbuotojų dokumentų bei nebegalės gauti naujų priskyrimų. Esami parašai išsaugomi – bet kada galėsite ją atstatyti.",
      failed_update_role: "Nepavyko atnaujinti pareigybės.",
      failed_restore_role: "Nepavyko atstatyti pareigybės. Bandykite dar kartą.",
      failed_archive_role: "Nepavyko archyvuoti pareigybės.",
      no_archived_roles: "Nėra archyvuotų pareigybių",
      no_archived_roles_description: "Archyvuotos pareigybės bus rodomos čia ir gali būti atstatytos.",
      work_security_roles: "Tvarkos",
      // The module's menu item and page title; «work_security_roles» stays for the employee card tile.
      work_security_module_title: "Įmonės vidiniai dokumentai",
      work_security: "Tvarkos",
      work_security_roles_tab: "Pareigybės",
      area_switcher_label: "Sritis",
      all_areas: "Visos sritys",
      manage_areas_link: "Tvarkyti sritis",
      ws_areas_load_failed: "Nepavyko įkelti sričių sąrašo. Rodomi visi jums prieinami įrašai.",
      ws_area_invalid_reset: "Pasirinkta sritis jums neprieinama. Rodoma numatytoji sritis.",
      area_unknown: "Kita sritis",
      work_security_required_at_hiring: "Privaloma įdarbinant",
      work_security_required_at_hiring_hint:
        "Šios instrukcijos nepasirašius, darbuotojo nepavyks įdarbinti.",
      area_field_required: "Pasirinkite instrukcijos sritį.",
      area_error_forbidden: "Neturite prieigos prie šios instrukcijų srities.",
      area_error_archived: "Ši instrukcijų sritis yra archyvuota.",
      area_error_group_mismatch: "Ši grupė priklauso kitai instrukcijų sričiai.",
      area_error_mismatch: "Šis įrašas priklauso kitai instrukcijų sričiai.",
      area_error_incidents_disabled: "Ši instrukcijų sritis nevykdo įvykių žurnalo.",
      area_error_system_archive_forbidden: "Sisteminės srities archyvuoti negalima.",
      area_error_move_has_test_links:
        "Ši pareigybė susieta su kitos srities mokymų testais ({{tests}}). Prieš perkeliant pareigybę, atsiekite juos.",
      area_error_master_required: "Sritį pakeisti gali tik Master.",
      work_security_areas_title: "Sritys",
      work_security_areas_hint:
        "Sritis — atskira tvarkų grupė su savo atsakingais, pvz., darbų sauga ar gaisrinė sauga. Atsakingi mato ir tvarko tik savo sritį.",
      work_security_area_create: "Nauja sritis",
      work_security_areas_load_error: "Nepavyko įkelti sričių sąrašo.",
      work_security_area_system_badge: "Sisteminė",
      work_security_area_archived_badge: "Archyvuota",
      work_security_area_no_responsibles: "Atsakingų asmenų nenurodyta",
      work_security_area_responsibles_list: "Atsakingi: {{names}}",
      work_security_area_can_register_incidents: "Galima registruoti incidentus",
      work_security_area_can_register_incidents_hint:
        "Šioje srityje bus incidentų žurnalas ir incidento aktai.",
      work_security_area_name: "Srities pavadinimas",
      work_security_area_name_placeholder: "pvz., Kibernetinis saugumas",
      work_security_area_name_required: "Srities pavadinimas yra privalomas.",
      work_security_area_responsibles_select: "Priskirti atsakingą",
      work_security_area_save_failed: "Nepavyko išsaugoti srities.",
      work_security_area_responsibles_save_failed:
        "Sritis išsaugota, tačiau nepavyko atnaujinti atsakingų asmenų sąrašo. Bandykite dar kartą.",
      work_security_area_archive: "Archyvuoti sritį",
      work_security_area_archive_confirm_desc:
        "Srities instrukcijos išliks, bet naujų kurti nebegalėsite.",
      work_security_area_archive_confirm: "Patvirtinti archyvavimą",
      work_security_area_archive_failed: "Nepavyko archyvuoti srities.",
      work_security_area_restore: "Atkurti sritį",
      work_security_area_restore_failed: "Nepavyko atkurti srities.",
      work_security_area_system_archive_disabled: "Sisteminės srities archyvuoti negalima.",
      work_security_settings_scope_label: "Nustatymai taikomi",
      work_security_settings_scope_company: "Visai įmonei",
      work_security_settings_inherited_banner_title: "Ši sritis naudoja bendrus įmonės nustatymus",
      work_security_settings_inherited_banner_desc:
        "Šiai sričiai galite nustatyti atskirus nustatymus ir bet kada grįžti prie bendrų įmonės nustatymų.",
      work_security_settings_use_own: "Naudoti atskirus šios srities nustatymus",
      work_security_area_reset_label: "Atskiri šios srities nustatymai",
      work_security_area_reset_description: "Ši sritis naudoja savo dokumentų nustatymus, o ne bendrus įmonės.",
      work_security_area_reset: "Grąžinti bendrus įmonės nustatymus",
      work_security_area_reset_confirm_description: "Srities dokumentų nustatymai bus ištrinti, ji naudos bendrus įmonės nustatymus.",
      work_security_area_reset_confirm: "Grąžinti",
      work_security_area_reset_done: "Sritis naudoja bendrus įmonės nustatymus.",
      work_security_area_reset_failed: "Nepavyko grąžinti bendrų nustatymų. Bandykite dar kartą.",
      work_security_settings_scope_load_error: "Nepavyko įkelti šios srities nustatymų. Bandykite dar kartą.",
      work_security_documents_title: "Dokumentai",
      work_security_documents_hint: "Galioja visoms sritims, nebent sritis turi savo nustatymus.",
      work_security_documents_hint_area: "Dokumentai, kuriuos naudoja pasirinkta sritis.",
      work_security_role_document: "Pareigybės tvarkų dokumentas",
      work_security_role_document_hint:
        "Dokumentas, kurį sistema sugeneruoja pareigybei su jos tvarkomis.",
      work_security_incident_act: "Incidento aktas",
      work_security_incident_act_hint:
        "Dokumentas, kurį sistema sugeneruoja užregistravus incidentą.",
      work_security_template_system: "Sistemos šablonas",
      work_security_template_custom: "Savas šablonas",
      work_security_filed_in: "dedama: {{path}}",
      work_security_filed_nowhere: "aplankas nepasirinktas",
      work_security_upload_folders: "Iš kurių aplankų galima prisegti esamus dokumentus",
      work_security_upload_folders_hint:
        "Prie pareigybės ar mokymo galima pridėti tik dokumentus iš šių aplankų (įskaitant poaplankius).",
      work_security_upload_folders_none: "Nepasirinkta",
      desk: "Desk",
      desk_settings: "Desk nustatymai",
      desk_mailboxes: "Pašto dėžutės",
      desk_mailboxes_hint:
        "Prijungtos pašto dėžutės ir jų apdorojimo būsena. Kiekvienas gautas laiškas tampa kortele.",
      desk_mailboxes_manage_hint: "Pasirinkite dėžutę nustatymams peržiūrėti/redaguoti arba pridėkite naują.",
      desk_mailboxes_new_hint: "Užpildykite formą žemiau, kad prijungtumėte šią dėžutę.",
      desk_no_mailboxes: "Dar nėra prijungtų pašto dėžučių.",
      desk_shared_without_mailbox_hint: "Vis tiek galite atidaryti su jumis bendrinamas korteles. Prijunkite pašto dėžutę Desk nustatymuose, kad gautumėte savo laiškus.",
      desk_mailbox_switch: "Dėžutė",
      desk_mailbox_switch_empty_hint: "Prijunkite pašto dėžutę Desk nustatymuose, kad čia matytumėte laiškus.",
      desk_mailboxes_load_failed: "Nepavyko įkelti pašto dėžučių. Bandykite dar kartą.",
      desk_address: "Adresas",
      desk_provider: "Tiekėjas",
      desk_ingest_mode: "Rinkimo režimas",
      desk_ingest_mode_all: "Visi laiškai",
      desk_ingest_mode_label: "Pagal žymę",
      desk_last_sync: "Paskutinė sinchronizacija",
      desk_ingest_errors: "Apdorojimo klaidos",
      desk_never_synced: "Dar nesinchronizuota",
      desk_mailbox_disabled: "Išjungta",
      desk_sync_stale: "Sinchronizacija vėluoja",
      desk_sync_ok: "OK",
      desk_inbox: "Gauta",
      desk_inbox_empty: "Dėžutė tuščia — nauji laiškai automatiškai tampa kortelėmis.",
      desk_archive: "Archyvas",
      desk_archive_empty: "Archyvuotų kortelių dar nėra.",
      desk_drafts: "Juodraščiai",
      desk_shared: "Bendrinama",
      desk_shared_empty: "Bendrinamų kortelių nėra — niekas su jumis nesidalijo ir jūs nieko nebendrinote.",
      desk_shared_with_me_empty: "Su jumis dar nėra bendrinamų kortelių.",
      desk_shared_by_me_empty: "Dar nesate bendrinę jokių kortelių.",
      desk_shared_scope_all: "Visos",
      desk_shared_scope_with_me: "Bendrinama su manimi",
      desk_shared_scope_by_me: "Bendrinu aš",
      desk_draft: "Juodraštis",
      desk_drafts_empty: "Juodraščių nerasta.",
      desk_trash: "Šiukšlinė",
      desk_trash_empty: "Šiukšlinė tuščia.",
      desk_save_draft: "Išsaugoti juodraštį",
      desk_restore: "Atkurti",
      desk_publish: "Paskelbti",
      desk_panel_widen: "Išplėsti skydelį",
      desk_panel_narrow: "Siaurinti skydelį",
      desk_delete_permanently: "Ištrinti visam laikui",
      desk_archive_action: "Archyvuoti",
      desk_unarchive: "Grąžinti",
      desk_archived_at: "Archyvuota",
      desk_actions: "Veiksmai",
      desk_search: "Ieškoti",
      desk_search_clear: "Išvalyti",
      desk_search_text: "Tekstas",
      desk_search_text_placeholder: "Pavadinimas, tema, peržiūra…",
      desk_search_email: "El. paštas",
      desk_search_email_placeholder: "vardas@imone.lt",
      desk_search_date_from: "Nuo datos",
      desk_search_date_to: "Iki datos",
      desk_search_empty: "Pagal paiešką kortelių nerasta.",
      desk_show_noise: "Rodyti triukšmą",
      desk_check_mail: "Tikrinti paštą",
      desk_check_mail_checking: "Tikrinama…",
      desk_check_mail_new: "Naujų laiškų: {{count}}",
      desk_check_mail_none: "Naujų laiškų nėra",
      desk_check_mail_problem: "{{address}}: {{reason}}",
      desk_check_mail_status_busy: "tikrinimas jau vyksta",
      desk_check_mail_status_disconnected: "šiuo metu neprisijungta",
      desk_check_mail_status_offline: "pašto rinkimas neveikia",
      desk_check_mail_status_timeout: "atsakymo dar nėra — sąrašas atsinaujins pats",
      desk_check_mail_status_unavailable: "pašto paslauga nepasiekiama",
      desk_check_mail_status_error: "patikrinti nepavyko",
      desk_card: "Kortelė",
      desk_from: "Nuo",
      desk_waiting: "Laukia",
      desk_last_message: "Paskutinė žinutė",
      desk_status_open: "Atvira",
      desk_status_waiting_client: "Laukiama kliento",
      desk_status_done: "Atlikta",
      desk_noise: "Triukšmas",
      desk_badge_manual: "Rankinė užduotis",
      desk_participants: "Dalyviai",
      desk_you: "Jūs",
      desk_note: "Pastaba",
      desk_auto_mail: "auto",
      desk_meeting_join: "Prisijungti",
      desk_meeting_organizer: "Organizatorius",
      desk_meeting_cancelled: "Atšauktas",
      desk_meeting_all_day: "visą dieną",
      desk_meeting_recurring: "kartojasi",
      desk_meeting_sender_time: "siuntėjo vietos laikas",
      desk_send_failed: "Išsiųsti nepavyko",
      desk_download: "Atsisiųsti",
      desk_reply: "Atsakyti",
      desk_forward: "Persiųsti",
      desk_share: "Bendrinti",
      desk_share_send: "Bendrinti kortelę",
      desk_share_placeholder: "Pridėkite pastabą kolegoms (privaloma)…",
      desk_share_users_required: "Pasirinkite bent vieną kolegą.",
      desk_share_note_required: "Bendrinimo pastaba yra privaloma.",
      desk_shared_with: "Bendrinama su",
      desk_unshare: "Pašalinti",
      desk_shared_with_me: "Bendrinama su manimi",
      desk_share_pick_users: "Kolegos",
      desk_share_search_placeholder: "Ieškoti pagal vardą ar el. paštą…",
      desk_share_users_empty: "Kolegų nerasta. Pabandykite išvalyti paiešką.",
      desk_share_users_load_failed: "Nepavyko įkelti kolegų.",
      desk_to: "Kam",
      desk_cc: "Kopija",
      desk_reply_placeholder: "Rašykite atsakymą — jis bus išsiųstas klientui el. paštu…",
      desk_forward_placeholder: "Trumpa pastaba kolegai…",
      desk_forward_to_placeholder: "kolega@imone.lt",
      desk_forward_send: "Persiųsti el. laišką",
      desk_forward_recipients_required: "Įveskite bent vieną gavėjo el. paštą.",
      desk_note_placeholder: "Vidinė pastaba — niekada nesiunčiama…",
      desk_sending: "Siunčiama…",
      desk_send_waiting: "Siųsti → Laukiama kliento",
      desk_send_keep_status: "Siųsti (nekeisti statuso)",
      desk_save_note: "Išsaugoti pastabą",
      desk_new_task: "Nauja užduotis",
      desk_new_task_title: "Sukurti užduotį",
      desk_task_title: "Pavadinimas",
      desk_task_title_placeholder: "Ką reikia padaryti?",
      desk_customer_email: "Kliento el. paštas",
      desk_customer_name: "Kliento vardas",
      desk_customer_name_optional: "Neprivaloma",
      desk_task_note_optional: "Pirmoji pastaba (neprivaloma)",
      desk_create_task: "Sukurti",
      desk_creating_task: "Kuriama…",
      desk_customer_email_required: "Kliento el. paštas privalomas.",
      desk_task_title_required: "Pavadinimas privalomas.",
      desk_no_project: "— Gauta (be projekto)",
      desk_snooze_tomorrow: "Atidėti → rytojui",
      desk_snooze_until: "Atidėti iki",
      desk_snooze: "Atidėti",
      desk_plan_on: "Planuoti",
      desk_add_to_plan: "Į planą",
      desk_planned: "Suplanuota",
      desk_mark_noise: "Žymėti triukšmu",
      desk_unmark_noise: "Ne triukšmas",
      desk_merge: "Sujungti",
      desk_merge_into_number: "į #…",
      desk_mail_collection: "Pašto rinkimas",
      desk_clients: "Klientai",
      desk_connect_mailbox: "Prijungti dėžutę",
      desk_add_mailbox: "Pridėti dėžutę",
      desk_add_mailbox_title: "Prijungti pašto dėžutę",
      desk_edit_mailbox: "Redaguoti",
      desk_edit_mailbox_title: "Dėžutės nustatymai",
      desk_provider_other: "Kita",
      desk_app_password: "Programos slaptažodis",
      desk_app_password_saved: "•••••• (išsaugota)",
      desk_own_addresses: "Savi adresai (praleidžiami)",
      desk_label_name: "Žymės pavadinimas",
      desk_mailbox_active: "Dėžutė aktyvi",
      desk_test_connection: "Tikrinti ryšį",
      desk_connection_ok: "Ryšys veikia",
      desk_connection_failed: "Ryšys nepavyko",
      desk_address_taken: "Šis el. pašto adresas jau prijungtas. Jo negalima pridėti dar kartą.",
      desk_save: "Išsaugoti",
      desk_saved: "Išsaugota",
      desk_client_name: "Kliento pavadinimas",
      desk_domains: "Domenai",
      desk_add_client: "Pridėti klientą",
      desk_projects: "Projektai",
      desk_new_project: "Naujas projektas…",
      desk_add_project: "Pridėti projektą",
      desk_today: "Šiandien",
      desk_add_to_today: "→ Šiandien",
      desk_carry_over: "Neužbaigta iš ankstesnių dienų",
      desk_carry_over_all: "Perkelti viską į šiandien",
      desk_no_plan: "Nieko nesuplanuota — atidarykite Gauta ir pridėkite korteles su „→ Šiandien“.",
      desk_entry_note: "pastaba…",
      desk_done_lc: "atlikta",
      desk_waiting_on_clients: "laukia klientų",
      desk_points: "Taškai",
      desk_edit_capacity: "Keisti dienos talpą",
      desk_over_capacity: "viršyta talpa!",
      desk_pick_customer: "Klientas (iš Customers)",
      desk_pick_customer_placeholder: "— pasirinkite klientą arba įveskite pavadinimą —",
      desk_view_all: "Visos kortelės",
      desk_discard_draft: "Atmesti neišsiųstą juodraštį?",
      desk_points_short: "tk",
      desk_domains_taken: "Domenai jau naudojami kito kliento",
      desk_confirm_delete_card: "Ar tikrai norite ištrinti šią kortelę?",
      desk_confirm_delete_cards: "Ar tikrai norite ištrinti {{count}} korteles?",
      desk_confirm_delete_card_soft: "Ar tikrai norite ištrinti šią kortelę? Ji bus perkelta į šiukšlinę.",
      desk_confirm_delete_cards_soft: "Ar tikrai norite ištrinti šias {{count}} korteles? Jos bus perkeltos į šiukšlinę.",
      desk_confirm_delete_card_permanent: "Ar tikrai norite visam laikui ištrinti šią kortelę ir visus jos laiškus? Šio veiksmo atšaukti negalima.",
      desk_confirm_delete_cards_permanent: "Ar tikrai norite visam laikui ištrinti {{count}} korteles ir visus jų laiškus? Šio veiksmo atšaukti negalima.",
      desk_confirm_restore_card: "Ar tikrai norite grąžinti šią kortelę į gautų laiškų dėžutę?",
      desk_confirm_restore_draft: "Ar tikrai norite grąžinti šį juodraštį į juodraščius?",
      desk_confirm_restore_card_yes: "Atkurti",
      desk_confirm_restore_card_no: "Atšaukti",
      desk_confirm_delete_card_title: "Ištrinti kortelę",
      desk_confirm_delete_card_yes: "Patvirtinti trynimą",
      desk_confirm_delete_card_no: "Atšaukti",
      desk_selected_count: "Pasirinkta: {{count}}",
      desk_delete_selected: "Ištrinti",
      desk_archive_selected: "Archyvuoti",
      desk_unarchive_selected: "Grąžinti",
      desk_clear_selection: "Išvalyti",
      desk_star: "Pažymėti žvaigždute",
      desk_unstar: "Nuimti žvaigždutę",
      desk_action_failed: "Nepavyko atlikti veiksmo",
      desk_load_failed: "Nepavyko įkelti dienos plano.",
      desk_move_up: "Pakelti aukščiau",
      desk_move_down: "Nuleisti žemiau",
      desk_remove_from_plan: "Pašalinti iš plano",
      desk_mark_done: "Pažymėti atlikta",
      desk_prev_day: "Ankstesnė diena",
      desk_next_day: "Kita diena",
      desk_plan_date: "Plano data",
      desk_card_number: "Kortelės numeris",
      desk_added_to_plan: "#{{number}} pridėta į planą",
      desk_carry_over_one: "Perkelti į šią dieną",
      desk_carry_over_done: "Į šią dieną perkelta įrašų: {{count}}",
      desk_carry_over_failed: "Nepavyko perkelti: {{numbers}}",
      desk_capacity_override: "pakeista",
      desk_capacity_reset: "Grąžinti numatytąją dienos apimtį",
      desk_invalid_capacity: "Įveskite skaičių nuo 0 iki 100.",
      desk_invalid_points: "Įveskite skaičių nuo 0 iki 100 arba palikite tuščią, kad būtų naudojamas kortelės įvertis.",
      desk_entry_points: "Šios dienos taškai",
      desk_entry_points_hint: "Šios dienos taškai — palikite tuščią, kad būtų naudojamas kortelės įvertis",
      desk_err_card_not_plannable: "Šios kortelės planuoti negalima — tai juodraštis, archyvuota, sujungta arba ištrinta kortelė.",
      desk_all_mailboxes: "Visos pašto dėžutės",
      desk_select_all_on_page: "Pažymėti visas šiame puslapyje",
      desk_mark_done_toggle: "Žymėti atlikta / atidaryti",
      desk_toggle_noise: "Žymėti kaip triukšmą / ne triukšmą",
      desk_move_to_project: "Perkelti į projektą",
      desk_no_projects: "Projektų kol kas nėra",
      desk_unknown_sender: "Nežinomas",
      desk_open_card_aria: "Atidaryti kortelę: {{contact}} — {{title}}",
      desk_page_prev: "Ankstesnis puslapis",
      desk_page_next: "Kitas puslapis",
      desk_bulk_success: "Atnaujinta kortelių: {{count}}",
      desk_bulk_partial: "Atnaujinta: {{success}}, nepavyko: {{failed}}",
      desk_bulk_failed: "Nepavyko atnaujinti kortelių: {{count}}",
      desk_publish_success: "Kortelė #{{number}} paskelbta",
      desk_shortcuts_hint: "d atlikta · n triukšmas · t šiandien · s atidėti · p projektas",
      desk_project: "Projektas",
      desk_refresh_card: "Atnaujinti kortelę",
      desk_summarize: "Apibendrinti",
      desk_summarize_refresh: "Atnaujinti apibendrinimą",
      desk_summarized: "Apibendrinta",
      desk_ai_fix: "Taisyti klaidas",
      desk_ai_rewrite: "Perrašyti gražiau",
      desk_ai_fixing: "Taisoma…",
      desk_ai_rewriting: "Perrašoma…",
      desk_ai_fixed: "Klaidos ištaisytos",
      desk_ai_rewritten: "Laiškas perrašytas",
      desk_ai_no_change: "Asistentas nerado ką taisyti",
      desk_ai_undo: "Atšaukti AI pakeitimą",
      desk_ai_draft_changed: "Kol asistentas dirbo, tekstas pasikeitė — niekas nepakeista",
      desk_ai_too_long: "Tekstas per ilgas asistentui — sutrumpinkite iki maždaug 6000 simbolių",
      desk_ai_disabled: "Šiai įmonei AI asistentas nesukonfigūruotas",
      desk_copy_context: "Kopijuoti kontekstą",
      desk_copy_context_hint: "Nukopijuoja kortelę ir visą susirašinėjimą kaip tekstą — įklijuokite pokalbyje, kuris neturi prieigos prie ERP",
      desk_copy_context_done: "Kortelės kontekstas nukopijuotas",
      desk_copy_context_failed: "Nepavyko nukopijuoti į iškarpinę",
      api_token_tab: "AI prieiga",
      api_token_heading: "Prijunkite AI programą prie savo Desk",
      api_token_intro: "Susikūrę asmeninį raktą, savo AI asistentui leisite skaityti jūsų Desk korteles ir jų susirašinėjimą, o jei norėsite — ir atsakyti. Raktas veikia jūsų vardu ir mato lygiai tą patį, ką matote jūs. Kam raktą duosite, tas gaus tokią pat prieigą, tad saugokite jį kaip slaptažodį ir panaikinkite, kai nebenaudojate.",
      api_token_new: "Naujas raktas",
      api_token_name: "Rakto pavadinimas",
      api_token_name_placeholder: "pvz., Claude mano kompiuteryje",
      api_token_create: "Sukurti raktą",
      api_token_creating: "Kuriama…",
      // mobile: orders
      order_steps_jump: "Pasirašymo ir sąskaitos žingsniai",
      api_token_scope_write: "Leisti ir keisti korteles bei siųsti atsakymus",
      api_token_scope_write_warning: "Įjungus, asistentas galės iš jūsų pašto išsiųsti tikrą laišką klientui jūsų neklausdamas. Palikite išjungtą, kad raktas tik skaitytų.",
      api_token_created_once: "Nusikopijuokite raktą dabar — jis rodomas vieną kartą ir vėliau jo nebeatkursite.",
      api_token_copy: "Kopijuoti",
      api_token_copied: "Raktas nukopijuotas",
      api_token_command_copied: "Komanda nukopijuota",
      api_token_connect_hint: "Terminale su Claude Code paleiskite:",
      api_token_hide: "Gerai, paslėpti",
      api_token_active: "Jūsų raktai",
      api_token_none: "Raktų dar nėra.",
      api_token_created_at: "sukurtas {{date}}",
      api_token_last_used: "paskutinį kartą naudotas {{date}}",
      api_token_never_used: "nenaudotas",
      api_token_revoke: "Panaikinti",
      api_token_revoke_confirm: "Panaikinti raktą „{{name}}“? Jį naudojanti programa iškart nustos veikti.",
      api_token_revoked: "Raktas panaikintas",
      api_token_copy_failed: "Nepavyko nukopijuoti į iškarpinę",
      desk_ai_summary_disclaimer: "DI gali klysti – patikrinkite tikslumą.",
      desk_ai_summary_generated_at: "parengta {{date}}",
      desk_ai_summary_stale: "Po šio apibendrinimo atsirado naujų žinučių.",
      desk_delete_card: "Ištrinti kortelę",
      desk_deleted: "Ištrinta",
      desk_deleted_done: "Perkelta į šiukšlinę: {{count}}",
      desk_deleted_permanently_done: "Ištrinta visam laikui: {{count}}",
      desk_delete_failed: "Nepavyko ištrinti kortelės.",
      desk_restore_failed: "Nepavyko atkurti kortelės.",
      desk_restored_done: "Atkurta: {{count}}",
      desk_confirm_restore_cards: "Ar tikrai norite grąžinti {{count}} korteles į Gauta?",
      desk_draft_saving: "Juodraštis saugomas…",
      desk_draft_saved_at: "Juodraštis išsaugotas {{time}}",
      desk_draft_not_saved: "Juodraštis neišsaugotas — patikrinkite ryšį.",
      desk_recipients_required: "Įveskite bent vieną gavėją.",
      desk_invalid_recipient: "Neteisingas el. pašto adresas: {{email}}",
      desk_reply_sent: "Atsakymas išsiųstas.",
      desk_note_saved: "Pastaba išsaugota.",
      desk_share_done: "Kortelė bendrinama.",
      desk_unshare_done: "Bendrinimas panaikintas.",
      desk_share_user_no_desk: "{{name}} neturi prieigos prie Desk ir buvo pašalintas iš sąrašo.",
      desk_share_user_not_in_company: "{{name}} nepriklauso šiai įmonei ir buvo pašalintas iš sąrašo.",
      desk_send_failed_use_retry: "Išsiųsti nepavyko. Atsakymas išsaugotas laiko juostoje — spauskite „Bandyti dar kartą“ raudonoje eilutėje, o ne siųskite iš naujo.",
      desk_merge_conversation: "Sujungti susirašinėjimą",
      desk_card_fields_toggle: "Projektas, atidėjimas ir planavimas",
      desk_merge_confirm: "Sujungti #{{source}} į #{{target}} — {{title}}? Visos žinutės persikels, atgal išskirti nebus galima.",
      desk_merge_done: "Sujungta į #{{number}}.",
      desk_merge_same_card: "Kortelės negalima sujungti su ja pačia.",
      desk_merge_target_not_found: "Kortelė #{{number}} nerasta.",
      desk_snoozed_until: "Atidėta iki {{date}}",
      desk_unsnooze: "Grąžinti dabar",
      desk_preview_unavailable: "Peržiūra negalima.",
      desk_images_blocked: "Šios žinutės paveikslėliai nerodomi ({{count}}).",
      desk_show_images: "Rodyti paveikslėlius",
      desk_blocked_image: "Paveikslėlis",
      desk_show_quoted: "Rodyti cituojamą tekstą",
      desk_hide_quoted: "Slėpti cituojamą tekstą",
      desk_event_status_changed: "Statusas: {{from}} → {{to}}",
      desk_event_project_moved: "Perkelta į projektą {{to}}",
      desk_event_assigned: "Pakeistas atsakingas asmuo",
      desk_event_snoozed: "Atidėta iki {{until}}",
      desk_event_archived: "Archyvuota",
      desk_event_unarchived: "Grąžinta iš archyvo",
      desk_event_published: "Paskelbta iš juodraščių",
      desk_event_restored: "Atkurta iš šiukšlinės",
      desk_event_deleted: "Perkelta į šiukšlinę",
      desk_event_reopened: "Vėl atidaryta gavus atsakymą",
      desk_event_shared: "Bendrinama su {{names}}",
      desk_event_unshared: "Bendrinimas panaikintas: {{names}}",
      desk_event_merged_from: "Sujungta iš kortelės #{{sourceCardNumber}}",
      desk_event_forwarded: "Persiųsta: {{to}}",
      desk_event_created_manual: "Užduotis sukurta",
      desk_event_created_draft: "Juodraštis sukurtas",
      desk_address_change_warning: "Keičiate prijungtos dėžutės adresą. Įveskite naujos paskyros programos slaptažodį — laiškų rinkimas prasidės nuo naujausių laiškų.",
      desk_password_required_address_change: "Pakeitus adresą reikia įvesti naujos paskyros programos slaptažodį.",
      desk_app_password_required: "Reikalingas programos slaptažodis.",
      desk_address_held: "Šis adresas priklauso atjungtai dėžutei, kurioje dar yra {{count}} kortelių.",
      desk_awaiting_first_sync: "Laukiama pirmos sinchronizacijos",
      desk_ingest_errors_7d: "Apdorojimo klaidos (7 d.)",
      desk_recent_ingest_errors: "Paskutinės apdorojimo klaidos",
      desk_err_auth_failed: "Pašto serveris atmetė slaptažodį — sugeneruokite naują programos slaptažodį.",
      desk_err_host_unreachable: "Nepavyko pasiekti pašto serverio — patikrinkite serverių pavadinimus.",
      desk_err_timeout: "Pašto serveris neatsakė laiku.",
      desk_imap_host_port: "IMAP serveris ir prievadas",
      desk_smtp_host_port: "SMTP serveris ir prievadas",
      desk_invalid_port: "Prievadas turi būti skaičius nuo 1 iki 65535.",
      desk_ingest_mode_label_gmail_only: "Rinkimas pagal žymę veikia tik su Gmail.",
      desk_connection_ok_sent: "Ryšys veikia (Siųstų aplankas: {{folder}})",
      desk_connection_failed_hint: "Patikrinkite adresą, programos slaptažodį ir serverių pavadinimus.",
      desk_mailbox_danger_zone: "Dėžutės atjungimas",
      desk_mailbox_danger_hint: "Atjungus ištrinamas išsaugotas slaptažodis ir laiškai nebesurenkami, o kortelės lieka. Ištrinti pačią dėžutę galima tik tada, kai su ja nesusieta nė viena kortelė.",
      desk_mailbox_disconnect: "Atjungti",
      desk_mailbox_delete: "Ištrinti dėžutę",
      desk_mailbox_disconnect_confirm: "Atjungti {{address}}? Išsaugotas slaptažodis bus ištrintas ir nauji laiškai nebebus renkami. Dėžutė ir jos kortelės liks matomos.",
      desk_mailbox_delete_confirm: "Ištrinti {{address}} visam laikui? Bus pašalinta pati dėžutė; tai įmanoma tik tada, kai su ja nesusieta nė viena kortelė.",
      desk_mailbox_disconnected: "Dėžutė atjungta",
      desk_mailbox_deleted: "Dėžutė ištrinta",
      desk_mailbox_has_cards: "Šioje dėžutėje dar yra {{count}} kortelių — verčiau ją atjunkite.",
      desk_guide_title: "Dėžutės prijungimo vadovas",
      desk_guide_tab_password: "Programos slaptažodis",
      desk_guide_config_title: "{{provider}} nustatymai:",
      desk_guide_imap_host: "IMAP serveris",
      desk_guide_imap_port: "IMAP prievadas",
      desk_guide_smtp_host: "SMTP serveris",
      desk_guide_smtp_port: "SMTP prievadas",
      desk_guide_yandex_warning: "Svarbu: nenaudokite .lt serverių (imap.yandex.lt) — visada naudokite .com.",
      desk_guide_gmail_imap: "Pirmiausia įjunkite IMAP prieigą Gmail nustatymuose: Settings → Forwarding and POP/IMAP.",
      desk_guide_password_title: "Programos slaptažodžio generavimas:",
      desk_guide_password_intro: "Neįveskite pagrindinio pašto slaptažodžio. Sugeneruokite 16 simbolių programos slaptažodį:",
      desk_guide_password_yandex: "Paskyros nustatymai → Programų slaptažodžiai → Sukurti naują → pasirinkite „Paštas“ ir gaukite 16 simbolių kodą.",
      desk_guide_password_gmail: "Google paskyros sauga → Dviejų veiksmų patvirtinimas → Programų slaptažodžiai → sugeneruokite 16 simbolių kodą.",
      desk_pick_existing_client: "Klientas (iš klientų sąrašo)",
      desk_customer_list_truncated: "Rodomi pirmi {{shown}} klientai iš {{total}} — jei jūsų kliento sąraše nėra, įveskite pavadinimą ranka.",
      desk_no_customers_found: "Klientų nerasta.",
      desk_no_clients: "Klientų dar nėra.",
      desk_no_clients_hint: "Klientas sujungia domenus, iš kurių ateina laiškai, kad naujos kortelės patektų pas tinkamą klientą ir jo projektus.",
      desk_clients_load_failed: "Nepavyko įkelti klientų. Bandykite dar kartą.",
      desk_client_added: "Klientas pridėtas",
      desk_project_added: "Projektas pridėtas",
      desk_err_card_forbidden: "Neturite prieigos prie šios kortelės.",
      desk_err_card_read_only: "Ši kortelė jums bendrinama tik skaitymui.",
      desk_err_mailbox_owner_only: "Siųsti iš šios pašto dėžutės gali tik jos savininkas.",
      desk_err_card_not_shareable: "Prieš bendrindami kortelę, ją paskelbkite.",
      desk_err_not_retryable: "Šios žinutės nebegalima siųsti.",
      desk_err_retry_in_progress: "Ši žinutė jau siunčiama.",
      desk_mailbox_disconnect_first: "Prieš ištrindami dėžutę, ją atjunkite.",
      desk_client_replied: "Atsakė klientas",
      desk_show_done: "Rodyti uždarytas",
      close_document: "Uždaryti dokumentą",
      reopen_document: "Atidaryti iš naujo",
      document_outdated: "Neaktualus",
      update_document_status_failed: "Nepavyko atnaujinti dokumento būsenos. Bandykite dar kartą.",
      create_role: "Sukurti pareigybę",
      manage_groups: "Tvarkyti grupes",
      group: "Grupė",
      no_group: "Be grupės",
      without_group: "Be grupės",
      all_groups: "Visos grupės",
      filter_by_group: "Filtruoti pagal grupę",
      filter_by_assignment: "Filtruoti pagal priskyrimą",
      roles_with_users: "Su priskirtais vartotojais",
      roles_without_users: "Be priskirtų vartotojų",
      search_roles: "Ieškoti pareigybių",
      search_roles_placeholder: "Ieškoti pagal pareigybės pavadinimą ar aprašymą...",
      no_roles_match_filters: "Pagal filtrus pareigybių nerasta",
      no_roles_match_filters_description: "Pabandykite pakeisti paiešką ar filtrus.",
      create_group: "Sukurti grupę",
      group_name: "Grupės pavadinimas",
      group_name_placeholder: "pvz., Sandėlis",
      group_delete_hint:
        "Ištrynus grupę, jos pareigybės nėra ištrinamos — jos tiesiog lieka be grupės.",
      no_groups_yet: "Grupių dar nėra. Sukurkite pirmąją viršuje.",
      roles_count: "Pareigybės",
      rename: "Pervadinti",
      failed_load_groups: "Nepavyko įkelti grupių.",
      failed_create_group: "Nepavyko sukurti grupės.",
      failed_update_group: "Nepavyko pervadinti grupės.",
      failed_delete_group: "Nepavyko ištrinti grupės.",
      roles_load_failed: "Nepavyko atnaujinti pareigybių. Bandykite dar kartą.",
      roles_load_failed_title: "Nepavyko įkelti pareigybių",
      roles_load_failed_description: "Nepavyko įkelti pareigybių. Bandykite dar kartą.",
      no_roles: "Nėra pareigybių",
      no_roles_description: "Sukurkite pareigybę, kad pradėtumėte apibrėžti taisykles ir pasirašymo reikalavimus.",
      create_first_role: "Sukurti pirmąją pareigybę",
      rules_count: "Taisyklės",
      workers_assigned: "priskirti darbuotojai",
      show_users: "Rodyti vartotojus",
      hide_users: "Slėpti vartotojus",
      show_signers: "Rodyti pasirašančiuosius",
      hide_signers: "Slėpti pasirašančiuosius",
      signers_count_signed: "pasirašyta",
      signers_count_pending: "laukiama",
      signers_count_total: "iš viso",
      and_n_more: "+{{count}} daugiau",
      no_description: "Nėra aprašymo",
      assign_user_roles: "Priskirti pareigybes",
      assign_roles_to_user: "Priskirti pareigybes darbuotojui",
      assigned_roles: "Priskirtos pareigybės",
      no_roles_assigned: "Nepriskirtos jokios pareigybės",
      manage_roles: "Valdyti pareigybes",
      role_assignments_dashboard: "Pareigybių priskyrimai",
      assignments_load_failed: "Nepavyko įkelti pareigybių priskyrimų. Bandykite dar kartą.",
      search_users: "Ieškoti darbuotojų",
      search_by_name_or_email: "Ieškoti pagal vardą arba el. paštą...",
      filter_by_role: "Filtruoti pagal pareigybę",
      all_roles: "Visos pareigybės",
      assigned_roles_load_failed: "Nepavyko įkelti priskirtų pareigybių. Bandykite dar kartą.",
      no_assigned_roles: "Priskirtų pareigybių nerasta.",
      assigned_work_security_roles: "Priskirtos pareigybės",
      signed_on: "Pasirašyta",
      no_document_yet_for_role: "Šiai pareigybei tvarkų dokumentas dar nesugeneruotas.",
      // --- Onboarding work-security step ---
      ws_signed_count: "Pasirašyta {{signed}} iš {{total}}",
      ws_manage_roles_hint:
        "Pareigybėms priskirti reikalinga teisė „Tvarkų priskyrimai“ — kreipkitės į atsakingą kolegą.",
      ws_docless_roles_warning:
        "Šios pareigybės neturi aktyvaus dokumento — nebus ko pasirašyti:",
      ws_docless_roles_ack:
        "Suprantu, kad šios pareigybės neturi pasirašomų dokumentų",
      ws_send_login_link_hint:
        "Darbuotojas tvarkų dokumentus pasirašo skiltyje „Mano įdarbinimas“ — jei negali prisijungti, išsiųskite prisijungimo nuorodą.",
      ws_complete_step_confirm_no_roles:
        "Šiam darbuotojui nepriskirta nė vienos priėmimo metu privalomos pareigybės. Užbaigti žingsnį be privalomų tvarkų dokumentų?",
      ws_unsigned_docs_warning: "Nepasirašyti tvarkų dokumentai:",
      ws_reopen_step: "Grąžinti į tvarkų žingsnį",
      ws_all_signed_waiting:
        "Visi tvarkų dokumentai pasirašyti — laukiama administratoriaus patvirtinimo.",
      ws_declined_ask_hr:
        "Atmesta — paprašykite personalo pakartotinai išsiųsti pasirašymo prašymą.",
      ws_load_failed: "Nepavyko įkelti tvarkų duomenų.",
      ws_error_unsigned: "Yra nepasirašytų tvarkų dokumentų.",
      ws_error_no_roles:
        "Nepriskirtos pareigybės — patvirtinkite žingsnio užbaigimą be pareigybių.",
      ws_error_docless_roles:
        "Kai kurios pareigybės neturi aktyvių dokumentų — pažymėkite patvirtinimą, kad tęstumėte.",
      ws_error_conflict:
        "Įdarbinimo būsena pasikeitė. Atnaujinkite ir bandykite dar kartą.",
      ws_error_roles_not_applied:
        "Privalomos tvarkų pareigybės dar nepriskirtos — bandykite po minutės arba kreipkitės į pagalbą.",
      onboarding_cancel_conflict:
        "Įdarbinimas tuo metu pasikeitė — duomenys atnaujinti, bandykite dar kartą.",
      ws_required_now: "Privaloma dabar",
      ws_other_instructions: "Kita",
      search_your_boards: "Ieškoti grupių",
      pinned: "Prisegtos",
      starred: "Pažymėtos",
      recent: "Paskutinės",
      all_boards: "Visos grupės",
      search_results: "Paieškos rezultatai",
      no_results: "Rezultatų nerasta",
      loading: "Įkeliama…",
      color: "Spalva",
      done: "Atlikta",
      board_history: "Istorija",
      board_load_failed: "Nepavyko įkelti šios grupės.",
      share: "Dalintis",
      share_board: "Dalintis lenta",
      copy_link: "Kopijuoti nuorodą",
      link_copied: "Nuoroda nukopijuota",
      copy_failed: "Nepavyko nukopijuoti",
      board_members: "Lentos nariai",
      sending: "Siunčiama…",
      email_sent: "Laiškas išsiųstas",
      email_send_failed: "Nepavyko išsiųsti laiško",
      share_no_users: "Vartotojų nerasta",
      share_access_hint: "Rodomi tik tie, kurie turi prieigą prie projektų modulio.",
      // --- Darbuotojų saugos incidentai (v1) ---
      incidents: "Incidentai",
      incident: "Incidentas",
      register_incident: "Registruoti incidentą",
      edit_incident: "Redaguoti incidentą",
      incident_number: "Nr.",
      incident_occurred_at: "Data ir laikas",
      incident_type: "Rūšis",
      incident_type_incident: "Incidentas (be žalos sveikatai)",
      incident_type_event_at_work: "Įvykis darbe (su žala sveikatai)",
      incident_severity: "Sunkumas",
      incident_severity_lengvas: "Lengvas",
      incident_severity_sunkus: "Sunkus",
      incident_severity_mirtinas: "Mirtinas",
      incident_status_registered: "Užregistruotas",
      incident_status_pending_signatures: "Laukiama parašų",
      incident_status_signed: "Pasirašytas",
      incident_status_closed: "Uždarytas",
      incident_status_cancelled: "Atšauktas",
      incident_victim: "Nukentėjęs darbuotojas",
      incident_location: "Vieta / padalinys",
      incident_time_since_shift: "Laikas nuo darbo pradžios",
      incident_description: "Kas įvyko",
      incident_activity_before: "Ką darbuotojas veikė prieš įvykį",
      incident_causing_factor: "Įvykį sukėlęs veiksnys / objektas",
      incident_injury_nature: "Sužalojimo pobūdis",
      incident_body_part: "Sužalota kūno dalis",
      incident_witnesses: "Liudytojai",
      incident_witness_name: "Vardas, pavardė",
      incident_witness_notes: "Pastabos",
      incident_add_witness: "Pridėti liudytoją",
      incident_causes_prevention: "Priežastys ir prevencinės priemonės",
      incident_causes: "Priežastys",
      incident_prevention: "Prevencinės priemonės",
      incident_general_info: "Bendra informacija",
      incident_circumstances: "Aplinkybės",
      incident_investigation_deadline: "Tyrimo terminas",
      incident_actions: "Prevencinės priemonės",
      incident_action_description: "Priemonė",
      incident_action_owner: "Atsakingas",
      incident_action_due: "Terminas",
      incident_action_placeholder: "pvz. Suorganizuoti papildomą instruktažą",
      incident_no_actions: "Prevencinių priemonių dar nėra.",
      incident_open_actions: "{{count}} neįvykdyta",
      incident_documents: "Dokumentai",
      incident_no_documents: "Aktas dar nesugeneruotas.",
      incident_doc_act: "Aktas",
      incident_doc_attachment: "Priedas",
      incident_deadline_overdue: "Tyrimo terminas praleistas",
      incident_deadline_overdue_banner:
        "Praėjo 10 darbo dienų lengvo nelaimingo atsitikimo tyrimo terminas.",
      incident_deadline_due: "Terminas",
      incident_severe_banner_title: "Sunkus / mirtinas nelaimingas atsitikimas — tiria VDI",
      incident_severe_banner_body:
        "Nedelsdami praneškite prokuratūrai, VDI teritoriniam skyriui ir šeimos nariui, išsaugokite įvykio vietą ir pateikite pranešimą apie įvykį darbe. Įmonė pati akto sudaryti negali — vietoje to prisekite VDI aktą kaip failą.",
      incident_severe_form_hint:
        "Sunkius / mirtinus nelaimingus atsitikimus tiria VDI. Įrašą galite užregistruoti, tačiau sistema neleis sugeneruoti ar pasirašyti vidinio akto.",
      generate_act: "Generuoti aktą",
      regenerate_act: "Pergeneruoti aktą",
      send_incident_for_signature: "Siųsti pasirašyti",
      incident_send_intro:
        "Aktas bus išsiųstas pasirašyti (Click) nukentėjusiam darbuotojui ir pasirinktam vadovui.",
      incident_manager: "Vadovas",
      incident_manager_required: "Vadovas privalomas.",
      incident_manager_same_as_victim: "Vadovas turi skirtis nuo nukentėjusio darbuotojo.",
      cancel_signing: "Atšaukti pasirašymą",
      close_incident: "Uždaryti incidentą",
      reopen_incident: "Atidaryti iš naujo",
      mark_done: "Žymėti įvykdyta",
      mark_open: "Žymėti neįvykdyta",
      incidents_load_failed: "Nepavyko įkelti incidentų. Bandykite dar kartą.",
      no_incidents: "Incidentų neužregistruota",
      no_incidents_description: "Užregistruokite darbo vietoje įvykusį incidentą, kad pradėtumėte apskaitą.",
      no_incidents_match_filters: "Pagal filtrus incidentų nerasta",
      no_incidents_match_filters_description: "Pabandykite pakeisti arba išvalyti filtrus.",
      status_archived: "Archyvuota",
      search_incidents: "Ieškoti incidentų",
      search_incidents_placeholder: "Ieškoti pagal numerį, darbuotoją, vietą...",
      filter_by_type: "Rūšis",
      filter_by_status: "Statusas",
      filter_by_archived: "Archyvas",
      archived_only: "Tik archyvuoti",
      incident_load_failed: "Nepavyko įkelti šio incidento.",
      incident_action_failed: "Veiksmas nepavyko. Bandykite dar kartą.",
      incident_save_failed: "Nepavyko išsaugoti incidento.",
      incident_send_failed: "Nepavyko išsiųsti pasirašyti.",
      incident_victim_required: "Nukentėjęs darbuotojas privalomas.",
      incident_description_required: "Aprašymas privalomas.",
      select_existing_document: "Pasirinkti dokumentą",
      select_existing_document_help:
        "Naršykite įkėlimo kategoriją (iš nustatymų) ir jos poaplankius arba ieškokite po visus juos. Jau priskirti pareigybei dokumentai nerodomi.",
      search_all_documents: "Ieškoti visuose dokumentuose…",
      all_documents: "Visi dokumentai",
      no_documents_match_search: "Pagal paiešką dokumentų nerasta.",
      no_documents_in_folder: "Šiame aplanke dokumentų nėra.",
      selectable_documents_load_failed: "Nepavyko įkelti dokumentų. Bandykite dar kartą.",
      attach_document: "Priskirti dokumentą",
      attaching: "Priskiriama...",
      associate_document_failed: "Nepavyko priskirti pasirinkto dokumento. Bandykite dar kartą.",
      document_already_attached_to_role:
        "Šis dokumentas jau priskirtas kitai pareigybei ir negali būti priskirtas dar kartą.",
      confirm_attach_document: "Patvirtinti dokumento priskyrimą",
      confirm_attach_document_intro:
        "Prieš priskirdami dokumentą pareigybei, peržiūrėkite parašų poveikį.",
      existing_signatures_on_file: "Parašai, jau esantys šiame faile",
      no_existing_signatures_on_file: "Šiame faile dar nėra parašų.",
      signatures_will_be_added: "Parašai, kurie bus pridėti",
      no_users_assigned_to_role_for_signatures:
        "Šiai pareigybei dar nepriskirti darbuotojai. Priskirkite dokumentą, tada pridėkite darbuotojus, kad būtų išsiųstos pasirašymo užklausos.",
      no_new_signatures_to_add:
        "Visi priskirti darbuotojai jau turi parašą šiame faile. Naujos užklausos nebus siunčiamos.",
      signature_emails_will_be_sent:
        "Šiems vartotojams bus išsiųsta {{count}} pasirašymo užklausos el. laiškų.",
      already_have_signature_on_file:
        "Priskirti darbuotojai, jau esantys faile (naujas el. laiškas nesiunčiamas)",
      existing_signatures_kept_notice:
        "Esami parašai faile bus išsaugoti. Naujos pasirašymo užklausos pridedamos tik tiems priskirtiems darbuotojams, kurių dar nėra faile.",
      attach_and_send_requests: "Priskirti ir siųsti pasirašymo užklausas",
      associate_preview_failed: "Nepavyko įkelti parašų peržiūros. Bandykite dar kartą.",
      // Work security — training / tests
      training: "Mokymai",
      training_test: "Mokymų testas",
      create_training_test: "Sukurti mokymų testą",
      training_col_questions: "Klausimai",
      training_col_roles: "Pareigybės",
      training_col_passed: "Išlaikė",
      training_col_duration: "Trukmė",
      training_status_draft: "Juodraštis",
      training_status_active: "Aktyvus",
      training_status_archived: "Archyvuotas",
      training_tests_load_failed: "Nepavyko įkelti mokymų testų.",
      search_training_tests: "Ieškoti pagal pavadinimą ar aprašymą…",
      no_training_tests: "Mokymų testų dar nėra",
      no_training_tests_hint:
        "Sukurkite testą, pridėkite medžiagas, klausimus ir susiekite su pareigybėmis.",
      pass_percent: "Išlaikymo %",
      duration_minutes: "Trukmė (min)",
      max_attempts: "Maks. bandymų (tuščia = neribota)",
      name_required: "Pavadinimas privalomas",
      create_failed: "Nepavyko sukurti testo",
      load_failed: "Nepavyko įkelti",
      ai_generate_failed: "Nepavyko sugeneruoti klausimų",
      activate_test: "Aktyvuoti testą",
      training_step_basics: "Pagrindai",
      training_step_materials: "Medžiaga",
      training_step_questions: "Klausimai",
      training_step_audience: "Auditorija",
      training_step_review: "Peržiūra",
      training_step_progress: "{{current}} žingsnis iš {{total}}",
      training_materials_optional_hint:
        "Neprivaloma — prisekite dokumentus, kuriuos darbuotojai gali peržiūrėti prieš testą.",
      select_training_material_help:
        "Naršykite įkėlimo kategoriją (iš Nustatymų) ir jos papunkčius arba ieškokite visuose. Šiam testui jau priskirti dokumentai yra paslėpti.",
      attach_material_failed:
        "Nepavyko prisegti pasirinkto dokumento. Bandykite dar kartą.",
      training_audience_hint:
        "Prieš aktyvuojant susiekite bent vieną pareigybę arba priskirkite vartotojus rankiniu būdu.",
      training_activate_requirements:
        "Užpildykite pagrindus, išsaugokite bent vieną galiojantį klausimą ir susiekite pareigybes arba priskirkite vartotojus.",
      training_unassign_hint:
        "Galite pašalinti vartotojus, kurie dar nepateikė jokio bandymo.",
      unassign_failed: "Nepavyko pašalinti vartotojo",
      cannot_unassign_has_attempts: "Jau bandė",
      assignments: "Priskyrimai",
      assigned_users: "Priskirti vartotojai",
      user_already_assigned_to_test: "Šis vartotojas jau priskirtas šiam testui.",
      review: "Peržiūra",
      save_settings: "Išsaugoti nustatymus",
      training_materials: "Mokymų medžiaga",
      no_materials_yet: "Medžiagos dar nepridėta.",
      search_files: "Ieškoti įmonės failų",
      attach: "Pridėti",
      add_question: "Pridėti klausimą",
      ai_generate_hint:
        "Pasirinkite prisegtą medžiagą (PDF/TXT su tekstu). Klausimai generuojami lietuvių kalba. Prieš išsaugodami peržiūrėkite.",
      source_text: "Papildomas tekstas (neprivaloma)",
      source_text_help:
        "Galite įklijuoti tekstą, jei dokumente nėra skaitomo teksto sluoksnio.",
      ai_select_materials: "Dokumentai generavimui",
      ai_attach_materials_first:
        "Prisekite mokymų medžiagą žingsnyje Medžiaga, kad DI galėtų skaityti dokumentų turinį.",
      ai_materials_skipped:
        "Naudota dokumentų: {{used}}; praleista (nėra skaitomo teksto): {{skipped}}: {{names}}",
      ai_materials_used: "Sugeneruota iš {{count}} dokumento(-ų).",
      ai_materials_used_pdf_scan:
        "Sugeneruota iš {{count}} dokumento(-ų), įskaitant skenuotus PDF, kuriuos perskaitė DI.",
      generate_with_ai: "Generuoti su DI",
      question_n: "Klausimas {{n}}",
      question: "Klausimas",
      questions: "Klausimai",
      previous: "Ankstesnis",
      mark_correct_hint:
        "Pažymėkite vieną ar daugiau teisingų atsakymų. Jei teisingų daugiau nei vienas, darbuotojas galės pasirinkti kelis.",
      mark_correct: "Pažymėti kaip teisingą",
      option: "Variantas",
      option_placeholder: "Atsakymo variantas…",
      add_option: "Pridėti variantą",
      save_questions: "Išsaugoti klausimus",
      linked_roles: "Susietos pareigybės",
      linked_roles_hint:
        "Šioms pareigybėms priskirti darbuotojai automatiškai įtraukiami, kai testas aktyvus.",
      save_roles: "Išsaugoti pareigybių ryšius",
      manual_assign: "Priskirti papildomus vartotojus",
      attempts: "Bandymų",
      last_score: "Paskutinis rezultatas",
      no_assignments_yet: "Priskyrimų dar nėra.",
      my_training: "Mokymų testai",
      training_open_count: "Dar reikia atlikti {{count}} testą(-us)",
      training_all_clear: "Visi priskirti testai atlikti.",
      training_meta:
        "{{duration}} min · išlaikyti {{pass}}% · bandymų {{attempts}}",
      continue_test: "Tęsti testą",
      start_test: "Pradėti testą",
      view_history: "Istorija",
      no_training_assigned: "Jums dar nepriskirta mokymų testų.",
      start_failed: "Nepavyko pradėti testo",
      submit_failed: "Nepavyko pateikti testo",
      test_passed: "Išlaikyta",
      test_failed: "Neišlaikyta",
      score_summary:
        "{{score}}% · {{correct}}/{{total}} teisingai · išlaikymo riba {{pass}}%",
      start_training: "Pradėti mokymus",
      open_test: "Atidaryti",
      mark_training_completed: "Pažymėti mokymus kaip baigtus",
      go_to_test: "Eiti į testą",
      worker_training_steps_hint:
        "Pirmiausia užbaikite mokymų medžiagą. Testas atrakinsite pažymėję mokymus kaip baigtus.",
      worker_training_materials_hint:
        "Peržiūrėkite dokumentus, tada pažymėkite mokymus kaip baigtus, kad atrakintumėte testą.",
      no_materials_for_training:
        "Mokymų dokumentų nepridėta. Galite eiti prie testo.",
      training_already_completed:
        "Mokymai pažymėti kaip baigti. Galite laikyti testą.",
      complete_training_to_unlock_test:
        "Pirmiausia užbaikite mokymų žingsnį, kad atrakintumėte testą.",
      back_to_training_step: "Grįžti į mokymus",
      complete_training_failed: "Nepavyko pažymėti mokymų kaip baigtų",
      cannot_start_test: "Šiuo metu testo pradėti negalite.",
      view_submitted_answers: "Peržiūrėti pateiktus atsakymus",
      submitted_answers: "Pateikti atsakymai",
      submitted_answers_hint:
        "Šio bandymo klausimai ir variantai. Jūsų pasirinkti atsakymai pažymėti.",
      back_to_training: "Grįžti į mokymų testus",
      reattempt: "Bandyti dar kartą",
      answer_review: "Atsakymų peržiūra",
      your_answer: "jūsų atsakymas",
      correct: "teisinga",
      question_progress:
        "Klausimas {{current}} iš {{total}} · atsakyta {{answered}}",
      time_remaining: "Liko laiko",
      select_all_that_apply: "Pasirinkite visus tinkamus",
      select_one_answer: "Pasirinkite vieną atsakymą",
      submit_test: "Pateikti testą",
      no_questions: "Šiame teste nėra klausimų.",
      attempt_history: "Bandymų istorija",
      attempt_n: "Bandymas {{n}}",
      hide_answers: "Slėpti atsakymus",
      show_answers: "Rodyti atsakymus",
      no_answer: "Neatsakyta",
      no_attempts: "Bandymų dar nėra.",
      min: "min",
      submitted_at: "Pateikta",
      started_at: "Pradėta",
      training_status_pending: "Laukiama",
      training_status_in_progress: "Vyksta",
      training_status_timed_out: "Baigėsi laikas",
      online_test: "Internetinis testas",
      time_left: "Liko laiko",
      hours: "valandos",
      minutes: "minutės",
      seconds: "sekundės",
      mark_for_review: "Pažymėti peržiūrai",
      unmark_review: "Nuimti peržiūros žymą",
      submitting: "Pateikiama…",
      exam_legend_current: "Dabartinis",
      exam_legend_not_attempted: "Nebandyta",
      exam_legend_answered: "Atsakyta",
      exam_legend_not_answered: "Neatsakyta",
      exam_legend_review: "Peržiūra",
      question_editor: "Klausimų redaktorius",
      work_security_ai_questions_settings: "Mokymų klausimai su DI",
      work_security_ai_questions_settings_help:
        "Vadovai gali sugeneruoti testo klausimus iš instrukcijos teksto. Reikia įjungto <assistantLink>DI asistento</assistantLink>.",
      work_security_ai_questions_assistant_required:
        "DI asistentas išjungtas arba be API rakto, todėl šios parinkties įjungti negalima.",
      enabled: "Įjungta",
      disabled: "Išjungta",
      show_ai_generate: "Generuoti su DI",
      hide_ai_generate: "Slėpti DI generavimą",
      ai_generate_optional_hint:
        "Pasirinktinai kurkite lietuviškus klausimų juodraščius su DI pagal prisegtus mokymų dokumentus.",
      configure_upload_category_to_select:
        "Prieš pasirenkant dokumentą, nustatymuose sukonfigūruokite įkėlimo kategoriją.",
      select_user_to_view_signed_docs:
        "Pasirinkite darbuotoją, kad peržiūrėtumėte jo pasirašytus tvarkų dokumentus.",
      signed_documents_load_failed: "Nepavyko įkelti pasirašytų dokumentų. Bandykite dar kartą.",
      no_signed_documents_for_user: "Šis darbuotojas neturi pasirašytų tvarkų dokumentų.",
      download_selected: "Atsisiųsti pasirinktus",
      download_all: "Atsisiųsti visus",
      select_all: "Pasirinkti visus",
      work_security_role_document_template: "Pareigybių PDF šablono nustatymai",
      configure_generation_settings_to_generate:
        "Prieš generuojant PDF dokumentus, nustatymuose sukonfigūruokite dokumentų generavimo nustatymus (šabloną, seriją, dokumento tipą ir kategoriją).",
      approve_medical_check: "Patvirtinti sveikatos patikrą",
      enter_medical_validity: "Įveskite, nuo kada iki kada galioja sveikatos patikra.",
      medical_valid_from: "Galioja nuo",
      medical_valid_until: "Galioja iki",
      medical_validity: "Galiojimas",
      medical_data: "Sveikatos patikros duomenys",
      medical_validity_invalid: "„Galioja nuo“ negali būti vėlesnė nei „galioja iki“.",
      medical_check_history: "Sveikatos patikrų istorija",
      current_medical_check: "Dabartinė sveikatos patikra",
      no_medical_check: "Sveikatos patikrų nėra.",
      no_medical_checks_company: "Sveikatos patikrų nerasta.",
      medical_status_pending: "Laukia patvirtinimo",
      medical_status_approved: "Patvirtinta",
      medical_status_superseded: "Pakeista",
      medical_check_approved_toast: "Sveikatos patikra patvirtinta",
      medical_certificate_uploaded: "Sveikatos pažyma įkelta",
      confirm_delete_medical_draft: "Ištrinti šią įkeltą sveikatos patikrą? Failai bus pašalinti.",
      upload_certificate: "Įkelti pažymą",
      upload_new_certificate: "Įkelti naują pažymą",
      start_new_medical_check: "Pradėti naują sveikatos patikrą",
      medical_check_renew_started: "Nauja sveikatos patikra pradėta. Įkelkite pažymą (-as).",
      medical_renew_pending_exists: "Jau turite sveikatos patikrą, laukiančią patvirtinimo.",
      medical_renew_too_early: "Atnaujinimas galimas nuo {{date}} (30 dienų iki galiojimo pabaigos).",
      medical_renew_not_available: "Kol kas negalima pradėti naujos sveikatos patikros.",
      medical_check_reopen: "Atidaryti peržiūrai",
      medical_check_reopened: "Sveikatos patikra atidaryta peržiūrai",
      add_document: "Pridėti dokumentą",
      delete_draft: "Ištrinti",
      approved_by: "Patvirtino",
      uploaded: "Įkelta",
      add_workers_disabled_closed_document: "Naujausias dokumentas uždarytas. Norėdami pridėti darbuotojų, sukurkite arba vėl atidarykite dokumentą.",
      latest_document_closed: "naujausias dokumentas uždarytas",
      medical_checks_pending: "Laukia patvirtinimo",
      medical_checks_approved: "Patvirtintos sveikatos patikros",
      medical_checks_approved_by_you: "Neseniai jūsų patvirtinta",
      medical_checks_search_placeholder: "Ieškoti pagal darbuotoją ar failo pavadinimą...",
      no_medical_checks_match_filters: "Pagal paiešką sveikatos patikrų nerasta.",
      approved_at: "Patvirtinta",
      not_fetch: "Nepavyko įkelti duomenų",
      departments: "Skyriai",
      department: "Skyrius",
      head: "Vadovas",
      members: "Nariai",
      company_schema: "Įmonės schema",
      no_departments: "Skyrių dar nėra",
      select_departments: "Pasirinkite skyrius",
      update_departments: "Atnaujinti skyrius",
      departments_updated: "Skyriai atnaujinti",
      no_departments_assigned: "Nepriskirta skyrių",
      onboarding_department_required: "Pasirinkite bent vieną skyrių",
      onboarding_department_not_in_scope:
        "Galite pasirinkti tik tuos skyrius, kuriems vadovaujate. Perkraukite puslapį ir bandykite dar kartą.",
      onboarding_no_department_message:
        "Įdarbinimo įrašus gali kurti tik personalo skyrius arba padalinio vadovas, kuriam leista priimti darbuotojus.",
      onboarding_department_load_failed:
        "Nepavyko įkelti skyrių. Prieš išsaugant bandykite dar kartą.",
      no_head: "Nėra vadovo",
      head_help: "Vadovas turi būti vienas iš pasirinktų narių",
      dependency_graph: "Priklausomybių schema",
      view_list: "Sąrašas",
      view_graph: "Schema",
      reports_to: "Atsiskaito",
      no_members_to_graph: "Nėra narių, kuriuos būtų galima pavaizduoti",
      subgroups: "Pogrupiai",
      subgroup: "Pogrupis",
      add_subgroup: "Pridėti pogrupį",
      edit_subgroup: "Redaguoti pogrupį",
      delete_subgroup: "Ištrinti pogrupį",
      no_subgroups: "Pogrupių dar nėra",
      subgroup_name: "Pogrupio pavadinimas",
      subgroup_head: "Pogrupio vadovas",
      subgroup_head_help: "Neprivaloma. Turi būti vienas iš pogrupio narių.",
      subgroup_members_help:
        "Sukurkite šio skyriaus pogrupį (vaikinį skyrių). Jis turi savo vadovą ir narius.",
      department_members: "Skyriaus nariai",
      document_cart: "Atsisiuntimų krepšelis",
      document_cart_subtitle: "Peržiūrėkite failus ir atsisiųskite ZIP",
      document_cart_add: "Į krepšelį",
      document_cart_added: "Pridėta į krepšelį",
      document_cart_already_in: "Jau krepšelyje",
      document_cart_in_cart: "Krepšelyje",
      document_cart_removed: "Pašalinta iš krepšelio",
      document_cart_remove_failed: "Nepavyko pašalinti iš krepšelio",
      document_cart_add_failed: "Nepavyko pridėti į krepšelį",
      document_cart_full: "Krepšelis pilnas (maks. 500 failų)",
      document_cart_too_large:
        "Atsisiuntimų krepšelis ribojamas iki {{limit}}. Pašalinkite dalį failų ir bandykite dar kartą.",
      document_cart_file_too_large:
        "Šis failas didesnis nei {{limit}} ir negali būti pridėtas į krepšelį.",
      document_cart_file_size_unknown:
        "Nepavyko patikrinti failo dydžio, todėl jis nebuvo pridėtas.",
      document_cart_added_children_partial:
        "Pridėta į krepšelį ({{count}} antrinių failų praleista pasiekus krepšelio limitą)",
      document_cart_add_no_access: "{{count}} nepridėta — neturite teisių",
      document_cart_folder_added_size_partial:
        "Pridėta {{count}} failų (sustabdyta pasiekus {{limit}} ribą)",
      document_cart_size_limit_hint: "Maks. paketo dydis: {{limit}}",
      document_cart_size_summary: "Dydžio suvestinė:",
      document_cart_current_size: "Dabartinis krepšelio dydis:",
      document_cart_adding_size: "Pridedamų failų dydis:",
      document_cart_estimated_total_size: "Numatomas bendras dydis:",
      document_cart_total_size_limit: "{{total}} MB / {{limit}} MB limitas",
      document_cart_clear_all: "Išvalyti viską",
      document_cart_cleared: "Krepšelis išvalytas",
      document_cart_clear_failed: "Nepavyko išvalyti krepšelio",
      document_cart_empty: "Atsisiuntimų krepšelis tuščias",
      document_cart_browse: "Naršyti dokumentus",
      document_cart_unavailable: "Nepasiekiamas",
      document_cart_unavailable_banner:
        "{{count}} failas(-ai) nepasiekiami ir nebus įtraukti",
      document_cart_uncategorized: "Be kategorijos",
      document_cart_preparing_zip_hint:
        "Ruošiame jūsų ZIP archyvą. Tai gali užtrukti keletą akimirkų. Prašome neuždaryti šio lango.",
      document_cart_download_ready_title: "ZIP paketas paruoštas!",
      document_cart_download_ready_desc:
        "Jei failas neatsisiuntė automatiškai, spustelėkite žemiau esantį mygtuką.",
      document_cart_ready_summary: "{{ready}} iš {{total}} paruošta atsisiųsti",
      document_cart_download_all: "Atsisiųsti viską ZIP",
      document_cart_download_coming_soon:
        "Masinis atsisiuntimas bus kitame etape",
      document_cart_tab_files: "Failai",
      document_cart_tab_folders: "Aplankai",
      document_cart_no_individual_files: "Nėra atskirai pridėtų failų",
      document_cart_no_folders: "Krepšelyje dar nėra aplankų",
      document_cart_folder_file_count: "{{count}} failai",
      document_cart_folder_removed: "Aplankas pašalintas ({{count}} failai)",
      document_cart_add_folder: "Pridėti aplanką į krepšelį",
      document_cart_add_folder_title: "Pridėti aplanką „{{name}}“ į krepšelį?",
      document_cart_add_folder_body:
        "Pasirinkime {{count}} prieinamų failų · bus pridėta {{newCount}}",
      document_cart_add_folder_includes_subfolders:
        "Įtraukiami ir poaplankių failai, kuriuos galite pasiekti",
      document_cart_add_folder_select_hint:
        "Pasirinkite aplankus, kuriuos norite pridėti. Pažymėti aplankai bus matomi krepšelyje.",
      document_cart_folder_select_all: "Pasirinkti visus",
      document_cart_folder_deselect_all: "Atžymėti visus",
      document_cart_folder_none_selected: "Pasirinkite bent vieną aplanką",
      document_cart_folder_already_short: "{{count}} jau krepšelyje",
      document_cart_folder_no_direct_files: "Šiame aplanke tiesioginių failų nėra",
      document_cart_add_folder_confirm: "Pridėti pasirinktus",
      document_cart_folder_added: "Iš aplanko pridėta {{count}} failų",
      document_cart_folder_added_partial:
        "Pridėta {{count}} failų (pasiektas krepšelio limitas)",
      document_cart_folder_already_in: "Šie failai jau yra krepšelyje",
      document_cart_folder_empty: "Šiame aplanke nėra jums prieinamų failų",
      document_cart_folder_preview_failed: "Nepavyko peržiūrėti aplanko",
      document_cart_folder_some_already:
        "{{count}} failas(-ai) jau krepšelyje bus praleisti",
      document_cart_folder_would_exceed:
        "Pridėjus šį aplanką būtų viršytas {{max}} failų limitas",
      document_cart_folder_samples: "Pavyzdžiai",
      document_cart_download_ready: "Atsisiuntimas {{number}} paruoštas",
      document_cart_download_failed: "Atsisiuntimo paketas nepavyko",
      document_cart_download_started: "Atsisiuntimas pradedamas",
      document_cart_preparing_zip: "Ruošiamas ZIP…",
      document_cart_checkout_failed: "Nepavyko pradėti atsisiuntimo",
      document_cart_nothing_to_download: "Nėra ką atsisiųsti",
      document_cart_partial_skipped:
        "{{count}} nepasiekiamas(-i) failas(-ai) praleisti",
      document_cart_downloads_tab: "Atsisiuntimai",
      document_cart_history_empty: "Atsisiuntimų dar nėra",
      document_cart_history_empty_hint:
        "Iš krepšelio atsisiųsti paketai bus rodomi čia",
      document_cart_history_snapshot_hint:
        "Kiekvienas paketas yra tą dieną atsisiųstų failų momentinė kopija — ne dabartinis aplanko turinys.",
      document_cart_history_load_failed: "Nepavyko įkelti atsisiuntimų istorijos",
      document_cart_history_loading: "Kraunama atsisiuntimų istorija…",
      document_cart_show_files: "Rodyti failus",
      document_cart_hide_files: "Slėpti failus",
      document_cart_files_loading: "Kraunami failai…",
      document_cart_no_files_in_pack: "Šiame pakete failų nėra",
      document_cart_downloading: "Atsisiunčiama…",
      document_cart_status_ready: "Paruošta",
      document_cart_status_failed: "Nepavyko",
      document_cart_status_processing: "Ruošiama",
      document_cart_status_pending: "Laukiama",
      document_cart_status_expired: "Pasibaigė",
      document_cart_page_hint:
        "Peržiūrėkite krepšelį, atsisiųskite ZIP arba atidarykite ankstesnius paketus.",
      document_cart_open: "Atidaryti krepšelį",
      document_cart_view_history: "Atsisiuntimų istorija",
      document_cart_add_selected: "Pridėti pažymėtus į krepšelį",
      document_cart_selected_count: "Pasirinkta: {{count}}",
      document_cart_clear_selection: "Išvalyti pasirinkimą",
      job_leave: "Išėjimas iš darbo",
      employment_leave: "Išėjimas iš darbo",
      onboarding_status: "Įdarbinimo statusas",
      left_company: "Išėjo iš įmonės",
      start_job_leave: "Pradėti išėjimą",
      tab_onboarding: "Įdarbinimas",
      read_only: "tik skaitymui",
      leave_locked_until_onboarding_complete:
        "Išėjimo procesą galima pradėti tik užbaigus įdarbinimą.",
      employee_leave_from_company: "Darbuotojo išėjimas iš įmonės",
      employee_leave_from_company_hint:
        "Pradėkite išėjimo kontrolinį sąrašą: grąžinkite turtą, atšaukite atostogas, išvalykite parašus ir teises, tada užblokuokite šios įmonės narystę.",
      onboarding_locked_during_leave:
        "Kol vyksta išėjimo procesas, įdarbinimo įrašas yra užrakintas.",
      employment_leave_empty:
        "Išėjimo proceso dar nėra. Pradėkite, kai darbuotojas išeina.",
      employment_leave_membership_disabled:
        "Šios įmonės narystė jau išjungta.",
      employment_leave_start_from_onboarding:
        "Išėjimą pradėkite iš užbaigto įdarbinimo (onboarding) įrašo.",
      job_leave_create_failed: "Nepavyko pradėti išėjimo",
      create_job_leave: "Pradėti išėjimą",
      complete_job_leave: "Užbaigti išėjimą",
      cancel_job_leave: "Atšaukti išėjimą",
      quit_date: "Išėjimo data",
      started_by: "Pradėjo",
      completed_by: "Užbaigė",
      leave_started_on: "Pradėta",
      leave_completed_on: "Užbaigta",
      job_leave_status_in_progress: "Vykdoma",
      job_leave_status_completed: "Užbaigta",
      job_leave_status_cancelled: "Atšaukta",
      job_leave_created: "Išėjimo procesas sukurtas",
      job_leave_completed: "Išėjimas užbaigtas — vartotojas užblokuotas",
      job_leave_cancelled: "Išėjimo procesas atšauktas",
      job_leave_completed_message:
        "Išėjimo procesas baigtas. Vartotojas šioje įmonėje užblokuotas.",
      job_leave_not_ready:
        "Prieš užbaigiant išėjimą užbaikite visas parašų užklausas ir grąžinkite visą turtą.",
      job_leave_ready:
        "Visi parašai ir turtas sutvarkyti. Galite užbaigti išėjimą.",
      job_leave_assets_not_ready:
        "Prieš užbaigiant šį žingsnį grąžinkite visą priskirtą turtą.",
      job_leave_assets_ready:
        "Visas turtas grąžintas. Galite užbaigti šį žingsnį.",
      job_leave_signatures_not_ready:
        "Prieš užbaigiant šį žingsnį atšaukite arba užbaikite visas laukiančias parašų užklausas.",
      job_leave_signatures_ready:
        "Laukiančių parašų neliko. Galite užbaigti šį žingsnį.",
      job_leave_permissions_not_ready:
        "Pašalinkite vadovo nuorodas ir kitus priskyrimus prieš užbaigiant išėjimą.",
      job_leave_permissions_ready:
        "Vadovo nuorodos ir kiti priskyrimai išvalyti. Galite užbaigti išėjimą.",
      job_leave_permissions_end_with_leave:
        "Atleidus darbuotoją visos jo teisės šioje įmonėje išnyksta automatiškai.",
      confirm_remove_all_permissions:
        "Išvalyti visas teisių grupes, vadovo nuorodas tiesioginiams pavaldiniams ir kitus aktyvius priskyrimus šiam vartotojui šioje įmonėje?",
      remove_all_permissions: "Išvalyti prieigos priskyrimus",
      permissions_removed: "Prieigos priskyrimai išvalyti",
      job_leave_direct_reports: "Tiesioginiai pavaldiniai",
      no_direct_reports: "Nėra pavaldinių, kuriems šis vartotojas yra vadovas",
      clear_manager_link: "Pašalinti vadovą",
      confirm_clear_manager_link:
        "Pašalinti vadovą vartotojui „{{name}}“? Jis nebebus pavaldus šiam vartotojui.",
      manager_link_cleared: "Vadovo nuoroda pašalinta",
      job_leave_other_assignments: "Kiti priskyrimai",
      no_other_assignments: "Nėra kitų aktyvių priskyrimų",
      no_category_assignments:
        "Nepriskirtas kaip atsakingasis arba peržiūrai jokioje kategorijoje",
      remove_assignment: "Pašalinti",
      confirm_remove_assignment: "Pašalinti „{{label}}“: {{name}}?",
      confirm_remove_assignment_from_section:
        "Pašalinti iš „{{section}}“ — {{label}}: {{name}}?",
      assignment_removed: "Priskyrimas pašalintas",
      job_leave_tab_permissions: "Teisės",
      job_leave_tab_managers: "Vadovai",
      job_leave_tab_categories: "Kategorijos",
      job_leave_tab_departments: "Padaliniai",
      job_leave_tab_other: "Kita",
      job_leave_removal_list: "Šalinami priskyrimai",
      job_leave_removal_list_hint:
        "Kiekvienoje eilutėje matote, iš kur priskyrimas, kas tai ir kokia rolė. Šalinkite po vieną.",
      job_leave_removal_list_empty: "Nėra ką šalinti",
      job_leave_removal_from: "Iš kur",
      job_leave_removal_item: "Pavadinimas",
      job_leave_removal_role: "Rolė",
      job_leave_tab_permissions_hint:
        "Teisių grupės, suteikiančios šiam vartotojui prieigą prie modulių.",
      job_leave_tab_managers_hint:
        "Darbuotojai, kuriems šis vartotojas vis dar yra vadovas.",
      job_leave_tab_categories_hint:
        "Vartotojai, priskirti failų kategorijoje kaip atsakingasis arba „Siųsti peržiūrai“. Rodomas kategorijos pavadinimas.",
      job_leave_tab_departments_hint:
        "Padaliniai, kuriuose šis vartotojas yra narys arba vadovas.",
      job_leave_tab_other_hint:
        "Klientai, įmonės rolės, medicininės patikros atsakingasis ir atviros užduotys.",
      no_department_assignments:
        "Nėra narystės ir nėra vadovas jokame padalinyje",
      job_leave_manager_of: "Pavaldus šiam vartotojui kaip vadovui",
      job_leave_other_assignments_hint:
        "Šie aktyvūs priskyrimai vis dar nurodo šį vartotoją. Pašalinkite po vieną.",
      job_leave_leaves_not_ready:
        "Prieš užbaigiant šį žingsnį atšaukite visas atviras atostogų užklausas.",
      job_leave_leaves_ready:
        "Atvirų atostogų užklausų neliko. Galite užbaigti šį žingsnį.",
      job_leave_step_completed: "Žingsnis užbaigtas",
      job_leave_step_reopened: "Žingsnis atidarytas iš naujo",
      confirm_complete_job_leave:
        "Užbaigti išėjimą? Likusios atostogų užklausos bus atšauktos, o vartotojas šioje įmonėje bus užblokuotas.",
      confirm_complete_job_leave_step:
        "Pažymėti šį žingsnį kaip baigtą ir atrakinti kitą?",
      confirm_reopen_job_leave_step:
        "Grįžti į „{{step}}“? Galėsite vėl dirbti su tuo žingsniu.",
      confirm_cancel_job_leave:
        "Atšaukti šį išėjimo procesą? Vartotojas nebus užblokuotas.",
      confirm_force_return_asset:
        "Pažymėti turtą kaip grąžintą be grąžinimo dokumento ir pašalinti priskyrimą?",
      confirm_cancel_signature: "Atšaukti šią laukiančią parašo užklausą?",
      confirm_remove_signature:
        "Pašalinti šį laukiantį pasirašantįjį? Jei visi kiti jau pasirašė, galutinis pasirašytas dokumentas bus atsisiųstas/pergeneruotas ir išsaugotas (Click/Dokobit). SignOnTab atšauks visą pasirašymo užklausą.",
      confirm_cancel_leave_request: "Atšaukti šią atostogų užklausą?",
      force_return_asset: "Priverstinai grąžinti",
      cancel_signature: "Atšaukti parašą",
      remove_signature: "Pašalinti parašą",
      cancel_leave_request: "Atšaukti atostogas",
      leave_request_cancelled: "Atostogų užklausa atšaukta",
      signature_cancelled: "Parašas atšauktas",
      signature_removed: "Parašas pašalintas",
      signers: "Pasirašantieji",
      no_signers: "Nėra pasirašančiųjų",
      this_signer: "šis pasirašantysis",
      will_be_removed: "bus pašalintas",
      job_leave_remove_signer_outcome_fully_signed:
        "Šalinamas {{name}} ({{signType}}). Visi kiti jau pasirašė — bus atsisiųstas/pergeneruotas galutinis pasirašytas dokumentas ir failas bus pažymėtas kaip pilnai pasirašytas.",
      job_leave_remove_signer_outcome_remove_only:
        "Šalinamas {{name}}. Liko kitų laukiančių pasirašančiųjų — failas liks nepasirašytas.",
      job_leave_remove_signer_outcome_only_signer:
        "Šalinamas {{name}} (vienintelis pasirašantysis). Parašo užklausa bus išvalyta; failas nebus pažymėtas kaip pilnai pasirašytas.",
      job_leave_remove_signer_outcome_signontab:
        "SignOnTab nepalaiko vieno pasirašančiojo pašalinimo. Bus atšaukta visa pasirašymo užklausa ir pašalinti visi šio failo pasirašantieji. Failas nebus pažymėtas kaip pilnai pasirašytas.",
      job_leave_remove_signer_outcome_unknown_signers:
        "Šalinamas {{name}} ({{signType}}). Pasirašančiųjų sąrašo nepavyko užkrauti — po pašalinimo patikrinkite dokumentą.",
      asset_returned: "Turtas grąžintas",
      complete_assets_step: "Užbaigti turto žingsnį",
      complete_leaves_step: "Užbaigti atostogų žingsnį",
      complete_signatures_step: "Užbaigti parašų žingsnį",
      reopen_step: "Atidaryti žingsnį",
      current_step: "Dabartinis",
      locked: "Užrakinta",
      open_asset: "Atidaryti turtą",
      open_leave: "Atidaryti atostogas",
      assigned_assets: "Priskirtas turtas",
      no_assigned_assets: "Nėra priskirto turto",
      open_leave_requests: "Atviros atostogų užklausos",
      open_leave_requests_hint:
        "Atšaukite atostogų užklausas žemiau, arba jos bus automatiškai atšauktos užbaigiant išėjimą.",
      no_open_leave_requests: "Nėra atvirų atostogų užklausų",

      // Desk #76: dokumento anuliavimas + pranešimai pasirašiusiems.
      annulled_badge: "ANULIUOTA",
      annul_document: "Anuliuoti dokumentą",
      annul_document_confirm_title: "Anuliuoti šį dokumentą?",
      annul_document_effect_kept:
        "Dokumentas liks ERP sistemoje, pažymėtas ANULIUOTA — pasirašytas originalas išsaugomas kaip įrodymas ir nėra trinamas.",
      annul_document_effect_notice:
        "Visi jį pasirašiusieji ir visi, kuriems jis buvo išsiųstas el. paštu, gaus pranešimą.",
      annul_document_effect_renamed:
        "Prie dokumento pavadinimo bus pridėta žyma „(ANULIUOTA)“.",
      annul_document_effect_leave:
        "Susijęs atostogų prašymas bus atšauktas.",
      annul_document_effect_trip:
        "Susijusi komandiruotė bus atšaukta.",
      annul_document_effect_trip_report:
        "Komandiruotės ataskaita bus atsieta, o komandiruotė vėl lauks ataskaitos.",
      annul_document_reason_label: "Anuliavimo priežastis",
      annul_document_reason_placeholder:
        "Nurodykite, kodėl šis dokumentas anuliuojamas",
      annul_document_success: "Dokumentas anuliuotas",
      document_annulled: "Šis dokumentas yra anuliuotas.",
      document_not_fully_signed: "Dokumentas dar nėra iki galo pasirašytas.",
      annul_reason_required: "Nurodykite anuliavimo priežastį.",
      document_signed: "Dokumentas jau pasirašytas.",
      signatures_collected:
        "Dokumentą jau kažkas pasirašė, o šis pakeitimas ištrintų jo parašą.",
      replacement_not_fresh_upload:
        "Šį dokumentą galima pakeisti tik ką tik jūsų įkeltu failu. Įkelkite pasirašytą kopiją dar kartą.",
      signer_edit_forbidden:
        "Neturite teisių tvarkyti šio dokumento pasirašančiųjų.",
      user_has_other_companies:
        "Šis asmuo dirba ir kitose įmonėse, todėl jo el. paštą, vardą, telefoną ar lytį gali keisti tik jis pats arba kiekvienos iš tų įmonių administratorius (Master).",
      prefill_employee_form: "Pildyti anketą už darbuotoją",
      prefill_employee_form_note:
        "Užpildykite, ką žinote. Darbuotojas prisijungęs patikrins, papildys ir pateiks anketą.",
      prefill_employee_form_locked:
        "Darbuotojas anketą jau pateikė — jos keisti nebegalima.",
      employee_form_locked:
        "Šią formą jau pateikėte, todėl jos duomenų ir dokumentų keisti nebegalima. Jei reikia ką nors pataisyti, kreipkitės į jūsų įdarbinimą tvarkantį asmenį.",
      file_not_a_fresh_upload:
        "Šis failas jau pasirašytas arba išsiųstas pasirašyti, todėl jo negalima pažymėti kaip pasirašytos skenuotos kopijos. Įkelkite skenuotą kopiją dar kartą.",
      onboarding_document_already_signed: "Šis dokumentas jau pasirašytas. Puslapis atnaujintas.",
      signed_contract_locked:
        "Šio įdarbinimo sutartis jau pasirašyta — tokiu būdu jos keisti nebegalima.",
      access_denied: "Prieiga uždrausta",
      forbidden: "Neturite teisės atlikti šio veiksmo.",
      annulment_not_found: "Anuliavimo įrašas nerastas",
      invalid_replacement: "Šis dokumentas negali būti nurodytas kaip pakaitalas",

      // Savininko pasirašymo taisyklė: pagal šabloną sugeneruoto dokumento
      // parašo/pasirašymo užklausos šalinti po vieną negalima — kol
      // dokumentas dar nepasirašytas iki galo, jį galima tik atšaukti visą.
      template_signatures_locked:
        "Pagal šabloną sugeneruoto dokumento parašų šalinti negalima — dokumentą galima tik atšaukti.",
      withdraw_document: "Atšaukti dokumentą",
      withdraw_document_confirm_title: "Atšaukti šį dokumentą?",
      withdraw_document_effect_unsigned: "Dokumentas nebus pasirašytas.",
      withdraw_document_effect_notice:
        "Dar nepasirašiusiems bus išsiųstas pranešimas.",
      withdraw_document_effect_permanent: "Šio veiksmo atšaukti negalima.",
      withdraw_document_reason_label: "Priežastis (neprivaloma)",
      withdraw_document_reason_placeholder:
        "Nurodykite, kodėl šis dokumentas atšaukiamas",
      withdraw_document_success: "Dokumentas atšauktas",
      withdraw_forbidden: "Neturite teisės atšaukti šio dokumento.",
      withdraw_not_template:
        "Atšaukti galima tik pagal šabloną sugeneruotus dokumentus.",
      withdraw_not_supported: "Šio dokumento atšaukti negalima.",
      document_withdrawn: "Šis dokumentas yra atšauktas.",
      withdrawn_badge: "ATŠAUKTA",
      signer_status_withdrawn: "Atšaukta",
      template_signers_locked_hint:
        "Šis dokumentas sugeneruotas pagal šabloną — jau pakviestų pasirašančiųjų čia pašalinti negalima. Naujus pasirašančiuosius pridėti vis dar galite; norėdami visiškai atšaukti užklausą, atšaukite dokumentą.",

      reset_signatures_fully_signed_notice:
        'Šis dokumentas yra iki galo pasirašytas. Visi pasirašiusieji gaus pranešimą, kad dokumentas bus pasirašomas iš naujo. Jei dokumentas nebegalioja – naudokite „Anuliuoti dokumentą“.',
      reset_signatures_reason_placeholder:
        "Neprivaloma – nurodykite, kodėl dokumentas pasirašomas iš naujo",
      annulment_reason_label: "Priežastis",
      annulment_panel_title: "Anuliavimo istorija",
      annulment_panel_resign_title: "Parašai atstatyti pasirašymui iš naujo",
      annulment_panel_unknown_actor: "Nežinoma",
      annulment_panel_replaced_by: "Pakeistas dokumentu:",
      annulment_panel_change_replacement: "Pakeisti",
      annulment_panel_remove_replacement: "Pašalinti ryšį",
      annulment_panel_set_replacement: "Nurodyti naują dokumentą",
      annulment_panel_replaces: "Pakeičia anuliuotą dokumentą:",
      annulment_panel_resend: "Siųsti pranešimus pakartotinai",
      annulment_panel_download_original:
        "Atsisiųsti originalą be žymos (įrodymas)",
      annulment_notices_resent: "Pranešimai išsiųsti pakartotinai",
      annulment_recipient_role: "Vaidmuo",
      annulment_recipient_role_signer: "Pasirašė",
      annulment_recipient_role_receiver: "Gavo dokumentą",
      annulment_recipient_status_sent: "Išsiųsta",
      annulment_recipient_status_failed: "Nepavyko",
      annulment_recipient_status_pending: "Laukiama",
      annulment_recipient_status_not_sent: "Neišsiųsta",
      annulment_panel_load_error: "Nepavyko įkelti anuliavimo istorijos.",
      status_cancelled: "Atšaukta",
      business_trip_cancelled: "Ši komandiruotė atšaukta",
      business_trip_cancelled_banner_title: "Ši komandiruotė atšaukta",
      business_trip_cancelled_banner_body:
        "Komandiruotės pagrindinis dokumentas buvo anuliuotas. Ataskaitos, jos dokumento ir atostogų užklausų nebegalima kurti ar redaguoti.",
      // Pareigų katalogas — docs/prd/positions-catalogue.md
      positions_title: "Pareigos",
      positions_tab_onboardings: "Darbo sutartys",
      positions_page_hint: "Įmonės pareigų sąrašas. Darbuotojams pareigos parenkamos iš čia; kiekvienos pareigos gali suteikti vidinius dokumentus.",
      positions_picker_search: "Ieškoti pareigų",
      positions_picker_empty: "Pareigų nerasta",
      positions_picker_create: "Naujos pareigos…",
      positions_name_lt: "Pavadinimas (LT)",
      positions_name_en: "Pavadinimas (EN)",
      positions_name_lt_required: "Įveskite pavadinimą lietuviškai",
      positions_create: "Sukurti",
      positions_archived_badge: "archyvuota",
      positions_move_left: "Perkelti anksčiau",
      positions_move_right: "Perkelti vėliau",
      positions_load_failed: "Nepavyko įkelti pareigų.",
      positions_order_hint: "Dokumentuose pareigos bus išvardytos šia tvarka.",
      positions_none_selected: "Pareigos nepasirinktos",
      positions_unknown: "Nežinomos pareigos",
      positions_saved: "Pareigos išsaugotos",
      positions_edit_title: "Redaguoti pareigas",
      positions_new_title: "Naujos pareigos",
      positions_rename_hint: "Pakeitus pavadinimą, jis atsinaujins esamiems darbuotojams; pasirašyti dokumentai lieka su senu tekstu.",
      positions_roles_title: "Dokumentai",
      positions_roles_hint: "Visi šias pareigas einantys darbuotojai iš karto gauna šiuos vidinius dokumentus.",
      positions_permissions_title: "Teisės",
      positions_permissions_hint: "Visi šias pareigas einantys darbuotojai gauna šias teises.",
      positions_permissions_applies_at_once: "Pakeitimas iškart galioja visiems šias pareigas turintiems darbuotojams.",
      positions_permissions_none: "Šios pareigos jokių teisių nesuteikia.",
      positions_area_no_roles: "Šioje srityje nėra aktyvių pareigybių.",
      positions_roles_read_only: "Sritys, kurių netvarkote (tik peržiūra):",
      positions_roles_none_manageable: "Netvarkote nė vienos srities, todėl pareigybių čia susieti negalite.",
      positions_holders_title: "Darbuotojai",
      positions_no_holders: "Šių pareigų niekas neina.",
      positions_holders_count: "darbuotojų: {{count}}",
      positions_no_roles: "Pareigybių nėra",
      positions_merge: "Sujungti",
      positions_merge_title: "Sujungti «{{name}}» su…",
      positions_merge_pick_hint: "Pasirinkite pareigas, kurios liks. Jos išlaiko savo pavadinimą, o šios bus archyvuotos.",
      positions_merge_next: "Toliau",
      positions_merge_action: "Sujungti",
      positions_merge_confirm_text: "«{{source}}» bus sujungtos su «{{target}}»: jų darbuotojai ({{count}}) eis «{{target}}» pareigas, o «{{source}}» bus archyvuotos. Pasirašyti dokumentai lieka nepakitę.",
      positions_merge_union_title: "«{{target}}» suteiks šias pareigybes:",
      positions_merge_union_warning: "«{{target}}» gaus pareigybių, kurių neturėjo — dabartiniai jų darbuotojai jas (ir dokumentus pasirašyti) gaus iš karto.",
      positions_merge_done: "«{{source}}» sujungtos su «{{target}}»",
      positions_archive_confirm: "Archyvuoti «{{name}}»? Naujiems darbuotojams šios pareigos nebebus siūlomos.",
      positions_archive_confirm_holders: "Archyvuoti «{{name}}»? Jas vis dar eina darbuotojų: {{count}} — jiems pareigos liks, kol bus pakeistos; naujiems nebebus siūlomos.",
      positions_show_archived: "Rodyti archyvuotas",
      // Pareigybių tvirtinimas pagal sritis (pareigų katalogas, §1 7–8 taisyklės)
      ws_approvals_tab: "Laukia patvirtinimo",
      ws_approvals_intro: "Darbuotojai, kurių pareigos suteikia pareigybių jūsų srityse. Kol sritis nepatvirtinta, joje niekas nepriskiriama.",
      ws_approvals_empty: "Jūsų patvirtinimo niekas nelaukia.",
      ws_approvals_load_failed: "Nepavyko įkelti tvirtinimų.",
      ws_approvals_forbidden: "Šis tvirtinimas priklauso sričiai, kurios netvarkote.",
      ws_approvals_not_found: "Šio tvirtinimo nebėra.",
      ws_approvals_col_area: "Sritis",
      ws_approvals_kind_hire: "Įdarbinimas",
      ws_approvals_kind_amendment: "Sutarties pakeitimas",
      ws_approvals_kind_profile: "Profilis",
      ws_approvals_status_label: "Pareigybių tvirtinimas",
      ws_approvals_auto: "patvirtinta automatiškai",
      ws_approvals_waiting: "laukia",
      // Bandomasis laikotarpis + antras atlyginimas (docs/prd/probation-salary-review.md)
      onboarding_planned_salary_change: "Kitas atlyginimas nuo {{date}}: <amount/>",
      salary_change_invalid: "Neteisingai nurodyta kito atlyginimo data ar suma.",
      salary_change_invalid_custom_template:
        "Šios įmonės sutarties šablonas yra individualus ir nepalaiko antro atlyginimo. Kreipkitės į administratorių.",
      amendment_cancels_planned_salary_change:
        "Pasirašius šį pakeitimą, numatytas atlyginimo pakeitimas nuo {{date}} (<amount/>) bus panaikintas.",
      personnel_planned_salary_change: "Numatytas pakeitimas",
      personnel_planned_salary_change_value: "Nuo {{date}}: <amount/>",
      // Atlyginimai paslėpti, kol žiūrintysis nespustelės akies
      show_amount: "Rodyti sumą",
      hide_amount: "Slėpti sumą",
      show_hidden_values: "Rodyti paslėptas reikšmes",
      hide_hidden_values: "Slėpti reikšmes",
      show_personal_code: "Rodyti asmens kodą",
      hide_personal_code: "Slėpti asmens kodą",
      edit_personal_code: "Redaguoti asmens kodą",
      personal_code_invalid: "Neteisingas asmens kodas — įveskite 11 Lietuvos asmens kodo skaitmenų arba palikite tuščią.",
      personal_code_save_failed: "Asmens kodas neišsaugotas. Bandykite dar kartą.",
      personnel_tile_probation: "Bandomasis laikotarpis",
      probation_status_ongoing: "Vyksta iki {{endDate}}",
      probation_status_awaiting_review: "Laukia vertinimo iki {{deadline}}",
      probation_status_passed: "Išlaikytas",
      probation_status_failed: "Neišlaikytas — įspėjimą įteikti iki {{deadline}}",
      probation_status_passed_unreviewed: "Laikomas išlaikytu (neįvertintas)",
      probation_review_action_submit: "Įvertinti",
      probation_review_action_view: "Peržiūrėti",
      probation_reviews_intro: "Darbuotojai, kurių bandomąjį laikotarpį jums reikia įvertinti.",
      probation_reviews_empty: "Šiuo metu nėra laukiančių vertinimų.",
      probation_reviews_load_failed: "Nepavyko įkelti sąrašo.",
      probation_review_reason: "Priežastis",
      probation_review_reason_manager: "Tiesioginis vadovas",
      probation_review_reason_no_manager: "Nėra vadovo",
      probation_review_reason_escalated: "Perduota HR",
      probation_review_dialog_title: "Bandomojo laikotarpio vertinimas",
      probation_end_date_field: "Bandomojo laikotarpio pabaiga",
      probation_decision_deadline: "Sprendimo terminas",
      probation_notice_deadline: "Įspėjimo terminas",
      probation_end_date_label: "Pabaigos data",
      probation_end_date_invalid: "Pabaigos data negali būti ankstesnė nei šiandien.",
      probation_absence_hint: "Per bandomąjį laikotarpį patvirtintų atostogų: {{days}} d. Jei reikia, pratęskite pabaigos datą.",
      probation_read_only_hint: "Tik peržiūra — šio vertinimo pateikti negalite.",
      probation_decision_label: "Sprendimas",
      probation_decision_option_passed: "Išlaikė",
      probation_decision_option_failed: "Neišlaikė",
      probation_comment_label: "Komentaras",
      probation_comment_required_min: "Neišlaikius komentaras privalomas (bent 10 simbolių).",
      probation_criterion_quality: "Darbo kokybė",
      probation_criterion_workload: "Darbo apimtis ir terminų laikymasis",
      probation_criterion_independence: "Savarankiškumas ir iniciatyva",
      probation_criterion_discipline: "Darbo drausmė, vidaus tvarkų laikymasis",
      probation_criterion_teamwork: "Bendradarbiavimas ir komunikacija",
      probation_criterion_trainings: "Privalomi mokymai (sutarties 3.2 p.)",
      probation_criterion_targets: "Nustatyti rodikliai (sutarties 3.2 p.)",
      probation_rating_meets: "Atitinka",
      probation_rating_partly: "Iš dalies",
      probation_rating_not_meets: "Neatitinka",
      probation_rating_na: "Netaikoma",
      probation_review_invalid: "Patikrinkite vertinimo laukus.",
      probation_review_forbidden: "Neturite teisės atlikti šio veiksmo.",
      probation_review_closed: "Vertinimas jau užbaigtas arba terminas praėjo.",
      probation_not_applicable: "Bandomasis laikotarpis netaikomas.",
      ws_approvals_status_superseded: "Pakeista naujesniu tvirtinimu",
      ws_approvals_approved_by: "Patvirtino",
      ws_approvals_proposal_title: "Siūlomos pareigybės",
      ws_approvals_proposal_hint: "Jos kyla iš darbuotojo pareigų. Norėdami pakeisti pasiūlymą, pakeiskite, kokias pareigybes suteikia pareigos.",
      ws_approvals_proposal_empty: "Pareigos šioje srityje pareigybių nebesuteikia.",
      ws_approvals_required_at_hiring: "Privaloma įdarbinant",
      ws_approvals_no_document: "nėra dokumento",
      ws_approvals_individual_title: "Individualios pareigybės šioje srityje",
      ws_approvals_individual_none: "Nėra.",
      ws_approvals_add_individual: "Pridėti individualiai",
      ws_approvals_add_individual_hint: "Pridedamos papildomai prie pareigų; lieka, kol pašalinamos rankiniu būdu.",
      ws_approvals_individual_selected: "Bus pridėta individualiai: {{count}}",
      ws_approvals_approve: "Patvirtinti",
      ws_approvals_approved_toast: "Patvirtinta: {{name}}",
      ws_approvals_already_decided: "Šis tvirtinimas jau išspręstas arba pakeistas — rodoma dabartinė būsena.",
      // Pareigų parinkimas įdarbinimo formoje, pakeitimuose ir profilyje
      positions_legacy_text_hint: "Anksčiau įvesta tekstu: «{{text}}». Pasirinkite atitinkamas pareigas iš sąrašo.",
      positions_required: "Pasirinkite bent vienas pareigas",
      positions_new_positions: "Naujos pareigos",
      positions_via_amendment_hint: "Keičiama per sutarties pakeitimą",
      // Pareigybių panelė darbuotojo redagavimo formoje
      user_form_roles_title: "Pareigybės",
      user_form_roles_hint: "Pritaikoma iš karto — nepriklauso nuo žemiau esančio mygtuko „Išsaugoti“.",
      // Personalo kortelė, darbuotojo kortelė ir pareigybės puslapis — pareigybės pagal pareigas
      ws_step_waiting_approvals: "Laukiama, kol sritys patvirtins pareigybes. Žingsnis užsibaigs pats, kai jos bus patvirtintos ir privalomi dokumentai pasirašyti.",
      ws_step_auto_complete_hint: "Žingsnis užsibaigs pats, kai bus pasirašyti privalomi dokumentai.",
      onboarding_employee_already_active: "Šis asmuo jau dirba įmonėje. Kreipkitės į personalo vadybininką.",
      onboarding_already_employed_here: "Šis el. paštas priklauso asmeniui {{name}}, jau dirbančiam šioje įmonėje. Naujas įdarbinimas negalimas – esamą darbo sutartį užregistruokite pasirinkę „Sutarties registracija“.",
      ws_role_source_positions: "nuo pareigų: {{names}}",
      ws_role_source_positions_plain: "nuo pareigų",
      ws_role_source_individual: "individuali",
      ws_individual_remove: "Pašalinti individualią",
      ws_individual_remove_confirm: "Pašalinti individualią pareigybę «{{name}}»? Jei ją suteikia ir pareigos, ji liks.",
      ws_individual_removed: "Individuali pareigybė pašalinta",
      ws_individual_added: "Individualios pareigybės pridėtos",
      ws_individual_nothing_to_add: "Visos jūsų sričių pareigybės jau priskirtos individualiai.",
      ws_individual_add_action: "Pridėti",
      positions_role_none: "Jokios pareigos šios pareigybės nesuteikia.",
      positions_role_link_hint: "Susiejimas galioja iš karto visiems šias pareigas einantiems: jie gauna pareigybę ir jos dokumentus pasirašyti. Atsiejus pareigybė jiems pašalinama, nebent ji priskirta individualiai.",
      // Pareigų / tvirtinimų klaidos iš serverio
      ws_error_approvals_pending: "Kai kurios sritys dar nepatvirtino pareigybių — palaukite jų patvirtinimo.",
      positions_error_name_taken: "Pareigos tokiu pavadinimu jau yra.",
      positions_error_area_forbidden: "Šios pareigybės srities netvarkote.",
      positions_error_permission_not_grantable: "Šios teisės per pareigas suteikti negalima.",
      positions_error_merge_permissions_master_only: "Šios pareigos suteikia skirtingas teises — sujungti gali tik administratorius.",
      positions_error_merge_area_forbidden: "Sujungus būtų pridėta pareigybių iš sričių, kurių netvarkote: {{areas}}. Kreipkitės į jų atsakingus asmenis arba Master.",
      positions_error_merge_area_forbidden_plain: "Sujungus būtų pridėta pareigybių iš sričių, kurių netvarkote. Kreipkitės į jų atsakingus asmenis arba Master.",
      // Pareigų pavadinimai pagal lytį (pareigų katalogas, §8)
      positions_name_lt_female: "Pavadinimas moteriškąja gimine (LT)",
      positions_name_lt_female_placeholder: "pvz. Buhalterė",
      positions_merge_as_female: "Naudoti „{{source}}“ kaip moterišką „{{target}}“ pavadinimą",
      user_gender: "Lytis",
      user_gender_male: "Vyras",
      user_gender_female: "Moteris",
      user_gender_unset: "Nenurodyta",
      user_gender_hint: "Moterims dokumentuose rašomas moteriškas pareigų pavadinimas, jei jis nurodytas.",
      // Priėmimo į darbą anketos 1 žingsnis: lyties laukas
      onboarding_gender_hint: "Naudojama, kad sutartyje pareigos būtų nurodytos tinkama gimine.",
      invalid_gender: "Pasirinkite tinkamą lytį.",
      // Sujungimas: darbuotojai, kuriems nustatyta lytis
      positions_merge_gender_set: "Moteriška lytis nustatyta darbuotojų: {{count}}.",
      // Pareigos sukurtos, pareigybės neišsaugotos
      positions_created_roles_failed: "Pareigos sukurtos, bet jų pareigybės neišsaugotos — spauskite „Išsaugoti“ dar kartą.",
      // Personalas → Darbuotojai sąrašas ir darbuotojo kortelė
      personnel_tab_employees: "Darbuotojai",
      personnel_list_hint: "Dirbantys žmonės, kuriuos galite matyti. Atidarykite eilutę — darbuotojo kortelė.",
      personnel_search_placeholder: "Paieška pagal vardą, el. paštą ar pareigas…",
      personnel_status_filter: "Būsena",
      personnel_status_active: "Dirba",
      personnel_status_left: "Išėję",
      personnel_status_left_one: "Išėjęs",
      personnel_status_hiring: "Įdarbinama",
      personnel_all_departments: "Visi skyriai",
      personnel_all_positions: "Visos pareigos",
      personnel_filter_no_onboarding_record: "Be įdarbinimo įrašo",
      personnel_load_failed: "Nepavyko įkelti darbuotojų.",
      personnel_empty: "Pagal šiuos filtrus darbuotojų nėra.",
      personnel_pagination: "{{from}}–{{to}} iš {{total}}",
      personnel_page_previous: "Atgal",
      personnel_chip_ws_unsigned: "Nepasirašyti Tvarkų dok.: {{n}}",
      personnel_chip_pending_approvals: "Laukia patvirtinimo: {{n}}",
      personnel_chip_medical_expired: "Sveikatos patikra baigėsi {{date}}",
      personnel_chip_medical_expiring: "Sveikatos patikra baigiasi {{date}}",
      personnel_chip_job_leave: "Išėjimas: {{status}}",
      personnel_chip_no_onboarding_record: "Nėra įdarbinimo įrašo",
      personnel_card_title: "Darbuotojo kortelė",
      personnel_card_forbidden: "Neturite prieigos prie šio darbuotojo kortelės.",
      personnel_card_load_failed: "Nepavyko įkelti darbuotojo kortelės.",
      personnel_employed_since: "Dirba nuo {{date}}",
      personnel_contract_no: "Sutartis Nr. {{number}}",
      personnel_new_amendment: "Naujas sutarties pakeitimas",
      personnel_start_leave: "Pradėti išėjimą",
      personnel_opens_record_hint: "Atidaro darbuotojo įdarbinimo įrašą",
      personnel_tab_summary: "Santrauka",
      personnel_tab_procedures: "Tvarkos",
      personnel_tab_health: "Sveikata",
      personnel_tab_leave: "Išėjimas",
      personnel_tab_records: "Įdarbinimo įrašai",
      personnel_tab_history: "Istorija",
      personnel_tile_open: "Atidaryti",
      personnel_tile_terms: "Darbo sąlygos",
      personnel_salary: "Atlyginimas",
      personnel_ws_required_unsigned: "Nepasirašyti privalomi dokumentai",
      personnel_ws_unsigned: "Visi nepasirašyti dokumentai",
      personnel_ws_pending_approvals: "Pareigybės, laukiančios patvirtinimo",
      personnel_medical_valid_until: "Galioja iki",
      personnel_medical_none: "Galiojančios sveikatos patikros nėra.",
      personnel_medical_renewal_open: "Vyksta pakartotinė patikra",
      personnel_no_job_leave: "Išėjimo procesas nepradėtas.",
      personnel_no_records: "Įdarbinimo įrašų nėra.",
      personnel_record_hire: "Įdarbinimas",
      personnel_signed_documents: "Pasirašyti Tvarkų dokumentai",
      personnel_tab_contract: "Sutartis ir pakeitimai",
      personnel_tab_leaves: "Atostogos",
      personnel_tab_assets: "Turtas",
      personnel_tab_businessTrips: "Komandiruotės",
      personnel_tab_fuelReports: "Kuro ataskaitos",
      personnel_tab_expenses: "Išlaidos",
      personnel_contract_record: "Įrašas",
      personnel_open_record: "Atidaryti įrašą",
      personnel_terms_other_record: "Dabartinės darbo sąlygos paimtos iš kito įrašo — jo sąlygas rasite atidarę šį įrašą.",
      personnel_amendments_after_contract: "Sutarties pakeitimai bus galimi, kai įdarbinimas pereis darbo sutarties etapą.",
      personnel_assets_load_failed: "Nepavyko įkelti turto.",
      personnel_assets_current: "Šiuo metu išduota",
      personnel_assets_none: "Darbuotojui nieko neišduota.",
      personnel_assets_history: "Išdavimo ir grąžinimo istorija",
      personnel_assets_history_none: "Išdavimo istorijos nėra.",
      personnel_asset_name: "Turtas",
      personnel_asset_type: "Tipas",
      personnel_asset_serial: "Unikalus / inventoriaus nr.",
      personnel_asset_issued: "Išduota",
      personnel_asset_returned: "Grąžinta",
      personnel_asset_broken: "Sugadintas",
      personnel_asset_still_issued: "Tebeturi",
      personnel_asset_status_in_use: "Naudojamas",
      personnel_asset_status_in_stock: "Sandėlyje",
      personnel_asset_act_signed: "Aktas pasirašytas",
      personnel_asset_act_pending: "Aktas laukia parašo",
      personnel_asset_act_annulled: "Aktas anuliuotas",
      // Personalas kortelė: komandiruotės / kuro ataskaitos / rankinės išlaidos (3 etapas)
      personnel_trips_load_failed: "Nepavyko įkelti komandiruočių.",
      personnel_trips_none: "Komandiruočių nėra.",
      personnel_trip_destination: "Paskirties vieta",
      personnel_trip_purpose: "Tikslas",
      personnel_trip_dates: "Datos",
      personnel_trip_report: "Ataskaita",
      personnel_trip_number: "Nr. {{number}}",
      personnel_trip_order: "Įsakymas",
      personnel_trip_report_status_pending: "Laukia parašo",
      personnel_trip_report_status_signed: "Pasirašyta",
      personnel_trip_report_status_rejected: "Atmesta",
      personnel_trip_report_status_annulled: "Anuliuota",
      personnel_fuel_load_failed: "Nepavyko įkelti kuro ataskaitų.",
      personnel_fuel_none: "Kuro ataskaitų nėra.",
      personnel_fuel_period: "Laikotarpis",
      personnel_fuel_asset: "Transporto priemonė",
      personnel_fuel_km: "Km",
      personnel_fuel_consumed_litres: "Sunaudota (l)",
      personnel_fuel_amount: "Suma",
      personnel_fuel_status_draft: "Juodraštis",
      personnel_fuel_status_pending: "Laukia parašo",
      personnel_fuel_status_signed: "Pasirašyta",
      personnel_fuel_status_annulled: "Anuliuota",
      personnel_expenses_load_failed: "Nepavyko įkelti išlaidų.",
      personnel_expenses_none: "Išlaidų nėra.",
      personnel_expense_category: "Kategorija",
      personnel_expense_category_fuel: "Kuras",
      personnel_expense_category_other: "Kitos išlaidos",
      leave_calendar_redacted_note: "Išsami informacija matoma tik darbuotojui, jo vadovui ir pasirašantiems.",
      // Skyriai: vadovo prieiga prie darbuotojų duomenų
      department_head_data_access: "Vadovas priima darbuotojus ir mato komandos duomenis",
      department_head_data_access_hint: "Vadovas gali priimti darbuotojus į šį padalinį ir jo popadalinius, tvirtinti sveikatos patikras ir mato šiuos darbuotojus Personalo skiltyje, įskaitant atlyginimus. Įjungti gali tik Master.",
      department_head_data_access_badge: "Prieiga prie duomenų",
      department_head_data_access_master_only: "Įjungti gali tik Master.",
      department_error_flagged_master_only: "Šio skyriaus vadovas turi prieigą prie darbuotojų duomenų — keisti vadovą, narius ar tėvinį skyrių gali tik Master.",
      department_error_head_changed: "Skyriaus vadovas ką tik pasikeitė — atnaujinkite puslapį ir bandykite dar kartą.",
      department_error_head_data_access_self_grant: "Prieigos prie darbuotojų duomenų negalima suteikti sau ir savo vadovaujamam skyriui plėsti — kreipkitės į Master.",
      // mobile: settings
      settings_nav_pick_section: "Skiltis",
      department_head_data_access_scope_count: "Vadovas matys šio skyriaus ir poskyrių darbuotojų duomenis ({{n}} žm.), įskaitant atlyginimus.",
      department_head_data_access_scope_generic: "Vadovas matys šio skyriaus ir poskyrių darbuotojų duomenis, įskaitant atlyginimus.",
      department_error_head_data_access_invalid_head: "Prieigos negalima suteikti svečiui, įgaliotam asmeniui ar išjungtam vartotojui.",
      department_head_data_access_regrant: "Pasikeitė vadovas — naujam vadovui prieigą reikia suteikti iš naujo.",
      asset_requests_tab_assets: "Turtas",
      asset_requests_tab_requests: "Prašymai",
      asset_requests_title: "Turto prašymai",
      asset_requests_page_hint: "Darbuotojų reikalingas turtas. Išduokite turtą ir pažymėkite prašymą įvykdytu.",
      asset_requests_new: "Naujas prašymas",
      asset_requests_filter_pending: "Laukia",
      asset_requests_filter_done: "Įvykdyti",
      asset_requests_filter_rejected: "Atmesti",
      asset_requests_status_pending: "Laukia",
      asset_requests_status_done: "Įvykdyta",
      asset_requests_status_rejected: "Atmesta",
      asset_requests_col_source: "Šaltinis",
      asset_requests_col_needed_by: "Reikia iki",
      asset_requests_col_result: "Sprendimas",
      asset_requests_source_onboarding: "Įdarbinimas",
      asset_requests_source_manual: "Rankinis",
      asset_requests_source_self: "Darbuotojo prašymas",
      asset_requests_overdue: "Vėluoja",
      asset_requests_created_by_system: "Sistema",
      asset_requests_issue: "Išduoti turtą",
      asset_requests_mark_done: "Įvykdyta",
      asset_requests_reject: "Atmesti",
      asset_requests_empty_pending: "Laukiančių prašymų nėra.",
      asset_requests_empty_done: "Įvykdytų prašymų nėra.",
      asset_requests_empty_rejected: "Atmestų prašymų nėra.",
      asset_requests_load_failed: "Nepavyko įkelti prašymų.",
      asset_requests_create: "Sukurti prašymą",
      asset_requests_created: "Prašymas sukurtas",
      asset_requests_search_employee: "Ieškoti darbuotojo",
      asset_requests_no_employee: "Darbuotojų nerasta.",
      asset_requests_self_title: "Prašymas dėl turto",
      asset_requests_self_hint: "Parašykite, ko jums reikia (nešiojamo kompiuterio, telefono, uniformos...). Prašymą matys už turto išdavimą atsakingas asmuo.",
      asset_requests_self_button: "Pildyti turto prašymą",
      asset_requests_mine_title: "Mano prašymai",
      asset_requests_mine_empty: "Prašymų dar nėra.",
      asset_requests_rejected_reason: "Priežastis: {{reason}}",
      asset_requests_complete_title: "Pažymėti prašymą įvykdytu",
      asset_requests_complete_note: "Pastaba (neprivaloma)",
      asset_requests_reject_title: "Atmesti prašymą",
      asset_requests_reject_reason: "Priežastis",
      asset_requests_for_employee: "Darbuotojui: {{name}}",
      asset_requests_pick_asset_title: "Pasirinkite išduodamą turtą",
      asset_requests_pick_asset_hint: "Rodomas tik sandėlyje esantis turtas.",
      asset_requests_pick_asset_search: "Ieškoti turto",
      asset_requests_pick_asset_empty: "Sandėlyje turto nėra.",
      asset_requests_pick_asset_next: "Tęsti",
      asset_requests_onboarding_label: "Turto prašymas",
      asset_requests_onboarding_none: "Bus sukurtas po 1 žingsnio",
      asset_requests_onboarding_absent: "Nėra",
      asset_requests_onboarding_done: "Įvykdytas {{date}}",
      asset_requests_onboarding_rejected: "Atmestas: {{reason}}",
      asset_requests_open_queue: "Atidaryti prašymus",
      asset_requests_error_generic: "Veiksmo atlikti nepavyko. Bandykite dar kartą.",
      asset_requests_error_employee_required: "Pasirinkite darbuotoją.",
      asset_requests_error_employee_not_active: "Šis asmuo nėra aktyvus įmonės darbuotojas.",
      asset_requests_error_comment_required: "Parašykite, ko jums reikia.",
      asset_requests_error_comment_too_long: "Komentaras per ilgas.",
      asset_requests_error_reason_required: "Nurodykite priežastį.",
      asset_requests_error_not_pending: "Šį prašymą jau apdorojo kitas asmuo.",
      asset_requests_error_not_found: "Prašymo nebėra.",
      microsoft_secret_saved_placeholder: "Įrašytas raktas ••••{{last4}} – palikite tuščią, jei nekeičiate",
      microsoft_secret_expires_at: "Raktas galioja iki",
      microsoft_secret_expires_at_hint:
        "Data matoma Azure portale (Certificates & secrets → Expires). Likus 30 d. iki jos, administratoriams bus rodomas priminimas.",
      microsoft_secret_expiring_banner:
        "Microsoft (OneDrive) rakto galiojimas baigiasi {{date}} (liko {{days}} d.). Atnaujinkite raktą Nustatymuose → <settingsLink>Microsoft Connect</settingsLink>.",
      microsoft_secret_expired_banner:
        "Microsoft (OneDrive) raktas nebegalioja nuo {{date}} – dokumentų generavimas ir failai neveikia. Atnaujinkite raktą Nustatymuose → <settingsLink>Microsoft Connect</settingsLink>.",
      // Įmonės nustatymai: sugrupuota naršymo juosta ir tarp skyrių perkelti blokai
      settings_nav_page_title: "Nustatymai",
      settings_nav_group_company: "Įmonė",
      settings_nav_group_people: "Žmonės ir teisės",
      settings_nav_group_documents: "Dokumentai",
      settings_nav_group_finance: "Finansai",
      settings_nav_group_modules: "Moduliai",
      settings_nav_group_tools: "Įrankiai",
      settings_nav_company_label: "Rekvizitai ir logotipas",
      settings_nav_company_lead: "Šie duomenys spausdinami sąskaitose, sutartyse ir kituose dokumentuose.",
      settings_nav_roles_label: "Kas ką tvirtina ir pasirašo",
      settings_nav_roles_lead: "Žmonės, kuriuos sistema pati įtraukia į dokumentų pasirašymą ir tvirtinimą.",
      settings_nav_holidays_label: "Kalendoriaus nustatymai",
      settings_nav_holidays_lead: "Pagal tai skaičiuojamos atostogų dienos.",
      settings_holidays_year_title: "Šventės {{year}}",
      settings_holidays_year_lead: "Valstybinės ir įmonės šventės — jos taip pat neįskaičiuojamos į atostogas.",
      settings_holidays_import: "Įkelti valstybines šventes",
      settings_holidays_imported: "Valstybinės šventės įkeltos.",
      settings_holidays_import_nothing: "Visos valstybinės šventės jau yra sąraše.",
      settings_holidays_add: "Pridėti įmonės šventę",
      settings_holidays_show_previous_year: "Rodyti {{year}} m. šventes",
      settings_holidays_col_date: "Data",
      settings_holidays_col_name: "Šventė",
      settings_holidays_turned_off: "išjungta",
      settings_holidays_turn_off: "Išjungti",
      settings_holidays_turn_on: "Įjungti",
      settings_holidays_empty: "Šiais metais švenčių dar nėra. Įkelkite valstybines šventes arba pridėkite savo.",
      settings_holidays_past_note: "Praėjusių švenčių keisti negalima — pagal jas jau suskaičiuotos atostogos.",
      settings_holidays_form_add_title: "Nauja įmonės šventė",
      settings_holidays_form_edit_title: "Keisti šventę",
      settings_holidays_field_name: "Pavadinimas",
      settings_holidays_field_start: "Pradžios data",
      settings_holidays_field_end: "Pabaigos data",
      settings_holidays_form_incomplete: "Įveskite pavadinimą ir abi datas.",
      settings_holidays_start_wrong_year: "Pradžios data turi būti {{year}} metais.",
      settings_holidays_end_before_start: "Pabaigos data negali būti ankstesnė už pradžios datą.",
      settings_holidays_past_forbidden: "Praėjusios šventės keisti negalima.",
      settings_holidays_load_failed: "Nepavyko įkelti švenčių.",
      settings_nav_users_label: "Naudotojai",
      settings_nav_users_lead: "Kas gali prisijungti prie šios įmonės.",
      users_search_placeholder: "Ieškoti pagal vardą, el. paštą ar telefoną",
      users_filter_active: "Aktyvūs",
      users_filter_disabled: "Išjungti",
      users_add: "Naujas naudotojas",
      users_empty: "Naudotojų nerasta.",
      settings_nav_permissions_label: "Teisės",
      settings_nav_permissions_lead: "Kas prie ko turi prieigą: iš pareigų ir papildomai suteiktos teisės.",
      perm_from_position: "iš pareigų",
      perm_source_manual: "suteikta papildomai",
      perm_source_position: "iš pareigų: {{position}}",
      perm_nobody: "Šios teisės niekas neturi",
      perm_add_person: "Pridėti žmogų",
      perm_choose_person: "Kam suteikti šią teisę",
      perm_choose_person_placeholder: "Pasirinkite žmogų",
      perm_remove_person: "Atimti teisę: {{name}}",
      perm_error_last_master: "Tai paskutinis įmonės administratorius, jo teisės atimti negalima.",
      perm_error_not_member: "Šis žmogus nebėra įmonės narys.",
      perm_error_unknown: "Tokios teisės nėra.",
      perm_error_stale: "Kažkas ką tik pakeitė šio žmogaus teises — įkėliau iš naujo, pabandykite dar kartą.",
      perm_not_activated: "dar neaktyvuotas",
      perm_position_rights_after_activation: "Teisės iš pareigų pradeda galioti, kai žmogus aktyvuoja paskyrą.",
      groups_retired_reload: "Sistema atnaujinta, o šis puslapis senas — perkraukite puslapį ir bandykite dar kartą.",
      perm_module_management: "Valdymas",
      perm_module_documents: "Dokumentai",
      perm_module_sales: "Pardavimai",
      perm_module_people: "Personalas",
      perm_module_assets: "Turtas ir kuras",
      perm_module_incoming_invoices: "Gautos sąskaitos",
      perm_module_other: "Kita",
      perm_master_name: "Administratorius",
      perm_master_desc: "Mato ir gali viską, įskaitant nustatymus ir teises.",
      perm_admin_name: "Vadovas",
      perm_admin_desc: "Mato skolas ir uždaro užsakymus.",
      perm_access_document_name: "Dokumentai",
      perm_access_document_desc: "Mato ir tvarko įmonės dokumentų medį.",
      perm_signature_name: "Parašas",
      perm_signature_desc: "Tvirtina ir pasirašo dokumentus įmonės vardu.",
      perm_salesman_name: "Vadybininkas",
      perm_salesman_desc: "Užsakymai, pardavimo sąskaitos ir savo klientai.",
      perm_access_all_customers_name: "Visi klientai",
      perm_access_all_customers_desc: "Mato visus klientus, ne tik savo.",
      perm_access_project_name: "Projektai",
      perm_access_project_desc: "Mato ir tvarko projektų lentas.",
      perm_access_onboarding_name: "Personalas",
      perm_access_onboarding_desc: "Įdarbina darbuotojus ir tvarko jų sutartis, sutarčių pakeitimus bei pareigas.",
      perm_access_departments_name: "Skyriai",
      perm_access_departments_desc: "Kuria ir keičia skyrius bei jų narius.",
      perm_access_job_leave_name: "Atleidimas",
      perm_access_job_leave_desc: "Tvarko darbuotojų išėjimą iš darbo: turto grąžinimą, parašus ir teisių nutraukimą.",
      perm_access_work_security_assignments_name: "Tvarkos",
      perm_access_work_security_assignments_desc: "Priskiria darbuotojams pareigybes ir instrukcijų sritis, mato ir tvirtina jų sveikatos patikras (darbo saugos specialistas).",
      perm_access_business_trips_name: "Komandiruotės",
      perm_access_business_trips_desc: "Mato ir tvarko visų darbuotojų komandiruotes.",
      perm_access_assets_name: "Turtas",
      perm_access_assets_desc: "Mato visą turtą, jį išduoda ir tvarko turto prašymus. Laiškus apie naujus prašymus gauna įmonės „Atsakingas už turtą“; šios teisės turėtojai – tik jei jis nepaskirtas.",
      perm_access_fuel_reports_name: "Kuro ataskaitos",
      perm_access_fuel_reports_desc: "Mato ir tvarko visų darbuotojų kuro ataskaitas.",
      perm_access_invoice_inbox_name: "Gautos sąskaitos",
      perm_access_invoice_inbox_desc: "Mato gautų sąskaitų registrą ir jas apdoroja.",
      perm_approve_invoices_as_accountant_name: "Sąskaitų tvirtinimas: buhalteris",
      perm_approve_invoices_as_accountant_desc: "Tvirtina gautas sąskaitas kaip buhalteris.",
      perm_approve_invoices_as_manager_name: "Sąskaitų tvirtinimas: vadovas",
      perm_approve_invoices_as_manager_desc: "Tvirtina gautas sąskaitas kaip vadovas.",
      perm_verify_supplier_bank_change_name: "Tiekėjo banko sąskaitos patikra",
      perm_verify_supplier_bank_change_desc: "Patvirtina, kad tiekėjo pasikeitusi banko sąskaita teisinga.",
      perm_manage_invoice_inbox_settings_name: "Gautų sąskaitų nustatymai",
      perm_manage_invoice_inbox_settings_desc: "Prijungia pašto dėžutę ir kuria gautų sąskaitų taisykles.",
      perm_access_desk_name: "Desk",
      perm_access_desk_desc: "Dirba su laiškų kortelėmis (Desk).",
      perm_feed_write_name: "Naujienų rašymas",
      perm_feed_write_desc: "Skelbia įrašus ir renginius naujienų sraute.",
      settings_nav_storage_label: "Dokumentų saugykla",
      settings_nav_storage_lead: "Čia keliauja visi sistemos dokumentai: sutartys, įdarbinimo dokumentai, sąskaitos ir įkelti failai.",
      settings_nav_signing_label: "El. parašas",
      settings_nav_signing_lead: "Kuriuo būdu pasirašyti, pasirenkama siunčiant dokumentą. Vidiniu parašu galima pasirašyti visada.",
      settings_nav_templates_label: "Dokumentų šablonai",
      settings_nav_templates_lead: "Maketai, iš kurių sistema sugeneruoja dokumentus.",
      settings_templates_title: "Šablonai",
      settings_templates_description: "Maketai, iš kurių sistema sugeneruoja sutartis ir kitus dokumentus.",
      settings_templates_new: "Naujas šablonas",
      settings_templates_edit: "Šablono redagavimas",
      settings_templates_back: "Visi šablonai",
      settings_templates_col_name: "Pavadinimas",
      settings_templates_col_category: "Kategorija",
      settings_templates_col_type: "Dokumento tipas",
      settings_templates_col_signing: "Kaip pasirašoma",
      settings_templates_sign_click: "Vidinis parašas",
      settings_templates_sign_manual: "Ranka",
      settings_templates_empty: "Šablonų dar nėra.",
      settings_templates_load_failed: "Nepavyko įkelti šablono duomenų. Bandykite atnaujinti puslapį.",
      settings_nav_series_label: "Dokumentų prefiksai",
      settings_nav_series_lead: "Trumpas kodas prieš dokumento numerį, pvz., SUT-0045.",
      settings_nav_file_names_label: "Failų pavadinimai",
      settings_nav_file_names_lead: "Kaip sistema pavadina sugeneruotą ar įkeltą failą.",
      settings_nav_custom_fields_label: "Papildomi laukai",
      settings_nav_custom_fields_lead: "Papildomi laukeliai dokumento kortelėje.",
      settings_nav_finvalda_label: "Finvalda",
      settings_nav_finvalda_lead: "Apskaitos programa, iš kurios ERP gauna klientus, prekes, sąskaitas ir skolas.",
      settings_nav_customer_terms_label: "Klientų finansinės sąlygos",
      settings_nav_customer_terms_lead: "Kasmetinis kliento finansinių sąlygų tvirtinimas ir patikros prieš jį.",
      settings_nav_sales_label: "Užsakymai ir sąskaitos",
      settings_nav_sales_lead: "Kaip numeruojamos ir kur dedamos iš užsakymų sugeneruotos sąskaitos.",
      settings_nav_incoming_invoices_label: "Gautos sąskaitos",
      settings_nav_incoming_invoices_lead: "Pirkimų registro taisyklės: kas tvirtina, iš kur renkamos sąskaitos ir kokios išimtys.",
      settings_nav_hr_label: "Personalas",
      settings_nav_hr_lead: "Kur dedami įdarbinimo metu sugeneruoti ir darbuotojo įkelti dokumentai.",
      settings_nav_procedures_label: "Tvarkos",
      settings_nav_procedures_lead: "Tvarkų sritys, jų dokumentai ir mokymų testai.",
      settings_nav_business_trips_label: "Komandiruotės",
      settings_nav_business_trips_lead: "Dokumentai, kurie sugeneruojami komandiruotei.",
      settings_nav_fuel_label: "Kuro ataskaitos",
      settings_nav_fuel_lead: "Kuro ataskaitos dokumentas ir kas kortelių išrašuose laikoma kuru.",
      settings_nav_asset_types_label: "Turto tipai",
      settings_nav_asset_types_lead: "Tipai, pagal kuriuos grupuojamas įmonės turtas.",
      settings_nav_terminal_label: "Terminalas",
      settings_nav_terminal_lead: "Ryšys su terminalo programa: krovos, siuntos ir sutartys.",
      terminal_delivery_accept: "Priimti siuntas ir sutartis iš terminalo",
      terminal_delivery_accept_hint:
        "Įjungus terminalo programa gali perduoti šios įmonės siuntas ir sutartis į ERP. Įmonė atpažįstama pagal įmonės kodą.",
      settings_nav_assistant_label: "DI asistentas",
      settings_nav_assistant_lead: "Dirbtinio intelekto pagalbininkas šiai įmonei.",
      settings_nav_activity_log_label: "Veiklos žurnalas",
      settings_nav_activity_log_lead: "Kas, ką ir kada pakeitė.",
      settings_nav_user_merge_label: "Paskyrų sujungimas",
      settings_nav_user_merge_lead: "Dviejų to paties žmogaus paskyrų sujungimas į vieną.",
      settings_nav_form_errors_label: "Klientų anketų klaidos",
      settings_nav_form_errors_lead: "Klientų anketų pildymo klaidos — pagalbai klientams.",
      // Shared by every settings page (src/containers/settings/ui)
      settings_change: "Keisti",
      settings_save: "Išsaugoti",
      settings_cancel: "Atšaukti",
      settings_saved: "Išsaugota",
      settings_save_failed: "Nepavyko išsaugoti. Bandykite dar kartą.",
      settings_load_failed: "Nepavyko įkelti sąrašo. Perkraukite puslapį ir bandykite dar kartą.",
      settings_add: "Pridėti",
      settings_none: "Nenustatyta",
      settings_master_only: "Tai gali keisti tik įmonės Master naudotojas.",
      settings_secret_entered: "Įvestas",
      settings_secret_entered_last4: "Įvestas · ••••{{last4}}",
      settings_secret_keep_placeholder: "Palikite tuščią, jei nekeičiate",
      settings_roles_director_hint: "Pasirašo darbo sutartis ir jų pakeitimus darbdavio vardu.",
      settings_roles_accountant_hint: "Gauna pasirašytų dokumentų kopijas (jei šablone pažymėta) ir pranešimus apie gautas sąskaitas.",
      settings_roles_invoice_approver: "Gautų sąskaitų tvirtintojas",
      settings_roles_invoice_approver_hint: "Pagal nutylėjimą tvirtina tiekėjų sąskaitas Pirkimų registre.",
      settings_roles_unassigned: "Nepaskirta",
      settings_roles_assets_responsible: "Atsakingas už turtą",
      settings_roles_assets_responsible_hint: "Laiškus apie naujus turto prašymus (pvz., įdarbinant darbuotoją) gauna tik šis asmuo. Jei nepaskirtas – visi, turintys teisę „Turtas“. Kad galėtų atidaryti prašymus, šis asmuo turi turėti teisę „Turtas“.",
      settings_roles_assets_responsible_clear: "Panaikinti paskyrimą",
      settings_roles_assets_responsible_empty: "Palikus nepaskirtą, laiškus gaus visi, turintys teisę „Turtas“.",
      settings_roles_nobody: "— niekas —",
      settings_roles_may_be_empty: "Galima palikti tuščią — tada šis žingsnis praleidžiamas.",
      settings_roles_director_clear_warning: "Be direktoriaus nebus kam pasirašyti darbo sutarčių darbdavio vardu.",
      settings_roles_name_unknown: "Paskirtas (vardo nepavyko įkelti)",
      settings_roles_error_not_member: "Šis žmogus nėra aktyvus įmonės narys.",
      settings_roles_error_required: "Pasirinkite žmogų arba „niekas“ ir išsaugokite dar kartą.",
      settings_roles_error_lacks_permission: "Šis žmogus neturi teisės tvirtinti sąskaitų (teisė „Approve invoices as manager“). Pirmiausia suteikite ją.",
      settings_storage_onedrive_heading: "OneDrive prisijungimas",
      settings_storage_connect_onedrive: "Prijungti OneDrive",
      settings_storage_permit_label: "Kas mato įmonės aplanką OneDrive",
      settings_storage_permit_hint: "Tik šis žmogus gauna tiesioginę prieigą prie aplanko OneDrive. Kiti dokumentus mato tik per sistemą.",
      settings_ms_card_description: "Microsoft 365 programos duomenys. Juos išduoda jūsų IT administratorius.",
      settings_ms_client_id: "Programos ID (Client ID)",
      settings_ms_tenant_id: "Organizacijos ID (Tenant ID)",
      settings_ms_secret: "Slaptas raktas (Value)",
      settings_ms_secret_entered_until: "Įvestas · galioja iki {{date}}",
      settings_ms_save_and_check: "Išsaugoti ir patikrinti",
      settings_ms_error_data_required: "Įrašykite programos ID, organizacijos ID ir slaptą raktą.",
      settings_ms_error_expiry_invalid: "Rakto galiojimo data nėra tikra data.",
      settings_ms_check_connection: "Patikrinti ryšį",
      settings_ms_check_ok: "Patikrinta ką tik: ryšys veikia.",
      settings_ms_check_not_configured: "Pirmiausia išsaugokite Microsoft programos duomenis (programos ID, organizacijos ID ir slaptą raktą).",
      settings_ms_check_expired: "Microsoft raktas nebegalioja — sukurkite naują Azure portale ir įrašykite čia.",
      settings_ms_check_invalid: "Įrašykite rakto reikšmę (Value), ne jo ID.",
      settings_ms_check_auth_failed: "Microsoft atmetė įrašytus duomenis. Patikrinkite programos ID, organizacijos ID ir slaptą raktą.",
      settings_ms_check_timeout: "Microsoft neatsakė per 10 sekundžių. Bandykite dar kartą.",
      settings_ms_check_no_folder: "Įmonės aplanko jūsų OneDrive nebėra. Atkurkite jį arba kreipkitės į pagalbą.",
      settings_ms_check_folder_error: "Nepavyko perskaityti įmonės aplanko OneDrive. Bandykite dar kartą.",
      settings_ms_check_request_failed: "Nepavyko patikrinti ryšio. Bandykite dar kartą.",
      settings_customer_terms_approvals_label: "Tvirtinti klientų finansines sąlygas",
      settings_customer_terms_approvals_hint: "Kasmet patvirtinamos kliento finansinės sąlygos ir klientas pasirašo dokumentą. Išjungus kliento kortelėje nebus šios skilties.",
      settings_customer_terms_document_card: "Dokumentas ir anketa",
      settings_customer_terms_document_label: "Dokumentas, kurį pasirašo klientas",
      settings_customer_terms_document_hint: "Šablonas, iš kurio sugeneruojamas finansinių sąlygų dokumentas.",
      settings_customer_terms_template_required: "Pirmiausia pasirinkite dokumentą, kurį pasirašo klientas.",
      settings_customer_terms_skip_questionnaire_label: "Neprašyti naujos anketos, jei klientas ją jau pildė",
      settings_customer_terms_skip_questionnaire_hint: "Jei klientas anketą užpildė bet kuriais ankstesniais metais, naujiems metams jos pildyti nereikės.",
      settings_customer_terms_checks_card: "Patikros prieš tvirtinant",
      settings_customer_terms_checks_hint: "Įjungtai patikrai prieš tvirtinant reikės prisegti įrodymą — ekrano kopiją ar dokumentą.",
      settings_check_eu_sanctions: "ES sankcijų sąrašas",
      settings_check_eu_sanctions_hint: "Patikrinti, ar klientas nėra ES sankcijų sąraše.",
      settings_check_usa_sanctions: "JAV sankcijų sąrašas (OFAC)",
      settings_check_usa_sanctions_hint: "Patikrinti, ar klientas nėra JAV sankcijų sąraše.",
      settings_check_lt_sanctions: "Lietuvos sankcijų sąrašas",
      settings_check_lt_sanctions_hint: "Patikrinti, ar klientas nėra Lietuvos sankcijų sąraše.",
      settings_check_vat: "PVM mokėtojo kodo patikra",
      settings_check_vat_hint: "Tik ES klientams: ar PVM kodas galioja.",
      settings_check_proof_place: "Įrodymas dedamas: {{place}}",
      settings_sales_numbering_missing_title: "Nepasirinkta sąskaitų numeracija",
      settings_sales_numbering_missing_detail: "Kol jos nėra, iš užsakymų sąskaitų sugeneruoti negalima.",
      settings_sales_numbering_pick: "Pasirinkti numeraciją",
      settings_sales_numbering_hint: "Iš šios serijos pardavimo sąskaitos gauna numerius, pvz., UA-000124.",
      settings_sales_manage_series: "Valdyti serijas",
      settings_sales_series_missing: "Nėra tinkamos?",
      settings_sales_series_current_number: "Numeris dabar",
      settings_sales_documents_card: "Dokumentai",
      settings_sales_documents_hint: "Kaip atrodo ir kur dedami sugeneruoti dokumentai.",
      settings_sales_document_invoice: "Pardavimo sąskaita",
      settings_sales_document_amendment: "Užsakymo pakeitimas",
      settings_sales_template_system: "Sistemos šablonas",
      settings_sales_template_custom: "Savas šablonas",
      settings_sales_filed_in: "{{source}} · dedama: {{category}}",
      settings_sales_registry_series_hint: "Registro serija — dokumento numeris failų registre, ne sąskaitos numeris.",
      settings_incoming_no_permission: "Neturite teisės matyti šių nustatymų.",
      settings_incoming_approver_label: "Kas tvirtina gautas sąskaitas",
      settings_incoming_approver_description: "Sąskaitą tvirtina skyriaus vadovas. Jei jo nėra ar jis atostogauja, tvirtina šis žmogus; jei ir jo nėra — direktorius.",
      settings_incoming_approver_none: "Nepaskirta",
      settings_incoming_approver_assign: "Paskirti",
      settings_incoming_approver_unknown: "Paskirtas (vardas nepasiekiamas)",
      settings_incoming_approver_inactive: "{{name}} (neaktyvus)",
      settings_incoming_strict_label: "Pareigų atskyrimas",
      settings_incoming_strict_description: "Kai įjungta, tas pats žmogus negali ir įvesti, ir patvirtinti sąskaitos ar naujos tiekėjo banko sąskaitos. Keičia sistemos administratorius.",
      settings_incoming_strict_on: "Įjungta",
      settings_incoming_strict_off: "Išjungta",
      settings_incoming_mailboxes_label: "Pašto dėžutės",
      settings_incoming_mailboxes_description: "Iš jų sąskaitos surenkamos automatiškai. Tvarko žmonės, kurie gali keisti pirkimų registro nustatymus.",
      settings_incoming_suppliers_title: "Tiekėjai su ypatingomis taisyklėmis",
      settings_incoming_suppliers_description: "Tiekėjai, kurių sąskaitos ateina po apmokėjimo arba laukiamos kas mėnesį.",
      settings_incoming_suppliers_name: "Tiekėjas",
      settings_incoming_suppliers_paid: "Sąskaita ateina po apmokėjimo",
      settings_incoming_suppliers_monthly: "Laukiama kas mėnesį",
      settings_incoming_suppliers_empty: "Tokių tiekėjų nėra.",
      settings_incoming_suppliers_truncated: "Rodoma tik pirmieji 500 tiekėjų.",
      settings_incoming_senders_title: "Užblokuoti siuntėjai",
      settings_incoming_senders_description: "Laiškai iš šių siuntėjų į registrą nepatenka.",
      settings_incoming_senders_empty: "Užblokuotų siuntėjų nėra.",
      settings_incoming_senders_blocked_by: "Užblokavo {{name}}, {{date}}",
      settings_incoming_senders_blocked_on: "Užblokuota {{date}}",
      settings_incoming_senders_unblock: "Atblokuoti",
      settings_incoming_senders_unblock_confirm: "Šio siuntėjo laiškai vėl pateks į registrą. Jau sulaikyti laiškai liks sąraše.",
      settings_incoming_senders_unblock_failed: "Nepavyko atblokuoti siuntėjo. Bandykite dar kartą.",
      settings_signing_tablets_link: "SignOnTab įranga",
      settings_signing_click_title: "Vidinis parašas",
      settings_signing_click_description: "Žmogus prisijungia prie sistemos ir paspaudžia „Pasirašyti“.",
      settings_signing_always_on: "Visada įjungta",
      settings_signing_key_label: "Prieigos raktas",
      settings_signing_dokobit_description: "Kvalifikuotas el. parašas: Smart-ID, Mobilusis parašas, asmens tapatybės kortelė.",
      settings_signing_dokobit_switch: "Leisti pasirašyti per Dokobit",
      settings_signing_dokobit_key_hint: "Gaunamas Dokobit paskyroje.",
      settings_signing_dokobit_key_required: "Įrašykite Dokobit prieigos raktą.",
      settings_signing_dokobit_key_too_short: "Raktas per trumpas. Įrašykite visą Dokobit prieigos raktą.",
      settings_signing_signontab_description: "Parašas ranka ant planšetės, pvz., biure ar sandėlyje.",
      settings_signing_signontab_switch: "Leisti pasirašyti per SignOnTab",
      settings_signing_signontab_login_label: "Prisijungimas",
      settings_signing_signontab_login_hint: "Adresas, kliento ID ir slaptas raktas iš SignOnTab.",
      settings_signing_domain: "Adresas",
      settings_signing_client_id: "Kliento ID",
      settings_signing_secret: "Slaptas raktas",
      settings_signing_signontab_data_required: "Įrašykite adresą, kliento ID ir slaptą raktą.",
      settings_signing_signontab_secret_required: "Pakeitus adresą ar kliento ID, įveskite slaptą raktą iš naujo.",
      settings_signing_signontab_secret_too_short: "Slaptas raktas per trumpas. Įrašykite visą raktą.",

      // Kabineto atostogos: prašymo langas, panaudotos dienos ir laukiančio prašymo atšaukimas
      leave_sheet_title: "Naujas prašymas",
      leave_sheet_other_types: "Kiti tipai",
      leave_sheet_no_template: "Įmonė neturi šio prašymo šablono",
      leave_sheet_previous_month: "Ankstesnis mėnuo",
      leave_sheet_next_month: "Kitas mėnuo",
      leave_sheet_pick_days: "Pasirinkite pirmą ir paskutinę dieną",
      leave_sheet_picked: "Pasirinkta: {{dates}} d. · {{days}}",
      leave_sheet_working_days: "{{n}} darbo d.",
      leave_sheet_counting: "Skaičiuojama…",
      leave_sheet_duration_full: "Visa diena",
      leave_sheet_duration_half: "Pusė dienos",
      leave_sheet_duration_hourly: "Valandos",
      leave_sheet_signer_manager: "Pasirašys: {{name}} (vadovas)",
      leave_sheet_signer_only_you: "Prašymą pasirašysite tik jūs",
      leave_sheet_submit: "Pateikti ir pasirašyti",
      leave_sheet_sign_hint: "Peržiūrėkite prašymą ir pasirašykite.",
      leave_sheet_unsigned_note: "Jei uždarysite nepasirašę, prašymas liks nepasirašytas. Pasirašyti jį galėsite vėliau, prašymų sąraše.",
      leave_sheet_submitted_waiting: "Prašymas pateiktas. Laukia vadovo parašo.",
      leave_sheet_submitted_done: "Prašymas pateiktas ir patvirtintas.",
      leave_sheet_submitted: "Prašymas pateiktas.",
      leave_sheet_template: "Šablonas",
      leave_sheet_fields_unsupported: "Šio šablono laukų čia užpildyti negalima. Pildykite prašymą atostogų kalendoriuje.",
      leave_calendar_comment_too_long: "Komentaras per ilgas (iki 1000 simbolių).",
      leave_calendar_substitute_not_member: "Pasirinktas pavaduojantis asmuo nėra aktyvus šios įmonės darbuotojas",
      leave_sheet_error_sign: "Nepavyko pasirašyti. Prašymas sukurtas ir laukia jūsų parašo: bandykite dar kartą arba pasirašykite jį sąraše.",
      leave_usage_used: "{{year}} m. panaudota: {{types}}",
      leave_usage_type_days: "{{type}} {{days}} d.",
      leave_usage_none: "{{year}} m. atostogų dar nepanaudota",
      leave_usage_no_balance_hint: "Likutis bus rodomas, kai įmonė suves metines normas.",
      leave_row_comment: "Komentaras: {{comment}}",
      leave_cancel_action: "Atšaukti prašymą",
      leave_cancel_action_short: "Atšaukti",
      leave_cancel_title: "Atšaukti prašymą?",
      leave_cancel_notice: "Pasirašantieji gaus pranešimą.",
      leave_cancel_keep: "Ne, palikti",
      leave_cancel_confirm: "Taip, atšaukti",
      leave_cancel_error_signed: "Prašymas jau pasirašytas, jo atšaukti nebegalima.",
      leave_cancel_error_generic: "Nepavyko atšaukti prašymo. Bandykite dar kartą.",

      // Asmeninis kabinetas: šoninio meniu grupės ir profilio skyriai
      cabinet_group: "Mano kabinetas",
      modules_group: "Moduliai",
      cabinet_assets: "Turtas",
      cabinet_safety: "Darbuotojo vidiniai dokumentai",
      cabinet_about_me: "Apie mane",
      cabinet_my_documents: "Mano dokumentai",
      module_documents: "Įmonės dokumentai",
      module_fuel_reports: "Įmonės kuro ataskaitos",
      module_business_trips: "Įmonės komandiruotės",
      cabinet_about_me_hint: "Jūsų duomenys ir nustatymai.",
      cabinet_leaves_hint: "Jūsų atostogų ir laisvų dienų prašymai.",
      cabinet_fuel_hint: "Mėnesio kuro ataskaitos už jums priskirtą automobilį.",
      cabinet_trips_hint: "Jūsų komandiruotės, jų ataskaitos ir išlaidos.",
      cabinet_assets_hint: "Daiktai, kuriuos jums išdavė įmonė, ir jūsų turto prašymai.",
      cabinet_documents_hint: "Jums matomi dokumentai, darbo sutartis ir įdarbinimo dokumentai.",
      cabinet_safety_hint: "Darbo sauga — jūsų pareigų saugos instrukcijos ir mokymai. Sveikatos patikra — jūsų medicininė pažyma.",
      cabinet_fill_leave_request: "Pildyti atostogų prašymą",
      cabinet_fill_document: "Pildyti dokumentą",
      cabinet_download_history: "Atsisiuntimų istorija",

      // Telefono apatinė juosta ir svečio skydelis
      phone_bar_label: "Pagrindiniai skyriai",
      phone_bar_menu: "Meniu",
      cabinet_guest_banner: "Esate svečias įmonėje {{company}}.",

      // Kabineto «Turtas», «Darbuotojo vidiniai dokumentai» ir «Apie mane» blokas «Darbas»
      cabinet_assets_none: "Jums neišduota jokio turto",
      cabinet_assets_count_one: "Turite {{count}} daiktą",
      cabinet_assets_count_few: "Turite {{count}} daiktus",
      cabinet_assets_count_other: "Turite {{count}} daiktų",
      cabinet_assets_acts_to_sign_one: "{{count}} aktas laukia jūsų parašo",
      cabinet_assets_acts_to_sign_few: "{{count}} aktai laukia jūsų parašo",
      cabinet_assets_acts_to_sign_other: "{{count}} aktų laukia jūsų parašo",
      cabinet_assets_load_failed: "Nepavyko įkelti jūsų turto",
      cabinet_assets_cards_title: "Mano turtas",
      cabinet_asset_serial: "SN {{serial}}",
      cabinet_asset_held_since: "Turite nuo {{date}}",
      cabinet_asset_act_signed: "Aktas pasirašytas",
      cabinet_asset_act_to_sign: "Aktas laukia jūsų parašo",
      cabinet_asset_act_waiting_others: "Aktas laukia kitų parašų",
      cabinet_asset_act_none: "Be akto",
      cabinet_asset_act_open: "Peržiūrėti ir pasirašyti",
      cabinet_safety_documents_to_sign_one: "{{count}} saugos dokumentas laukia jūsų parašo",
      cabinet_safety_documents_to_sign_few: "{{count}} saugos dokumentai laukia jūsų parašo",
      cabinet_safety_documents_to_sign_other: "{{count}} saugos dokumentų laukia jūsų parašo",
      cabinet_safety_upload_medical: "Įkelkite sveikatos patikros pažymą",
      cabinet_safety_documents_check_failed: "Nepavyko patikrinti saugos dokumentų",
      cabinet_safety_trainings_waiting_one: "Laukia {{count}} mokymas",
      cabinet_safety_trainings_waiting_few: "Laukia {{count}} mokymai",
      cabinet_safety_trainings_waiting_other: "Laukia {{count}} mokymų",
      cabinet_safety_all_in_order: "Viskas tvarkoje",
      cabinet_safety_medical_valid_until: "sveikatos patikra galioja iki {{date}}",
      cabinet_safety_block_instructions: "Saugos instrukcijos ir dokumentai",
      cabinet_safety_block_training: "Mokymai",
      cabinet_safety_block_medical: "Sveikatos patikra",
      cabinet_work_title: "Darbas",
      cabinet_work_department: "Padalinys",
      cabinet_work_since: "Dirba nuo",
      cabinet_work_contract_until: "Sutartis galioja iki",
      cabinet_work_hours: "Darbo valandos per savaitę",
      cabinet_work_probation_until: "Bandomasis laikotarpis iki",
      cabinet_work_contract: "Darbo sutartis",
      cabinet_work_amendments: "Sutarties pakeitimai ({{total}})",
      cabinet_work_terms_change: "Darbo sąlygų pakeitimas",
      cabinet_work_all_documents: "Visi įdarbinimo dokumentai",
      cabinet_work_no_terms: "Darbo sutarties duomenų sistemoje nėra",
      cabinet_work_load_failed: "Nepavyko įkelti darbo duomenų",

      // «Užduotys» puslapis: kabineto suvestinė, darbo eilės ir dokumentų pildymas
      tasks_status_waiting_one: "Laukia jūsų {{count}} darbas",
      tasks_status_waiting_few: "Laukia jūsų {{count}} darbai",
      tasks_status_waiting_other: "Laukia jūsų {{count}} darbų",
      tasks_status_all_clear: "Viskas tvarkoje — jūsų niekas nelaukia",
      tasks_all_my_companies: "Visos mano įmonės",
      tasks_load_failed: "Nepavyko įkelti užduočių",
      tasks_section_mine: "Mano",
      tasks_section_queues: "Darbo eilės",
      tasks_section_fill_in: "Pildyti",
      tasks_section_waiting_others: "Laukia kitų",
      tasks_group_sign: "Laukia jūsų parašo",
      tasks_group_do: "Atlikti",
      tasks_do_medical: "Sveikatos patikra",
      tasks_do_training: "Mokymai",
      tasks_do_pinned: "Svarbios naujienos",
      tasks_do_trip_reports: "Komandiruočių ataskaitos",
      tasks_group_expiring: "Baigiasi galiojimas",
      tasks_show_all: "Rodyti visus ({{count}})",
      tasks_all_of_kind: "Visi ({{count}})",
      tasks_not_in_app_one: "{{count}} dokumentas pasirašomas popieriuje arba planšetėje — jo čia pasirašyti negalima.",
      tasks_not_in_app_few: "{{count}} dokumentai pasirašomi popieriuje arba planšetėje — jų čia pasirašyti negalima.",
      tasks_not_in_app_other: "{{count}} dokumentų pasirašoma popieriuje arba planšetėje — jų čia pasirašyti negalima.",
      tasks_kind_asset_act: "Turto aktas",
      tasks_kind_work_safety: "Darbo saugos instrukcija",
      tasks_kind_leave: "Atostogų prašymas",
      tasks_kind_fuel: "Kuro ataskaita",
      tasks_kind_trip: "Komandiruotė",
      tasks_kind_document: "Dokumentas",
      tasks_action_sign: "Pasirašyti",
      tasks_action_sign_dokobit: "Pasirašyti per Dokobit",
      tasks_action_start: "Pradėti",
      tasks_action_read: "Skaityti",
      tasks_action_fill_report: "Pildyti ataskaitą",
      tasks_action_upload: "Įkelti",
      tasks_action_open: "Atidaryti",
      tasks_action_view: "Peržiūrėti",
      tasks_medical_upload_needed: "Įkelkite sveikatos patikros pažymą",
      tasks_valid_until: "Galioja iki {{date}}",
      tasks_expired_on: "Baigėsi {{date}}",
      expiry_handled_action: "Sutvarkyta",
      expiry_handled_confirm: "Pažymėti kaip sutvarkytą? Dokumentas nebebus rodomas šiame sąraše.",
      expiry_handled_failed: "Nepavyko pažymėti dokumento. Bandykite dar kartą.",
      expiry_handled_changed: "Dokumentas pasikeitė, sąrašas atnaujintas",
      expiring_no_match: "Nerasta pagal filtrus",
      tasks_age_today: "šiandien",
      tasks_age_days: "prieš {{count}} d.",
      tasks_queue_sign_work: "Įmonės dokumentai, laukiantys parašo",
      tasks_queue_team: "Komandos prašymai",
      tasks_queue_probation: "Bandomojo laikotarpio vertinimai",
      tasks_queue_invoices: "Sąskaitų tvirtinimas",
      tasks_queue_ws: "Tvarkos tvirtinimai",
      tasks_queue_customer_finance: "Klientų finansų patvirtinimai",
      tasks_queue_medical: "Sveikatos patikros",
      tasks_queue_asset_requests: "Turto prašymai",
      tasks_queue_review: "Peržiūrėti dokumentus",
      tasks_queue_sent: "Mano išsiųsti, laukiantys kitų",
      tasks_queue_training: "Mokymai",
      tasks_meta_sign_work: "{{click}} Click · {{dokobit}} Dokobit · seniausias {{days}} d.",
      tasks_meta_paper_one: "Dar {{count}} dokumentas pasirašomas popieriuje",
      tasks_meta_paper_few: "Dar {{count}} dokumentai pasirašomi popieriuje",
      tasks_meta_paper_other: "Dar {{count}} dokumentų pasirašoma popieriuje",
      tasks_meta_team: "atostogos ir nuotolinis darbas",
      tasks_meta_invoices: "seniausia {{days}} d.",
      tasks_meta_review: "seniausias {{date}}",
      tasks_meta_sent: "pasirašė ne visi",
      tasks_review_not_counted: "Neįeina į užduočių skaičių",
      tasks_fill_leave: "Atostogų prašymas",
      tasks_fill_fuel: "Kuro ataskaita",
      tasks_fill_trip: "Komandiruotė",
      tasks_fill_asset: "Turto prašymas",
      tasks_fill_document: "Kitas dokumentas",
      tasks_waiting_approval: "Laukia patvirtinimo",

      // Kabinetas: «Kuro ataskaitos» mėnesių lentelė, «Komandiruotės» kiti žingsniai ir kuro užduotis
      cabinet_action_fill: "Pildyti",
      cabinet_action_continue: "Tęsti",
      cabinet_action_fix: "Taisyti",
      cabinet_fuel_month_01: "sausio",
      cabinet_fuel_month_02: "vasario",
      cabinet_fuel_month_03: "kovo",
      cabinet_fuel_month_04: "balandžio",
      cabinet_fuel_month_05: "gegužės",
      cabinet_fuel_month_06: "birželio",
      cabinet_fuel_month_07: "liepos",
      cabinet_fuel_month_08: "rugpjūčio",
      cabinet_fuel_month_09: "rugsėjo",
      cabinet_fuel_month_10: "spalio",
      cabinet_fuel_month_11: "lapkričio",
      cabinet_fuel_month_12: "gruodžio",
      cabinet_fuel_all_filed: "Visos ataskaitos pateiktos",
      cabinet_fuel_missing_month: "Trūksta {{year}} m. {{month}} ataskaitos",
      cabinet_fuel_missing_count_one: "Trūksta {{count}} ataskaitos",
      cabinet_fuel_missing_count_few: "Trūksta {{count}} ataskaitų",
      cabinet_fuel_missing_count_other: "Trūksta {{count}} ataskaitų",
      cabinet_fuel_fill_month: "Pildyti {{month}} ataskaitą",
      cabinet_fuel_fill: "Pildyti kuro ataskaitą",
      cabinet_fuel_table_label: "Kuro ataskaitos pagal mėnesius",
      cabinet_fuel_col_month: "Mėnuo",
      cabinet_fuel_col_vehicle: "Automobilis",
      cabinet_fuel_col_status: "Būsena",
      cabinet_fuel_col_action: "Veiksmas",
      cabinet_fuel_status_missing: "Nepateikta",
      cabinet_fuel_status_current: "Einamasis mėnuo",
      cabinet_fuel_status_draft: "Pildoma",
      cabinet_fuel_status_to_sign: "Laukia jūsų parašo",
      cabinet_fuel_status_waiting_manager: "Laukia vadovo",
      cabinet_fuel_status_rejected: "Atmesta",
      cabinet_fuel_status_approved: "Patvirtinta",
      cabinet_fuel_status_annulled: "Anuliuota",
      cabinet_fuel_note: "Pasirašius ataskaitą, ji automatiškai siunčiama vadovui.",
      cabinet_fuel_load_failed: "Nepavyko įkelti kuro ataskaitų",
      cabinet_trip_new: "Nauja komandiruotė",
      cabinet_trip_next_step: "Kitas žingsnis",
      cabinet_trips_waiting_report_single: "Viena komandiruotė laukia ataskaitos",
      cabinet_trips_waiting_report_one: "{{count}} komandiruotė laukia ataskaitos",
      cabinet_trips_waiting_report_few: "{{count}} komandiruotės laukia ataskaitos",
      cabinet_trips_waiting_report_other: "{{count}} komandiruočių laukia ataskaitos",
      cabinet_trips_waiting_signature_single: "Viena komandiruotė laukia jūsų parašo",
      cabinet_trips_waiting_signature_one: "{{count}} komandiruotė laukia jūsų parašo",
      cabinet_trips_waiting_signature_few: "{{count}} komandiruotės laukia jūsų parašo",
      cabinet_trips_waiting_signature_other: "{{count}} komandiruočių laukia jūsų parašo",
      cabinet_trips_all_in_order: "Visos komandiruotės tvarkoje",
      cabinet_trip_step_create_order: "Sugeneruoti komandiruotės įsakymą",
      cabinet_trip_step_sign_order: "Pasirašyti įsakymą",
      cabinet_trip_step_wait_order: "Laukiama įsakymo parašų",
      cabinet_trip_step_trip_ahead: "Komandiruotė dar nesibaigė",
      cabinet_trip_step_fill_report: "Užpildyti ataskaitą",
      cabinet_trip_step_sign_report: "Pasirašyti ataskaitą",
      cabinet_trip_step_wait_report: "Laukiama ataskaitos parašų",
      cabinet_trip_step_fix_report: "Ataskaita atmesta — pataisykite",
      cabinet_trip_step_done: "Užbaigta",
      cabinet_trip_step_cancelled: "Atšaukta",
      tasks_do_fuel_reports: "Kuro ataskaitos",
      tasks_fuel_report_title: "Pildyti {{month}} kuro ataskaitą",

      // Eilių sąrašai («Pasirašyti dokumentus», «Peržiūrėti dokumentus») ir dokumentų iš eilės langas
      queue_sign_status_one: "{{count}} dokumentas laukia jūsų parašo",
      queue_sign_status_few: "{{count}} dokumentai laukia jūsų parašo",
      queue_sign_status_other: "{{count}} dokumentų laukia jūsų parašo",
      queue_sign_oldest: "seniausias {{days}} d.",
      queue_sign_all_signed: "Viskas pasirašyta",
      queue_sign_nothing_matches: "Pagal filtrus nieko nerasta",
      queue_sign_start: "Peržiūrėti ir pasirašyti iš eilės",
      queue_filter_type: "Tipas",
      queue_filter_company: "Įmonė",
      queue_filter_signature: "Parašas",
      queue_filter_all: "Visi",
      queue_filter_all_companies: "Visos",
      queue_type_work: "Darbo",
      queue_type_mine: "Mano",
      queue_type_team: "Komandos prašymai",
      queue_signature_click: "Click",
      queue_signature_dokobit: "Dokobit",
      queue_filter_older: "Senesni nei {{days}} d.",
      queue_search: "Ieškoti",
      queue_col_title: "Pavadinimas",
      queue_col_type: "Tipas",
      queue_col_company: "Įmonė",
      queue_col_owner: "Pateikė",
      queue_col_customer: "Klientas",
      queue_col_waiting: "Laukia",
      queue_col_signature: "Parašas",
      queue_col_received: "Gauta",
      queue_group_team: "Komandos",
      queue_waiting_days: "{{days}} d.",
      queue_paper_title: "Pasirašoma popieriuje ({{count}})",
      queue_paper_note: "Šių dokumentų programoje pasirašyti negalima. Kai klientas pasirašys popieriuje ir dokumento savininkas įkels skenuotą kopiją, dokumentas atsiras šiame sąraše pasirašymui per Dokobit.",
      queue_load_failed: "Nepavyko įkelti dokumentų",
      queue_retry: "Bandyti dar kartą",
      queue_review_status_one: "{{formatted}} dokumentas laukia peržiūros",
      queue_review_status_few: "{{formatted}} dokumentai laukia peržiūros",
      queue_review_status_other: "{{formatted}} dokumentų laukia peržiūros",
      queue_review_start: "Peržiūrėti iš eilės",
      queue_review_not_counted: "Peržiūrimi dokumentai neįeina į užduočių skaičių.",
      queue_page_range: "{{from}}–{{to}} iš {{total}}",
      queue_prev_page: "Ankstesnis puslapis",
      queue_next_page: "Kitas puslapis",
      queue_sheet_word_sign: "Pasirašyti",
      queue_sheet_word_team: "Prašymas",
      queue_sheet_word_review: "Peržiūrėti",
      queue_sheet_counter: "{{i}} iš {{n}}",
      queue_sheet_open_document: "Atidaryti visą dokumentą",
      queue_sheet_loading_more: "Kraunami kiti dokumentai…",
      queue_fact_owner: "Pateikė: {{name}}",
      queue_fact_customer: "Klientas: {{names}}",
      queue_fact_waiting: "Laukia: {{days}} d.",
      queue_leave_employee: "Darbuotojas",
      queue_leave_dates: "Data",
      queue_leave_hours: "Valandos",
      queue_action_review: "Pažymėti peržiūrėtu",
      queue_action_skip: "Praleisti",
      queue_action_decline: "Atmesti…",
      queue_action_decline_confirm: "Atmesti",
      queue_action_next: "Toliau",
      queue_decline_reason: "Atmetimo priežastis",
      queue_msg_signed: "Pasirašyta",
      queue_msg_signed_manager_asked: "Pasirašyta, prašymas išsiųstas vadovui",
      queue_msg_declined: "Atmesta",
      queue_msg_reviewed: "Pažymėta peržiūrėtu",
      queue_msg_dokobit_opened: "Pasirašymas atidarytas naujame skirtuke. Pasirašę grįžkite į šį skirtuką ir spauskite „Toliau“. Patvirtinimas iš Dokobit gali užtrukti iki 30 min.",
      queue_error_annulled: "Dokumentas anuliuotas",
      queue_error_withdrawn: "Dokumentas atšauktas",
      queue_error_changed: "Šio dokumento būsena pasikeitė",
      queue_error_generic: "Nepavyko atlikti veiksmo. Bandykite dar kartą arba praleiskite dokumentą.",
      queue_error_popup_blocked: "Naršyklė užblokavo naują langą. Leiskite iššokančius langus ir bandykite dar kartą.",
      queue_end_title: "Eilė baigta: {{summary}}",
      queue_end_signed: "pasirašyta {{n}}",
      queue_end_declined: "atmesta {{n}}",
      queue_end_skipped: "praleista {{n}}",
      queue_end_reviewed: "peržiūrėta {{n}}",
      queue_end_opened: "atidaryta Dokobit {{n}}",
      queue_end_more_failed: "Nepavyko įkelti tolesnių dokumentų. Atnaujinkite sąrašą, kad tęstumėte.",
      needs_attention: "Reikia dėmesio",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "lt", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
